(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as HF, getPartnerDevApiHeaders as WF, WidgetContextProvider as KF, makeExecuteQuery as GF, makeUseLazyQuery as YF, makeUseQuery as JF, makeUseMutation as QF, validateApiHostName as JN, useTracking as gn, useWidgetContext as mn, hasDownstreamApiForbiddenError as Hh, hasDownstreamApiAuthorizationError as Wh, DisplayErrors as wn, useCopyWithDelay as Dr, defaultDateFormat as ct, displayAttributeValue as QN, OAuthSettings as kc, useData as Kh, isDownstreamApiNotFoundError as XF, KlaviyoSubscribeSetting as ZF, isDownstreamApiAuthorizationError as eI, isDownstreamApiPermissionError as nI, capitalizeFirstCharacter as bc, hasDownstreamApiTooManyRequestsError as tI, hasDownstreamApiPermissionError as XN, hasDownstreamApiNotFoundError as as, getCountryNameFromCountryCode as rI } from "@dixa/partner-widget-integration-support";
export * from "@dixa/partner-widget-integration-support";
import Se, { useMemo as Wn, useState as oe, useEffect as qe, useRef as ga, useCallback as vt, useReducer as iI, useLayoutEffect as aI, isValidElement as oI, createElement as sI, Fragment as lI } from "react";
import { Modal as Nt, ModalHead as jt, ModalBody as wt, ModalFoot as Ot, Text as A, FlexBox as b, Spinner as dn, Icon as me, Tooltip as Qe, List as He, Badge as Mn, Button as Kn, IconButton as tr, Tag as Rn, NavigationButton as Tt, Select as Lr, CollapseCard as hr, Box as Qn, FormGrid as Gt, FormField as rn, FieldWrapper as An, InputText as Pr, Textarea as Uf, TagsInput as _c, Image as Ta, Banner as xc, Divider as Gh, InputSelectionList as ki, SelectionList as ht, FieldText as vr, FieldTextarea as cI, CopyToClipboardButton as uI, Avatar as Yh, Timestamp as dI, Attachment as mI, Switch as Bf, FieldLabel as pI, EmptyState as Jh, Table as Xn, Checkbox as My, TextWithHighlight as fI, ErrorBoundaryContext as ZN, FieldSwitch as ej } from "@dixa/lib-shared-habla";
import { ApolloLink as Qh, Observable as nj, ApolloClient as hI, InMemoryCache as vI, createHttpLink as yI, ApolloProvider as gI, useApolloClient as kI, ApolloConsumer as bI, gql as ji, NetworkStatus as yr, isApolloError as tj, ApolloError as _I, useQuery as xI, useMutation as Uy } from "@apollo/client";
import SI from "cross-fetch";
import { config as Qo } from "lib-shared-backend-config";
import ut from "classnames";
import Dn from "moment";
import { __rest as NI, __assign as cu } from "tslib";
import "moment-timezone";
import { useLocation as jI } from "react-router-dom";
function Xh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Rs = { exports: {} }, Ja = {};
var By;
function wI() {
  if (By) return Ja;
  By = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return Ja.Fragment = t, Ja.jsx = s, Ja.jsxs = s, Ja;
}
var Qa = {};
var qy;
function CI() {
  return qy || (qy = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c, R));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    Qa.Fragment = i, Qa.jsx = Bn, Qa.jsxs = qn;
  }()), Qa;
}
var Hy;
function FI() {
  return Hy || (Hy = 1, process.env.NODE_ENV === "production" ? Rs.exports = wI() : Rs.exports = CI()), Rs.exports;
}
var ze = FI();
function rj(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: II } = Object.prototype, { getPrototypeOf: Zh } = Object, { iterator: Sc, toStringTag: ij } = Symbol, Nc = /* @__PURE__ */ ((e) => (n) => {
  const t = II.call(n);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Vr = (e) => (e = e.toLowerCase(), (n) => Nc(n) === e), jc = (e) => (n) => typeof n === e, { isArray: Oa } = Array, ja = jc("undefined");
function os(e) {
  return e !== null && !ja(e) && e.constructor !== null && !ja(e.constructor) && Zt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const aj = Vr("ArrayBuffer");
function $I(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && aj(e.buffer), n;
}
const EI = jc("string"), Zt = jc("function"), oj = jc("number"), ss = (e) => e !== null && typeof e == "object", TI = (e) => e === !0 || e === !1, wl = (e) => {
  if (Nc(e) !== "object")
    return !1;
  const n = Zh(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(ij in e) && !(Sc in e);
}, OI = (e) => {
  if (!ss(e) || os(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, RI = Vr("Date"), DI = Vr("File"), PI = Vr("Blob"), AI = Vr("FileList"), LI = (e) => ss(e) && Zt(e.pipe), VI = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || Zt(e.append) && ((n = Nc(e)) === "formdata" || // detect form-data instance
  n === "object" && Zt(e.toString) && e.toString() === "[object FormData]"));
}, zI = Vr("URLSearchParams"), [MI, UI, BI, qI] = ["ReadableStream", "Request", "Response", "Headers"].map(Vr), HI = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ls(e, n, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Oa(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (os(e))
      return;
    const o = t ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function sj(e, n) {
  if (os(e))
    return null;
  n = n.toLowerCase();
  const t = Object.keys(e);
  let i = t.length, a;
  for (; i-- > 0; )
    if (a = t[i], n === a.toLowerCase())
      return a;
  return null;
}
const Li = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, lj = (e) => !ja(e) && e !== Li;
function qf() {
  const { caseless: e, skipUndefined: n } = lj(this) && this || {}, t = {}, i = (a, o) => {
    const s = e && sj(t, o) || o;
    wl(t[s]) && wl(a) ? t[s] = qf(t[s], a) : wl(a) ? t[s] = qf({}, a) : Oa(a) ? t[s] = a.slice() : (!n || !ja(a)) && (t[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && ls(arguments[a], i);
  return t;
}
const WI = (e, n, t, { allOwnKeys: i } = {}) => (ls(n, (a, o) => {
  t && Zt(a) ? e[o] = rj(a, t) : e[o] = a;
}, { allOwnKeys: i }), e), KI = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), GI = (e, n, t, i) => {
  e.prototype = Object.create(n.prototype, i), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), t && Object.assign(e.prototype, t);
}, YI = (e, n, t, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = t !== !1 && Zh(e);
  } while (e && (!t || t(e, n)) && e !== Object.prototype);
  return n;
}, JI = (e, n, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= n.length;
  const i = e.indexOf(n, t);
  return i !== -1 && i === t;
}, QI = (e) => {
  if (!e) return null;
  if (Oa(e)) return e;
  let n = e.length;
  if (!oj(n)) return null;
  const t = new Array(n);
  for (; n-- > 0; )
    t[n] = e[n];
  return t;
}, XI = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Zh(Uint8Array)), ZI = (e, n) => {
  const i = (e && e[Sc]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, e$ = (e, n) => {
  let t;
  const i = [];
  for (; (t = e.exec(n)) !== null; )
    i.push(t);
  return i;
}, n$ = Vr("HTMLFormElement"), t$ = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, i, a) {
    return i.toUpperCase() + a;
  }
), Wy = (({ hasOwnProperty: e }) => (n, t) => e.call(n, t))(Object.prototype), r$ = Vr("RegExp"), cj = (e, n) => {
  const t = Object.getOwnPropertyDescriptors(e), i = {};
  ls(t, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, i$ = (e) => {
  cj(e, (n, t) => {
    if (Zt(e) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const i = e[t];
    if (Zt(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, a$ = (e, n) => {
  const t = {}, i = (a) => {
    a.forEach((o) => {
      t[o] = !0;
    });
  };
  return Oa(e) ? i(e) : i(String(e).split(n)), t;
}, o$ = () => {
}, s$ = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function l$(e) {
  return !!(e && Zt(e.append) && e[ij] === "FormData" && e[Sc]);
}
const c$ = (e) => {
  const n = new Array(10), t = (i, a) => {
    if (ss(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (os(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = Oa(i) ? [] : {};
        return ls(i, (s, l) => {
          const u = t(s, a + 1);
          !ja(u) && (o[l] = u);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return t(e, 0);
}, u$ = Vr("AsyncFunction"), d$ = (e) => e && (ss(e) || Zt(e)) && Zt(e.then) && Zt(e.catch), uj = ((e, n) => e ? setImmediate : n ? ((t, i) => (Li.addEventListener("message", ({ source: a, data: o }) => {
  a === Li && o === t && i.length && i.shift()();
}, !1), (a) => {
  i.push(a), Li.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(
  typeof setImmediate == "function",
  Zt(Li.postMessage)
), m$ = typeof queueMicrotask < "u" ? queueMicrotask.bind(Li) : typeof process < "u" && process.nextTick || uj, p$ = (e) => e != null && Zt(e[Sc]), ge = {
  isArray: Oa,
  isArrayBuffer: aj,
  isBuffer: os,
  isFormData: VI,
  isArrayBufferView: $I,
  isString: EI,
  isNumber: oj,
  isBoolean: TI,
  isObject: ss,
  isPlainObject: wl,
  isEmptyObject: OI,
  isReadableStream: MI,
  isRequest: UI,
  isResponse: BI,
  isHeaders: qI,
  isUndefined: ja,
  isDate: RI,
  isFile: DI,
  isBlob: PI,
  isRegExp: r$,
  isFunction: Zt,
  isStream: LI,
  isURLSearchParams: zI,
  isTypedArray: XI,
  isFileList: AI,
  forEach: ls,
  merge: qf,
  extend: WI,
  trim: HI,
  stripBOM: KI,
  inherits: GI,
  toFlatObject: YI,
  kindOf: Nc,
  kindOfTest: Vr,
  endsWith: JI,
  toArray: QI,
  forEachEntry: ZI,
  matchAll: e$,
  isHTMLForm: n$,
  hasOwnProperty: Wy,
  hasOwnProp: Wy,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: cj,
  freezeMethods: i$,
  toObjectSet: a$,
  toCamelCase: t$,
  noop: o$,
  toFiniteNumber: s$,
  findKey: sj,
  global: Li,
  isContextDefined: lj,
  isSpecCompliantForm: l$,
  toJSONObject: c$,
  isAsyncFn: u$,
  isThenable: d$,
  setImmediate: uj,
  asap: m$,
  isIterable: p$
};
function Fn(e, n, t, i, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), t && (this.config = t), i && (this.request = i), a && (this.response = a, this.status = a.status ? a.status : null);
}
ge.inherits(Fn, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ge.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const dj = Fn.prototype, mj = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  mj[e] = { value: e };
});
Object.defineProperties(Fn, mj);
Object.defineProperty(dj, "isAxiosError", { value: !0 });
Fn.from = (e, n, t, i, a, o) => {
  const s = Object.create(dj);
  ge.toFlatObject(e, s, function(d) {
    return d !== Error.prototype;
  }, (m) => m !== "isAxiosError");
  const l = e && e.message ? e.message : "Error", u = n == null && e ? e.code : n;
  return Fn.call(s, l, u, t, i, a), e && s.cause == null && Object.defineProperty(s, "cause", { value: e, configurable: !0 }), s.name = e && e.name || "Error", o && Object.assign(s, o), s;
};
const f$ = null;
function Hf(e) {
  return ge.isPlainObject(e) || ge.isArray(e);
}
function pj(e) {
  return ge.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Ky(e, n, t) {
  return e ? e.concat(n).map(function(a, o) {
    return a = pj(a), !t && o ? "[" + a + "]" : a;
  }).join(t ? "." : "") : n;
}
function h$(e) {
  return ge.isArray(e) && !e.some(Hf);
}
const v$ = ge.toFlatObject(ge, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function wc(e, n, t) {
  if (!ge.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), t = ge.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(S, j) {
    return !ge.isUndefined(j[S]);
  });
  const i = t.metaTokens, a = t.visitor || d, o = t.dots, s = t.indexes, u = (t.Blob || typeof Blob < "u" && Blob) && ge.isSpecCompliantForm(n);
  if (!ge.isFunction(a))
    throw new TypeError("visitor must be a function");
  function m(x) {
    if (x === null) return "";
    if (ge.isDate(x))
      return x.toISOString();
    if (ge.isBoolean(x))
      return x.toString();
    if (!u && ge.isBlob(x))
      throw new Fn("Blob is not supported. Use a Buffer instead.");
    return ge.isArrayBuffer(x) || ge.isTypedArray(x) ? u && typeof Blob == "function" ? new Blob([x]) : Buffer.from(x) : x;
  }
  function d(x, S, j) {
    let w = x;
    if (x && !j && typeof x == "object") {
      if (ge.endsWith(S, "{}"))
        S = i ? S : S.slice(0, -2), x = JSON.stringify(x);
      else if (ge.isArray(x) && h$(x) || (ge.isFileList(x) || ge.endsWith(S, "[]")) && (w = ge.toArray(x)))
        return S = pj(S), w.forEach(function(q, T) {
          !(ge.isUndefined(q) || q === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Ky([S], T, o) : s === null ? S : S + "[]",
            m(q)
          );
        }), !1;
    }
    return Hf(x) ? !0 : (n.append(Ky(j, S, o), m(x)), !1);
  }
  const f = [], h = Object.assign(v$, {
    defaultVisitor: d,
    convertValue: m,
    isVisitable: Hf
  });
  function y(x, S) {
    if (!ge.isUndefined(x)) {
      if (f.indexOf(x) !== -1)
        throw Error("Circular reference detected in " + S.join("."));
      f.push(x), ge.forEach(x, function(w, v) {
        (!(ge.isUndefined(w) || w === null) && a.call(
          n,
          w,
          ge.isString(v) ? v.trim() : v,
          S,
          h
        )) === !0 && y(w, S ? S.concat(v) : [v]);
      }), f.pop();
    }
  }
  if (!ge.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), n;
}
function Gy(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(i) {
    return n[i];
  });
}
function ev(e, n) {
  this._pairs = [], e && wc(e, this, n);
}
const fj = ev.prototype;
fj.append = function(n, t) {
  this._pairs.push([n, t]);
};
fj.toString = function(n) {
  const t = n ? function(i) {
    return n.call(this, i, Gy);
  } : Gy;
  return this._pairs.map(function(a) {
    return t(a[0]) + "=" + t(a[1]);
  }, "").join("&");
};
function y$(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function hj(e, n, t) {
  if (!n)
    return e;
  const i = t && t.encode || y$;
  ge.isFunction(t) && (t = {
    serialize: t
  });
  const a = t && t.serialize;
  let o;
  if (a ? o = a(n, t) : o = ge.isURLSearchParams(n) ? n.toString() : new ev(n, t).toString(i), o) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class Yy {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, t, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: t,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ge.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const vj = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, g$ = typeof URLSearchParams < "u" ? URLSearchParams : ev, k$ = typeof FormData < "u" ? FormData : null, b$ = typeof Blob < "u" ? Blob : null, _$ = {
  isBrowser: !0,
  classes: {
    URLSearchParams: g$,
    FormData: k$,
    Blob: b$
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, nv = typeof window < "u" && typeof document < "u", Wf = typeof navigator == "object" && navigator || void 0, x$ = nv && (!Wf || ["ReactNative", "NativeScript", "NS"].indexOf(Wf.product) < 0), S$ = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", N$ = nv && window.location.href || "http://localhost", j$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: nv,
  hasStandardBrowserEnv: x$,
  hasStandardBrowserWebWorkerEnv: S$,
  navigator: Wf,
  origin: N$
}, Symbol.toStringTag, { value: "Module" })), Dt = {
  ...j$,
  ..._$
};
function w$(e, n) {
  return wc(e, new Dt.classes.URLSearchParams(), {
    visitor: function(t, i, a, o) {
      return Dt.isNode && ge.isBuffer(t) ? (this.append(i, t.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function C$(e) {
  return ge.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function F$(e) {
  const n = {}, t = Object.keys(e);
  let i;
  const a = t.length;
  let o;
  for (i = 0; i < a; i++)
    o = t[i], n[o] = e[o];
  return n;
}
function yj(e) {
  function n(t, i, a, o) {
    let s = t[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), u = o >= t.length;
    return s = !s && ge.isArray(a) ? a.length : s, u ? (ge.hasOwnProp(a, s) ? a[s] = [a[s], i] : a[s] = i, !l) : ((!a[s] || !ge.isObject(a[s])) && (a[s] = []), n(t, i, a[s], o) && ge.isArray(a[s]) && (a[s] = F$(a[s])), !l);
  }
  if (ge.isFormData(e) && ge.isFunction(e.entries)) {
    const t = {};
    return ge.forEachEntry(e, (i, a) => {
      n(C$(i), a, t, 0);
    }), t;
  }
  return null;
}
function I$(e, n, t) {
  if (ge.isString(e))
    try {
      return (n || JSON.parse)(e), ge.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (t || JSON.stringify)(e);
}
const cs = {
  transitional: vj,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(n, t) {
    const i = t.getContentType() || "", a = i.indexOf("application/json") > -1, o = ge.isObject(n);
    if (o && ge.isHTMLForm(n) && (n = new FormData(n)), ge.isFormData(n))
      return a ? JSON.stringify(yj(n)) : n;
    if (ge.isArrayBuffer(n) || ge.isBuffer(n) || ge.isStream(n) || ge.isFile(n) || ge.isBlob(n) || ge.isReadableStream(n))
      return n;
    if (ge.isArrayBufferView(n))
      return n.buffer;
    if (ge.isURLSearchParams(n))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let l;
    if (o) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return w$(n, this.formSerializer).toString();
      if ((l = ge.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return wc(
          l ? { "files[]": n } : n,
          u && new u(),
          this.formSerializer
        );
      }
    }
    return o || a ? (t.setContentType("application/json", !1), I$(n)) : n;
  }],
  transformResponse: [function(n) {
    const t = this.transitional || cs.transitional, i = t && t.forcedJSONParsing, a = this.responseType === "json";
    if (ge.isResponse(n) || ge.isReadableStream(n))
      return n;
    if (n && ge.isString(n) && (i && !this.responseType || a)) {
      const s = !(t && t.silentJSONParsing) && a;
      try {
        return JSON.parse(n, this.parseReviver);
      } catch (l) {
        if (s)
          throw l.name === "SyntaxError" ? Fn.from(l, Fn.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Dt.classes.FormData,
    Blob: Dt.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ge.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  cs.headers[e] = {};
});
const $$ = ge.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), E$ = (e) => {
  const n = {};
  let t, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), t = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!t || n[t] && $$[t]) && (t === "set-cookie" ? n[t] ? n[t].push(i) : n[t] = [i] : n[t] = n[t] ? n[t] + ", " + i : i);
  }), n;
}, Jy = Symbol("internals");
function Xa(e) {
  return e && String(e).trim().toLowerCase();
}
function Cl(e) {
  return e === !1 || e == null ? e : ge.isArray(e) ? e.map(Cl) : String(e);
}
function T$(e) {
  const n = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = t.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const O$ = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function uu(e, n, t, i, a) {
  if (ge.isFunction(i))
    return i.call(this, n, t);
  if (a && (n = t), !!ge.isString(n)) {
    if (ge.isString(i))
      return n.indexOf(i) !== -1;
    if (ge.isRegExp(i))
      return i.test(n);
  }
}
function R$(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, t, i) => t.toUpperCase() + i);
}
function D$(e, n) {
  const t = ge.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + t, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let er = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, t, i) {
    const a = this;
    function o(l, u, m) {
      const d = Xa(u);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const f = ge.findKey(a, d);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || u] = Cl(l));
    }
    const s = (l, u) => ge.forEach(l, (m, d) => o(m, d, u));
    if (ge.isPlainObject(n) || n instanceof this.constructor)
      s(n, t);
    else if (ge.isString(n) && (n = n.trim()) && !O$(n))
      s(E$(n), t);
    else if (ge.isObject(n) && ge.isIterable(n)) {
      let l = {}, u, m;
      for (const d of n) {
        if (!ge.isArray(d))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = d[0]] = (u = l[m]) ? ge.isArray(u) ? [...u, d[1]] : [u, d[1]] : d[1];
      }
      s(l, t);
    } else
      n != null && o(t, n, i);
    return this;
  }
  get(n, t) {
    if (n = Xa(n), n) {
      const i = ge.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!t)
          return a;
        if (t === !0)
          return T$(a);
        if (ge.isFunction(t))
          return t.call(this, a, i);
        if (ge.isRegExp(t))
          return t.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, t) {
    if (n = Xa(n), n) {
      const i = ge.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!t || uu(this, this[i], i, t)));
    }
    return !1;
  }
  delete(n, t) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Xa(s), s) {
        const l = ge.findKey(i, s);
        l && (!t || uu(i, i[l], l, t)) && (delete i[l], a = !0);
      }
    }
    return ge.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const t = Object.keys(this);
    let i = t.length, a = !1;
    for (; i--; ) {
      const o = t[i];
      (!n || uu(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const t = this, i = {};
    return ge.forEach(this, (a, o) => {
      const s = ge.findKey(i, o);
      if (s) {
        t[s] = Cl(a), delete t[o];
        return;
      }
      const l = n ? R$(o) : String(o).trim();
      l !== o && delete t[o], t[l] = Cl(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const t = /* @__PURE__ */ Object.create(null);
    return ge.forEach(this, (i, a) => {
      i != null && i !== !1 && (t[a] = n && ge.isArray(i) ? i.join(", ") : i);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, t]) => n + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...t) {
    const i = new this(n);
    return t.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[Jy] = this[Jy] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Xa(s);
      i[l] || (D$(a, s), i[l] = !0);
    }
    return ge.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
er.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ge.reduceDescriptors(er.prototype, ({ value: e }, n) => {
  let t = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[t] = i;
    }
  };
});
ge.freezeMethods(er);
function du(e, n) {
  const t = this || cs, i = n || t, a = er.from(i.headers);
  let o = i.data;
  return ge.forEach(e, function(l) {
    o = l.call(t, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function gj(e) {
  return !!(e && e.__CANCEL__);
}
function Ra(e, n, t) {
  Fn.call(this, e ?? "canceled", Fn.ERR_CANCELED, n, t), this.name = "CanceledError";
}
ge.inherits(Ra, Fn, {
  __CANCEL__: !0
});
function kj(e, n, t) {
  const i = t.config.validateStatus;
  !t.status || !i || i(t.status) ? e(t) : n(new Fn(
    "Request failed with status code " + t.status,
    [Fn.ERR_BAD_REQUEST, Fn.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
function P$(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function A$(e, n) {
  e = e || 10;
  const t = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(u) {
    const m = Date.now(), d = i[o];
    s || (s = m), t[a] = u, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += t[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const y = d && m - d;
    return y ? Math.round(h * 1e3 / y) : void 0;
  };
}
function L$(e, n) {
  let t = 0, i = 1e3 / n, a, o;
  const s = (m, d = Date.now()) => {
    t = d, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const d = Date.now(), f = d - t;
    f >= i ? s(m, d) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const Hl = (e, n, t = 3) => {
  let i = 0;
  const a = A$(50, 250);
  return L$((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, u = s - i, m = a(u), d = s <= l;
    i = s;
    const f = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: u,
      rate: m || void 0,
      estimated: m && l && d ? (l - s) / m : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, t);
}, Qy = (e, n) => {
  const t = e != null;
  return [(i) => n[0]({
    lengthComputable: t,
    total: e,
    loaded: i
  }), n[1]];
}, Xy = (e) => (...n) => ge.asap(() => e(...n)), V$ = Dt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (t) => (t = new URL(t, Dt.origin), e.protocol === t.protocol && e.host === t.host && (n || e.port === t.port)))(
  new URL(Dt.origin),
  Dt.navigator && /(msie|trident)/i.test(Dt.navigator.userAgent)
) : () => !0, z$ = Dt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, t, i, a, o) {
      const s = [e + "=" + encodeURIComponent(n)];
      ge.isNumber(t) && s.push("expires=" + new Date(t).toGMTString()), ge.isString(i) && s.push("path=" + i), ge.isString(a) && s.push("domain=" + a), o === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function M$(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function U$(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function bj(e, n, t) {
  let i = !M$(n);
  return e && (i || t == !1) ? U$(e, n) : n;
}
const Zy = (e) => e instanceof er ? { ...e } : e;
function Ki(e, n) {
  n = n || {};
  const t = {};
  function i(m, d, f, h) {
    return ge.isPlainObject(m) && ge.isPlainObject(d) ? ge.merge.call({ caseless: h }, m, d) : ge.isPlainObject(d) ? ge.merge({}, d) : ge.isArray(d) ? d.slice() : d;
  }
  function a(m, d, f, h) {
    if (ge.isUndefined(d)) {
      if (!ge.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, d, f, h);
  }
  function o(m, d) {
    if (!ge.isUndefined(d))
      return i(void 0, d);
  }
  function s(m, d) {
    if (ge.isUndefined(d)) {
      if (!ge.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, d);
  }
  function l(m, d, f) {
    if (f in n)
      return i(m, d);
    if (f in e)
      return i(void 0, m);
  }
  const u = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, d, f) => a(Zy(m), Zy(d), f, !0)
  };
  return ge.forEach(Object.keys({ ...e, ...n }), function(d) {
    const f = u[d] || a, h = f(e[d], n[d], d);
    ge.isUndefined(h) && f !== l || (t[d] = h);
  }), t;
}
const _j = (e) => {
  const n = Ki({}, e);
  let { data: t, withXSRFToken: i, xsrfHeaderName: a, xsrfCookieName: o, headers: s, auth: l } = n;
  if (n.headers = s = er.from(s), n.url = hj(bj(n.baseURL, n.url, n.allowAbsoluteUrls), e.params, e.paramsSerializer), l && s.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  ), ge.isFormData(t)) {
    if (Dt.hasStandardBrowserEnv || Dt.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if (ge.isFunction(t.getHeaders)) {
      const u = t.getHeaders(), m = ["content-type", "content-length"];
      Object.entries(u).forEach(([d, f]) => {
        m.includes(d.toLowerCase()) && s.set(d, f);
      });
    }
  }
  if (Dt.hasStandardBrowserEnv && (i && ge.isFunction(i) && (i = i(n)), i || i !== !1 && V$(n.url))) {
    const u = a && o && z$.read(o);
    u && s.set(a, u);
  }
  return n;
}, B$ = typeof XMLHttpRequest < "u", q$ = B$ && function(e) {
  return new Promise(function(t, i) {
    const a = _j(e);
    let o = a.data;
    const s = er.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: u, onDownloadProgress: m } = a, d, f, h, y, x;
    function S() {
      y && y(), x && x(), a.cancelToken && a.cancelToken.unsubscribe(d), a.signal && a.signal.removeEventListener("abort", d);
    }
    let j = new XMLHttpRequest();
    j.open(a.method.toUpperCase(), a.url, !0), j.timeout = a.timeout;
    function w() {
      if (!j)
        return;
      const q = er.from(
        "getAllResponseHeaders" in j && j.getAllResponseHeaders()
      ), I = {
        data: !l || l === "text" || l === "json" ? j.responseText : j.response,
        status: j.status,
        statusText: j.statusText,
        headers: q,
        config: e,
        request: j
      };
      kj(function(U) {
        t(U), S();
      }, function(U) {
        i(U), S();
      }, I), j = null;
    }
    "onloadend" in j ? j.onloadend = w : j.onreadystatechange = function() {
      !j || j.readyState !== 4 || j.status === 0 && !(j.responseURL && j.responseURL.indexOf("file:") === 0) || setTimeout(w);
    }, j.onabort = function() {
      j && (i(new Fn("Request aborted", Fn.ECONNABORTED, e, j)), j = null);
    }, j.onerror = function(T) {
      const I = T && T.message ? T.message : "Network Error", O = new Fn(I, Fn.ERR_NETWORK, e, j);
      O.event = T || null, i(O), j = null;
    }, j.ontimeout = function() {
      let T = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const I = a.transitional || vj;
      a.timeoutErrorMessage && (T = a.timeoutErrorMessage), i(new Fn(
        T,
        I.clarifyTimeoutError ? Fn.ETIMEDOUT : Fn.ECONNABORTED,
        e,
        j
      )), j = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in j && ge.forEach(s.toJSON(), function(T, I) {
      j.setRequestHeader(I, T);
    }), ge.isUndefined(a.withCredentials) || (j.withCredentials = !!a.withCredentials), l && l !== "json" && (j.responseType = a.responseType), m && ([h, x] = Hl(m, !0), j.addEventListener("progress", h)), u && j.upload && ([f, y] = Hl(u), j.upload.addEventListener("progress", f), j.upload.addEventListener("loadend", y)), (a.cancelToken || a.signal) && (d = (q) => {
      j && (i(!q || q.type ? new Ra(null, e, j) : q), j.abort(), j = null);
    }, a.cancelToken && a.cancelToken.subscribe(d), a.signal && (a.signal.aborted ? d() : a.signal.addEventListener("abort", d)));
    const v = P$(a.url);
    if (v && Dt.protocols.indexOf(v) === -1) {
      i(new Fn("Unsupported protocol " + v + ":", Fn.ERR_BAD_REQUEST, e));
      return;
    }
    j.send(o || null);
  });
}, H$ = (e, n) => {
  const { length: t } = e = e ? e.filter(Boolean) : [];
  if (n || t) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const d = m instanceof Error ? m : this.reason;
        i.abort(d instanceof Fn ? d : new Ra(d instanceof Error ? d.message : d));
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new Fn(`timeout ${n} of ms exceeded`, Fn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: u } = i;
    return u.unsubscribe = () => ge.asap(l), u;
  }
}, W$ = function* (e, n) {
  let t = e.byteLength;
  if (t < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < t; )
    a = i + n, yield e.slice(i, a), i = a;
}, K$ = async function* (e, n) {
  for await (const t of G$(e))
    yield* W$(t, n);
}, G$ = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: t, value: i } = await n.read();
      if (t)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, eg = (e, n, t, i) => {
  const a = K$(e, n);
  let o = 0, s, l = (u) => {
    s || (s = !0, i && i(u));
  };
  return new ReadableStream({
    async pull(u) {
      try {
        const { done: m, value: d } = await a.next();
        if (m) {
          l(), u.close();
          return;
        }
        let f = d.byteLength;
        if (t) {
          let h = o += f;
          t(h);
        }
        u.enqueue(new Uint8Array(d));
      } catch (m) {
        throw l(m), m;
      }
    },
    cancel(u) {
      return l(u), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, ng = 64 * 1024, { isFunction: Ds } = ge, Y$ = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ge.global), {
  ReadableStream: tg,
  TextEncoder: rg
} = ge.global, ig = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, J$ = (e) => {
  e = ge.merge.call({
    skipUndefined: !0
  }, Y$, e);
  const { fetch: n, Request: t, Response: i } = e, a = n ? Ds(n) : typeof fetch == "function", o = Ds(t), s = Ds(i);
  if (!a)
    return !1;
  const l = a && Ds(tg), u = a && (typeof rg == "function" ? /* @__PURE__ */ ((x) => (S) => x.encode(S))(new rg()) : async (x) => new Uint8Array(await new t(x).arrayBuffer())), m = o && l && ig(() => {
    let x = !1;
    const S = new t(Dt.origin, {
      body: new tg(),
      method: "POST",
      get duplex() {
        return x = !0, "half";
      }
    }).headers.has("Content-Type");
    return x && !S;
  }), d = s && l && ig(() => ge.isReadableStream(new i("").body)), f = {
    stream: d && ((x) => x.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((x) => {
    !f[x] && (f[x] = (S, j) => {
      let w = S && S[x];
      if (w)
        return w.call(S);
      throw new Fn(`Response type '${x}' is not supported`, Fn.ERR_NOT_SUPPORT, j);
    });
  });
  const h = async (x) => {
    if (x == null)
      return 0;
    if (ge.isBlob(x))
      return x.size;
    if (ge.isSpecCompliantForm(x))
      return (await new t(Dt.origin, {
        method: "POST",
        body: x
      }).arrayBuffer()).byteLength;
    if (ge.isArrayBufferView(x) || ge.isArrayBuffer(x))
      return x.byteLength;
    if (ge.isURLSearchParams(x) && (x = x + ""), ge.isString(x))
      return (await u(x)).byteLength;
  }, y = async (x, S) => {
    const j = ge.toFiniteNumber(x.getContentLength());
    return j ?? h(S);
  };
  return async (x) => {
    let {
      url: S,
      method: j,
      data: w,
      signal: v,
      cancelToken: q,
      timeout: T,
      onDownloadProgress: I,
      onUploadProgress: O,
      responseType: U,
      headers: Z,
      withCredentials: Q = "same-origin",
      fetchOptions: ee
    } = _j(x), J = n || fetch;
    U = U ? (U + "").toLowerCase() : "text";
    let G = H$([v, q && q.toAbortSignal()], T), P = null;
    const K = G && G.unsubscribe && (() => {
      G.unsubscribe();
    });
    let ne;
    try {
      if (O && m && j !== "get" && j !== "head" && (ne = await y(Z, w)) !== 0) {
        let ke = new t(S, {
          method: "POST",
          body: w,
          duplex: "half"
        }), Ce;
        if (ge.isFormData(w) && (Ce = ke.headers.get("content-type")) && Z.setContentType(Ce), ke.body) {
          const [W, Be] = Qy(
            ne,
            Hl(Xy(O))
          );
          w = eg(ke.body, ng, W, Be);
        }
      }
      ge.isString(Q) || (Q = Q ? "include" : "omit");
      const pe = o && "credentials" in t.prototype, ye = {
        ...ee,
        signal: G,
        method: j.toUpperCase(),
        headers: Z.normalize().toJSON(),
        body: w,
        duplex: "half",
        credentials: pe ? Q : void 0
      };
      P = o && new t(S, ye);
      let ue = await (o ? J(P, ee) : J(S, ye));
      const ve = d && (U === "stream" || U === "response");
      if (d && (I || ve && K)) {
        const ke = {};
        ["status", "statusText", "headers"].forEach((Me) => {
          ke[Me] = ue[Me];
        });
        const Ce = ge.toFiniteNumber(ue.headers.get("content-length")), [W, Be] = I && Qy(
          Ce,
          Hl(Xy(I), !0)
        ) || [];
        ue = new i(
          eg(ue.body, ng, W, () => {
            Be && Be(), K && K();
          }),
          ke
        );
      }
      U = U || "text";
      let H = await f[ge.findKey(f, U) || "text"](ue, x);
      return !ve && K && K(), await new Promise((ke, Ce) => {
        kj(ke, Ce, {
          data: H,
          headers: er.from(ue.headers),
          status: ue.status,
          statusText: ue.statusText,
          config: x,
          request: P
        });
      });
    } catch (pe) {
      throw K && K(), pe && pe.name === "TypeError" && /Load failed|fetch/i.test(pe.message) ? Object.assign(
        new Fn("Network Error", Fn.ERR_NETWORK, x, P),
        {
          cause: pe.cause || pe
        }
      ) : Fn.from(pe, pe && pe.code, x, P);
    }
  };
}, Q$ = /* @__PURE__ */ new Map(), xj = (e) => {
  let n = e ? e.env : {};
  const { fetch: t, Request: i, Response: a } = n, o = [
    i,
    a,
    t
  ];
  let s = o.length, l = s, u, m, d = Q$;
  for (; l--; )
    u = o[l], m = d.get(u), m === void 0 && d.set(u, m = l ? /* @__PURE__ */ new Map() : J$(n)), d = m;
  return m;
};
xj();
const Kf = {
  http: f$,
  xhr: q$,
  fetch: {
    get: xj
  }
};
ge.forEach(Kf, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const ag = (e) => `- ${e}`, X$ = (e) => ge.isFunction(e) || e === null || e === !1, Sj = {
  getAdapter: (e, n) => {
    e = ge.isArray(e) ? e : [e];
    const { length: t } = e;
    let i, a;
    const o = {};
    for (let s = 0; s < t; s++) {
      i = e[s];
      let l;
      if (a = i, !X$(i) && (a = Kf[(l = String(i)).toLowerCase()], a === void 0))
        throw new Fn(`Unknown adapter '${l}'`);
      if (a && (ge.isFunction(a) || (a = a.get(n))))
        break;
      o[l || "#" + s] = a;
    }
    if (!a) {
      const s = Object.entries(o).map(
        ([u, m]) => `adapter ${u} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = t ? s.length > 1 ? `since :
` + s.map(ag).join(`
`) : " " + ag(s[0]) : "as no adapter specified";
      throw new Fn(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return a;
  },
  adapters: Kf
};
function mu(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ra(null, e);
}
function og(e) {
  return mu(e), e.headers = er.from(e.headers), e.data = du.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Sj.getAdapter(e.adapter || cs.adapter, e)(e).then(function(i) {
    return mu(e), i.data = du.call(
      e,
      e.transformResponse,
      i
    ), i.headers = er.from(i.headers), i;
  }, function(i) {
    return gj(i) || (mu(e), i && i.response && (i.response.data = du.call(
      e,
      e.transformResponse,
      i.response
    ), i.response.headers = er.from(i.response.headers))), Promise.reject(i);
  });
}
const Nj = "1.12.2", Cc = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Cc[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const sg = {};
Cc.transitional = function(n, t, i) {
  function a(o, s) {
    return "[Axios v" + Nj + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new Fn(
        a(s, " has been removed" + (t ? " in " + t : "")),
        Fn.ERR_DEPRECATED
      );
    return t && !sg[s] && (sg[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Cc.spelling = function(n) {
  return (t, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function Z$(e, n, t) {
  if (typeof e != "object")
    throw new Fn("options must be an object", Fn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = n[o];
    if (s) {
      const l = e[o], u = l === void 0 || s(l, o, e);
      if (u !== !0)
        throw new Fn("option " + o + " must be " + u, Fn.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new Fn("Unknown option " + o, Fn.ERR_BAD_OPTION);
  }
}
const Fl = {
  assertOptions: Z$,
  validators: Cc
}, Ur = Fl.validators;
let Ui = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new Yy(),
      response: new Yy()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, t) {
    try {
      return await this._request(n, t);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          i.stack ? o && !String(i.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (i.stack += `
` + o) : i.stack = o;
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, t) {
    typeof n == "string" ? (t = t || {}, t.url = n) : t = n || {}, t = Ki(this.defaults, t);
    const { transitional: i, paramsSerializer: a, headers: o } = t;
    i !== void 0 && Fl.assertOptions(i, {
      silentJSONParsing: Ur.transitional(Ur.boolean),
      forcedJSONParsing: Ur.transitional(Ur.boolean),
      clarifyTimeoutError: Ur.transitional(Ur.boolean)
    }, !1), a != null && (ge.isFunction(a) ? t.paramsSerializer = {
      serialize: a
    } : Fl.assertOptions(a, {
      encode: Ur.function,
      serialize: Ur.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), Fl.assertOptions(t, {
      baseUrl: Ur.spelling("baseURL"),
      withXsrfToken: Ur.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let s = o && ge.merge(
      o.common,
      o[t.method]
    );
    o && ge.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (x) => {
        delete o[x];
      }
    ), t.headers = er.concat(s, o);
    const l = [];
    let u = !0;
    this.interceptors.request.forEach(function(S) {
      typeof S.runWhen == "function" && S.runWhen(t) === !1 || (u = u && S.synchronous, l.unshift(S.fulfilled, S.rejected));
    });
    const m = [];
    this.interceptors.response.forEach(function(S) {
      m.push(S.fulfilled, S.rejected);
    });
    let d, f = 0, h;
    if (!u) {
      const x = [og.bind(this), void 0];
      for (x.unshift(...l), x.push(...m), h = x.length, d = Promise.resolve(t); f < h; )
        d = d.then(x[f++], x[f++]);
      return d;
    }
    h = l.length;
    let y = t;
    for (; f < h; ) {
      const x = l[f++], S = l[f++];
      try {
        y = x(y);
      } catch (j) {
        S.call(this, j);
        break;
      }
    }
    try {
      d = og.call(this, y);
    } catch (x) {
      return Promise.reject(x);
    }
    for (f = 0, h = m.length; f < h; )
      d = d.then(m[f++], m[f++]);
    return d;
  }
  getUri(n) {
    n = Ki(this.defaults, n);
    const t = bj(n.baseURL, n.url, n.allowAbsoluteUrls);
    return hj(t, n.params, n.paramsSerializer);
  }
};
ge.forEach(["delete", "get", "head", "options"], function(n) {
  Ui.prototype[n] = function(t, i) {
    return this.request(Ki(i || {}, {
      method: n,
      url: t,
      data: (i || {}).data
    }));
  };
});
ge.forEach(["post", "put", "patch"], function(n) {
  function t(i) {
    return function(o, s, l) {
      return this.request(Ki(l || {}, {
        method: n,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: s
      }));
    };
  }
  Ui.prototype[n] = t(), Ui.prototype[n + "Form"] = t(!0);
});
let eE = class jj {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(o) {
      t = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new Ra(o, s, l), t(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(n);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), t = (i) => {
      n.abort(i);
    };
    return this.subscribe(t), n.signal.unsubscribe = () => this.unsubscribe(t), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new jj(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function nE(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function tE(e) {
  return ge.isObject(e) && e.isAxiosError === !0;
}
const Gf = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Gf).forEach(([e, n]) => {
  Gf[n] = e;
});
function wj(e) {
  const n = new Ui(e), t = rj(Ui.prototype.request, n);
  return ge.extend(t, Ui.prototype, n, { allOwnKeys: !0 }), ge.extend(t, n, null, { allOwnKeys: !0 }), t.create = function(a) {
    return wj(Ki(e, a));
  }, t;
}
const dt = wj(cs);
dt.Axios = Ui;
dt.CanceledError = Ra;
dt.CancelToken = eE;
dt.isCancel = gj;
dt.VERSION = Nj;
dt.toFormData = wc;
dt.AxiosError = Fn;
dt.Cancel = dt.CanceledError;
dt.all = function(n) {
  return Promise.all(n);
};
dt.spread = nE;
dt.isAxiosError = tE;
dt.mergeConfig = Ki;
dt.AxiosHeaders = er;
dt.formToJSON = (e) => yj(ge.isHTMLForm(e) ? new FormData(e) : e);
dt.getAdapter = Sj.getAdapter;
dt.HttpStatusCode = Gf;
dt.default = dt;
const {
  Axios: Cte,
  AxiosError: Fte,
  CanceledError: Ite,
  isCancel: $te,
  CancelToken: Ete,
  VERSION: Tte,
  all: Ote,
  Cancel: Rte,
  isAxiosError: rE,
  spread: Dte,
  toFormData: Pte,
  AxiosHeaders: Ate,
  HttpStatusCode: Lte,
  formToJSON: Vte,
  getAdapter: zte,
  mergeConfig: Mte
} = dt;
var pu = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function iE(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ps = function(e) {
  return e && e.Math === Math && e;
}, _t = (
  // eslint-disable-next-line es/no-global-this -- safe
  Ps(typeof globalThis == "object" && globalThis) || Ps(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Ps(typeof self == "object" && self) || Ps(typeof pu == "object" && pu) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || pu || Function("return this")()
), mt = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, aE = mt, Fc = !aE(function() {
  var e = (function() {
  }).bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), oE = Fc, Cj = Function.prototype, lg = Cj.apply, cg = Cj.call, tv = typeof Reflect == "object" && Reflect.apply || (oE ? cg.bind(lg) : function() {
  return cg.apply(lg, arguments);
}), Fj = Fc, Ij = Function.prototype, Yf = Ij.call, sE = Fj && Ij.bind.bind(Yf, Yf), xt = Fj ? sE : function(e) {
  return function() {
    return Yf.apply(e, arguments);
  };
}, $j = xt, lE = $j({}.toString), cE = $j("".slice), Yi = function(e) {
  return cE(lE(e), 8, -1);
}, uE = Yi, dE = xt, rv = function(e) {
  if (uE(e) === "Function") return dE(e);
}, Jf = typeof document == "object" && document.all, mE = typeof Jf > "u" && Jf !== void 0, Ej = {
  all: Jf,
  IS_HTMLDDA: mE
}, Tj = Ej, pE = Tj.all, yt = Tj.IS_HTMLDDA ? function(e) {
  return typeof e == "function" || e === pE;
} : function(e) {
  return typeof e == "function";
}, Da = {}, fE = mt, dr = !fE(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), hE = Fc, As = Function.prototype.call, Rt = hE ? As.bind(As) : function() {
  return As.apply(As, arguments);
}, Ic = {}, Oj = {}.propertyIsEnumerable, Rj = Object.getOwnPropertyDescriptor, vE = Rj && !Oj.call({ 1: 2 }, 1);
Ic.f = vE ? function(n) {
  var t = Rj(this, n);
  return !!t && t.enumerable;
} : Oj;
var Ji = function(e, n) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: n
  };
}, yE = xt, gE = mt, kE = Yi, fu = Object, bE = yE("".split), iv = gE(function() {
  return !fu("z").propertyIsEnumerable(0);
}) ? function(e) {
  return kE(e) === "String" ? bE(e, "") : fu(e);
} : fu, $c = function(e) {
  return e == null;
}, _E = $c, xE = TypeError, av = function(e) {
  if (_E(e)) throw xE("Can't call method on " + e);
  return e;
}, SE = iv, NE = av, pi = function(e) {
  return SE(NE(e));
}, ug = yt, Dj = Ej, jE = Dj.all, kr = Dj.IS_HTMLDDA ? function(e) {
  return typeof e == "object" ? e !== null : ug(e) || e === jE;
} : function(e) {
  return typeof e == "object" ? e !== null : ug(e);
}, br = {}, hu = br, vu = _t, wE = yt, dg = function(e) {
  return wE(e) ? e : void 0;
}, _r = function(e, n) {
  return arguments.length < 2 ? dg(hu[e]) || dg(vu[e]) : hu[e] && hu[e][n] || vu[e] && vu[e][n];
}, CE = xt, us = CE({}.isPrototypeOf), Ec = typeof navigator < "u" && String(navigator.userAgent) || "", Pj = _t, yu = Ec, mg = Pj.process, pg = Pj.Deno, fg = mg && mg.versions || pg && pg.version, hg = fg && fg.v8, Cr, Wl;
hg && (Cr = hg.split("."), Wl = Cr[0] > 0 && Cr[0] < 4 ? 1 : +(Cr[0] + Cr[1]));
!Wl && yu && (Cr = yu.match(/Edge\/(\d+)/), (!Cr || Cr[1] >= 74) && (Cr = yu.match(/Chrome\/(\d+)/), Cr && (Wl = +Cr[1])));
var Tc = Wl, vg = Tc, FE = mt, IE = _t, $E = IE.String, Pa = !!Object.getOwnPropertySymbols && !FE(function() {
  var e = Symbol("symbol detection");
  return !$E(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && vg && vg < 41;
}), EE = Pa, Aj = EE && !Symbol.sham && typeof Symbol.iterator == "symbol", TE = _r, OE = yt, RE = us, DE = Aj, PE = Object, Oc = DE ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var n = TE("Symbol");
  return OE(n) && RE(n.prototype, PE(e));
}, AE = String, ds = function(e) {
  try {
    return AE(e);
  } catch {
    return "Object";
  }
}, LE = yt, VE = ds, zE = TypeError, ni = function(e) {
  if (LE(e)) return e;
  throw zE(VE(e) + " is not a function");
}, ME = ni, UE = $c, ov = function(e, n) {
  var t = e[n];
  return UE(t) ? void 0 : ME(t);
}, gu = Rt, ku = yt, bu = kr, BE = TypeError, qE = function(e, n) {
  var t, i;
  if (n === "string" && ku(t = e.toString) && !bu(i = gu(t, e)) || ku(t = e.valueOf) && !bu(i = gu(t, e)) || n !== "string" && ku(t = e.toString) && !bu(i = gu(t, e))) return i;
  throw BE("Can't convert object to primitive value");
}, Lj = { exports: {} }, HE = !0, yg = _t, WE = Object.defineProperty, KE = function(e, n) {
  try {
    WE(yg, e, { value: n, configurable: !0, writable: !0 });
  } catch {
    yg[e] = n;
  }
  return n;
}, GE = _t, YE = KE, gg = "__core-js_shared__", JE = GE[gg] || YE(gg, {}), sv = JE, kg = sv;
(Lj.exports = function(e, n) {
  return kg[e] || (kg[e] = n !== void 0 ? n : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var ms = Lj.exports, QE = av, XE = Object, Aa = function(e) {
  return XE(QE(e));
}, ZE = xt, eT = Aa, nT = ZE({}.hasOwnProperty), rr = Object.hasOwn || function(n, t) {
  return nT(eT(n), t);
}, tT = xt, rT = 0, iT = Math.random(), aT = tT(1 .toString), lv = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + aT(++rT + iT, 36);
}, oT = _t, sT = ms, bg = rr, lT = lv, cT = Pa, uT = Aj, ha = oT.Symbol, _u = sT("wks"), dT = uT ? ha.for || ha : ha && ha.withoutSetter || lT, pt = function(e) {
  return bg(_u, e) || (_u[e] = cT && bg(ha, e) ? ha[e] : dT("Symbol." + e)), _u[e];
}, mT = Rt, _g = kr, xg = Oc, pT = ov, fT = qE, hT = pt, vT = TypeError, yT = hT("toPrimitive"), gT = function(e, n) {
  if (!_g(e) || xg(e)) return e;
  var t = pT(e, yT), i;
  if (t) {
    if (n === void 0 && (n = "default"), i = mT(t, e, n), !_g(i) || xg(i)) return i;
    throw vT("Can't convert object to primitive value");
  }
  return n === void 0 && (n = "number"), fT(e, n);
}, kT = gT, bT = Oc, Rc = function(e) {
  var n = kT(e, "string");
  return bT(n) ? n : n + "";
}, _T = _t, Sg = kr, Qf = _T.document, xT = Sg(Qf) && Sg(Qf.createElement), cv = function(e) {
  return xT ? Qf.createElement(e) : {};
}, ST = dr, NT = mt, jT = cv, Vj = !ST && !NT(function() {
  return Object.defineProperty(jT("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), wT = dr, CT = Rt, FT = Ic, IT = Ji, $T = pi, ET = Rc, TT = rr, OT = Vj, Ng = Object.getOwnPropertyDescriptor;
Da.f = wT ? Ng : function(n, t) {
  if (n = $T(n), t = ET(t), OT) try {
    return Ng(n, t);
  } catch {
  }
  if (TT(n, t)) return IT(!CT(FT.f, n, t), n[t]);
};
var RT = mt, DT = yt, PT = /#|\.prototype\./, ps = function(e, n) {
  var t = LT[AT(e)];
  return t === zT ? !0 : t === VT ? !1 : DT(n) ? RT(n) : !!n;
}, AT = ps.normalize = function(e) {
  return String(e).replace(PT, ".").toLowerCase();
}, LT = ps.data = {}, VT = ps.NATIVE = "N", zT = ps.POLYFILL = "P", zj = ps, jg = rv, MT = ni, UT = Fc, BT = jg(jg.bind), fs = function(e, n) {
  return MT(e), n === void 0 ? e : UT ? BT(e, n) : function() {
    return e.apply(n, arguments);
  };
}, zr = {}, qT = dr, HT = mt, Mj = qT && HT(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), WT = kr, KT = String, GT = TypeError, Mr = function(e) {
  if (WT(e)) return e;
  throw GT(KT(e) + " is not an object");
}, YT = dr, JT = Vj, QT = Mj, Ls = Mr, wg = Rc, XT = TypeError, xu = Object.defineProperty, ZT = Object.getOwnPropertyDescriptor, Su = "enumerable", Nu = "configurable", ju = "writable";
zr.f = YT ? QT ? function(n, t, i) {
  if (Ls(n), t = wg(t), Ls(i), typeof n == "function" && t === "prototype" && "value" in i && ju in i && !i[ju]) {
    var a = ZT(n, t);
    a && a[ju] && (n[t] = i.value, i = {
      configurable: Nu in i ? i[Nu] : a[Nu],
      enumerable: Su in i ? i[Su] : a[Su],
      writable: !1
    });
  }
  return xu(n, t, i);
} : xu : function(n, t, i) {
  if (Ls(n), t = wg(t), Ls(i), JT) try {
    return xu(n, t, i);
  } catch {
  }
  if ("get" in i || "set" in i) throw XT("Accessors not supported");
  return "value" in i && (n[t] = i.value), n;
};
var eO = dr, nO = zr, tO = Ji, wi = eO ? function(e, n, t) {
  return nO.f(e, n, tO(1, t));
} : function(e, n, t) {
  return e[n] = t, e;
}, Vs = _t, rO = tv, iO = rv, aO = yt, oO = Da.f, sO = zj, na = br, lO = fs, ta = wi, Cg = rr, cO = function(e) {
  var n = function(t, i, a) {
    if (this instanceof n) {
      switch (arguments.length) {
        case 0:
          return new e();
        case 1:
          return new e(t);
        case 2:
          return new e(t, i);
      }
      return new e(t, i, a);
    }
    return rO(e, this, arguments);
  };
  return n.prototype = e.prototype, n;
}, nt = function(e, n) {
  var t = e.target, i = e.global, a = e.stat, o = e.proto, s = i ? Vs : a ? Vs[t] : (Vs[t] || {}).prototype, l = i ? na : na[t] || ta(na, t, {})[t], u = l.prototype, m, d, f, h, y, x, S, j, w;
  for (h in n)
    m = sO(i ? h : t + (a ? "." : "#") + h, e.forced), d = !m && s && Cg(s, h), x = l[h], d && (e.dontCallGetSet ? (w = oO(s, h), S = w && w.value) : S = s[h]), y = d && S ? S : n[h], !(d && typeof x == typeof y) && (e.bind && d ? j = lO(y, Vs) : e.wrap && d ? j = cO(y) : o && aO(y) ? j = iO(y) : j = y, (e.sham || y && y.sham || x && x.sham) && ta(j, "sham", !0), ta(l, h, j), o && (f = t + "Prototype", Cg(na, f) || ta(na, f, {}), ta(na[f], h, y), e.real && u && (m || !u[h]) && ta(u, h, y)));
}, uO = xt, dO = ni, mO = function(e, n, t) {
  try {
    return uO(dO(Object.getOwnPropertyDescriptor(e, n)[t]));
  } catch {
  }
}, pO = yt, fO = String, hO = TypeError, vO = function(e) {
  if (typeof e == "object" || pO(e)) return e;
  throw hO("Can't set " + fO(e) + " as a prototype");
}, yO = mO, gO = Mr, kO = vO, Uj = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, n = {}, t;
  try {
    t = yO(Object.prototype, "__proto__", "set"), t(n, []), e = n instanceof Array;
  } catch {
  }
  return function(a, o) {
    return gO(a), kO(o), e ? t(a, o) : a.__proto__ = o, a;
  };
}() : void 0), bO = nt, _O = Uj;
bO({ target: "Object", stat: !0 }, {
  setPrototypeOf: _O
});
var xO = br;
xO.Object.setPrototypeOf;
var uv = {}, SO = Math.ceil, NO = Math.floor, jO = Math.trunc || function(n) {
  var t = +n;
  return (t > 0 ? NO : SO)(t);
}, wO = jO, dv = function(e) {
  var n = +e;
  return n !== n || n === 0 ? 0 : wO(n);
}, CO = dv, FO = Math.max, IO = Math.min, mv = function(e, n) {
  var t = CO(e);
  return t < 0 ? FO(t + n, 0) : IO(t, n);
}, $O = dv, EO = Math.min, TO = function(e) {
  return e > 0 ? EO($O(e), 9007199254740991) : 0;
}, OO = TO, La = function(e) {
  return OO(e.length);
}, RO = pi, DO = mv, PO = La, AO = function(e) {
  return function(n, t, i) {
    for (var a = RO(n), o = PO(a), s = DO(i, o); o > s; s++)
      if (s in a && a[s] === t) return s || 0;
    return -1;
  };
}, Bj = {
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: AO()
}, Dc = {}, LO = xt, wu = rr, VO = pi, zO = Bj.indexOf, MO = Dc, Fg = LO([].push), qj = function(e, n) {
  var t = VO(e), i = 0, a = [], o;
  for (o in t) !wu(MO, o) && wu(t, o) && Fg(a, o);
  for (; n.length > i; ) wu(t, o = n[i++]) && (~zO(a, o) || Fg(a, o));
  return a;
}, pv = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], UO = qj, BO = pv, fv = Object.keys || function(n) {
  return UO(n, BO);
}, qO = dr, HO = Mj, WO = zr, KO = Mr, GO = pi, YO = fv;
uv.f = qO && !HO ? Object.defineProperties : function(n, t) {
  KO(n);
  for (var i = GO(t), a = YO(t), o = a.length, s = 0, l; o > s; ) WO.f(n, l = a[s++], i[l]);
  return n;
};
var JO = _r, Hj = JO("document", "documentElement"), QO = ms, XO = lv, Ig = QO("keys"), Pc = function(e) {
  return Ig[e] || (Ig[e] = XO(e));
}, ZO = Mr, eR = uv, $g = pv, nR = Dc, tR = Hj, rR = cv, iR = Pc, Eg = ">", Tg = "<", Xf = "prototype", Zf = "script", Wj = iR("IE_PROTO"), Cu = function() {
}, Kj = function(e) {
  return Tg + Zf + Eg + e + Tg + "/" + Zf + Eg;
}, Og = function(e) {
  e.write(Kj("")), e.close();
  var n = e.parentWindow.Object;
  return e = null, n;
}, aR = function() {
  var e = rR("iframe"), n = "java" + Zf + ":", t;
  return e.style.display = "none", tR.appendChild(e), e.src = String(n), t = e.contentWindow.document, t.open(), t.write(Kj("document.F=Object")), t.close(), t.F;
}, zs, Il = function() {
  try {
    zs = new ActiveXObject("htmlfile");
  } catch {
  }
  Il = typeof document < "u" ? document.domain && zs ? Og(zs) : aR() : Og(zs);
  for (var e = $g.length; e--; ) delete Il[Xf][$g[e]];
  return Il();
};
nR[Wj] = !0;
var hs = Object.create || function(n, t) {
  var i;
  return n !== null ? (Cu[Xf] = ZO(n), i = new Cu(), Cu[Xf] = null, i[Wj] = n) : i = Il(), t === void 0 ? i : eR.f(i, t);
}, oR = nt, sR = dr, lR = hs;
oR({ target: "Object", stat: !0, sham: !sR }, {
  create: lR
});
var cR = br;
cR.Object;
var vs = {};
vs.f = Object.getOwnPropertySymbols;
var Rg = dr, uR = xt, dR = Rt, mR = mt, Fu = fv, pR = vs, fR = Ic, hR = Aa, vR = iv, ra = Object.assign, Dg = Object.defineProperty, yR = uR([].concat), gR = !ra || mR(function() {
  if (Rg && ra({ b: 1 }, ra(Dg({}, "a", {
    enumerable: !0,
    get: function() {
      Dg(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1) return !0;
  var e = {}, n = {}, t = Symbol("assign detection"), i = "abcdefghijklmnopqrst";
  return e[t] = 7, i.split("").forEach(function(a) {
    n[a] = a;
  }), ra({}, e)[t] !== 7 || Fu(ra({}, n)).join("") !== i;
}) ? function(n, t) {
  for (var i = hR(n), a = arguments.length, o = 1, s = pR.f, l = fR.f; a > o; )
    for (var u = vR(arguments[o++]), m = s ? yR(Fu(u), s(u)) : Fu(u), d = m.length, f = 0, h; d > f; )
      h = m[f++], (!Rg || dR(l, u, h)) && (i[h] = u[h]);
  return i;
} : ra, kR = nt, Pg = gR;
kR({ target: "Object", stat: !0, forced: Object.assign !== Pg }, {
  assign: Pg
});
var bR = br;
bR.Object.assign;
var _R = mt, xR = function(e, n) {
  var t = [][e];
  return !!t && _R(function() {
    t.call(null, n || function() {
      return 1;
    }, 1);
  });
}, SR = nt, NR = rv, jR = Bj.indexOf, wR = xR, eh = NR([].indexOf), Gj = !!eh && 1 / eh([1], 1, -0) < 0, CR = Gj || !wR("indexOf");
SR({ target: "Array", proto: !0, forced: CR }, {
  indexOf: function(n) {
    var t = arguments.length > 1 ? arguments[1] : void 0;
    return Gj ? eh(this, n, t) || 0 : jR(this, n, t);
  }
});
var FR = br, hv = function(e) {
  return FR[e + "Prototype"];
}, IR = hv;
IR("Array").indexOf;
var $R = pt, ER = $R("toStringTag"), Yj = {};
Yj[ER] = "z";
var vv = String(Yj) === "[object z]", TR = vv, OR = yt, $l = Yi, RR = pt, DR = RR("toStringTag"), PR = Object, AR = $l(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", LR = function(e, n) {
  try {
    return e[n];
  } catch {
  }
}, ys = TR ? $l : function(e) {
  var n, t, i;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t = LR(n = PR(e), DR)) == "string" ? t : AR ? $l(n) : (i = $l(n)) === "Object" && OR(n.callee) ? "Arguments" : i;
}, VR = ys, zR = String, Va = function(e) {
  if (VR(e) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return zR(e);
}, Ac = {}, MR = qj, UR = pv, BR = UR.concat("length", "prototype");
Ac.f = Object.getOwnPropertyNames || function(n) {
  return MR(n, BR);
};
var Jj = {}, qR = Rc, HR = zr, WR = Ji, yv = function(e, n, t) {
  var i = qR(n);
  i in e ? HR.f(e, i, WR(0, t)) : e[i] = t;
}, Ag = mv, KR = La, GR = yv, YR = Array, JR = Math.max, QR = function(e, n, t) {
  for (var i = KR(e), a = Ag(n, i), o = Ag(t === void 0 ? i : t, i), s = YR(JR(o - a, 0)), l = 0; a < o; a++, l++) GR(s, l, e[a]);
  return s.length = l, s;
}, XR = Yi, ZR = pi, Qj = Ac.f, eD = QR, Xj = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], nD = function(e) {
  try {
    return Qj(e);
  } catch {
    return eD(Xj);
  }
};
Jj.f = function(n) {
  return Xj && XR(n) === "Window" ? nD(n) : Qj(ZR(n));
};
var tD = wi, gs = function(e, n, t, i) {
  return i && i.enumerable ? e[n] = t : tD(e, n, t), e;
}, rD = zr, Zj = function(e, n, t) {
  return rD.f(e, n, t);
}, ks = {}, iD = pt;
ks.f = iD;
var Lg = br, aD = rr, oD = ks, sD = zr.f, ir = function(e) {
  var n = Lg.Symbol || (Lg.Symbol = {});
  aD(n, e) || sD(n, e, {
    value: oD.f(e)
  });
}, lD = Rt, cD = _r, uD = pt, dD = gs, ew = function() {
  var e = cD("Symbol"), n = e && e.prototype, t = n && n.valueOf, i = uD("toPrimitive");
  n && !n[i] && dD(n, i, function(a) {
    return lD(t, this);
  }, {});
}, mD = vv, pD = ys, fD = mD ? {}.toString : function() {
  return "[object " + pD(this) + "]";
}, hD = vv, vD = zr.f, yD = wi, gD = rr, kD = fD, bD = pt, Vg = bD("toStringTag"), za = function(e, n, t, i) {
  if (e) {
    var a = t ? e : e.prototype;
    gD(a, Vg) || vD(a, Vg, { configurable: !0, value: n }), i && !hD && yD(a, "toString", kD);
  }
}, _D = _t, xD = yt, zg = _D.WeakMap, SD = xD(zg) && /native code/.test(String(zg)), ND = SD, nw = _t, jD = kr, wD = wi, Iu = rr, $u = sv, CD = Pc, FD = Dc, Mg = "Object already initialized", nh = nw.TypeError, ID = nw.WeakMap, Kl, Xo, Gl, $D = function(e) {
  return Gl(e) ? Xo(e) : Kl(e, {});
}, ED = function(e) {
  return function(n) {
    var t;
    if (!jD(n) || (t = Xo(n)).type !== e)
      throw nh("Incompatible receiver, " + e + " required");
    return t;
  };
};
if (ND || $u.state) {
  var Br = $u.state || ($u.state = new ID());
  Br.get = Br.get, Br.has = Br.has, Br.set = Br.set, Kl = function(e, n) {
    if (Br.has(e)) throw nh(Mg);
    return n.facade = e, Br.set(e, n), n;
  }, Xo = function(e) {
    return Br.get(e) || {};
  }, Gl = function(e) {
    return Br.has(e);
  };
} else {
  var ia = CD("state");
  FD[ia] = !0, Kl = function(e, n) {
    if (Iu(e, ia)) throw nh(Mg);
    return n.facade = e, wD(e, ia, n), n;
  }, Xo = function(e) {
    return Iu(e, ia) ? e[ia] : {};
  }, Gl = function(e) {
    return Iu(e, ia);
  };
}
var Lc = {
  set: Kl,
  get: Xo,
  has: Gl,
  enforce: $D,
  getterFor: ED
}, TD = Yi, Vc = Array.isArray || function(n) {
  return TD(n) === "Array";
}, OD = xt, RD = yt, th = sv, DD = OD(Function.toString);
RD(th.inspectSource) || (th.inspectSource = function(e) {
  return DD(e);
});
var tw = th.inspectSource, PD = xt, AD = mt, rw = yt, LD = ys, VD = _r, zD = tw, iw = function() {
}, MD = [], aw = VD("Reflect", "construct"), gv = /^\s*(?:class|function)\b/, UD = PD(gv.exec), BD = !gv.exec(iw), Za = function(n) {
  if (!rw(n)) return !1;
  try {
    return aw(iw, MD, n), !0;
  } catch {
    return !1;
  }
}, ow = function(n) {
  if (!rw(n)) return !1;
  switch (LD(n)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return BD || !!UD(gv, zD(n));
  } catch {
    return !0;
  }
};
ow.sham = !0;
var kv = !aw || AD(function() {
  var e;
  return Za(Za.call) || !Za(Object) || !Za(function() {
    e = !0;
  }) || e;
}) ? ow : Za, Ug = Vc, qD = kv, HD = kr, WD = pt, KD = WD("species"), Bg = Array, GD = function(e) {
  var n;
  return Ug(e) && (n = e.constructor, qD(n) && (n === Bg || Ug(n.prototype)) ? n = void 0 : HD(n) && (n = n[KD], n === null && (n = void 0))), n === void 0 ? Bg : n;
}, YD = GD, JD = function(e, n) {
  return new (YD(e))(n === 0 ? 0 : n);
}, QD = fs, XD = xt, ZD = iv, eP = Aa, nP = La;
XD([].push);
var tP = function(e) {
  return function(n, t, i, a) {
    for (var o = eP(n), s = ZD(o), l = QD(t, i), u = nP(s), m = 0, d = void 0, f; u > m; m++) m in s && (f = s[m], l(f, m, o));
    return d;
  };
}, rP = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: tP()
}, zc = nt, bv = _t, _v = Rt, iP = xt, wa = dr, Ca = Pa, aP = mt, St = rr, oP = us, rh = Mr, Mc = pi, xv = Rc, sP = Va, ih = Ji, Zo = hs, sw = fv, lP = Ac, lw = Jj, cP = vs, cw = Da, uw = zr, uP = uv, dw = Ic, qg = gs, dP = Zj, Sv = ms, mP = Pc, mw = Dc, Hg = lv, pP = pt, fP = ks, hP = ir, vP = ew, yP = za, pw = Lc, Uc = rP.forEach, Qt = mP("hidden"), Bc = "Symbol", es = "prototype", gP = pw.set, Wg = pw.getterFor(Bc), Rr = Object[es], Bi = bv.Symbol, Do = Bi && Bi[es], kP = bv.TypeError, Eu = bv.QObject, fw = cw.f, Ai = uw.f, hw = lw.f, bP = dw.f, vw = iP([].push), di = Sv("symbols"), bs = Sv("op-symbols"), _P = Sv("wks"), ah = !Eu || !Eu[es] || !Eu[es].findChild, oh = wa && aP(function() {
  return Zo(Ai({}, "a", {
    get: function() {
      return Ai(this, "a", { value: 7 }).a;
    }
  })).a !== 7;
}) ? function(e, n, t) {
  var i = fw(Rr, n);
  i && delete Rr[n], Ai(e, n, t), i && e !== Rr && Ai(Rr, n, i);
} : Ai, Tu = function(e, n) {
  var t = di[e] = Zo(Do);
  return gP(t, {
    type: Bc,
    tag: e,
    description: n
  }), wa || (t.description = n), t;
}, qc = function(n, t, i) {
  n === Rr && qc(bs, t, i), rh(n);
  var a = xv(t);
  return rh(i), St(di, a) ? (i.enumerable ? (St(n, Qt) && n[Qt][a] && (n[Qt][a] = !1), i = Zo(i, { enumerable: ih(0, !1) })) : (St(n, Qt) || Ai(n, Qt, ih(1, {})), n[Qt][a] = !0), oh(n, a, i)) : Ai(n, a, i);
}, Nv = function(n, t) {
  rh(n);
  var i = Mc(t), a = sw(i).concat(bw(i));
  return Uc(a, function(o) {
    (!wa || _v(yw, i, o)) && qc(n, o, i[o]);
  }), n;
}, xP = function(n, t) {
  return t === void 0 ? Zo(n) : Nv(Zo(n), t);
}, yw = function(n) {
  var t = xv(n), i = _v(bP, this, t);
  return this === Rr && St(di, t) && !St(bs, t) ? !1 : i || !St(this, t) || !St(di, t) || St(this, Qt) && this[Qt][t] ? i : !0;
}, gw = function(n, t) {
  var i = Mc(n), a = xv(t);
  if (!(i === Rr && St(di, a) && !St(bs, a))) {
    var o = fw(i, a);
    return o && St(di, a) && !(St(i, Qt) && i[Qt][a]) && (o.enumerable = !0), o;
  }
}, kw = function(n) {
  var t = hw(Mc(n)), i = [];
  return Uc(t, function(a) {
    !St(di, a) && !St(mw, a) && vw(i, a);
  }), i;
}, bw = function(e) {
  var n = e === Rr, t = hw(n ? bs : Mc(e)), i = [];
  return Uc(t, function(a) {
    St(di, a) && (!n || St(Rr, a)) && vw(i, di[a]);
  }), i;
};
Ca || (Bi = function() {
  if (oP(Do, this)) throw kP("Symbol is not a constructor");
  var n = !arguments.length || arguments[0] === void 0 ? void 0 : sP(arguments[0]), t = Hg(n), i = function(a) {
    this === Rr && _v(i, bs, a), St(this, Qt) && St(this[Qt], t) && (this[Qt][t] = !1), oh(this, t, ih(1, a));
  };
  return wa && ah && oh(Rr, t, { configurable: !0, set: i }), Tu(t, n);
}, Do = Bi[es], qg(Do, "toString", function() {
  return Wg(this).tag;
}), qg(Bi, "withoutSetter", function(e) {
  return Tu(Hg(e), e);
}), dw.f = yw, uw.f = qc, uP.f = Nv, cw.f = gw, lP.f = lw.f = kw, cP.f = bw, fP.f = function(e) {
  return Tu(pP(e), e);
}, wa && dP(Do, "description", {
  configurable: !0,
  get: function() {
    return Wg(this).description;
  }
}));
zc({ global: !0, wrap: !0, forced: !Ca, sham: !Ca }, {
  Symbol: Bi
});
Uc(sw(_P), function(e) {
  hP(e);
});
zc({ target: Bc, stat: !0, forced: !Ca }, {
  useSetter: function() {
    ah = !0;
  },
  useSimple: function() {
    ah = !1;
  }
});
zc({ target: "Object", stat: !0, forced: !Ca, sham: !wa }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: xP,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: qc,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: Nv,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: gw
});
zc({ target: "Object", stat: !0, forced: !Ca }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: kw
});
vP();
yP(Bi, Bc);
mw[Qt] = !0;
var SP = Pa, _w = SP && !!Symbol.for && !!Symbol.keyFor, NP = nt, jP = _r, wP = rr, CP = Va, xw = ms, FP = _w, Ou = xw("string-to-symbol-registry"), IP = xw("symbol-to-string-registry");
NP({ target: "Symbol", stat: !0, forced: !FP }, {
  for: function(e) {
    var n = CP(e);
    if (wP(Ou, n)) return Ou[n];
    var t = jP("Symbol")(n);
    return Ou[n] = t, IP[t] = n, t;
  }
});
var $P = nt, EP = rr, TP = Oc, OP = ds, RP = ms, DP = _w, Kg = RP("symbol-to-string-registry");
$P({ target: "Symbol", stat: !0, forced: !DP }, {
  keyFor: function(n) {
    if (!TP(n)) throw TypeError(OP(n) + " is not a symbol");
    if (EP(Kg, n)) return Kg[n];
  }
});
var PP = xt, jv = PP([].slice), AP = xt, Gg = Vc, LP = yt, Yg = Yi, VP = Va, Jg = AP([].push), zP = function(e) {
  if (LP(e)) return e;
  if (Gg(e)) {
    for (var n = e.length, t = [], i = 0; i < n; i++) {
      var a = e[i];
      typeof a == "string" ? Jg(t, a) : (typeof a == "number" || Yg(a) === "Number" || Yg(a) === "String") && Jg(t, VP(a));
    }
    var o = t.length, s = !0;
    return function(l, u) {
      if (s)
        return s = !1, u;
      if (Gg(this)) return u;
      for (var m = 0; m < o; m++) if (t[m] === l) return u;
    };
  }
}, MP = nt, Sw = _r, Nw = tv, UP = Rt, _s = xt, jw = mt, Qg = yt, Xg = Oc, ww = jv, BP = zP, qP = Pa, HP = String, Si = Sw("JSON", "stringify"), Ms = _s(/./.exec), Zg = _s("".charAt), WP = _s("".charCodeAt), KP = _s("".replace), GP = _s(1 .toString), YP = /[\uD800-\uDFFF]/g, ek = /^[\uD800-\uDBFF]$/, nk = /^[\uDC00-\uDFFF]$/, tk = !qP || jw(function() {
  var e = Sw("Symbol")("stringify detection");
  return Si([e]) !== "[null]" || Si({ a: e }) !== "{}" || Si(Object(e)) !== "{}";
}), rk = jw(function() {
  return Si("\uDF06\uD834") !== '"\\udf06\\ud834"' || Si("\uDEAD") !== '"\\udead"';
}), JP = function(e, n) {
  var t = ww(arguments), i = BP(n);
  if (!(!Qg(i) && (e === void 0 || Xg(e))))
    return t[1] = function(a, o) {
      if (Qg(i) && (o = UP(i, this, HP(a), o)), !Xg(o)) return o;
    }, Nw(Si, null, t);
}, QP = function(e, n, t) {
  var i = Zg(t, n - 1), a = Zg(t, n + 1);
  return Ms(ek, e) && !Ms(nk, a) || Ms(nk, e) && !Ms(ek, i) ? "\\u" + GP(WP(e, 0), 16) : e;
};
Si && MP({ target: "JSON", stat: !0, forced: tk || rk }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(n, t, i) {
    var a = ww(arguments), o = Nw(tk ? JP : Si, null, a);
    return rk && typeof o == "string" ? KP(o, YP, QP) : o;
  }
});
var XP = nt, ZP = Pa, eA = mt, Cw = vs, nA = Aa, tA = !ZP || eA(function() {
  Cw.f(1);
});
XP({ target: "Object", stat: !0, forced: tA }, {
  getOwnPropertySymbols: function(n) {
    var t = Cw.f;
    return t ? t(nA(n)) : [];
  }
});
var rA = br;
rA.Object.getOwnPropertySymbols;
var iA = nt, aA = mt, oA = pi, Fw = Da.f, Iw = dr, sA = !Iw || aA(function() {
  Fw(1);
});
iA({ target: "Object", stat: !0, forced: sA, sham: !Iw }, {
  getOwnPropertyDescriptor: function(n, t) {
    return Fw(oA(n), t);
  }
});
var lA = br, cA = lA.Object;
cA.getOwnPropertyDescriptor.sham;
var uA = nt, dA = dr, ik = zr.f;
uA({ target: "Object", stat: !0, forced: Object.defineProperty !== ik, sham: !dA }, {
  defineProperty: ik
});
var mA = br, pA = mA.Object;
pA.defineProperty.sham;
var fA = mt, hA = !fA(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), vA = rr, yA = yt, gA = Aa, kA = Pc, bA = hA, ak = kA("IE_PROTO"), sh = Object, _A = sh.prototype, wv = bA ? sh.getPrototypeOf : function(e) {
  var n = gA(e);
  if (vA(n, ak)) return n[ak];
  var t = n.constructor;
  return yA(t) && n instanceof t ? t.prototype : n instanceof sh ? _A : null;
}, xA = _r, SA = xt, NA = Ac, jA = vs, wA = Mr, CA = SA([].concat), FA = xA("Reflect", "ownKeys") || function(n) {
  var t = NA.f(wA(n)), i = jA.f;
  return i ? CA(t, i(n)) : t;
}, ok = rr, IA = FA, $A = Da, EA = zr, TA = function(e, n, t) {
  for (var i = IA(n), a = EA.f, o = $A.f, s = 0; s < i.length; s++) {
    var l = i[s];
    !ok(e, l) && !(t && ok(t, l)) && a(e, l, o(n, l));
  }
}, OA = kr, RA = wi, DA = function(e, n) {
  OA(n) && "cause" in n && RA(e, "cause", n.cause);
}, PA = xt, $w = Error, AA = PA("".replace), LA = function(e) {
  return String($w(e).stack);
}("zxcasd"), Ew = /\n\s*at [^:]*:[^\n]*/, VA = Ew.test(LA), zA = function(e, n) {
  if (VA && typeof e == "string" && !$w.prepareStackTrace)
    for (; n--; ) e = AA(e, Ew, "");
  return e;
}, MA = mt, UA = Ji, BA = !MA(function() {
  var e = Error("a");
  return "stack" in e ? (Object.defineProperty(e, "stack", UA(1, 7)), e.stack !== 7) : !0;
}), qA = wi, HA = zA, WA = BA, sk = Error.captureStackTrace, KA = function(e, n, t, i) {
  WA && (sk ? sk(e, n) : qA(e, "stack", HA(t, i)));
}, Ma = {}, GA = pt, YA = Ma, JA = GA("iterator"), QA = Array.prototype, XA = function(e) {
  return e !== void 0 && (YA.Array === e || QA[JA] === e);
}, ZA = ys, lk = ov, e2 = $c, n2 = Ma, t2 = pt, r2 = t2("iterator"), Tw = function(e) {
  if (!e2(e)) return lk(e, r2) || lk(e, "@@iterator") || n2[ZA(e)];
}, i2 = Rt, a2 = ni, o2 = Mr, s2 = ds, l2 = Tw, c2 = TypeError, u2 = function(e, n) {
  var t = arguments.length < 2 ? l2(e) : n;
  if (a2(t)) return o2(i2(t, e));
  throw c2(s2(e) + " is not iterable");
}, d2 = Rt, ck = Mr, m2 = ov, p2 = function(e, n, t) {
  var i, a;
  ck(e);
  try {
    if (i = m2(e, "return"), !i) {
      if (n === "throw") throw t;
      return t;
    }
    i = d2(i, e);
  } catch (o) {
    a = !0, i = o;
  }
  if (n === "throw") throw t;
  if (a) throw i;
  return ck(i), t;
}, f2 = fs, h2 = Rt, v2 = Mr, y2 = ds, g2 = XA, k2 = La, uk = us, b2 = u2, _2 = Tw, dk = p2, x2 = TypeError, El = function(e, n) {
  this.stopped = e, this.result = n;
}, mk = El.prototype, xs = function(e, n, t) {
  var i = t && t.that, a = !!(t && t.AS_ENTRIES), o = !!(t && t.IS_RECORD), s = !!(t && t.IS_ITERATOR), l = !!(t && t.INTERRUPTED), u = f2(n, i), m, d, f, h, y, x, S, j = function(v) {
    return m && dk(m, "normal", v), new El(!0, v);
  }, w = function(v) {
    return a ? (v2(v), l ? u(v[0], v[1], j) : u(v[0], v[1])) : l ? u(v, j) : u(v);
  };
  if (o)
    m = e.iterator;
  else if (s)
    m = e;
  else {
    if (d = _2(e), !d) throw x2(y2(e) + " is not iterable");
    if (g2(d)) {
      for (f = 0, h = k2(e); h > f; f++)
        if (y = w(e[f]), y && uk(mk, y)) return y;
      return new El(!1);
    }
    m = b2(e, d);
  }
  for (x = o ? e.next : m.next; !(S = h2(x, m)).done; ) {
    try {
      y = w(S.value);
    } catch (v) {
      dk(m, "throw", v);
    }
    if (typeof y == "object" && y && uk(mk, y)) return y;
  }
  return new El(!1);
}, S2 = Va, N2 = function(e, n) {
  return e === void 0 ? arguments.length < 2 ? "" : n : S2(e);
}, j2 = nt, w2 = us, C2 = wv, Yl = Uj, F2 = TA, Ow = hs, Ru = wi, Du = Ji, I2 = DA, $2 = KA, E2 = xs, T2 = N2, O2 = pt, R2 = O2("toStringTag"), Jl = Error, D2 = [].push, Fa = function(n, t) {
  var i = w2(Pu, this), a;
  Yl ? a = Yl(Jl(), i ? C2(this) : Pu) : (a = i ? this : Ow(Pu), Ru(a, R2, "Error")), t !== void 0 && Ru(a, "message", T2(t)), $2(a, Fa, a.stack, 1), arguments.length > 2 && I2(a, arguments[2]);
  var o = [];
  return E2(n, D2, { that: o }), Ru(a, "errors", o), a;
};
Yl ? Yl(Fa, Jl) : F2(Fa, Jl, { name: !0 });
var Pu = Fa.prototype = Ow(Jl.prototype, {
  constructor: Du(1, Fa),
  message: Du(1, ""),
  name: Du(1, "AggregateError")
});
j2({ global: !0 }, {
  AggregateError: Fa
});
var lh = dr, P2 = rr, Rw = Function.prototype, A2 = lh && Object.getOwnPropertyDescriptor, Dw = P2(Rw, "name"), L2 = Dw && (function() {
}).name === "something";
Dw && (!lh || lh && A2(Rw, "name").configurable);
var V2 = {
  PROPER: L2
}, z2 = mt, M2 = yt, U2 = kr, B2 = hs, pk = wv, q2 = gs, H2 = pt, ch = H2("iterator"), Pw = !1, ui, Au, Lu;
[].keys && (Lu = [].keys(), "next" in Lu ? (Au = pk(pk(Lu)), Au !== Object.prototype && (ui = Au)) : Pw = !0);
var W2 = !U2(ui) || z2(function() {
  var e = {};
  return ui[ch].call(e) !== e;
});
W2 ? ui = {} : ui = B2(ui);
M2(ui[ch]) || q2(ui, ch, function() {
  return this;
});
var Aw = {
  IteratorPrototype: ui,
  BUGGY_SAFARI_ITERATORS: Pw
}, K2 = Aw.IteratorPrototype, G2 = hs, Y2 = Ji, J2 = za, Q2 = Ma, X2 = function() {
  return this;
}, Z2 = function(e, n, t, i) {
  var a = n + " Iterator";
  return e.prototype = G2(K2, { next: Y2(+!i, t) }), J2(e, a, !1, !0), Q2[a] = X2, e;
}, eL = nt, nL = Rt, tL = V2, rL = Z2, iL = wv, aL = za, fk = gs, oL = pt, hk = Ma, sL = Aw, lL = tL.PROPER, Us = sL.BUGGY_SAFARI_ITERATORS, Vu = oL("iterator"), vk = "keys", Bs = "values", yk = "entries", cL = function() {
  return this;
}, Lw = function(e, n, t, i, a, o, s) {
  rL(t, n, i);
  var l = function(w) {
    if (w === a && h) return h;
    if (!Us && w in d) return d[w];
    switch (w) {
      case vk:
        return function() {
          return new t(this, w);
        };
      case Bs:
        return function() {
          return new t(this, w);
        };
      case yk:
        return function() {
          return new t(this, w);
        };
    }
    return function() {
      return new t(this);
    };
  }, u = n + " Iterator", m = !1, d = e.prototype, f = d[Vu] || d["@@iterator"] || a && d[a], h = !Us && f || l(a), y = n === "Array" && d.entries || f, x, S, j;
  if (y && (x = iL(y.call(new e())), x !== Object.prototype && x.next && (aL(x, u, !0, !0), hk[u] = cL)), lL && a === Bs && f && f.name !== Bs && (m = !0, h = function() {
    return nL(f, this);
  }), a)
    if (S = {
      values: l(Bs),
      keys: o ? h : l(vk),
      entries: l(yk)
    }, s) for (j in S)
      (Us || m || !(j in d)) && fk(d, j, S[j]);
    else eL({ target: n, proto: !0, forced: Us || m }, S);
  return s && d[Vu] !== h && fk(d, Vu, h, {}), hk[n] = h, S;
}, Vw = function(e, n) {
  return { value: e, done: n };
}, uL = pi, gk = Ma, zw = Lc;
zr.f;
var dL = Lw, qs = Vw, Mw = "Array Iterator", mL = zw.set, pL = zw.getterFor(Mw);
dL(Array, "Array", function(e, n) {
  mL(this, {
    type: Mw,
    target: uL(e),
    // target
    index: 0,
    // next index
    kind: n
    // kind
  });
}, function() {
  var e = pL(this), n = e.target, t = e.kind, i = e.index++;
  if (!n || i >= n.length)
    return e.target = void 0, qs(void 0, !0);
  switch (t) {
    case "keys":
      return qs(i, !1);
    case "values":
      return qs(n[i], !1);
  }
  return qs([i, n[i]], !1);
}, "values");
gk.Arguments = gk.Array;
var fL = _t, hL = Yi, Hc = hL(fL.process) === "process", vL = _r, yL = Zj, gL = pt, kL = dr, kk = gL("species"), bL = function(e) {
  var n = vL(e);
  kL && n && !n[kk] && yL(n, kk, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, _L = us, xL = TypeError, SL = function(e, n) {
  if (_L(n, e)) return e;
  throw xL("Incorrect invocation");
}, NL = kv, jL = ds, wL = TypeError, CL = function(e) {
  if (NL(e)) return e;
  throw wL(jL(e) + " is not a constructor");
}, bk = Mr, FL = CL, IL = $c, $L = pt, EL = $L("species"), Uw = function(e, n) {
  var t = bk(e).constructor, i;
  return t === void 0 || IL(i = bk(t)[EL]) ? n : FL(i);
}, TL = TypeError, OL = function(e, n) {
  if (e < n) throw TL("Not enough arguments");
  return e;
}, RL = Ec, Bw = /(?:ipad|iphone|ipod).*applewebkit/i.test(RL), cr = _t, DL = tv, PL = fs, _k = yt, AL = rr, qw = mt, xk = Hj, LL = jv, Sk = cv, VL = OL, zL = Bw, ML = Hc, uh = cr.setImmediate, Nk = cr.clearImmediate, UL = cr.process, zu = cr.Dispatch, BL = cr.Function, jk = cr.MessageChannel, qL = cr.String, Mu = 0, Lo = {}, wk = "onreadystatechange", ns, $i, Uu, Bu;
qw(function() {
  ns = cr.location;
});
var Cv = function(e) {
  if (AL(Lo, e)) {
    var n = Lo[e];
    delete Lo[e], n();
  }
}, qu = function(e) {
  return function() {
    Cv(e);
  };
}, Ck = function(e) {
  Cv(e.data);
}, Fk = function(e) {
  cr.postMessage(qL(e), ns.protocol + "//" + ns.host);
};
(!uh || !Nk) && (uh = function(n) {
  VL(arguments.length, 1);
  var t = _k(n) ? n : BL(n), i = LL(arguments, 1);
  return Lo[++Mu] = function() {
    DL(t, void 0, i);
  }, $i(Mu), Mu;
}, Nk = function(n) {
  delete Lo[n];
}, ML ? $i = function(e) {
  UL.nextTick(qu(e));
} : zu && zu.now ? $i = function(e) {
  zu.now(qu(e));
} : jk && !zL ? (Uu = new jk(), Bu = Uu.port2, Uu.port1.onmessage = Ck, $i = PL(Bu.postMessage, Bu)) : cr.addEventListener && _k(cr.postMessage) && !cr.importScripts && ns && ns.protocol !== "file:" && !qw(Fk) ? ($i = Fk, cr.addEventListener("message", Ck, !1)) : wk in Sk("script") ? $i = function(e) {
  xk.appendChild(Sk("script"))[wk] = function() {
    xk.removeChild(this), Cv(e);
  };
} : $i = function(e) {
  setTimeout(qu(e), 0);
});
var Hw = {
  set: uh
}, Ww = function() {
  this.head = null, this.tail = null;
};
Ww.prototype = {
  add: function(e) {
    var n = { item: e, next: null }, t = this.tail;
    t ? t.next = n : this.head = n, this.tail = n;
  },
  get: function() {
    var e = this.head;
    if (e) {
      var n = this.head = e.next;
      return n === null && (this.tail = null), e.item;
    }
  }
};
var Kw = Ww, HL = Ec, WL = /ipad|iphone|ipod/i.test(HL) && typeof Pebble < "u", KL = Ec, GL = /web0s(?!.*chrome)/i.test(KL), Gi = _t, Ik = fs, YL = Da.f, Hu = Hw.set, JL = Kw, QL = Bw, XL = WL, ZL = GL, Wu = Hc, $k = Gi.MutationObserver || Gi.WebKitMutationObserver, Ek = Gi.document, Tk = Gi.process, Hs = Gi.Promise, Ok = YL(Gi, "queueMicrotask"), dh = Ok && Ok.value, aa, Ku, Gu, Ws, Rk;
if (!dh) {
  var Ks = new JL(), Gs = function() {
    var e, n;
    for (Wu && (e = Tk.domain) && e.exit(); n = Ks.get(); ) try {
      n();
    } catch (t) {
      throw Ks.head && aa(), t;
    }
    e && e.enter();
  };
  !QL && !Wu && !ZL && $k && Ek ? (Ku = !0, Gu = Ek.createTextNode(""), new $k(Gs).observe(Gu, { characterData: !0 }), aa = function() {
    Gu.data = Ku = !Ku;
  }) : !XL && Hs && Hs.resolve ? (Ws = Hs.resolve(void 0), Ws.constructor = Hs, Rk = Ik(Ws.then, Ws), aa = function() {
    Rk(Gs);
  }) : Wu ? aa = function() {
    Tk.nextTick(Gs);
  } : (Hu = Ik(Hu, Gi), aa = function() {
    Hu(Gs);
  }), dh = function(e) {
    Ks.head || aa(), Ks.add(e);
  };
}
var eV = dh, nV = function(e, n) {
  try {
    arguments.length === 1 ? console.error(e) : console.error(e, n);
  } catch {
  }
}, Ss = function(e) {
  try {
    return { error: !1, value: e() };
  } catch (n) {
    return { error: !0, value: n };
  }
}, tV = _t, Ua = tV.Promise, Gw = typeof Deno == "object" && Deno && typeof Deno.version == "object", rV = Gw, iV = Hc, aV = !rV && !iV && typeof window == "object" && typeof document == "object", oV = _t, Vo = Ua, sV = yt, lV = zj, cV = tw, uV = pt, dV = aV, mV = Gw, Yu = Tc, Dk = Vo && Vo.prototype, pV = uV("species"), Pk = !1, Yw = sV(oV.PromiseRejectionEvent), fV = lV("Promise", function() {
  var e = cV(Vo), n = e !== String(Vo);
  if (!n && Yu === 66 || !(Dk.catch && Dk.finally)) return !0;
  if (!Yu || Yu < 51 || !/native code/.test(e)) {
    var t = new Vo(function(o) {
      o(1);
    }), i = function(o) {
      o(function() {
      }, function() {
      });
    }, a = t.constructor = {};
    if (a[pV] = i, Pk = t.then(function() {
    }) instanceof i, !Pk) return !0;
  }
  return !n && (dV || mV) && !Yw;
}), Ns = {
  CONSTRUCTOR: fV,
  REJECTION_EVENT: Yw
}, Ci = {}, Ak = ni, hV = TypeError, vV = function(e) {
  var n, t;
  this.promise = new e(function(i, a) {
    if (n !== void 0 || t !== void 0) throw hV("Bad Promise constructor");
    n = i, t = a;
  }), this.resolve = Ak(n), this.reject = Ak(t);
};
Ci.f = function(e) {
  return new vV(e);
};
var yV = nt, Ql = Hc, Ni = _t, js = Rt, gV = gs, kV = za, bV = bL, _V = ni, mh = yt, xV = kr, SV = SL, NV = Uw, Jw = Hw.set, Fv = eV, jV = nV, wV = Ss, CV = Kw, Qw = Lc, ph = Ua, Xw = Ns, Zw = Ci, Wc = "Promise", eC = Xw.CONSTRUCTOR, FV = Xw.REJECTION_EVENT, Ju = Qw.getterFor(Wc), IV = Qw.set, $V = ph && ph.prototype, va = ph, Qu = $V, nC = Ni.TypeError, fh = Ni.document, Iv = Ni.process, hh = Zw.f, EV = hh, TV = !!(fh && fh.createEvent && Ni.dispatchEvent), tC = "unhandledrejection", OV = "rejectionhandled", Lk = 0, rC = 1, RV = 2, $v = 1, iC = 2, Ys, Vk, DV, aC = function(e) {
  var n;
  return xV(e) && mh(n = e.then) ? n : !1;
}, oC = function(e, n) {
  var t = n.value, i = n.state === rC, a = i ? e.ok : e.fail, o = e.resolve, s = e.reject, l = e.domain, u, m, d;
  try {
    a ? (i || (n.rejection === iC && AV(n), n.rejection = $v), a === !0 ? u = t : (l && l.enter(), u = a(t), l && (l.exit(), d = !0)), u === e.promise ? s(nC("Promise-chain cycle")) : (m = aC(u)) ? js(m, u, o, s) : o(u)) : s(t);
  } catch (f) {
    l && !d && l.exit(), s(f);
  }
}, sC = function(e, n) {
  e.notified || (e.notified = !0, Fv(function() {
    for (var t = e.reactions, i; i = t.get(); )
      oC(i, e);
    e.notified = !1, n && !e.rejection && PV(e);
  }));
}, lC = function(e, n, t) {
  var i, a;
  TV ? (i = fh.createEvent("Event"), i.promise = n, i.reason = t, i.initEvent(e, !1, !0), Ni.dispatchEvent(i)) : i = { promise: n, reason: t }, !FV && (a = Ni["on" + e]) ? a(i) : e === tC && jV("Unhandled promise rejection", t);
}, PV = function(e) {
  js(Jw, Ni, function() {
    var n = e.facade, t = e.value, i = zk(e), a;
    if (i && (a = wV(function() {
      Ql ? Iv.emit("unhandledRejection", t, n) : lC(tC, n, t);
    }), e.rejection = Ql || zk(e) ? iC : $v, a.error))
      throw a.value;
  });
}, zk = function(e) {
  return e.rejection !== $v && !e.parent;
}, AV = function(e) {
  js(Jw, Ni, function() {
    var n = e.facade;
    Ql ? Iv.emit("rejectionHandled", n) : lC(OV, n, e.value);
  });
}, ya = function(e, n, t) {
  return function(i) {
    e(n, i, t);
  };
}, ka = function(e, n, t) {
  e.done || (e.done = !0, t && (e = t), e.value = n, e.state = RV, sC(e, !0));
}, vh = function(e, n, t) {
  if (!e.done) {
    e.done = !0, t && (e = t);
    try {
      if (e.facade === n) throw nC("Promise can't be resolved itself");
      var i = aC(n);
      i ? Fv(function() {
        var a = { done: !1 };
        try {
          js(
            i,
            n,
            ya(vh, a, e),
            ya(ka, a, e)
          );
        } catch (o) {
          ka(a, o, e);
        }
      }) : (e.value = n, e.state = rC, sC(e, !1));
    } catch (a) {
      ka({ done: !1 }, a, e);
    }
  }
};
eC && (va = function(n) {
  SV(this, Qu), _V(n), js(Ys, this);
  var t = Ju(this);
  try {
    n(ya(vh, t), ya(ka, t));
  } catch (i) {
    ka(t, i);
  }
}, Qu = va.prototype, Ys = function(n) {
  IV(this, {
    type: Wc,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new CV(),
    rejection: !1,
    state: Lk,
    value: void 0
  });
}, Ys.prototype = gV(Qu, "then", function(n, t) {
  var i = Ju(this), a = hh(NV(this, va));
  return i.parent = !0, a.ok = mh(n) ? n : !0, a.fail = mh(t) && t, a.domain = Ql ? Iv.domain : void 0, i.state === Lk ? i.reactions.add(a) : Fv(function() {
    oC(a, i);
  }), a.promise;
}), Vk = function() {
  var e = new Ys(), n = Ju(e);
  this.promise = e, this.resolve = ya(vh, n), this.reject = ya(ka, n);
}, Zw.f = hh = function(e) {
  return e === va || e === DV ? new Vk(e) : EV(e);
});
yV({ global: !0, wrap: !0, forced: eC }, {
  Promise: va
});
kV(va, Wc, !1, !0);
bV(Wc);
var LV = pt, cC = LV("iterator"), uC = !1;
try {
  var VV = 0, Mk = {
    next: function() {
      return { done: !!VV++ };
    },
    return: function() {
      uC = !0;
    }
  };
  Mk[cC] = function() {
    return this;
  }, Array.from(Mk, function() {
    throw 2;
  });
} catch {
}
var zV = function(e, n) {
  if (!n && !uC) return !1;
  var t = !1;
  try {
    var i = {};
    i[cC] = function() {
      return {
        next: function() {
          return { done: t = !0 };
        }
      };
    }, e(i);
  } catch {
  }
  return t;
}, MV = Ua, UV = zV, BV = Ns.CONSTRUCTOR, Kc = BV || !UV(function(e) {
  MV.all(e).then(void 0, function() {
  });
}), qV = nt, HV = Rt, WV = ni, KV = Ci, GV = Ss, YV = xs, JV = Kc;
qV({ target: "Promise", stat: !0, forced: JV }, {
  all: function(n) {
    var t = this, i = KV.f(t), a = i.resolve, o = i.reject, s = GV(function() {
      var l = WV(t.resolve), u = [], m = 0, d = 1;
      YV(n, function(f) {
        var h = m++, y = !1;
        d++, HV(l, t, f).then(function(x) {
          y || (y = !0, u[h] = x, --d || a(u));
        }, o);
      }), --d || a(u);
    });
    return s.error && o(s.value), i.promise;
  }
});
var QV = nt, XV = Ns.CONSTRUCTOR, Uk = Ua;
Uk && Uk.prototype;
QV({ target: "Promise", proto: !0, forced: XV, real: !0 }, {
  catch: function(e) {
    return this.then(void 0, e);
  }
});
var ZV = nt, e3 = Rt, n3 = ni, t3 = Ci, r3 = Ss, i3 = xs, a3 = Kc;
ZV({ target: "Promise", stat: !0, forced: a3 }, {
  race: function(n) {
    var t = this, i = t3.f(t), a = i.reject, o = r3(function() {
      var s = n3(t.resolve);
      i3(n, function(l) {
        e3(s, t, l).then(i.resolve, a);
      });
    });
    return o.error && a(o.value), i.promise;
  }
});
var o3 = nt, s3 = Rt, l3 = Ci, c3 = Ns.CONSTRUCTOR;
o3({ target: "Promise", stat: !0, forced: c3 }, {
  reject: function(n) {
    var t = l3.f(this);
    return s3(t.reject, void 0, n), t.promise;
  }
});
var u3 = Mr, d3 = kr, m3 = Ci, dC = function(e, n) {
  if (u3(e), d3(n) && n.constructor === e) return n;
  var t = m3.f(e), i = t.resolve;
  return i(n), t.promise;
}, p3 = nt, f3 = _r, h3 = HE, v3 = Ua, y3 = Ns.CONSTRUCTOR, g3 = dC, k3 = f3("Promise"), b3 = !y3;
p3({ target: "Promise", stat: !0, forced: h3 }, {
  resolve: function(n) {
    return g3(b3 && this === k3 ? v3 : this, n);
  }
});
var _3 = nt, x3 = Rt, S3 = ni, N3 = Ci, j3 = Ss, w3 = xs, C3 = Kc;
_3({ target: "Promise", stat: !0, forced: C3 }, {
  allSettled: function(n) {
    var t = this, i = N3.f(t), a = i.resolve, o = i.reject, s = j3(function() {
      var l = S3(t.resolve), u = [], m = 0, d = 1;
      w3(n, function(f) {
        var h = m++, y = !1;
        d++, x3(l, t, f).then(function(x) {
          y || (y = !0, u[h] = { status: "fulfilled", value: x }, --d || a(u));
        }, function(x) {
          y || (y = !0, u[h] = { status: "rejected", reason: x }, --d || a(u));
        });
      }), --d || a(u);
    });
    return s.error && o(s.value), i.promise;
  }
});
var F3 = nt, I3 = Rt, $3 = ni, E3 = _r, T3 = Ci, O3 = Ss, R3 = xs, D3 = Kc, Bk = "No one promise resolved";
F3({ target: "Promise", stat: !0, forced: D3 }, {
  any: function(n) {
    var t = this, i = E3("AggregateError"), a = T3.f(t), o = a.resolve, s = a.reject, l = O3(function() {
      var u = $3(t.resolve), m = [], d = 0, f = 1, h = !1;
      R3(n, function(y) {
        var x = d++, S = !1;
        f++, I3(u, t, y).then(function(j) {
          S || h || (h = !0, o(j));
        }, function(j) {
          S || h || (S = !0, m[x] = j, --f || s(new i(m, Bk)));
        });
      }), --f || s(new i(m, Bk));
    });
    return l.error && s(l.value), a.promise;
  }
});
var P3 = nt, yh = Ua, A3 = mt, L3 = _r, V3 = yt, z3 = Uw, qk = dC, M3 = yh && yh.prototype, U3 = !!yh && A3(function() {
  M3.finally.call({ then: function() {
  } }, function() {
  });
});
P3({ target: "Promise", proto: !0, real: !0, forced: U3 }, {
  finally: function(e) {
    var n = z3(this, L3("Promise")), t = V3(e);
    return this.then(
      t ? function(i) {
        return qk(n, e()).then(function() {
          return i;
        });
      } : e,
      t ? function(i) {
        return qk(n, e()).then(function() {
          throw i;
        });
      } : e
    );
  }
});
var Ev = xt, B3 = dv, q3 = Va, H3 = av, W3 = Ev("".charAt), Hk = Ev("".charCodeAt), K3 = Ev("".slice), G3 = function(e) {
  return function(n, t) {
    var i = q3(H3(n)), a = B3(t), o = i.length, s, l;
    return a < 0 || a >= o ? "" : (s = Hk(i, a), s < 55296 || s > 56319 || a + 1 === o || (l = Hk(i, a + 1)) < 56320 || l > 57343 ? W3(i, a) : K3(i, a, a + 2));
  };
}, Y3 = {
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: G3()
}, J3 = Y3.charAt, Q3 = Va, mC = Lc, X3 = Lw, Wk = Vw, pC = "String Iterator", Z3 = mC.set, ez = mC.getterFor(pC);
X3(String, "String", function(e) {
  Z3(this, {
    type: pC,
    string: Q3(e),
    index: 0
  });
}, function() {
  var n = ez(this), t = n.string, i = n.index, a;
  return i >= t.length ? Wk(void 0, !0) : (a = J3(t, i), n.index += a.length, Wk(a, !1));
});
var nz = br, tz = nz.Promise, rz = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, iz = rz, az = _t, oz = ys, sz = wi, Kk = Ma, lz = pt, Gk = lz("toStringTag");
for (var Xu in iz) {
  var Yk = az[Xu], Zu = Yk && Yk.prototype;
  Zu && oz(Zu) !== Gk && sz(Zu, Gk, Xu), Kk[Xu] = Kk.Array;
}
var cz = tz, uz = cz, dz = uz, mz = /* @__PURE__ */ iE(dz), pz = TypeError, fz = 9007199254740991, hz = function(e) {
  if (e > fz) throw pz("Maximum allowed index exceeded");
  return e;
}, vz = mt, yz = pt, gz = Tc, kz = yz("species"), fC = function(e) {
  return gz >= 51 || !vz(function() {
    var n = [], t = n.constructor = {};
    return t[kz] = function() {
      return { foo: 1 };
    }, n[e](Boolean).foo !== 1;
  });
}, bz = nt, _z = mt, xz = Vc, Sz = kr, Nz = Aa, jz = La, Jk = hz, Qk = yv, wz = JD, Cz = fC, Fz = pt, Iz = Tc, hC = Fz("isConcatSpreadable"), $z = Iz >= 51 || !_z(function() {
  var e = [];
  return e[hC] = !1, e.concat()[0] !== e;
}), Ez = function(e) {
  if (!Sz(e)) return !1;
  var n = e[hC];
  return n !== void 0 ? !!n : xz(e);
}, Tz = !$z || !Cz("concat");
bz({ target: "Array", proto: !0, forced: Tz }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(n) {
    var t = Nz(this), i = wz(t, 0), a = 0, o, s, l, u, m;
    for (o = -1, l = arguments.length; o < l; o++)
      if (m = o === -1 ? t : arguments[o], Ez(m))
        for (u = jz(m), Jk(a + u), s = 0; s < u; s++, a++) s in m && Qk(i, a, m[s]);
      else
        Jk(a + 1), Qk(i, a++, m);
    return i.length = a, i;
  }
});
var Oz = ir;
Oz("asyncIterator");
var Rz = ir;
Rz("hasInstance");
var Dz = ir;
Dz("isConcatSpreadable");
var Pz = ir;
Pz("iterator");
var Az = ir;
Az("match");
var Lz = ir;
Lz("matchAll");
var Vz = ir;
Vz("replace");
var zz = ir;
zz("search");
var Mz = ir;
Mz("species");
var Uz = ir;
Uz("split");
var Bz = ir, qz = ew;
Bz("toPrimitive");
qz();
var Hz = _r, Wz = ir, Kz = za;
Wz("toStringTag");
Kz(Hz("Symbol"), "Symbol");
var Gz = ir;
Gz("unscopables");
var Yz = _t, Jz = za;
Jz(Yz.JSON, "JSON", !0);
var Qz = br;
Qz.Symbol;
var Xz = ks;
Xz.f("iterator");
var Zz = hv;
Zz("Array").concat;
var eM = nt, Xk = Vc, nM = kv, tM = kr, Zk = mv, rM = La, iM = pi, aM = yv, oM = pt, sM = fC, lM = jv, cM = sM("slice"), uM = oM("species"), ed = Array, dM = Math.max;
eM({ target: "Array", proto: !0, forced: !cM }, {
  slice: function(n, t) {
    var i = iM(this), a = rM(i), o = Zk(n, a), s = Zk(t === void 0 ? a : t, a), l, u, m;
    if (Xk(i) && (l = i.constructor, nM(l) && (l === ed || Xk(l.prototype)) ? l = void 0 : tM(l) && (l = l[uM], l === null && (l = void 0)), l === ed || l === void 0))
      return lM(i, o, s);
    for (u = new (l === void 0 ? ed : l)(dM(s - o, 0)), m = 0; o < s; o++, m++) o in i && aM(u, m, i[o]);
    return u.length = m, u;
  }
});
var mM = hv;
mM("Array").slice;
var pM = ks;
pM.f("asyncIterator");
function nd(e, n, t, i) {
  function a(o) {
    return o instanceof t ? o : new t(function(s) {
      s(o);
    });
  }
  return new (t || (t = mz))(function(o, s) {
    function l(d) {
      try {
        m(i.next(d));
      } catch (f) {
        s(f);
      }
    }
    function u(d) {
      try {
        m(i.throw(d));
      } catch (f) {
        s(f);
      }
    }
    function m(d) {
      d.done ? o(d.value) : a(d.value).then(l, u);
    }
    m((i = i.apply(e, [])).next());
  });
}
class fM {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    var n;
    return window.electron ? !!window.electron : !!(!((n = process == null ? void 0 : process.versions) === null || n === void 0) && n.electron) || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  getVersion() {
    return nd(this, void 0, void 0, function* () {
      return window.electron ? (yield window.electron.getVersion()).split("-")[0] : "0.0.0";
    });
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  isStandaloneBuild() {
    return nd(this, void 0, void 0, function* () {
      var n;
      return !((n = window.electron) === null || n === void 0) && n.isStandaloneBuild ? yield window.electron.isStandaloneBuild() : null;
    });
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  isMsiBuild() {
    return nd(this, void 0, void 0, function* () {
      var n;
      return !((n = window.electron) === null || n === void 0) && n.isMsiBuild ? yield window.electron.isMsiBuild() : null;
    });
  }
}
const eb = new fM();
function hM(e, n) {
  return nb(e), nb(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function nb(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const vM = Object.prototype.toString;
function yM(e, n) {
  return vM.call(e) === `[object ${n}]`;
}
function gM(e) {
  return yM(e, "Object");
}
function kM(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const zo = "8.36.0", mi = globalThis;
function Tv(e, n, t) {
  const i = t || mi, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[zo] = a[zo] || {};
  return o[e] || (o[e] = n());
}
const vC = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, bM = "Sentry Logger ", tb = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], rb = {};
function yC(e) {
  if (!("console" in mi))
    return e();
  const n = mi.console, t = {}, i = Object.keys(rb);
  i.forEach((a) => {
    const o = rb[a];
    t[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = t[a];
    });
  }
}
function _M() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return vC ? tb.forEach((t) => {
    n[t] = (...i) => {
      e && yC(() => {
        mi.console[t](`${bM}[${t}]:`, ...i);
      });
    };
  }) : tb.forEach((t) => {
    n[t] = () => {
    };
  }), n;
}
const Tl = Tv("logger", _M);
function xM(e, n, t) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: t,
      writable: !0,
      configurable: !0
    });
  } catch {
    vC && Tl.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const gC = 1e3;
function Ov() {
  return Date.now() / gC;
}
function SM() {
  const { performance: e } = mi;
  if (!e || !e.now)
    return Ov;
  const n = Date.now() - e.now(), t = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (t + e.now()) / gC;
}
const NM = SM();
(() => {
  const { performance: e } = mi;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, t = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + t - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, u = typeof s == "number" ? Math.abs(s + t - i) : n, m = u < n;
  return o || m ? a <= u ? e.timeOrigin : s : i;
})();
function ba() {
  const e = mi, n = e.crypto || e.msCrypto;
  let t = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (t = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (t() & 15) >> i / 4).toString(16)
    )
  );
}
function ib() {
  return {
    traceId: ba(),
    spanId: ba().substring(16)
  };
}
function Rv() {
  return Dv(mi), mi;
}
function Dv(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || zo, n[zo] = n[zo] || {};
}
function jM(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || NM(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : ba()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const t = e.timestamp - e.started;
    e.duration = t >= 0 ? t : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const gh = "_sentrySpan";
function ab(e, n) {
  n ? xM(e, gh, n) : delete e[gh];
}
function ob(e) {
  return e[gh];
}
const wM = 100;
class Pv {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = ib();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Pv();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, ab(n, ob(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && jM(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, t) {
    return this._tags = { ...this._tags, [n]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, t) {
    return this._extra = { ...this._extra, [n]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, t) {
    return t === null ? delete this._contexts[n] : this._contexts[n] = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const t = typeof n == "function" ? n(this) : n, [i, a] = t instanceof Ia ? [t.getScopeData(), t.getRequestSession()] : gM(t) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: u, level: m, fingerprint: d = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...u }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), d.length && (this._fingerprint = d), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, ab(this, void 0), this._attachments = [], this._propagationContext = ib(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, t) {
    const i = typeof t == "number" ? t : wM;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Ov(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: ob(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, t) {
    const i = t && t.event_id ? t.event_id : ba();
    if (!this._client)
      return Tl.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...t,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, t, i) {
    const a = i && i.event_id ? i.event_id : ba();
    if (!this._client)
      return Tl.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      t,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, t) {
    const i = t && t.event_id ? t.event_id : ba();
    return this._client ? (this._client.captureEvent(n, { ...t, event_id: i }, this), i) : (Tl.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Ia = Pv;
function CM() {
  return Tv("defaultCurrentScope", () => new Ia());
}
function FM() {
  return Tv("defaultIsolationScope", () => new Ia());
}
class IM {
  constructor(n, t) {
    let i;
    n ? i = n : i = new Ia();
    let a;
    t ? a = t : a = new Ia(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const t = this._pushScope();
    let i;
    try {
      i = n(t);
    } catch (a) {
      throw this._popScope(), a;
    }
    return kM(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function $a() {
  const e = Rv(), n = Dv(e);
  return n.stack = n.stack || new IM(CM(), FM());
}
function $M(e) {
  return $a().withScope(e);
}
function EM(e, n) {
  const t = $a();
  return t.withScope(() => (t.getStackTop().scope = e, n(e)));
}
function sb(e) {
  return $a().withScope(() => e($a().getIsolationScope()));
}
function TM() {
  return {
    withIsolationScope: sb,
    withScope: $M,
    withSetScope: EM,
    withSetIsolationScope: (e, n) => sb(n),
    getCurrentScope: () => $a().getScope(),
    getIsolationScope: () => $a().getIsolationScope()
  };
}
function kC(e) {
  const n = Dv(e);
  return n.acs ? n.acs : TM();
}
function Av() {
  const e = Rv();
  return kC(e).getCurrentScope();
}
function bC() {
  const e = Rv();
  return kC(e).getIsolationScope();
}
function OM() {
  return Av().getClient();
}
function RM(e) {
  if (e)
    return DM(e) ? { captureContext: e } : AM(e) ? {
      captureContext: e
    } : e;
}
function DM(e) {
  return e instanceof Ia || typeof e == "function";
}
const PM = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function AM(e) {
  return Object.keys(e).some((n) => PM.includes(n));
}
function lb(e, n) {
  return Av().captureException(e, RM(n));
}
function LM(e, n) {
  const t = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Av().captureMessage(e, t, i);
}
function VM(e, n) {
  bC().setContext(e, n);
}
const zM = 100;
function Oi(e, n) {
  const t = OM(), i = bC();
  if (!t) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = zM } = t.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Ov(), ...e }, u = a ? yC(() => a(l, n)) : l;
  u !== null && (t.emit && t.emit("beforeAddBreadcrumb", u, n), i.addBreadcrumb(u, o));
}
var ts;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(ts || (ts = {}));
function _a(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const t = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(t, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const MM = Qo.backendDomain ? {
  "backend-domain": Qo.backendDomain
} : void 0;
function Ol() {
  const e = new URLSearchParams(Object.assign({ noToken: "true" }, MM)).toString();
  document.location.href = `${Qo.url.logIn}?${e}`;
}
const td = "authData", rd = 30, UM = 600, id = 5;
class BM {
  constructor() {
    Object.defineProperty(this, "authData", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "accessTokenExpiresAt", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "clientServerTimeDiff", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= id || this.clientServerTimeDiff <= -id ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + UM, a = _a(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > id) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(td, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(td), t = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(t) && (this.authData = t), t;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(td);
  }
  getAccessToken() {
    var n;
    return ((n = this.authData) === null || n === void 0 ? void 0 : n.access_token) || null;
  }
  getRefreshToken() {
    var n;
    return ((n = this.authData) === null || n === void 0 ? void 0 : n.refresh_token) || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const t = this.accessTokenExpiresAt - rd;
    return this.estimatedServerTime() >= t;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const t = _a(n), i = t.exp - rd;
    return !t || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - rd - this.estimatedServerTime()) * 1e3;
  }
}
const Ct = new BM();
var qM = function(e, n, t, i) {
  function a(o) {
    return o instanceof t ? o : new t(function(s) {
      s(o);
    });
  }
  return new (t || (t = Promise))(function(o, s) {
    function l(d) {
      try {
        m(i.next(d));
      } catch (f) {
        s(f);
      }
    }
    function u(d) {
      try {
        m(i.throw(d));
      } catch (f) {
        s(f);
      }
    }
    function m(d) {
      d.done ? o(d.value) : a(d.value).then(l, u);
    }
    m((i = i.apply(e, n || [])).next());
  });
};
function HM(e) {
  return qM(this, void 0, void 0, function* () {
    var n, t;
    const i = window.location.origin.replace(/^https?:\/\//, ""), a = ["localhost:8080", "uptrends-monitor"];
    if (!(!e.response || a.some((o) => i.includes(o)))) {
      try {
        const o = (n = e.response.config.headers.Authorization) !== null && n !== void 0 ? n : "", s = o ? (t = o.toString()) === null || t === void 0 ? void 0 : t.split("Basic ")[1] : "", l = s ? atob(s).split("token:")[1] : "", u = l ? _a(l).exp : "None", m = yield Gc.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), f = m?.access_token, h = m?.refresh_token, y = f ? _a(f).exp : "None", x = h ? _a(h).exp : "None", S = typeof u == "number" ? d - u : "Unknown", j = typeof y == "number" ? d - y : "Unknown", w = typeof x == "number" ? d - x : "Unknown", v = e.response.headers["x-dixa-rid"];
        VM("Expires", {
          currentTimestamp: d,
          accessTokenFromHeader: u,
          accessTokenFromHeaderDiff: S,
          accessTokenFromLocalStorage: y,
          accessTokenFromLocalStorageDiff: j,
          refreshTokenFromLocalStorage: x,
          refreshTokenFromLocalStorageDiff: w,
          xDixaRid: v,
          navigatorOnline: navigator.onLine
        });
      } catch (o) {
        console.error("Error adding Sentry error context", o);
      }
      LM("401 unauthorized interceptor", {
        level: "debug",
        tags: {
          team: ts.Platform,
          domain: i
        }
      });
    }
  });
}
const ad = /* @__PURE__ */ new Map(), WM = 3;
function KM(e) {
  e.interceptors.response.use((n) => (ad.delete(n.config.url), n), (n) => {
    var t;
    if (n.response) {
      const { status: i } = n.response;
      switch (i) {
        case kh.Unauthorized:
          if (!Gc.isRefreshTokenExpired() && n.config) {
            Oi({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const a = (t = ad.get(n.config.url)) !== null && t !== void 0 ? t : 0;
            if (console.log(`Retrying request (${a + 1}): ${n.config.url}`), a <= WM)
              return ad.set(n.config.url, a + 1), e(n.config);
          }
          HM(n), console.error("401 unauthorized interceptor"), Ol();
          break;
      }
    }
    return Promise.reject(n);
  });
}
var gi = function(e, n, t, i) {
  function a(o) {
    return o instanceof t ? o : new t(function(s) {
      s(o);
    });
  }
  return new (t || (t = Promise))(function(o, s) {
    function l(d) {
      try {
        m(i.next(d));
      } catch (f) {
        s(f);
      }
    }
    function u(d) {
      try {
        m(i.throw(d));
      } catch (f) {
        s(f);
      }
    }
    function m(d) {
      d.done ? o(d.value) : a(d.value).then(l, u);
    }
    m((i = i.apply(e, n || [])).next());
  });
};
const _C = dt.create();
KM(_C);
const ii = console.log;
function cb(e) {
  return gi(this, void 0, void 0, function* () {
    return new Promise((n) => setTimeout(n, e * 1e3));
  });
}
class GM extends Error {
  constructor(n, t) {
    super(n, t);
  }
}
function YM(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const JM = 5;
class QM {
  constructor() {
    Object.defineProperty(this, "authDataPromise", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  init(n) {
    return gi(this, void 0, void 0, function* () {
      const t = yield this.refresh(n);
      if (t)
        Ct.setAuthData(t);
      else {
        const i = Ct.isRefreshTokenExpired(n) ? "expired" : "unknown";
        throw new GM("Failed to init refresh token", {
          cause: i
        });
      }
    });
  }
  getDebugInfo() {
    const n = Ct.getAccessToken();
    if (!n)
      return {};
    const t = _a(n), { exp: i } = t;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  getAuthData() {
    return gi(this, arguments, void 0, function* ({ localStorageOnly: n = !1 } = {}) {
      if (n)
        return Ct.getAuthData();
      if (this.authDataPromise)
        return yield this.authDataPromise;
      const t = Ct.getAuthData();
      return t ? Ct.isAccessTokenExpired() ? (Oi({
        category: "refreshToken",
        // Cannot include "token" in the message, as it will be redacted
        message: "expired or about to expire",
        level: "debug",
        data: this.getDebugInfo()
      }), this.authDataPromise = this.refresh(t.refresh_token).then((i) => (i && Ct.setAuthData(i), this.authDataPromise = null, i)), yield this.authDataPromise) : t : null;
    });
  }
  removeAuthData() {
    return Ct.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return Ct.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return Ct.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = Ct.getAuthData();
    return n ? Ct.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  isSupported() {
    return gi(this, void 0, void 0, function* () {
      if (!eb.isElectron())
        return !0;
      const n = yield eb.getVersion();
      return hM(n, "3.7.0") === 1;
    });
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  refresh(n) {
    return gi(this, arguments, void 0, function* (t, i = JM) {
      try {
        return yield _C.post(`${Qo.url.rest}/v2/login/refresh`, {
          refreshToken: t
        }).then((a) => (this.retryCount = 0, a.data.data));
      } catch (a) {
        return yield this.handleRefreshError(a, t, i);
      }
    });
  }
  waitUntilOnline() {
    return gi(this, void 0, void 0, function* () {
      const n = navigator.onLine === !1;
      for (n && (ii("AUTH", "Network connection offline - waiting..."), Oi({
        category: "refreshToken",
        message: "Network connection offline - waiting...",
        level: "debug"
      })); navigator.onLine === !1; )
        yield cb(5);
      n && (ii("AUTH", "Network connection restored"), Oi({
        category: "refreshToken",
        message: "Network connection restored",
        level: "debug"
      }));
    });
  }
  retryRefresh(n, t) {
    return gi(this, void 0, void 0, function* () {
      yield this.waitUntilOnline(), this.retryCount++;
      const i = YM(this.retryCount);
      return ii("AUTH", `Retrying in ${i} seconds`), yield cb(i), yield this.refresh(n, t);
    });
  }
  handleRefreshError(n, t, i) {
    return gi(this, void 0, void 0, function* () {
      var a;
      if (Ct.isRefreshTokenExpired(t))
        return ii("AUTH", "Refresh token expired"), Oi({
          category: "refreshToken",
          message: "Refresh token expired",
          level: "debug"
        }), Ct.removeAuthData(), Ol(), null;
      if (rE(n)) {
        if (n.message === "timeout exceeded")
          return ii("AUTH", "Timeout exceeded"), Oi({
            category: "refreshToken",
            message: "Timeout exceeded",
            level: "debug"
          }), yield this.retryRefresh(t, i);
        if (n.message === "Network Error")
          return ii("AUTH", "Network error"), Oi({
            category: "refreshToken",
            message: "Network error",
            level: "debug"
          }), yield this.retryRefresh(t, i);
        if (((a = n.response) === null || a === void 0 ? void 0 : a.status) === 401)
          return ii("AUTH", "Refresh token invalid (401)"), Ct.removeAuthData(), Ol(), null;
        lb(n, {
          level: "error",
          tags: {
            team: ts.Platform,
            errorSource: "authManager.refresh"
          }
        });
      }
      return i <= 0 ? (ii("AUTH", "Retries exhausted, logging out"), lb(n, {
        level: "error",
        tags: {
          team: ts.Platform,
          errorSource: "authManager.refresh"
        }
      }), Ct.removeAuthData(), Ol(), null) : (ii("AUTH", `Retrying ${i} more times`), yield this.retryRefresh(t, i - 1));
    });
  }
  accessTokenExpiresInMs() {
    return Ct.accessTokenExpiresInMs();
  }
}
const Gc = new QM();
var kh;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(kh || (kh = {}));
const XM = new Qh((e, n) => new nj((t) => {
  Gc.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(t);
  }).catch((i) => t.error(i));
})), ZM = new Qh(
  (e, n) => new nj((t) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Gc.getAuthData().then((u) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...HF(Qo.url.partnerIntegrations) && u?.access_token && WF(u.access_token)
      }
    }), n(e).subscribe(t))).catch((u) => t.error(u));
  })
), eU = new AbortController(), xC = (e) => new hI({
  queryDeduplication: !1,
  cache: new vI(),
  link: Qh.from([
    XM,
    ZM,
    yI({
      uri: `${e}/graphql`,
      fetch: SI,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: eU.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), nU = ({
  configuration: e,
  children: n
}) => {
  const t = Wn(
    () => xC(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ ze.jsx(gI, { client: t, children: n });
};
function tU() {
  try {
    return kI(), !0;
  } catch {
    return !1;
  }
}
const rU = ({
  configuration: e,
  children: n
}) => tU() ? n : /* @__PURE__ */ ze.jsx(nU, { configuration: e, children: n }), iU = ({
  integrationId: e,
  type: n,
  showNotification: t,
  showModal: i,
  children: a
}) => /* @__PURE__ */ ze.jsx(bI, { children: (o) => /* @__PURE__ */ ze.jsx(
  KF,
  {
    value: {
      useMutation: QF(e, n),
      useQuery: JF(e, n),
      useLazyQuery: YF(e, n),
      executeQuery: GF(e, n, o),
      showNotification: t,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), SC = ({
  integrationId: e,
  type: n,
  configuration: t,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ ze.jsx(rU, { configuration: t, children: s ? /* @__PURE__ */ ze.jsx(
    iU,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, aU = ji`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        settings {
          key
          value
        }
      }
    }
  }
`;
function oU(e) {
  const [n, t] = oe([]), [i, a] = oe(!1);
  return qe(() => {
    a(!0), xC(e).query({
      query: aU
    }).then(({ data: o }) => {
      t(o?.Management?.widgetConfigurations), a(!1);
    }).catch(() => a(!1));
  }, [e]), {
    isLoading: i,
    widgets: n
  };
}
const NC = ({
  headline: e,
  text: n,
  children: t,
  onConfirm: i,
  onCancel: a,
  confirmLabel: o,
  cancelLabel: s = "Cancel",
  confirmVariant: l = "primary",
  cancelVariant: u = "secondary",
  isOpen: m,
  setIsOpen: d,
  showOnClose: f = !1
}) => /* @__PURE__ */ ze.jsxs(
  Nt,
  {
    isOpen: m,
    onClose: () => {
      a && a(), d(!1);
    },
    children: [
      /* @__PURE__ */ ze.jsx(
        jt,
        {
          title: e,
          onClose: f ? a : void 0
        }
      ),
      /* @__PURE__ */ ze.jsxs(wt, { children: [
        n && /* @__PURE__ */ ze.jsx("div", { style: { width: "600px" }, children: n }),
        t
      ] }),
      /* @__PURE__ */ ze.jsx(
        Ot,
        {
          confirmOnClick: i ? () => {
            i(), d(!1);
          } : void 0,
          cancelOnClick: () => {
            a && a(), d(!1);
          },
          confirmName: o,
          cancelName: s,
          confirmProps: { variant: l },
          cancelProps: { variant: u }
        }
      )
    ]
  }
);
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var od = { exports: {} }, eo = {}, ub;
function sU() {
  if (ub) return eo;
  ub = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return eo.Fragment = t, eo.jsx = s, eo.jsxs = s, eo;
}
var Js = {}, db;
function lU() {
  return db || (db = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    Js.Fragment = i, Js.jsx = Bn, Js.jsxs = qn;
  }()), Js;
}
var mb;
function cU() {
  return mb || (mb = 1, process.env.NODE_ENV === "production" ? od.exports = sU() : od.exports = lU()), od.exports;
}
var le = cU();
const uU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, dU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, mU = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": uU,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": dU
};
function jC(e) {
  return mU[e] ?? {};
}
const pU = jC(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), fU = jC(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), hU = "_copyIcon_1wjfs_48", vU = "_list_1wjfs_53", yU = "_listItem_1wjfs_63", gU = "_collapsible_1wjfs_72", kU = "_collapsibleIsOpen_1wjfs_80", bU = "_collapsibleHeader_1wjfs_83", _U = "_collapsibleIconTrue_1wjfs_86", xU = "_collapsibleIconFalse_1wjfs_89", Pn = {
  copyIcon: hU,
  list: vU,
  listItem: yU,
  collapsible: gU,
  collapsibleIsOpen: kU,
  collapsibleHeader: bU,
  collapsibleIconTrue: _U,
  collapsibleIconFalse: xU
}, SU = ({
  app: e,
  openByDefault: n
}) => {
  const [t, i] = oe(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: u,
    last_used: m
  } = e;
  return /* @__PURE__ */ le.jsxs(
    b,
    {
      className: ut(Pn.collapsible, {
        [Pn.collapsibleIsOpen]: t
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ le.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Pn.collapsibleHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ le.jsx(
                tr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ le.jsxs(He, { className: Pn.list, children: [
          /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Dn(u).format(ct) })
          ] }) }),
          /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Dn(m).format(ct) })
          ] }) })
        ] })
      ]
    }
  );
}, NU = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ le.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ le.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ le.jsx(Mn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ le.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((t, i) => /* @__PURE__ */ le.jsx(SU, { app: t, openByDefault: i === 0 }, i))
  ] });
}, jU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, t = Object.keys(n).length > 0;
  return /* @__PURE__ */ le.jsx(le.Fragment, { children: /* @__PURE__ */ le.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !t && /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    t && /* @__PURE__ */ le.jsx(He, { className: Pn.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ le.jsx(
      He.Text,
      {
        variant: "dense",
        className: Pn.listItem,
        children: /* @__PURE__ */ le.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: i }),
          QN(a)
        ] })
      },
      o
    )) })
  ] }) });
}, wU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, t = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = t && t.length > 0;
  return /* @__PURE__ */ le.jsx(le.Fragment, { children: /* @__PURE__ */ le.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ le.jsx(He, { className: Pn.list, children: t.map((a, o) => /* @__PURE__ */ le.jsx(
      He.Text,
      {
        variant: "dense",
        className: Pn.listItem,
        children: /* @__PURE__ */ le.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ le.jsx(
            Qe,
            {
              content: /* @__PURE__ */ le.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ le.jsx(b, { children: `First ${Dn(a?.first).format(
                  ct
                )}` }),
                /* @__PURE__ */ le.jsx(b, { children: `Last ${Dn(a?.last).format(
                  ct
                )}` })
              ] }),
              children: /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Xl = ({
  state: e,
  noTooltip: n = !1,
  isPush: t = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const u = t ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${u}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${u}.` : `Opted in: The user has explicitly confirmed they want to receive ${u}.`;
  };
  return /* @__PURE__ */ le.jsx(Qe, { content: n ? null : l(), children: /* @__PURE__ */ le.jsx(b, { alignItems: "center", children: /* @__PURE__ */ le.jsx(me, { size: 14, name: o(), color: s() }) }) });
}, CU = "_wrapper_1xucg_1", FU = "_externalLink_1xucg_7", sd = {
  wrapper: CU,
  externalLink: FU
}, IU = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: t } = Dr(), { isCopied: i, copy: a } = Dr(), { isCopied: o, copy: s } = Dr();
  if (!e)
    return null;
  const {
    first_name: l,
    last_name: u,
    home_city: m,
    country: d,
    email: f,
    phone: h,
    dob: y,
    created_at: x,
    email_subscribe: S,
    push_subscribe: j
  } = e, w = 14, v = `${l || ""} ${u || ""}`.trim() || "A customer has no name", q = `${m ? `${m} /` : ""} ${d || ""}`.trim(), T = y ? Dn(y).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ le.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ le.jsxs(b, { className: sd.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ le.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: sd.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-2", children: v }),
          T && /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    x && /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: Dn(x).format(ct) })
    ] }),
    q && /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ le.jsx(me, { size: w, name: "map-pin" }),
        /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: q })
      ] }),
      /* @__PURE__ */ le.jsx(Qe, { content: "Copy location", children: /* @__PURE__ */ le.jsx(b, { alignItems: "center", children: /* @__PURE__ */ le.jsx(
        me,
        {
          size: w,
          name: o ? "done" : "copy",
          onClick: () => s(q),
          className: Pn.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ le.jsx(me, { size: w, name: "mail" }),
        /* @__PURE__ */ le.jsx("span", { className: sd.externalLink, children: f })
      ] }),
      /* @__PURE__ */ le.jsx(Qe, { content: "Copy email", children: /* @__PURE__ */ le.jsx(b, { alignItems: "center", children: /* @__PURE__ */ le.jsx(
        me,
        {
          size: w,
          name: n ? "done" : "copy",
          onClick: () => t(f),
          className: Pn.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ le.jsx(me, { size: w, name: "phone" }),
        /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: h })
      ] }),
      /* @__PURE__ */ le.jsx(Qe, { content: "Copy phone number", children: /* @__PURE__ */ le.jsx(b, { alignItems: "center", children: /* @__PURE__ */ le.jsx(
        me,
        {
          size: w,
          name: i ? "done" : "copy",
          onClick: () => a(h),
          className: Pn.copyIcon
        }
      ) }) })
    ] }),
    S && /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ le.jsx(me, { size: w, name: "sync" }),
        /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ le.jsx(Xl, { state: S })
    ] }),
    j && /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ le.jsx(me, { size: w, name: "bell" }),
        /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ le.jsx(Xl, { isPush: !0, state: j })
    ] })
  ] }) });
}, $U = ({
  device: e,
  openByDefault: n
}) => {
  const [t, i] = oe(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: u,
    idfa: m,
    idfv: d,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ le.jsxs(
    b,
    {
      className: ut(Pn.collapsible, {
        [Pn.collapsibleIsOpen]: t
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ le.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Pn.collapsibleHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ le.jsx(
                tr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ le.jsxs(He, { className: Pn.list, children: [
          /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ le.jsx(
              me,
              {
                size: a,
                className: ut({
                  [Pn.collapsibleIconTrue]: u,
                  [Pn.collapsibleIconFalse]: !u
                }),
                name: u ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ le.jsx(Qe, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: d })
              ]
            }
          ) }) }),
          /* @__PURE__ */ le.jsx(Qe, { content: "For iOS", children: /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, EU = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ le.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ le.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ le.jsx(Mn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ le.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((t, i) => /* @__PURE__ */ le.jsx($U, { device: t, openByDefault: i === 0 }, i))
  ] });
}, no = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, Qs = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: t
}) => {
  const { track: i } = gn(), { useMutation: a } = mn(), [o, s] = oe(!1), [l] = a(
    fU,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), u = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: no[n].parameter
        }
      }
    }), setTimeout(async () => {
      await t().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ le.jsx(Qe, { content: no[n].tooltipContent, children: /* @__PURE__ */ le.jsx(
    Kn,
    {
      variant: "secondary",
      color: no[n].color,
      isLoading: o,
      onClick: () => u(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ le.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ le.jsx(
          Xl,
          {
            noTooltip: !0,
            state: no[n].parameter
          }
        ),
        no[n].label
      ] })
    }
  ) });
}, TU = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: t
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ le.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ le.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ le.jsx(He, { className: Pn.list, children: /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Pn.listItem, children: /* @__PURE__ */ le.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ le.jsx(me, { size: 14, name: "sync" }),
        /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ le.jsx(Xl, { state: a })
    ] }) }) }),
    /* @__PURE__ */ le.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ le.jsxs(le.Fragment, { children: [
        /* @__PURE__ */ le.jsx(
          Qs,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: t
          }
        ),
        /* @__PURE__ */ le.jsx(
          Qs,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: t
          }
        )
      ] }),
      s && /* @__PURE__ */ le.jsx(
        Qs,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: t
        }
      ),
      l && /* @__PURE__ */ le.jsx(
        Qs,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: t
        }
      )
    ] })
  ] }) });
}, OU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, t = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = t && t.length > 0;
  return /* @__PURE__ */ le.jsx(le.Fragment, { children: /* @__PURE__ */ le.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ le.jsx(He, { className: Pn.list, children: t.map((a, o) => /* @__PURE__ */ le.jsx(
      He.Text,
      {
        variant: "dense",
        className: Pn.listItem,
        children: /* @__PURE__ */ le.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ le.jsx(
            Qe,
            {
              content: /* @__PURE__ */ le.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ le.jsx(b, { children: `First ${Dn(a?.first).format(
                  ct
                )}` }),
                /* @__PURE__ */ le.jsx(b, { children: `Last ${Dn(a?.last).format(
                  ct
                )}` })
              ] }),
              children: /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, RU = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: t } = gn(), { useMutation: i } = mn(), [a, o] = oe(), [s, l] = oe(!1), [u, m] = oe(!1), d = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, y = n.updateEmailSubscriptionState ?? !1, x = n.displayCustomAttributes ?? !1, S = n.displayCustomEvents ?? !1, j = n.displayPuchases ?? !1, w = n.displayDevices ?? !1, v = n.displayApps ?? !1, q = !h && !y && !x && !S && !j, [T, { error: I }] = i(
    pU,
    {
      onError: () => {
      },
      onCompleted: (U) => {
        const Z = U?.Braze?.exportUserDetails?.users?.[0];
        Z ? (o(Z), l(!1), t("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), O = async () => {
    d || f ? await T({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...d ? { email_address: d } : { phone: f },
          fields_to_export: [
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  return qe(() => {
    async function U() {
      m(!0), await O();
    }
    U().finally(() => m(!1));
  }, [d, f]), I ? Hh({ errors: I.graphQLErrors }) ? /* @__PURE__ */ le.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      "data-testid": "widget-downstream-api-forbidden-error",
      children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
    }
  ) : Wh({ errors: I.graphQLErrors }) ? /* @__PURE__ */ le.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      "data-testid": "widget-downstream-api-authorization-error",
      children: "The integration could not authorize against Braze. Please contact your administrator."
    }
  ) : /* @__PURE__ */ le.jsx(wn, { error: I }) : u ? /* @__PURE__ */ le.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ le.jsx(dn, {}) }) : q ? /* @__PURE__ */ le.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ le.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ le.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ le.jsx(IU, { customerDetails: a }),
        y && !!a && /* @__PURE__ */ le.jsx(
          TU,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await O()
          }
        ),
        x && !!a && /* @__PURE__ */ le.jsx(jU, { customerDetails: a }),
        S && !!a && /* @__PURE__ */ le.jsx(wU, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ le.jsx(OU, { customerDetails: a }),
        w && !!a && /* @__PURE__ */ le.jsx(EU, { devices: a?.devices }),
        v && !!a && /* @__PURE__ */ le.jsx(NU, { apps: a?.apps })
      ]
    }
  );
}, DU = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => JN(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function PU() {
  var e = ga(!1), n = vt(function() {
    return e.current;
  }, []);
  return qe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var AU = function(e) {
  e === void 0 && (e = {});
  var n = oe(e), t = n[0], i = n[1], a = vt(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [t, a];
}, LU = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, pb = function(e) {
  return iI(LU, e);
}, ld, fb;
function VU() {
  return fb || (fb = 1, ld = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, t = [], i = 0; i < e.rangeCount; i++)
      t.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || t.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), ld;
}
var cd, hb;
function zU() {
  if (hb) return cd;
  hb = 1;
  var e = VU(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, t = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, u, m, d, f, h, y = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), d = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(S) {
        if (S.stopPropagation(), s.format)
          if (S.preventDefault(), typeof S.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var j = n[s.format] || n.default;
            window.clipboardData.setData(j, o);
          } else
            S.clipboardData.clearData(), S.clipboardData.setData(s.format, o);
        s.onCopy && (S.preventDefault(), s.onCopy(S.clipboardData));
      }), document.body.appendChild(h), d.selectNodeContents(h), f.addRange(d);
      var x = document.execCommand("copy");
      if (!x)
        throw new Error("copy command was unsuccessful");
      y = !0;
    } catch (S) {
      l && console.error("unable to copy using execCommand: ", S), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), y = !0;
      } catch (j) {
        l && console.error("unable to copy using clipboardData: ", j), l && console.error("falling back to prompt"), u = i("message" in s ? s.message : t), window.prompt(u, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(d) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return y;
  }
  return cd = a, cd;
}
var MU = zU();
const UU = /* @__PURE__ */ Xh(MU);
var wC = function() {
  var e = PU(), n = AU({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), t = n[0], i = n[1], a = vt(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var u = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(u), i({
            value: o,
            error: u,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var u = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(u), i({
            value: o,
            error: u,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = UU(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [t, a];
};
function BU(e, n) {
  var t = ga(!1), i = ga(), a = ga(e), o = vt(function() {
    return t.current;
  }, []), s = vt(function() {
    t.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      t.current = !0, a.current();
    }, n);
  }, [n]), l = vt(function() {
    t.current = null, i.current && clearTimeout(i.current);
  }, []);
  return qe(function() {
    a.current = e;
  }, [e]), qe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function Ba(e, n, t) {
  t === void 0 && (t = []);
  var i = BU(e, n), a = i[0], o = i[1], s = i[2];
  return qe(s, t), [a, o];
}
var qU = function(e) {
  qe(e, []);
}, HU = function(e, n) {
  var t = ga(function() {
  });
  qe(function() {
    t.current = e;
  }), qe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return t.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, WU = function(e) {
  e === void 0 && (e = {});
  var n = oe(e), t = n[0], i = n[1], a = Wn(function() {
    return {
      set: function(s, l) {
        i(function(u) {
          var m;
          return cu(cu({}, u), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var u = l, m = s;
          u[m];
          var d = NI(u, [typeof m == "symbol" ? m : m + ""]);
          return d;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = cu({ get: vt(function(s) {
    return t[s];
  }, [t]) }, a);
  return [t, o];
}, KU = function(e) {
  var n = ga(e);
  n.current = e, qU(function() {
    return function() {
      return n.current();
    };
  });
}, ws = (e) => e.type === "checkbox", Vi = (e) => e instanceof Date, Mt = (e) => e == null;
const CC = (e) => typeof e == "object";
var ot = (e) => !Mt(e) && !Array.isArray(e) && CC(e) && !Vi(e), FC = (e) => ot(e) && e.target ? ws(e.target) ? e.target.checked : e.target.value : e, GU = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, IC = (e, n) => e.has(GU(n)), YU = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ot(n) && n.hasOwnProperty("isPrototypeOf");
}, Lv = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function It(e) {
  let n;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Lv && (e instanceof Blob || i)) && (t || ot(e)))
    if (n = t ? [] : {}, !t && !YU(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = It(e[a]));
  else
    return e;
  return n;
}
var Yc = (e) => Array.isArray(e) ? e.filter(Boolean) : [], rt = (e) => e === void 0, Ge = (e, n, t) => {
  if (!n || !ot(e))
    return t;
  const i = Yc(n.split(/[,[\].]+?/)).reduce((a, o) => Mt(a) ? a : a[o], e);
  return rt(i) || i === e ? rt(e[n]) ? t : e[n] : i;
}, or = (e) => typeof e == "boolean", Vv = (e) => /^\w*$/.test(e), $C = (e) => Yc(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Gn = (e, n, t) => {
  let i = -1;
  const a = Vv(n) ? [n] : $C(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = t;
    if (i !== s) {
      const m = e[l];
      u = ot(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const Zl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Fr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ai = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, EC = Se.createContext(null), ti = () => Se.useContext(EC), zv = (e) => {
  const { children: n, ...t } = e;
  return Se.createElement(EC.Provider, { value: t }, n);
};
var TC = (e, n, t, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Fr.all && (n._proxyFormState[s] = !i || Fr.all), t && (t[s] = !0), e[s];
      }
    });
  return a;
};
function JU(e) {
  const n = ti(), { control: t = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(t._formState), u = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => t._subscribe({
    name: m.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...t._formState,
        ...d
      });
    }
  }), [t, i, o]), Se.useEffect(() => {
    u.current.isValid && t._setValid(!0);
  }, [t]), Se.useMemo(() => TC(s, t, u.current, !1), [s, t]);
}
var Jr = (e) => typeof e == "string", OC = (e, n, t, i, a) => Jr(e) ? (i && n.watch.add(e), Ge(t, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ge(t, o))) : (i && (n.watchAll = !0), t);
function Rl(e) {
  const n = ti(), { control: t = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), u = Se.useRef(a);
  l.current = i, Se.useEffect(() => t._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(OC(l.current, t._names, f.values || t._formValues, !1, u.current))
  }), [t, o, s]);
  const [m, d] = Se.useState(t._getWatch(i, a));
  return Se.useEffect(() => t._removeUnmounted()), m;
}
function Mv(e) {
  const n = ti(), { name: t, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = IC(a._names.array, t), l = Rl({
    control: a,
    name: t,
    defaultValue: Ge(a._formValues, t, Ge(a._defaultValues, t, e.defaultValue)),
    exact: !0
  }), u = JU({
    control: a,
    name: t,
    exact: !0
  }), m = Se.useRef(e), d = Se.useRef(a.register(t, {
    ...e.rules,
    value: l,
    ...or(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ge(u.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ge(u.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ge(u.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ge(u.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => Ge(u.errors, t)
    }
  }), [u, t]), h = Se.useCallback((j) => d.current.onChange({
    target: {
      value: FC(j),
      name: t
    },
    type: Zl.CHANGE
  }), [t]), y = Se.useCallback(() => d.current.onBlur({
    target: {
      value: Ge(a._formValues, t),
      name: t
    },
    type: Zl.BLUR
  }), [t, a._formValues]), x = Se.useCallback((j) => {
    const w = Ge(a._fields, t);
    w && j && (w._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (v) => j.setCustomValidity(v),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, t]), S = Se.useMemo(() => ({
    name: t,
    value: l,
    ...or(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: y,
    ref: x
  }), [t, i, u.disabled, h, y, x, l]);
  return Se.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(t, {
      ...m.current.rules,
      ...or(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const w = (v, q) => {
      const T = Ge(a._fields, v);
      T && T._f && (T._f.mount = q);
    };
    if (w(t, !0), j) {
      const v = It(Ge(a._options.defaultValues, t));
      Gn(a._defaultValues, t, v), rt(Ge(a._formValues, t)) && Gn(a._formValues, t, v);
    }
    return !s && a.register(t), () => {
      (s ? j && !a._state.action : j) ? a.unregister(t) : w(t, !1);
    };
  }, [t, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, a]), Se.useMemo(() => ({
    field: S,
    formState: u,
    fieldState: f
  }), [S, u, f]);
}
const qt = (e) => e.render(Mv(e));
var QU = (e, n, t, i, a) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: a || !0
  }
} : {}, Mo = (e) => Array.isArray(e) ? e : [e], vb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, bh = (e) => Mt(e) || !CC(e);
function bi(e, n) {
  if (bh(e) || bh(n))
    return e === n;
  if (Vi(e) && Vi(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const a of t) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Vi(o) && Vi(s) || ot(o) && ot(s) || Array.isArray(o) && Array.isArray(s) ? !bi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Lt = (e) => ot(e) && !Object.keys(e).length, Uv = (e) => e.type === "file", Ir = (e) => typeof e == "function", ec = (e) => {
  if (!Lv)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, RC = (e) => e.type === "select-multiple", Bv = (e) => e.type === "radio", XU = (e) => Bv(e) || ws(e), ud = (e) => ec(e) && e.isConnected;
function ZU(e, n) {
  const t = n.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = rt(e) ? i++ : e[n[i++]];
  return e;
}
function e4(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !rt(e[n]))
      return !1;
  return !0;
}
function gt(e, n) {
  const t = Array.isArray(n) ? n : Vv(n) ? [n] : $C(n), i = t.length === 1 ? e : ZU(e, t), a = t.length - 1, o = t[a];
  return i && delete i[o], a !== 0 && (ot(i) && Lt(i) || Array.isArray(i) && e4(i)) && gt(e, t.slice(0, -1)), e;
}
var DC = (e) => {
  for (const n in e)
    if (Ir(e[n]))
      return !0;
  return !1;
};
function nc(e, n = {}) {
  const t = Array.isArray(e);
  if (ot(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || ot(e[i]) && !DC(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, nc(e[i], n[i])) : Mt(e[i]) || (n[i] = !0);
  return n;
}
function PC(e, n, t) {
  const i = Array.isArray(e);
  if (ot(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ot(e[a]) && !DC(e[a]) ? rt(n) || bh(t[a]) ? t[a] = Array.isArray(e[a]) ? nc(e[a], []) : { ...nc(e[a]) } : PC(e[a], Mt(n) ? {} : n[a], t[a]) : t[a] = !bi(e[a], n[a]);
  return t;
}
var to = (e, n) => PC(e, n, nc(n));
const yb = {
  value: !1,
  isValid: !1
}, gb = { value: !0, isValid: !0 };
var AC = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !rt(e[0].attributes.value) ? rt(e[0].value) || e[0].value === "" ? gb : { value: e[0].value, isValid: !0 } : gb
    ) : yb;
  }
  return yb;
}, LC = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: i }) => rt(e) ? e : n ? e === "" ? NaN : e && +e : t && Jr(e) ? new Date(e) : i ? i(e) : e;
const kb = {
  isValid: !1,
  value: null
};
var VC = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, kb) : kb;
function bb(e) {
  const n = e.ref;
  return Uv(n) ? n.files : Bv(n) ? VC(e.refs).value : RC(n) ? [...n.selectedOptions].map(({ value: t }) => t) : ws(n) ? AC(e.refs).value : LC(rt(n.value) ? e.ref.value : n.value, e);
}
var n4 = (e, n, t, i) => {
  const a = {};
  for (const o of e) {
    const s = Ge(n, o);
    s && Gn(a, o, s._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, tc = (e) => e instanceof RegExp, ro = (e) => rt(e) ? e : tc(e) ? e.source : ot(e) ? tc(e.value) ? e.value.source : e.value : e, _b = (e) => ({
  isOnSubmit: !e || e === Fr.onSubmit,
  isOnBlur: e === Fr.onBlur,
  isOnChange: e === Fr.onChange,
  isOnAll: e === Fr.all,
  isOnTouch: e === Fr.onTouched
});
const xb = "AsyncFunction";
var t4 = (e) => !!e && !!e.validate && !!(Ir(e.validate) && e.validate.constructor.name === xb || ot(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === xb)), r4 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Sb = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Uo = (e, n, t, i) => {
  for (const a of t || Object.keys(e)) {
    const o = Ge(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Uo(l, n))
          break;
      } else if (ot(l) && Uo(l, n))
        break;
    }
  }
};
function Nb(e, n, t) {
  const i = Ge(e, t);
  if (i || Vv(t))
    return {
      error: i,
      name: t
    };
  const a = t.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ge(n, o), l = Ge(e, o);
    if (s && !Array.isArray(s) && t !== o)
      return { name: t };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: t
  };
}
var i4 = (e, n, t, i) => {
  t(e);
  const { name: a, ...o } = e;
  return Lt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Fr.all));
}, a4 = (e, n, t) => !e || !n || e === n || Mo(e).some((i) => i && (t ? i === n : i.startsWith(n) || n.startsWith(i))), o4 = (e, n, t, i, a) => a.isOnAll ? !1 : !t && a.isOnTouch ? !(n || e) : (t ? i.isOnBlur : a.isOnBlur) ? !e : (t ? i.isOnChange : a.isOnChange) ? e : !0, s4 = (e, n) => !Yc(Ge(e, n)).length && gt(e, n), l4 = (e, n, t) => {
  const i = Mo(Ge(e, t));
  return Gn(i, "root", n[t]), Gn(e, t, i), e;
}, Dl = (e) => Jr(e);
function jb(e, n, t = "validate") {
  if (Dl(e) || Array.isArray(e) && e.every(Dl) || or(e) && !e)
    return {
      type: t,
      message: Dl(e) ? e : "",
      ref: n
    };
}
var oa = (e) => ot(e) && !tc(e) ? e : {
  value: e,
  message: ""
}, wb = async (e, n, t, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: m, minLength: d, min: f, max: h, pattern: y, validate: x, name: S, valueAsNumber: j, mount: w } = e._f, v = Ge(t, S);
  if (!w || n.has(S))
    return {};
  const q = l ? l[0] : s, T = (G) => {
    a && q.reportValidity && (q.setCustomValidity(or(G) ? "" : G || ""), q.reportValidity());
  }, I = {}, O = Bv(s), U = ws(s), Z = O || U, Q = (j || Uv(s)) && rt(s.value) && rt(v) || ec(s) && s.value === "" || v === "" || Array.isArray(v) && !v.length, ee = QU.bind(null, S, i, I), J = (G, P, K, ne = ai.maxLength, pe = ai.minLength) => {
    const ye = G ? P : K;
    I[S] = {
      type: G ? ne : pe,
      message: ye,
      ref: s,
      ...ee(G ? ne : pe, ye)
    };
  };
  if (o ? !Array.isArray(v) || !v.length : u && (!Z && (Q || Mt(v)) || or(v) && !v || U && !AC(l).isValid || O && !VC(l).isValid)) {
    const { value: G, message: P } = Dl(u) ? { value: !!u, message: u } : oa(u);
    if (G && (I[S] = {
      type: ai.required,
      message: P,
      ref: q,
      ...ee(ai.required, P)
    }, !i))
      return T(P), I;
  }
  if (!Q && (!Mt(f) || !Mt(h))) {
    let G, P;
    const K = oa(h), ne = oa(f);
    if (!Mt(v) && !isNaN(v)) {
      const pe = s.valueAsNumber || v && +v;
      Mt(K.value) || (G = pe > K.value), Mt(ne.value) || (P = pe < ne.value);
    } else {
      const pe = s.valueAsDate || new Date(v), ye = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), ue = s.type == "time", ve = s.type == "week";
      Jr(K.value) && v && (G = ue ? ye(v) > ye(K.value) : ve ? v > K.value : pe > new Date(K.value)), Jr(ne.value) && v && (P = ue ? ye(v) < ye(ne.value) : ve ? v < ne.value : pe < new Date(ne.value));
    }
    if ((G || P) && (J(!!G, K.message, ne.message, ai.max, ai.min), !i))
      return T(I[S].message), I;
  }
  if ((m || d) && !Q && (Jr(v) || o && Array.isArray(v))) {
    const G = oa(m), P = oa(d), K = !Mt(G.value) && v.length > +G.value, ne = !Mt(P.value) && v.length < +P.value;
    if ((K || ne) && (J(K, G.message, P.message), !i))
      return T(I[S].message), I;
  }
  if (y && !Q && Jr(v)) {
    const { value: G, message: P } = oa(y);
    if (tc(G) && !v.match(G) && (I[S] = {
      type: ai.pattern,
      message: P,
      ref: s,
      ...ee(ai.pattern, P)
    }, !i))
      return T(P), I;
  }
  if (x) {
    if (Ir(x)) {
      const G = await x(v, t), P = jb(G, q);
      if (P && (I[S] = {
        ...P,
        ...ee(ai.validate, P.message)
      }, !i))
        return T(P.message), I;
    } else if (ot(x)) {
      let G = {};
      for (const P in x) {
        if (!Lt(G) && !i)
          break;
        const K = jb(await x[P](v, t), q, P);
        K && (G = {
          ...K,
          ...ee(P, K.message)
        }, T(K.message), i && (I[S] = G));
      }
      if (!Lt(G) && (I[S] = {
        ref: q,
        ...G
      }, !i))
        return I;
    }
  }
  return T(!0), I;
};
const c4 = {
  mode: Fr.onSubmit,
  reValidateMode: Fr.onChange,
  shouldFocusError: !0
};
function u4(e = {}) {
  let n = {
    ...c4,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Ir(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ot(n.defaultValues) || ot(n.values) ? It(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : It(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, m = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: vb(),
    state: vb()
  }, y = _b(n.mode), x = _b(n.reValidateMode), S = n.criteriaMode === Fr.all, j = (_) => (E) => {
    clearTimeout(m), m = setTimeout(_, E);
  }, w = async (_) => {
    if (!n.disabled && (d.isValid || f.isValid || _)) {
      const E = n.resolver ? Lt((await Q()).errors) : await J(i, !0);
      E !== t.isValid && h.state.next({
        isValid: E
      });
    }
  }, v = (_, E) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((_ || Array.from(l.mount)).forEach((Y) => {
      Y && (E ? Gn(t.validatingFields, Y, E) : gt(t.validatingFields, Y));
    }), h.state.next({
      validatingFields: t.validatingFields,
      isValidating: !Lt(t.validatingFields)
    }));
  }, q = (_, E = [], Y, X, D = !0, B = !0) => {
    if (X && Y && !n.disabled) {
      if (s.action = !0, B && Array.isArray(Ge(i, _))) {
        const ie = Y(Ge(i, _), X.argA, X.argB);
        D && Gn(i, _, ie);
      }
      if (B && Array.isArray(Ge(t.errors, _))) {
        const ie = Y(Ge(t.errors, _), X.argA, X.argB);
        D && Gn(t.errors, _, ie), s4(t.errors, _);
      }
      if ((d.touchedFields || f.touchedFields) && B && Array.isArray(Ge(t.touchedFields, _))) {
        const ie = Y(Ge(t.touchedFields, _), X.argA, X.argB);
        D && Gn(t.touchedFields, _, ie);
      }
      (d.dirtyFields || f.dirtyFields) && (t.dirtyFields = to(a, o)), h.state.next({
        name: _,
        isDirty: P(_, E),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Gn(o, _, E);
  }, T = (_, E) => {
    Gn(t.errors, _, E), h.state.next({
      errors: t.errors
    });
  }, I = (_) => {
    t.errors = _, h.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, O = (_, E, Y, X) => {
    const D = Ge(i, _);
    if (D) {
      const B = Ge(o, _, rt(Y) ? Ge(a, _) : Y);
      rt(B) || X && X.defaultChecked || E ? Gn(o, _, E ? B : bb(D._f)) : pe(_, B), s.mount && w();
    }
  }, U = (_, E, Y, X, D) => {
    let B = !1, ie = !1;
    const fe = {
      name: _
    };
    if (!n.disabled) {
      if (!Y || X) {
        (d.isDirty || f.isDirty) && (ie = t.isDirty, t.isDirty = fe.isDirty = P(), B = ie !== fe.isDirty);
        const _e = bi(Ge(a, _), E);
        ie = !!Ge(t.dirtyFields, _), _e ? gt(t.dirtyFields, _) : Gn(t.dirtyFields, _, !0), fe.dirtyFields = t.dirtyFields, B = B || (d.dirtyFields || f.dirtyFields) && ie !== !_e;
      }
      if (Y) {
        const _e = Ge(t.touchedFields, _);
        _e || (Gn(t.touchedFields, _, Y), fe.touchedFields = t.touchedFields, B = B || (d.touchedFields || f.touchedFields) && _e !== Y);
      }
      B && D && h.state.next(fe);
    }
    return B ? fe : {};
  }, Z = (_, E, Y, X) => {
    const D = Ge(t.errors, _), B = (d.isValid || f.isValid) && or(E) && t.isValid !== E;
    if (n.delayError && Y ? (u = j(() => T(_, Y)), u(n.delayError)) : (clearTimeout(m), u = null, Y ? Gn(t.errors, _, Y) : gt(t.errors, _)), (Y ? !bi(D, Y) : D) || !Lt(X) || B) {
      const ie = {
        ...X,
        ...B && or(E) ? { isValid: E } : {},
        errors: t.errors,
        name: _
      };
      t = {
        ...t,
        ...ie
      }, h.state.next(ie);
    }
  }, Q = async (_) => {
    v(_, !0);
    const E = await n.resolver(o, n.context, n4(_ || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return v(_), E;
  }, ee = async (_) => {
    const { errors: E } = await Q(_);
    if (_)
      for (const Y of _) {
        const X = Ge(E, Y);
        X ? Gn(t.errors, Y, X) : gt(t.errors, Y);
      }
    else
      t.errors = E;
    return E;
  }, J = async (_, E, Y = {
    valid: !0
  }) => {
    for (const X in _) {
      const D = _[X];
      if (D) {
        const { _f: B, ...ie } = D;
        if (B) {
          const fe = l.array.has(B.name), _e = D._f && t4(D._f);
          _e && d.validatingFields && v([X], !0);
          const en = await wb(D, l.disabled, o, S, n.shouldUseNativeValidation && !E, fe);
          if (_e && d.validatingFields && v([X]), en[B.name] && (Y.valid = !1, E))
            break;
          !E && (Ge(en, B.name) ? fe ? l4(t.errors, en, B.name) : Gn(t.errors, B.name, en[B.name]) : gt(t.errors, B.name));
        }
        !Lt(ie) && await J(ie, E, Y);
      }
    }
    return Y.valid;
  }, G = () => {
    for (const _ of l.unMount) {
      const E = Ge(i, _);
      E && (E._f.refs ? E._f.refs.every((Y) => !ud(Y)) : !ud(E._f.ref)) && Le(_);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (_, E) => !n.disabled && (_ && E && Gn(o, _, E), !bi(Ce(), a)), K = (_, E, Y) => OC(_, l, {
    ...s.mount ? o : rt(E) ? a : Jr(_) ? { [_]: E } : E
  }, Y, E), ne = (_) => Yc(Ge(s.mount ? o : a, _, n.shouldUnregister ? Ge(a, _, []) : [])), pe = (_, E, Y = {}) => {
    const X = Ge(i, _);
    let D = E;
    if (X) {
      const B = X._f;
      B && (!B.disabled && Gn(o, _, LC(E, B)), D = ec(B.ref) && Mt(E) ? "" : E, RC(B.ref) ? [...B.ref.options].forEach((ie) => ie.selected = D.includes(ie.value)) : B.refs ? ws(B.ref) ? B.refs.length > 1 ? B.refs.forEach((ie) => (!ie.defaultChecked || !ie.disabled) && (ie.checked = Array.isArray(D) ? !!D.find((fe) => fe === ie.value) : D === ie.value)) : B.refs[0] && (B.refs[0].checked = !!D) : B.refs.forEach((ie) => ie.checked = ie.value === D) : Uv(B.ref) ? B.ref.value = "" : (B.ref.value = D, B.ref.type || h.state.next({
        name: _,
        values: It(o)
      })));
    }
    (Y.shouldDirty || Y.shouldTouch) && U(_, D, Y.shouldTouch, Y.shouldDirty, !0), Y.shouldValidate && ke(_);
  }, ye = (_, E, Y) => {
    for (const X in E) {
      const D = E[X], B = `${_}.${X}`, ie = Ge(i, B);
      (l.array.has(_) || ot(D) || ie && !ie._f) && !Vi(D) ? ye(B, D, Y) : pe(B, D, Y);
    }
  }, ue = (_, E, Y = {}) => {
    const X = Ge(i, _), D = l.array.has(_), B = It(E);
    Gn(o, _, B), D ? (h.array.next({
      name: _,
      values: It(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && Y.shouldDirty && h.state.next({
      name: _,
      dirtyFields: to(a, o),
      isDirty: P(_, B)
    })) : X && !X._f && !Mt(B) ? ye(_, B, Y) : pe(_, B, Y), Sb(_, l) && h.state.next({ ...t }), h.state.next({
      name: s.mount ? _ : void 0,
      values: It(o)
    });
  }, ve = async (_) => {
    s.mount = !0;
    const E = _.target;
    let Y = E.name, X = !0;
    const D = Ge(i, Y), B = (ie) => {
      X = Number.isNaN(ie) || Vi(ie) && isNaN(ie.getTime()) || bi(ie, Ge(o, Y, ie));
    };
    if (D) {
      let ie, fe;
      const _e = E.type ? bb(D._f) : FC(_), en = _.type === Zl.BLUR || _.type === Zl.FOCUS_OUT, un = !r4(D._f) && !n.resolver && !Ge(t.errors, Y) && !D._f.deps || o4(en, Ge(t.touchedFields, Y), t.isSubmitted, x, y), tn = Sb(Y, l, en);
      Gn(o, Y, _e), en ? (D._f.onBlur && D._f.onBlur(_), u && u(0)) : D._f.onChange && D._f.onChange(_);
      const ln = U(Y, _e, en), fn = !Lt(ln) || tn;
      if (!en && h.state.next({
        name: Y,
        type: _.type,
        values: It(o)
      }), un)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? en && w() : en || w()), fn && h.state.next({ name: Y, ...tn ? {} : ln });
      if (!en && tn && h.state.next({ ...t }), n.resolver) {
        const { errors: pn } = await Q([Y]);
        if (B(_e), X) {
          const vn = Nb(t.errors, i, Y), Xe = Nb(pn, i, vn.name || Y);
          ie = Xe.error, Y = Xe.name, fe = Lt(pn);
        }
      } else
        v([Y], !0), ie = (await wb(D, l.disabled, o, S, n.shouldUseNativeValidation))[Y], v([Y]), B(_e), X && (ie ? fe = !1 : (d.isValid || f.isValid) && (fe = await J(i, !0)));
      X && (D._f.deps && ke(D._f.deps), Z(Y, fe, ie, ln));
    }
  }, H = (_, E) => {
    if (Ge(t.errors, E) && _.focus)
      return _.focus(), 1;
  }, ke = async (_, E = {}) => {
    let Y, X;
    const D = Mo(_);
    if (n.resolver) {
      const B = await ee(rt(_) ? _ : D);
      Y = Lt(B), X = _ ? !D.some((ie) => Ge(B, ie)) : Y;
    } else _ ? (X = (await Promise.all(D.map(async (B) => {
      const ie = Ge(i, B);
      return await J(ie && ie._f ? { [B]: ie } : ie);
    }))).every(Boolean), !(!X && !t.isValid) && w()) : X = Y = await J(i);
    return h.state.next({
      ...!Jr(_) || (d.isValid || f.isValid) && Y !== t.isValid ? {} : { name: _ },
      ...n.resolver || !_ ? { isValid: Y } : {},
      errors: t.errors
    }), E.shouldFocus && !X && Uo(i, H, _ ? D : l.mount), X;
  }, Ce = (_) => {
    const E = {
      ...s.mount ? o : a
    };
    return rt(_) ? E : Jr(_) ? Ge(E, _) : _.map((Y) => Ge(E, Y));
  }, W = (_, E) => ({
    invalid: !!Ge((E || t).errors, _),
    isDirty: !!Ge((E || t).dirtyFields, _),
    error: Ge((E || t).errors, _),
    isValidating: !!Ge(t.validatingFields, _),
    isTouched: !!Ge((E || t).touchedFields, _)
  }), Be = (_) => {
    _ && Mo(_).forEach((E) => gt(t.errors, E)), h.state.next({
      errors: _ ? t.errors : {}
    });
  }, Me = (_, E, Y) => {
    const X = (Ge(i, _, { _f: {} })._f || {}).ref, D = Ge(t.errors, _) || {}, { ref: B, message: ie, type: fe, ..._e } = D;
    Gn(t.errors, _, {
      ..._e,
      ...E,
      ref: X
    }), h.state.next({
      name: _,
      errors: t.errors,
      isValid: !1
    }), Y && Y.shouldFocus && X && X.focus && X.focus();
  }, Pe = (_, E) => Ir(_) ? h.state.subscribe({
    next: (Y) => _(K(void 0, E), Y)
  }) : K(_, E, !0), Ue = (_) => h.state.subscribe({
    next: (E) => {
      a4(_.name, E.name, _.exact) && i4(E, _.formState || d, Re, _.reRenderRoot) && _.callback({
        values: { ...o },
        ...t,
        ...E
      });
    }
  }).unsubscribe, Ie = (_) => (s.mount = !0, f = {
    ...f,
    ..._.formState
  }, Ue({
    ..._,
    formState: f
  })), Le = (_, E = {}) => {
    for (const Y of _ ? Mo(_) : l.mount)
      l.mount.delete(Y), l.array.delete(Y), E.keepValue || (gt(i, Y), gt(o, Y)), !E.keepError && gt(t.errors, Y), !E.keepDirty && gt(t.dirtyFields, Y), !E.keepTouched && gt(t.touchedFields, Y), !E.keepIsValidating && gt(t.validatingFields, Y), !n.shouldUnregister && !E.keepDefaultValue && gt(a, Y);
    h.state.next({
      values: It(o)
    }), h.state.next({
      ...t,
      ...E.keepDirty ? { isDirty: P() } : {}
    }), !E.keepIsValid && w();
  }, Oe = ({ disabled: _, name: E }) => {
    (or(_) && s.mount || _ || l.disabled.has(E)) && (_ ? l.disabled.add(E) : l.disabled.delete(E));
  }, an = (_, E = {}) => {
    let Y = Ge(i, _);
    const X = or(E.disabled) || or(n.disabled);
    return Gn(i, _, {
      ...Y || {},
      _f: {
        ...Y && Y._f ? Y._f : { ref: { name: _ } },
        name: _,
        mount: !0,
        ...E
      }
    }), l.mount.add(_), Y ? Oe({
      disabled: or(E.disabled) ? E.disabled : n.disabled,
      name: _
    }) : O(_, !0, E.value), {
      ...X ? { disabled: E.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!E.required,
        min: ro(E.min),
        max: ro(E.max),
        minLength: ro(E.minLength),
        maxLength: ro(E.maxLength),
        pattern: ro(E.pattern)
      } : {},
      name: _,
      onChange: ve,
      onBlur: ve,
      ref: (D) => {
        if (D) {
          an(_, E), Y = Ge(i, _);
          const B = rt(D.value) && D.querySelectorAll && D.querySelectorAll("input,select,textarea")[0] || D, ie = XU(B), fe = Y._f.refs || [];
          if (ie ? fe.find((_e) => _e === B) : B === Y._f.ref)
            return;
          Gn(i, _, {
            _f: {
              ...Y._f,
              ...ie ? {
                refs: [
                  ...fe.filter(ud),
                  B,
                  ...Array.isArray(Ge(a, _)) ? [{}] : []
                ],
                ref: { type: B.type, name: _ }
              } : { ref: B }
            }
          }), O(_, !1, void 0, B);
        } else
          Y = Ge(i, _, {}), Y._f && (Y._f.mount = !1), (n.shouldUnregister || E.shouldUnregister) && !(IC(l.array, _) && s.action) && l.unMount.add(_);
      }
    };
  }, Ne = () => n.shouldFocusError && Uo(i, H, l.mount), We = (_) => {
    or(_) && (h.state.next({ disabled: _ }), Uo(i, (E, Y) => {
      const X = Ge(i, Y);
      X && (E.disabled = X._f.disabled || _, Array.isArray(X._f.refs) && X._f.refs.forEach((D) => {
        D.disabled = X._f.disabled || _;
      }));
    }, 0, !1));
  }, Ke = (_, E) => async (Y) => {
    let X;
    Y && (Y.preventDefault && Y.preventDefault(), Y.persist && Y.persist());
    let D = It(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: B, values: ie } = await Q();
      t.errors = B, D = ie;
    } else
      await J(i);
    if (l.disabled.size)
      for (const B of l.disabled)
        Gn(D, B, void 0);
    if (gt(t.errors, "root"), Lt(t.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await _(D, Y);
      } catch (B) {
        X = B;
      }
    } else
      E && await E({ ...t.errors }, Y), Ne(), setTimeout(Ne);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Lt(t.errors) && !X,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), X)
      throw X;
  }, se = (_, E = {}) => {
    Ge(i, _) && (rt(E.defaultValue) ? ue(_, It(Ge(a, _))) : (ue(_, E.defaultValue), Gn(a, _, It(E.defaultValue))), E.keepTouched || gt(t.touchedFields, _), E.keepDirty || (gt(t.dirtyFields, _), t.isDirty = E.defaultValue ? P(_, It(Ge(a, _))) : P()), E.keepError || (gt(t.errors, _), d.isValid && w()), h.state.next({ ...t }));
  }, de = (_, E = {}) => {
    const Y = _ ? It(_) : a, X = It(Y), D = Lt(_), B = D ? a : X;
    if (E.keepDefaultValues || (a = Y), !E.keepValues) {
      if (E.keepDirtyValues) {
        const ie = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(to(a, o))
        ]);
        for (const fe of Array.from(ie))
          Ge(t.dirtyFields, fe) ? Gn(B, fe, Ge(o, fe)) : ue(fe, Ge(B, fe));
      } else {
        if (Lv && rt(_))
          for (const ie of l.mount) {
            const fe = Ge(i, ie);
            if (fe && fe._f) {
              const _e = Array.isArray(fe._f.refs) ? fe._f.refs[0] : fe._f.ref;
              if (ec(_e)) {
                const en = _e.closest("form");
                if (en) {
                  en.reset();
                  break;
                }
              }
            }
          }
        for (const ie of l.mount)
          ue(ie, Ge(B, ie));
      }
      o = It(B), h.array.next({
        values: { ...B }
      }), h.state.next({
        values: { ...B }
      });
    }
    l = {
      mount: E.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!E.keepIsValid || !!E.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: E.keepSubmitCount ? t.submitCount : 0,
      isDirty: D ? !1 : E.keepDirty ? t.isDirty : !!(E.keepDefaultValues && !bi(_, a)),
      isSubmitted: E.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: D ? {} : E.keepDirtyValues ? E.keepDefaultValues && o ? to(a, o) : t.dirtyFields : E.keepDefaultValues && _ ? to(a, _) : E.keepDirty ? t.dirtyFields : {},
      touchedFields: E.keepTouched ? t.touchedFields : {},
      errors: E.keepErrors ? t.errors : {},
      isSubmitSuccessful: E.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, je = (_, E) => de(Ir(_) ? _(o) : _, E), Ae = (_, E = {}) => {
    const Y = Ge(i, _), X = Y && Y._f;
    if (X) {
      const D = X.refs ? X.refs[0] : X.ref;
      D.focus && (D.focus(), E.shouldSelect && Ir(D.select) && D.select());
    }
  }, Re = (_) => {
    t = {
      ...t,
      ..._
    };
  }, F = {
    control: {
      register: an,
      unregister: Le,
      getFieldState: W,
      handleSubmit: Ke,
      setError: Me,
      _subscribe: Ue,
      _runSchema: Q,
      _getWatch: K,
      _getDirty: P,
      _setValid: w,
      _setFieldArray: q,
      _setDisabledField: Oe,
      _setErrors: I,
      _getFieldArray: ne,
      _reset: de,
      _resetDefaultValues: () => Ir(n.defaultValues) && n.defaultValues().then((_) => {
        je(_, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: G,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(_) {
        s = _;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(_) {
        l = _;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return n;
      },
      set _options(_) {
        n = {
          ...n,
          ..._
        };
      }
    },
    subscribe: Ie,
    trigger: ke,
    register: an,
    handleSubmit: Ke,
    watch: Pe,
    setValue: ue,
    getValues: Ce,
    reset: je,
    resetField: se,
    clearErrors: Be,
    unregister: Le,
    setError: Me,
    setFocus: Ae,
    getFieldState: W
  };
  return {
    ...F,
    formControl: F
  };
}
function xr(e = {}) {
  const n = Se.useRef(void 0), t = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Ir(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Ir(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : u4(e),
    formState: i
  }, e.formControl && e.defaultValues && !Ir(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !bi(e.values, t.current) ? (o._reset(e.values, o._options.resetOptions), t.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !Lt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = TC(i, o), n.current;
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var dd = { exports: {} }, io = {}, Cb;
function d4() {
  if (Cb) return io;
  Cb = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return io.Fragment = t, io.jsx = s, io.jsxs = s, io;
}
var Xs = {}, Fb;
function m4() {
  return Fb || (Fb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    Xs.Fragment = i, Xs.jsx = Bn, Xs.jsxs = qn;
  }()), Xs;
}
var Ib;
function p4() {
  return Ib || (Ib = 1, process.env.NODE_ENV === "production" ? dd.exports = d4() : dd.exports = m4()), dd.exports;
}
var xe = p4();
const f4 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, h4 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, v4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, y4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, g4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, k4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, b4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, _4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, x4 = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": v4,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": y4,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": g4,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": f4,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": h4,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": k4,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": b4,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": _4
};
function qa(e) {
  return x4[e] ?? {};
}
const S4 = qa(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), N4 = qa(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), j4 = qa(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), $b = ({
  owner: e,
  repository: n,
  number: t
}) => `https://github.com/${e}/${n}/issues/${t}`, pr = ({
  owner: e,
  repository: n,
  number: t
}) => `${e}/${n} #${t}`, w4 = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), Eb = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, _h = (e, n, t) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: t,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ xe.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: t,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ xe.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: t,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: t,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: t,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function C4({
  conversationId: e,
  githubOrganization: n
}) {
  const t = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = oe(
    []
  ), [o, s] = oe([]), [l, u] = oe([]), [m, d] = oe([]), [f, h] = oe(), { showNotification: y, showModal: x, executeQuery: S } = mn(), { track: j } = gn(), {
    loading: w,
    data: v,
    error: q,
    store: T
  } = Kh(e ?? null), I = v?.github?.issues || [], O = v?.github?.pullRequests || [], [U, Z] = oe(!1), [Q, ee] = oe();
  qe(
    () => h(q || Q || void 0),
    [q, Q]
  ), qe(
    () => {
      !w && (I?.length || O?.length) ? (a(I), s(O), G(I, O)) : (a([]), s([]), u([]), d([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [v]
  );
  const J = async (ve, H) => {
    await T(ve).then(() => {
      y({
        icon: "check-circle-filled",
        severity: "success",
        title: H.success.title,
        text: H.success.text
      });
    }).catch((ke) => {
      y({
        title: H.error.title,
        text: `${H.error.text} ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, G = (ve, H) => {
    if (!ve?.length && !H?.length) {
      u([]), d([]);
      return;
    }
    const ke = (ve || []).map(
      (Be) => S(N4, {
        owner: Be.owner,
        repositoryName: Be.repository,
        issueNumber: Be.number
      })
    ), Ce = (H || []).map(
      (Be) => S(j4, {
        owner: Be.owner,
        repositoryName: Be.repository,
        prNumber: Be.number
      })
    ), W = [...ke, ...Ce];
    Z(!0), Promise.all(W).then((Be) => {
      const Me = [], Pe = [];
      Be.forEach((Ue) => {
        const Ie = Ue?.data?.GitHub;
        if (!Ie) {
          u([]), d([]);
          return;
        }
        Object.keys(Ie).forEach((Le) => {
          if (Le.startsWith("repository")) {
            const Oe = Ie[Le];
            Object.keys(Oe).forEach((an) => {
              const Ne = Oe[an], We = {
                number: Ne?.number,
                owner: Ne?.repository?.owner?.login,
                repository: Ne?.repository?.name
              };
              an.startsWith("issue") && Me.push({
                ...Ne,
                type: "ISSUE",
                key: We
              }), an.startsWith("pullRequest") && Pe.push({
                ...Ne,
                type: "PR",
                key: We
              });
            });
          }
        });
      }), u(Me), d(Pe);
    }).catch(ee).finally(() => {
      Z(!1);
    });
  }, P = ({ key: ve, type: H }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = v && (I.length || O.length) ? v : t, Ce = H === "ISSUE" ? "issues" : "pullRequests";
    ke.github[Ce] = Array.from(
      new Set(ke.github[Ce]).add(ve)
    ), J(ke, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${pr(
          ve
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${pr(ve)} failed. Please try again.`
      }
    });
  }, K = async ({ key: ve, type: H }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = v && (I.length || O.length) ? v : t, Ce = H === "ISSUE" ? "issues" : "pullRequests";
    ke.github[Ce] = Array.from(
      new Set(ke.github[Ce]).add(ve)
    ), await T(ke).catch((W) => {
      y({
        title: "Linking failed",
        text: `Linking ${ve} failed. Please try again. ${W.message && " (" + W.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ne = ({ key: ve, type: H }) => {
    j("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const ke = H === "ISSUE" ? "issue" : "pull request";
    x({
      headline: `Unlink ${ke} ${pr(ve)}?`,
      text: `You are about to unlink the ${ke} ${pr(
        ve
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${ke}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Ce = H === "ISSUE" ? "issues" : "pullRequests";
        if (!v)
          return;
        const W = {
          ...v,
          github: {
            ...v?.github,
            [Ce]: v?.github?.[Ce].filter(
              (Be) => Be.number !== ve.number || Be.owner !== ve.owner || Be.repository !== ve.repository
            )
          }
        };
        j("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), J(W, {
          success: {
            title: `GitHub ${ke} unlinked`,
            text: `You unlinked the GitHub ${ke} ${pr(
              ve
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${pr(ve)} failed.`
          }
        });
      },
      onCancel: () => {
        j("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, pe = () => {
    j("github:unlink:all:clicked", {
      githubOrganization: n
    }), x({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        j("github:unlink:all:confirmed", {
          githubOrganization: n
        }), J(t, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        j("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ye = I.filter(
    (ve) => !i?.includes(ve)
  ) || [], ue = O.filter(
    (ve) => !o?.includes(ve)
  ) || [];
  return {
    linkGithubItem: P,
    linkGithubItemQuietly: K,
    unlinkGithubItem: ne,
    loadGithubItems: G,
    removeDanglingGithubItemLinks: () => {
      const ve = {
        ...v,
        github: {
          ...v?.github,
          issues: I.filter(
            (H) => !ye.includes(H)
          ) || [],
          pullRequests: O.filter(
            (H) => !ue.includes(H)
          ) || []
        }
      };
      T(ve);
    },
    unlinkAllGithubItems: pe,
    isLoadingGithubItemLinks: w,
    danglingIssueLinks: ye,
    danglingPullRequestLinks: ue,
    isLoadingGithubItems: U,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const F4 = "_contentWrapper_1vx3c_1", I4 = "_contentWrapperHeadline_1vx3c_4", $4 = "_contentWrapperBody_1vx3c_11", E4 = "_contentWrapperAssigneeIcon_1vx3c_15", T4 = "_contentWrapperStatusTag_1vx3c_20", oi = {
  contentWrapper: F4,
  contentWrapperHeadline: I4,
  contentWrapperBody: $4,
  contentWrapperAssigneeIcon: E4,
  contentWrapperStatusTag: T4
}, zC = ({
  description: e,
  assignees: n,
  labels: t
}) => /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
  e && /* @__PURE__ */ xe.jsxs(Qn, { className: oi.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(Qn, { className: oi.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ xe.jsx(Qn, { className: oi.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ xe.jsxs(Qn, { className: oi.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(Qn, { className: oi.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ xe.jsx(Qn, { className: oi.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ xe.jsxs(Qn, { margin: "100 0", children: [
        /* @__PURE__ */ xe.jsx(
          "img",
          {
            className: oi.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  t?.nodes && t?.nodes.length > 0 && /* @__PURE__ */ xe.jsx(Qn, { className: oi.contentWrapper, children: t.nodes.map(
    (i) => i && /* @__PURE__ */ xe.jsx(
      Rn,
      {
        className: oi.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), O4 = "_collapse_1bdjy_1", R4 = "_collapseHeader_1bdjy_10", D4 = "_collapseHeaderKey_1bdjy_31", P4 = "_collapseHeaderKeyIcon_1bdjy_36", A4 = "_collapseHeaderKeyLink_1bdjy_41", L4 = "_collapseHeaderIcon_1bdjy_44", V4 = "_collapseHeaderTitle_1bdjy_49", z4 = "_collapseContent_1bdjy_57", M4 = "_collapseContentButtonSpacer_1bdjy_60", U4 = "_collapseContentButtonLink_1bdjy_63", qr = {
  collapse: O4,
  collapseHeader: R4,
  collapseHeaderKey: D4,
  collapseHeaderKeyIcon: P4,
  collapseHeaderKeyLink: A4,
  collapseHeaderIcon: L4,
  collapseHeaderTitle: V4,
  collapseContent: z4,
  collapseContentButtonSpacer: M4,
  collapseContentButtonLink: U4
}, B4 = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: t
}) => {
  const i = e.reduce(
    (u, m) => ({ ...u, [m.id]: !1 }),
    {}
  ), [a, o] = oe(i), { track: s } = gn(), l = (u, m) => {
    o({ ...a, [u]: m });
  };
  return /* @__PURE__ */ xe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((u) => {
    const {
      id: m,
      number: d,
      key: f,
      title: h,
      bodyText: y,
      repository: x,
      type: S,
      state: j,
      assignees: w,
      labels: v
    } = u, q = a[m];
    return /* @__PURE__ */ xe.jsxs(
      hr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: q,
        className: qr.collapse,
        children: [
          /* @__PURE__ */ xe.jsx(hr.Header, { className: qr.collapseHeader, children: /* @__PURE__ */ xe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ xe.jsx(Qn, { children: /* @__PURE__ */ xe.jsxs(Qn, { as: "span", className: qr.collapseHeaderKey, children: [
                  _h(
                    S,
                    j,
                    qr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ xe.jsxs(
                    "a",
                    {
                      href: $b(f),
                      className: qr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (T) => {
                        T.stopPropagation();
                      },
                      children: [
                        pr(f),
                        /* @__PURE__ */ xe.jsx(
                          me,
                          {
                            className: qr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ xe.jsx(Qn, { className: qr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ xe.jsx(hr.Content, { className: qr.collapseContent, children: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ xe.jsx(
              zC,
              {
                description: y,
                assignees: w,
                labels: v
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: qr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: d,
                    owner: x?.owner.login,
                    repository: u.repository.name
                  },
                  type: S
                }),
                children: [
                  "Unlink ",
                  Eb(S)
                ]
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              Tt,
              {
                slotEnd: /* @__PURE__ */ xe.jsx(me, { name: "external-link" }),
                variant: "tertiary",
                className: qr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: t
                  }), window.open($b(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  Eb(S),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ xe.jsx(xe.Fragment, {}) });
}, q4 = "_result_1uaom_1", H4 = "_resultName_1uaom_21", W4 = "_resultItemIcon_1uaom_29", K4 = "_resultDescription_1uaom_34", G4 = "_resultLinkIcon_1uaom_46", Y4 = "_tooltip_1uaom_55", J4 = "_tooltipName_1uaom_61", Q4 = "_tooltipTag_1uaom_71", si = {
  result: q4,
  resultName: H4,
  resultItemIcon: W4,
  resultDescription: K4,
  resultLinkIcon: G4,
  tooltip: Y4,
  tooltipName: J4,
  tooltipTag: Q4
}, X4 = ({
  item: e,
  onSelect: n
}) => {
  const { key: t, title: i, type: a, state: o, labels: s, bodyText: l, assignees: u } = e, [m, d] = oe(!1);
  return /* @__PURE__ */ xe.jsx(
    Qe,
    {
      className: si.tooltip,
      content: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ xe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ xe.jsxs(Qn, { as: "span", className: si.tooltipName, children: [
                _h(a, o, si.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ xe.jsx(Rn, { className: si.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ xe.jsx(
          zC,
          {
            description: l,
            assignees: u,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ xe.jsxs(
        "button",
        {
          className: si.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => d(!0),
          onMouseLeave: () => d(!1),
          children: [
            /* @__PURE__ */ xe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsxs(Qn, { as: "span", className: si.resultName, children: [
                    _h(a, o, si.resultItemIcon),
                    pr(t)
                  ] }) }),
                  /* @__PURE__ */ xe.jsx(Qn, { className: si.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ xe.jsx(
              me,
              {
                className: si.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, Z4 = ({
  className: e,
  searched: n,
  githubOrganization: t
}) => /* @__PURE__ */ xe.jsx(
  Tt,
  {
    slotEnd: /* @__PURE__ */ xe.jsx(me, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${t}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), rc = "[a-zA-z0-9_.-]+", MC = "[0-9]+", eB = new RegExp(
  `(${rc})/(${rc})/(?:issues|pull)/(${MC})`,
  "i"
), Tb = new RegExp(`^${eB.source}$`), Ob = new RegExp(
  `https://github.com/(${rc})/(${rc})/(?:issues|pull)/(${MC})`,
  "i"
), nB = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: t,
  linkedPullRequests: i
}) => {
  const a = Wn(() => t?.map((O) => O.id) || [], [t]), o = Wn(() => i?.map((O) => O.id) || [], [i]), [s, l] = oe([]), { useLazyQuery: u } = mn(), [m, d] = oe(), [f, { loading: h, error: y, data: x, networkStatus: S }] = u(S4, {
    notifyOnNetworkStatusChange: !0
  });
  Ba(
    () => {
      !h && m && S === yr.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), qe(() => {
    let O = x?.GitHub?.issues?.nodes || [], U = x?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (O = O.filter((Z) => !a.includes(Z.id))), o.length > 0 && (U = U.filter(
      (Z) => !o.includes(Z.id)
    )), l([
      ...O.map((Z) => ({
        ...Z,
        type: "ISSUE",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      })),
      ...U.map((Z) => ({
        ...Z,
        type: "PR",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      }))
    ]);
  }, [x, a, o]);
  function j(O) {
    const U = O?.trim();
    if (Tb.test(U)) {
      const [Z, Q, ee, J] = U.match(Tb) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ee,
        number: parseInt(J)
      };
    }
    if (Ob.test(U)) {
      const [Z, Q, ee, J] = U.match(Ob) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ee,
        number: parseInt(J)
      };
    }
  }
  const w = (O) => {
    e({
      key: w4(O),
      type: O.type
    }), d(void 0);
  }, v = (O) => {
    const U = j(O);
    d(
      U ? `org:${U.owner} repo:${U.repository} ${U.number}` : `org:${n} ${O}`
    );
  }, q = () => {
    d(void 0);
  }, T = ({ className: O, searched: U }) => /* @__PURE__ */ xe.jsx(
    Z4,
    {
      className: O,
      searched: U,
      githubOrganization: n
    }
  ), I = ({ item: O, onSelect: U }) => /* @__PURE__ */ xe.jsx(X4, { item: O, onSelect: U });
  return !h && y ? /* @__PURE__ */ xe.jsx(wn, { error: y }) : /* @__PURE__ */ xe.jsx(
    Lr,
    {
      items: s?.map((O) => ({ name: O.title, ...O })),
      loading: h,
      onSearch: v,
      onSelect: w,
      onClear: q,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: T,
      itemComponent: I,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, tB = "_itemButton_3sxfy_1", rB = "_result_3sxfy_6", iB = "_resultName_3sxfy_30", aB = "_resultCheckIcon_3sxfy_38", oB = "_resultAssigneeIcon_3sxfy_41", ao = {
  itemButton: tB,
  result: rB,
  resultName: iB,
  resultCheckIcon: aB,
  resultAssigneeIcon: oB
}, UC = ({
  item: e,
  checked: n = !1,
  onSelectItem: t
}) => /* @__PURE__ */ xe.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ xe.jsx(
      "button",
      {
        onClick: () => {
          t(e);
        },
        className: ao.itemButton,
        children: /* @__PURE__ */ xe.jsxs(b, { className: ao.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ xe.jsx(Qn, { margin: "100 0", children: /* @__PURE__ */ xe.jsx(
            "img",
            {
              className: ao.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ xe.jsx(Qn, { className: ao.resultName, children: e.name }),
          n && /* @__PURE__ */ xe.jsx(Qn, { className: ao.resultCheckIcon, children: /* @__PURE__ */ xe.jsx(me, { name: "done" }) })
        ] })
      }
    )
  }
), sB = qa(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), lB = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: t,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = oe([]), [l, u] = oe(""), m = 2, [d, { loading: f, error: h, data: y, networkStatus: x }] = a(
    sB,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return Ba(
    () => {
      !f && l && l.length >= m && x === yr.ready ? d({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const S = y?.GitHub?.organization?.teams || { edges: [] }, j = [];
    S?.edges?.forEach((w) => {
      const v = w?.node?.members?.edges;
      (v?.length || 0) > 0 && v?.forEach((q) => {
        const T = q?.node;
        T && (T?.id && j.find((I) => I.id === T.id) || j.push(T));
      });
    }), s(
      j.sort((w, v) => {
        const q = w.name?.toLowerCase() || w.login?.toLowerCase(), T = v.name?.toLowerCase() || v.login?.toLowerCase();
        return q.localeCompare(T, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [y]), !f && h ? /* @__PURE__ */ xe.jsx(wn, { error: h }) : /* @__PURE__ */ xe.jsx(
    Lr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: S, name: j, login: w, avatarUrl: v }) => ({
        id: S,
        name: j || w,
        iconUrl: v
      })) || [],
      loading: f,
      onSearch: (S) => u(S),
      onChange: (S, j) => {
        const w = S.id;
        i ? (j && !n.find(
          (v) => v.id === w
        ) && n.push(S), j || (n = n.filter(
          (v) => v.id !== w
        ))) : n = j ? [S] : [], t(n);
      },
      onClear: () => u(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: S, onSelect: j, checked: w }) => /* @__PURE__ */ xe.jsx(
        UC,
        {
          item: S,
          checked: w,
          onSelectItem: j
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, cB = ({
  field: e,
  value: n,
  onChange: t,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ xe.jsx(Pr, { onChange: t, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ xe.jsx(
        Lr,
        {
          onSelect: t,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: u }) => ({
            id: s,
            name: l || u
          }))
        }
      ) : /* @__PURE__ */ xe.jsx(
        _c,
        {
          onChange: t,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ xe.jsx(Pr, { type: "number", onChange: t, value: n });
    case "option":
      return /* @__PURE__ */ xe.jsx(
        Lr,
        {
          onSelect: t,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: u }) => ({
              id: s,
              name: l || u
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ xe.jsx(Pr, { onChange: t, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ xe.jsx(Uf, { onChange: t, value: n || "" });
    case "user":
      return /* @__PURE__ */ xe.jsx(
        lB,
        {
          githubOrganization: i,
          onChange: t,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ xe.jsx(xe.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, uB = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: t,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ xe.jsx(xe.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ xe.jsx(
  qt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ xe.jsx(
      An,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: cB({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: t
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), dB = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: t,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ xe.jsxs(A.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ xe.jsxs(A.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ xe.jsx(me, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ xe.jsx(An, { label: "GitHub issue link", children: /* @__PURE__ */ xe.jsx(
          Pr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: t ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, mB = "_modalBody_1hk1o_1", pB = "_modalBodyFormFields_1hk1o_4", md = {
  modalBody: mB,
  modalBodyFormFields: pB
}, fB = qa(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), hB = qa(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), vB = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], yB = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: t,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = mn(), { track: u } = gn(), {
    control: m,
    handleSubmit: d,
    formState: { errors: f },
    reset: h,
    getValues: y
  } = xr(), [x, S] = oe(""), [j, w] = oe([]), [v, q] = oe(), [T, I] = oe(!1), [O, U] = oe(!1), [Z, Q] = wC(), [
    ee,
    {
      loading: J,
      error: G,
      networkStatus: P
    }
  ] = s(fB, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Ce) => {
      w(
        Ce.GitHub.search?.edges?.map((W) => W?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), w([]);
    }
  });
  Ba(
    () => {
      !J && x && P === yr.ready ? ee({
        variables: {
          query: x,
          maxResults: 10
        }
      }) : w([]);
    },
    500,
    [x]
  );
  const [K, { error: ne }] = l(
    hB,
    {
      onError: (Ce) => {
        I(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Ce);
      },
      onCompleted: (Ce) => {
        I(!1);
        const W = Ce.GitHub.createIssue?.issue;
        q(W), o({
          title: "Success",
          text: `GitHub issue '${W.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), t({
          owner: a,
          repository: W.repository.name,
          number: W.number
        });
      }
    }
  ), pe = (Ce) => {
    S(`org:${a} ${Ce}`);
  }, ye = (Ce, W) => {
    W(Ce), S("");
  }, ue = () => {
    S("");
  }, ve = (Ce) => {
    u("github:create:issue:confirmed", {
      githubOrganization: a
    }), I(!0), K({
      variables: {
        input: {
          repositoryId: Ce.repository.id,
          title: Ce.title,
          body: Ce.body,
          assigneeIds: Ce.assignees?.length > 0 ? Ce.assignees.map((W) => W.id) : void 0
        }
      }
    });
  };
  qe(() => {
    const Ce = O ? window.setTimeout(() => U(!1), 2e3) : void 0;
    return () => window.clearTimeout(Ce);
  }, [O]);
  const H = () => {
    S(""), w([]), q(void 0), I(!1), U(!1);
  }, ke = () => {
    u("github:create:issue:canceled", {
      githubOrganization: a
    }), H(), h(), n();
  };
  return /* @__PURE__ */ xe.jsxs(
    Nt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: ke,
      children: [
        /* @__PURE__ */ xe.jsx(
          jt,
          {
            title: v ? "Issue creation successful" : "Create new GitHub issue",
            onClose: ke
          }
        ),
        /* @__PURE__ */ xe.jsxs(wt, { className: md.modalBody, children: [
          !J && G && /* @__PURE__ */ xe.jsx(wn, { error: G }),
          !T && ne && /* @__PURE__ */ xe.jsx(wn, { error: ne }),
          v ? /* @__PURE__ */ xe.jsx(
            dB,
            {
              createdIssue: v,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: O,
              setIssueLinkCopied: U,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ xe.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: d(ve),
              children: /* @__PURE__ */ xe.jsxs(Gt, { children: [
                /* @__PURE__ */ xe.jsx(rn, { children: /* @__PURE__ */ xe.jsx(An, { label: "Repository", required: !0, children: /* @__PURE__ */ xe.jsx(
                  qt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Ce, value: W } }) => /* @__PURE__ */ xe.jsx(
                      Lr,
                      {
                        className: md.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: J,
                        onSearch: pe,
                        onSelect: (Be) => ye(Be, Ce),
                        onClear: ue,
                        selectedItems: [W],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: G ? "No repositories found" : "No repositories available",
                        items: j || [],
                        itemComponent: ({ item: Be, onSelect: Me, checked: Pe }) => /* @__PURE__ */ xe.jsx(
                          UC,
                          {
                            item: Be,
                            checked: Pe,
                            onSelectItem: Me
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ xe.jsx(rn, { className: md.modalBodyFormFields, children: /* @__PURE__ */ xe.jsx(
                  uB,
                  {
                    control: m,
                    errors: f,
                    getValues: y,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: vB
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ xe.jsx(
          Ot,
          {
            confirmOnClick: v ? ke : d(ve),
            confirmProps: {
              isLoading: T,
              loadingIndicator: /* @__PURE__ */ xe.jsx(dn, { size: 16 })
            },
            confirmName: v ? "Close" : "Save",
            cancelOnClick: v ? void 0 : ke
          }
        )
      ]
    }
  );
}, gB = "_wrapper_19v8w_1", kB = "_inputWrapper_19v8w_6", bB = "_buttonLink_19v8w_19", _B = "_noItemsFound_19v8w_23", xB = "_createIssueButton_19v8w_28", sa = {
  wrapper: gB,
  inputWrapper: kB,
  buttonLink: bB,
  noItemsFound: _B,
  createIssueButton: xB
}, SB = ({
  conversationContext: e,
  settings: n
}) => {
  const [t, i] = oe(!1), { track: a } = gn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: u,
    unlinkGithubItem: m,
    loadGithubItems: d,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: y,
    danglingIssueLinks: x,
    danglingPullRequestLinks: S,
    isLoadingGithubItems: j,
    issues: w,
    pullRequests: v,
    error: q
  } = C4({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), T = (Q) => u({ key: Q, type: "ISSUE" }), I = !(!!w?.length).valueOf() && !(!!v?.length).valueOf() && !(!!x?.length).valueOf() && !(!!S?.length).valueOf(), O = !y && !j && !!x?.length && !!S?.length && !!n?.showDanglingLinks, U = n?.enableCreateIssue, Z = !!w?.length || !!v?.length;
  return !j && q ? /* @__PURE__ */ xe.jsx(wn, { error: q, retry: () => d() }) : /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
    /* @__PURE__ */ xe.jsxs(b, { className: sa.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ xe.jsxs(b, { className: sa.inputWrapper, flexDirection: "column", children: [
        U && /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
          /* @__PURE__ */ xe.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: sa.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ xe.jsx("div", { className: sa.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ xe.jsx(
          nB,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: w,
            linkedPullRequests: v
          }
        )
      ] }),
      j ? /* @__PURE__ */ xe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ xe.jsx(dn, { "data-testid": "github-widget-item-spinner" }) }) : Z ? /* @__PURE__ */ xe.jsx(
        B4,
        {
          items: [...w, ...v],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ xe.jsx(A.Paragraph, { align: "center", className: sa.noItemsFound, children: "No linked items found." }),
      O && /* @__PURE__ */ xe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ xe.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ xe.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              x.map((Q) => /* @__PURE__ */ xe.jsx(
                Rn,
                {
                  onDelete: () => m({
                    key: Q,
                    type: "ISSUE"
                  }),
                  children: pr(Q)
                },
                pr(Q)
              )),
              S.map((Q) => /* @__PURE__ */ xe.jsx(
                Rn,
                {
                  onDelete: () => m({ key: Q, type: "PR" }),
                  children: pr(Q)
                },
                pr(Q)
              ))
            ] }),
            /* @__PURE__ */ xe.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Z && /* @__PURE__ */ xe.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: I,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ xe.jsx(
        Tt,
        {
          slotEnd: /* @__PURE__ */ xe.jsx(me, { name: "external-link" }),
          variant: "tertiary",
          className: sa.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ xe.jsx(
      yB,
      {
        isOpen: t,
        onClose: () => i(!1),
        linkGithubIssueQuietly: T,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, NB = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: kc
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var pd = { exports: {} }, oo = {}, Rb;
function jB() {
  if (Rb) return oo;
  Rb = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return oo.Fragment = t, oo.jsx = s, oo.jsxs = s, oo;
}
var Zs = {}, Db;
function wB() {
  return Db || (Db = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    Zs.Fragment = i, Zs.jsx = Bn, Zs.jsxs = qn;
  }()), Zs;
}
var Pb;
function CB() {
  return Pb || (Pb = 1, process.env.NODE_ENV === "production" ? pd.exports = jB() : pd.exports = wB()), pd.exports;
}
var $e = CB(), Po = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Po || {}), Ri = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(Ri || {}), Yt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Yt || {});
const FB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, IB = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": FB
};
function $B(e) {
  return IB[e] ?? {};
}
const EB = $B(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Ab = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, BC = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, TB = "_listItem_16pij_4", OB = "_clickableIcon_16pij_15", ic = {
  listItem: TB,
  clickableIcon: OB
}, qC = ({
  items: e,
  title: n,
  currency: t,
  openByDefault: i = !1
}) => {
  const [a, o] = oe(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ $e.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ $e.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ $e.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ $e.jsx(me, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ $e.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ $e.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: ic.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ $e.jsx(
              me,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ $e.jsx(He, { children: e.map((l, u) => {
      if (!l) return null;
      const { name: m, quantity: d, price: f, image: h, sku: y } = l, x = l.currency ?? t;
      return /* @__PURE__ */ $e.jsx(
        He.Item,
        {
          contentLeft: /* @__PURE__ */ $e.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ $e.jsx(A.Paragraph, { children: d }),
            /* @__PURE__ */ $e.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ $e.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: BC(f / 100, x) })
          ] }),
          contentRight: h && /* @__PURE__ */ $e.jsx(Ta, { src: h, alt: m ?? "Product image" }),
          className: ic.listItem
        },
        `item-${u}-${y}`
      );
    }) })
  ] }) });
}, RB = "_boxWrapper_89s7l_1", DB = "_trackButton_89s7l_10", Lb = {
  boxWrapper: RB,
  trackButton: DB
}, PB = {
  [Yt.StepUnknown]: "Unknown",
  [Yt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Yt.StepPreparedByMerchant]: "Prepared by merchant",
  [Yt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Yt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Yt.StepOnRoute]: "On route",
  [Yt.StepDeliveredToPickupPoint]: "At pickup point",
  [Yt.StepDeliveredToConsumer]: "Delivered to customer",
  [Yt.StepDeliveredToMerchant]: "Returned to merchant",
  [Yt.StepReturnRequested]: "Return requested",
  [Yt.StepSentBack]: "Sent back",
  [Yt.StepTerminated]: "Terminated",
  [Yt.StepAwaitingSupplier]: "Awaiting supplier"
}, AB = {
  [Ri.Delivery]: "Home delivery",
  [Ri.Pickup]: "Pickup point",
  [Ri.Instore]: "In-store pickup",
  [Ri.Mailbox]: "Mailbox",
  [Ri.Inwarehouse]: "Warehouse",
  [Ri.Unknown]: "Unknown"
}, LB = {
  [Po.Outbound]: "From merchant to customer",
  [Po.Return]: "Return from customer to merchant",
  [Po.Unspecified]: "Unspecified",
  [Po.UnknownDirectionType]: "Unknown"
}, VB = (e) => e ? PB[e] ?? e : "", zB = (e) => e ? AB[e] ?? e : "", MB = (e) => e ? LB[e] ?? e : "", UB = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, BB = ({
  parcel: e
}) => {
  const { isCopied: n, copy: t } = Dr();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: u,
    display_carrier_name: m,
    delivery_type: d,
    direction_type: f,
    estimated_delivery_time: h
  } = e, y = m || l || i, x = a?.filter((T) => T?.time !== ""), S = VB(x?.[0]?.step), j = zB(d), w = MB(f), v = UB(e.location?.address), q = 14;
  return /* @__PURE__ */ $e.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Lb.boxWrapper,
      children: [
        /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-4", children: y }),
        /* @__PURE__ */ $e.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ $e.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ $e.jsx(
              me,
              {
                size: q,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ $e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ $e.jsx(Qe, { content: "Copy tracking ID", children: /* @__PURE__ */ $e.jsx(
            me,
            {
              size: q,
              name: n ? "done" : "copy",
              className: ic.clickableIcon,
              onClick: () => t(o)
            }
          ) }) })
        ] }),
        S && /* @__PURE__ */ $e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ $e.jsx(me, { size: q, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: S })
          ] })
        ] }),
        w && /* @__PURE__ */ $e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ $e.jsx(me, { size: q, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: w })
          ] })
        ] }),
        h && /* @__PURE__ */ $e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ $e.jsx(me, { size: q, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ $e.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
              Ab(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Ab(h.end) })
          ] })
        ] }),
        d && /* @__PURE__ */ $e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ $e.jsx(me, { size: q, name: "info", color: "blue.900" }),
          /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        v && /* @__PURE__ */ $e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ $e.jsx(me, { size: q, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: v })
          ] })
        ] }),
        /* @__PURE__ */ $e.jsx(qC, { title: "Parcel items", items: s }),
        u && /* @__PURE__ */ $e.jsxs(
          Tt,
          {
            variant: "secondary",
            className: Lb.trackButton,
            navigate: () => window.open(u, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ $e.jsx(me, { name: "external-link" }),
            children: [
              "Track on ",
              y ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, qB = "_order_135ze_1", HB = "_orderIsOpen_135ze_9", WB = "_orderHeader_135ze_12", fd = {
  order: qB,
  orderIsOpen: HB,
  orderHeader: WB
}, KB = ({
  order: e,
  openByDefault: n
}) => {
  const [t, i] = oe(n), { isCopied: a, copy: o } = Dr();
  if (!e)
    return null;
  const {
    cart: s,
    parcels: l,
    external_id: u,
    sender_name: m,
    tos_id: d
  } = e, f = s?.currency || "", h = s?.prices?.total?.price ?? 0, y = BC(h / 100, f), x = 14;
  return /* @__PURE__ */ $e.jsxs(
    b,
    {
      className: ut(fd.order, {
        [fd.orderIsOpen]: t
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ $e.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: fd.orderHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ $e.jsxs(A.Paragraph, { variant: "4", children: [
                  "From ",
                  m ?? "unknown sender"
                ] }),
                /* @__PURE__ */ $e.jsxs(A.Paragraph, { variant: "3", children: [
                  "#",
                  u
                ] })
              ] }),
              /* @__PURE__ */ $e.jsx(
                tr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ $e.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ $e.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ $e.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ $e.jsx(
                me,
                {
                  size: x,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !d && /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  d && /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: d })
                ] })
              ] })
            ] }),
            d && /* @__PURE__ */ $e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ $e.jsx(Qe, { content: "Copy tracking ID", children: /* @__PURE__ */ $e.jsx(
              me,
              {
                size: x,
                name: a ? "done" : "copy",
                className: ic.clickableIcon,
                onClick: () => o(d)
              }
            ) }) })
          ] }),
          m && /* @__PURE__ */ $e.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ $e.jsx(me, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", children: m })
            ] })
          ] }),
          /* @__PURE__ */ $e.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ $e.jsx(me, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ $e.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", children: y })
            ] })
          ] }),
          /* @__PURE__ */ $e.jsx(
            qC,
            {
              openByDefault: !0,
              title: "Order items",
              items: s?.items?.map((S) => S),
              currency: s?.currency
            }
          ),
          l && /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-4", children: "Parcels" }),
              l.length > 0 && /* @__PURE__ */ $e.jsx(Mn, { variant: "success", size: "small", children: l.length })
            ] }),
            l.length === 0 && /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            l.map((S, j) => /* @__PURE__ */ $e.jsx(
              BB,
              {
                parcel: S
              },
              `parcel-${j}-${S?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, GB = ({
  customerEmail: e
}) => {
  const { useQuery: n } = mn(), [t, i] = oe([]), a = !e, { data: o, loading: s, error: l } = n(EB, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), u = !s && t.length > 0, m = l ? XF({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return qe(() => {
    const d = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    d?.orders && i(d.orders);
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ $e.jsx(dn, {}) }) : m || !u ? /* @__PURE__ */ $e.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ $e.jsx(A.Paragraph, { color: "tertiary", children: "No orders to track" }) }) : l ? /* @__PURE__ */ $e.jsx(wn, { error: l }) : /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ $e.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ $e.jsx(Mn, { variant: "success", size: "small", children: t.length })
    ] }),
    /* @__PURE__ */ $e.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ $e.jsx(b, { gap: "200", flexDirection: "column", children: t.map((d, f) => /* @__PURE__ */ $e.jsx(
      KB,
      {
        order: d,
        openByDefault: f === 0
      },
      `${f}-${d?.tos_id}`
    )) }) })
  ] });
}, YB = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ $e.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ $e.jsx(GB, { customerEmail: n })
    }
  );
}, JB = [
  {
    key: "ingridApiHostName",
    label: "API URL",
    placeholder: "API URL from Ingrid",
    required: !0,
    secret: !1,
    type: "input",
    defaultValue: "https://api.ingrid.com/v1/delivery_tracking"
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    placeholder: "Site ID from Ingrid",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "ingridApiToken",
    label: "API token",
    placeholder: "API token from Ingrid",
    required: !0,
    secret: !0,
    type: "input"
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var hd = { exports: {} }, so = {}, Vb;
function QB() {
  if (Vb) return so;
  Vb = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return so.Fragment = t, so.jsx = s, so.jsxs = s, so;
}
var el = {}, zb;
function XB() {
  return zb || (zb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    el.Fragment = i, el.jsx = Bn, el.jsxs = qn;
  }()), el;
}
var Mb;
function ZB() {
  return Mb || (Mb = 1, process.env.NODE_ENV === "production" ? hd.exports = QB() : hd.exports = XB()), hd.exports;
}
var he = ZB();
const qv = (e, n) => {
  const t = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => qv(l, s)) : [], a = n.nodes[e.type] || n.default;
  return t(
    a(e, i(e, n))
  );
}, e5 = "_jiraCode_h30p6_1", n5 = "_jiraCodeInline_h30p6_8", vd = {
  jiraCode: e5,
  jiraCodeInline: n5
}, HC = {
  default: (e, n) => n().every((t) => typeof t == "string") ? n().join(" ") : /* @__PURE__ */ he.jsx(he.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ he.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ he.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ he.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ he.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ he.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ he.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ he.jsx("pre", { children: /* @__PURE__ */ he.jsx("code", { className: vd.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ he.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ he.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ he.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ he.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ he.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ he.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ he.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ he.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ he.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ he.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ he.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ he.jsx("code", { className: ut(vd.jiraCode, vd.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, ac = ({
  iconUrl: e,
  className: n,
  width: t
}) => {
  const [i, a] = oe(!1);
  return !e || i ? /* @__PURE__ */ he.jsx(me, { size: t, name: "question", className: n }) : /* @__PURE__ */ he.jsx(
    "img",
    {
      src: e,
      width: t,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, t5 = "_collapse_m2gjh_1", r5 = "_collapseHeader_m2gjh_10", i5 = "_collapseHeaderLink_m2gjh_31", a5 = "_collapseHeaderStatus_m2gjh_40", o5 = "_collapseHeaderTitle_m2gjh_51", s5 = "_collapseContent_m2gjh_59", l5 = "_collapseContentHeadline_m2gjh_62", c5 = "_collapseContentButtonSpacer_m2gjh_68", u5 = "_collapseContentButtonLink_m2gjh_71", d5 = "_collapseContentStatusTag_m2gjh_74", m5 = "_collapseContentDescription_m2gjh_77", jr = {
  collapse: t5,
  collapseHeader: r5,
  collapseHeaderLink: i5,
  collapseHeaderStatus: a5,
  collapseHeaderTitle: o5,
  collapseContent: s5,
  collapseContentHeadline: l5,
  collapseContentButtonSpacer: c5,
  collapseContentButtonLink: u5,
  collapseContentStatusTag: d5,
  collapseContentDescription: m5
}, WC = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: t
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : t, p5 = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: t
}) => {
  const i = e.reduce(
    (u, m) => m?.id ? { ...u, [m.id]: !1 } : u,
    {}
  ), [a, o] = oe(i), { track: s } = gn(), l = (u, m) => {
    o({ ...a, [u]: m });
  };
  return /* @__PURE__ */ he.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((u) => {
    const { summary: m, description: d, status: f, issuetype: h } = u?.fields || {}, y = WC({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), x = !!(u?.id && a[u.id]);
    return /* @__PURE__ */ he.jsxs(
      hr,
      {
        onToggle: () => u?.id && l(u.id, !a[u.id]),
        isOpen: x,
        className: jr.collapse,
        children: [
          /* @__PURE__ */ he.jsx(hr.Header, { className: jr.collapseHeader, children: /* @__PURE__ */ he.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ he.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ he.jsx(ac, { width: 16, iconUrl: y }),
                    /* @__PURE__ */ he.jsx(
                      "a",
                      {
                        className: jr.collapseHeaderLink,
                        href: `${n}/browse/${u?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (S) => {
                          S.stopPropagation(), u?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: u.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "200", children: [
                          u?.key,
                          /* @__PURE__ */ he.jsx(me, { name: "external-link", size: 16 })
                        ] })
                      },
                      u?.key
                    )
                  ] }),
                  /* @__PURE__ */ he.jsx("span", { className: jr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ he.jsx(Rn, { className: jr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ he.jsx("div", { className: jr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ he.jsx(hr.Content, { className: jr.collapseContent, children: /* @__PURE__ */ he.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ he.jsx("div", { className: jr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ he.jsx(Qn, { className: jr.collapseContentDescription, children: d ? qv(d, HC) : "" }),
            /* @__PURE__ */ he.jsx(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: jr.collapseContentButtonSpacer,
                onClick: () => u?.key && t(u.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ he.jsx(
              Tt,
              {
                slotEnd: /* @__PURE__ */ he.jsx(me, { name: "external-link" }),
                variant: "tertiary",
                className: jr.collapseContentButtonLink,
                navigate: () => {
                  u?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: u.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${u.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      u?.id
    );
  }) : /* @__PURE__ */ he.jsx(he.Fragment, {}) });
}, f5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, h5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, v5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, y5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, g5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, k5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, b5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, _5 = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': f5,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": h5,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": v5,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": y5,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': g5,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': k5,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": b5
};
function Qi(e) {
  return _5[e] ?? {};
}
const KC = Qi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), x5 = Qi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), S5 = Qi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), N5 = Qi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), j5 = Qi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), w5 = Qi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), C5 = Qi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Hv = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), F5 = new RegExp(`^${Hv.source}$`), I5 = new RegExp(`/${Hv.source}$`), Ub = new RegExp(
  `.+?[&?]selectedIssue=(${Hv.source})[&?]?.*`
);
function GC(e, n) {
  const t = { jira: { issues: [] } }, [i, a] = oe([]), [o, s] = oe([]), [l, u] = oe(), { track: m } = gn(), { showNotification: d, showModal: f, useLazyQuery: h, useMutation: y } = mn(), {
    loading: x,
    data: S,
    error: j,
    store: w
  } = Kh(e ?? null), [
    v,
    { loading: q, error: T, data: I }
  ] = h(KC, {
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    const ue = I?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    ue?.length && (s(ue), a(ue.map((ve) => ve?.key).filter(Boolean)));
  }, [I]), qe(
    () => u(j || T || void 0),
    [j, T]
  ), qe(
    () => {
      x || G();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [S?.jira?.issues, x]
  );
  const O = async (ue, ve) => {
    await w(ue).then(() => {
      d({
        icon: "check-circle-filled",
        severity: "success",
        title: ve.success.title,
        text: ve.success.text
      });
    }).catch((H) => {
      d({
        title: ve.error.title,
        text: `${ve.error.text} ${H.message && " (" + H.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [U] = y(x5, {
    onError: (ue) => {
      d({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${ue.message && " (" + ue.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Z = (ue, ve) => {
    const H = window.location.href, ke = ve ? H.replace(
      e?.toString() ?? "",
      ve?.toString()
    ) : H, Ce = ve ? `# ${ve}` : `# ${e}`;
    U({
      variables: {
        issueKey: ue,
        title: Ce,
        url: ke,
        globalId: `system=${ke}`
      }
    });
  }, [Q] = y(S5, {
    onError: (ue) => {
      d({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${ue.message && " (" + ue.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ee = (ue) => {
    const ve = window.location.href;
    Q({
      variables: {
        issueKey: ue,
        globalId: `system=${ve}`
      }
    });
  }, J = (ue) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: ue
  }), G = () => {
    S && S.jira?.issues?.length > 0 ? v({
      variables: {
        jql: `key in (${S?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, P = async (ue, ve) => {
    m("jira:issue:link:clicked", J(ue));
    const H = S?.jira?.issues ? S : t;
    H.jira.issues = Array.from(
      new Set(H.jira.issues).add(ue)
    ), await w(H, ve?.toString()).then(() => Z(ue, ve)).catch((ke) => {
      d({
        title: "Linking failed",
        text: `Linking ${ue} failed. Please try again. ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, K = (ue) => {
    m("jira:issue:link:clicked", J(ue));
    const ve = S?.jira?.issues ? S : t;
    ve.jira.issues = Array.from(
      new Set(ve.jira.issues).add(ue)
    ), O(ve, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${ue} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ue} failed. Please try again.`
      }
    }).then(() => Z(ue));
  }, ne = (ue) => {
    m("jira:issue:unlink:clicked", J(ue)), f({
      headline: `Unlink issue ${ue}?`,
      text: `You are about to unlink the issue ${ue}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", J(ue));
        const ve = {
          ...S,
          jira: {
            ...S?.jira,
            issues: S?.jira?.issues.filter((H) => H !== ue) || []
          }
        };
        O(ve, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${ue}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ue} failed.`
          }
        }).then(() => ee(ue));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", J(ue))
    });
  }, pe = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((ue) => ue?.key && ee(ue.key)), O(t, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, ye = S?.jira?.issues?.filter(
    (ue) => !i?.includes(ue)
  ) || [];
  return {
    linkIssue: K,
    linkIssueQuietly: P,
    unlinkIssue: ne,
    loadIssues: G,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const ue = {
        ...S,
        jira: {
          ...S?.jira,
          issues: S?.jira?.issues.filter(
            (ve) => !ye.includes(ve)
          ) || []
        }
      };
      w(ue);
    },
    unlinkAllIssues: pe,
    maybeExtractIssueKey: (ue) => {
      const ve = ue.replace(/\s/g, "");
      if (F5.test(ve))
        return ve;
      if (Ub.test(ue))
        return ue.match(Ub)?.[1];
      if (ue.startsWith(n) && I5.test(ue))
        return ue.substring(ue.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: x,
    danglingIssueLinks: ye,
    isLoadingIssues: q,
    issues: o,
    error: l
  };
}
function $5(e = !1, n) {
  const [t, i] = oe(e);
  return qe(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const E5 = "_result_axxxc_48", T5 = "_resultName_axxxc_68", O5 = "_resultNameIcon_axxxc_76", R5 = "_resultDescription_axxxc_81", D5 = "_resultLinkIcon_axxxc_93", P5 = "_tooltip_axxxc_102", A5 = "_tooltipContent_axxxc_108", L5 = "_tooltipName_axxxc_115", V5 = "_tooltipNameIcon_axxxc_120", z5 = "_tooltipDescription_axxxc_125", M5 = "_tooltipSummary_axxxc_133", U5 = "_tooltipTag_axxxc_137", mr = {
  result: E5,
  resultName: T5,
  resultNameIcon: O5,
  resultDescription: R5,
  resultLinkIcon: D5,
  tooltip: P5,
  tooltipContent: A5,
  tooltipName: L5,
  tooltipNameIcon: V5,
  tooltipDescription: z5,
  tooltipSummary: M5,
  tooltipTag: U5
}, B5 = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: t,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: u, description: m } = e, [d, f] = oe(!1), h = WC({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ he.jsx(
    Qe,
    {
      disabled: i,
      className: mr.tooltip,
      content: /* @__PURE__ */ he.jsxs("div", { className: mr.tooltipContent, children: [
        /* @__PURE__ */ he.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ he.jsxs("span", { className: mr.tooltipName, children: [
                /* @__PURE__ */ he.jsx(
                  ac,
                  {
                    width: 16,
                    iconUrl: h,
                    className: mr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ he.jsx(Rn, { className: mr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ he.jsx("div", { className: mr.tooltipSummary, children: m }),
        u && /* @__PURE__ */ he.jsx("div", { className: mr.tooltipDescription, children: u })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ he.jsxs(
        "button",
        {
          ...a,
          className: mr.result,
          type: "button",
          onClick: () => {
            t(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ he.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: d ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ he.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ he.jsxs("span", { className: mr.resultName, children: [
                    /* @__PURE__ */ he.jsx(
                      ac,
                      {
                        width: 16,
                        iconUrl: h,
                        className: mr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ he.jsx("div", { className: mr.resultDescription, children: m })
                ]
              }
            ),
            d && /* @__PURE__ */ he.jsx(
              me,
              {
                className: mr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, q5 = ({
  className: e,
  searched: n,
  jiraInstanceUrl: t
}) => /* @__PURE__ */ he.jsx(
  Tt,
  {
    slotEnd: /* @__PURE__ */ he.jsx(me, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${t}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), H5 = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: t,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = oe([]), [l, u] = oe(""), [m, { loading: d, error: f, data: h, networkStatus: y }] = a(KC, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: x } = GC(null, n);
  Ba(
    () => {
      !d && l && y === yr.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const T = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      T.map((I) => ({
        id: I?.key ?? "",
        name: I?.key ?? "",
        description: I?.fields.summary,
        status: I?.fields.status,
        issuetype: I?.fields.issuetype,
        text: I?.fields.description ? qv(I?.fields.description, HC) : /* @__PURE__ */ he.jsx(he.Fragment, {})
      }))
    );
  }, [h]);
  const S = (T) => {
    e(T.id), u("");
  }, j = (T) => {
    const I = T.trim(), O = x(I);
    if (O) {
      const U = O.replaceAll("[-_|]", "\\\\$0");
      u(`key = '${U}'`);
    } else I !== "" && u(
      `text ~ '${I}'${t ? " and project = " + t : ""}`
    );
  }, w = () => {
    u("");
  }, v = (T) => /* @__PURE__ */ he.jsx(q5, { ...T, jiraInstanceUrl: n }), q = (T) => /* @__PURE__ */ he.jsx(
    B5,
    {
      ...T,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !d && f ? /* @__PURE__ */ he.jsx(wn, { error: f }) : /* @__PURE__ */ he.jsx(
    Lr,
    {
      items: o,
      loading: d,
      onSearch: j,
      onSelect: S,
      onClear: w,
      emptyMessage: l ? d ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: v,
      itemComponent: q,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, W5 = ({
  field: e,
  value: n,
  onChange: t
}) => {
  const [i, a] = oe(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: u }) => u !== s.id)
    );
  };
  return qe(() => {
    t(i);
  }, [i]), /* @__PURE__ */ he.jsx(
    Lr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: u }) => ({
          id: s,
          name: l || u
        })
      )
    }
  );
}, K5 = "_itemButton_1hl53_1", G5 = "_result_1hl53_6", Y5 = "_resultIcon_1hl53_26", J5 = "_resultName_1hl53_30", Q5 = "_resultCheckIcon_1hl53_38", lo = {
  itemButton: K5,
  result: G5,
  resultIcon: Y5,
  resultName: J5,
  resultCheckIcon: Q5
}, xh = ({
  item: e,
  checked: n = !1,
  onSelectItem: t,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ he.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ he.jsx(
        "button",
        {
          onClick: () => {
            t(e);
          },
          className: lo.itemButton,
          children: /* @__PURE__ */ he.jsxs(b, { className: lo.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ he.jsx(
              ac,
              {
                width: 36,
                iconUrl: o || "",
                className: lo.resultIcon
              }
            ),
            /* @__PURE__ */ he.jsx(Qn, { className: lo.resultName, children: e.name }),
            n && /* @__PURE__ */ he.jsx(Qn, { className: lo.resultCheckIcon, children: /* @__PURE__ */ he.jsx(me, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, X5 = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: t,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = mn(), [o, s] = oe([]), [l, u] = oe(), m = 2, [d, { loading: f, error: h, data: y, networkStatus: x }] = a(C5, {
    notifyOnNetworkStatusChange: !0
  });
  return Ba(
    () => {
      !f && l && l.length >= m && x === yr.ready ? d({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    n && d({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((S) => {
      if (S?.data?.Jira.findUsers?.length === 1) {
        const j = S?.data?.Jira?.findUsers[0];
        t(j.accountId), s([
          {
            id: j.accountId,
            name: j.displayName
          }
        ]);
      }
    });
  }, []), qe(() => {
    const S = y?.Jira?.findUsers || [];
    s(
      S.filter(({ active: j }) => j).map(({ accountId: j, displayName: w, avatarUrls: v, active: q }) => ({
        id: j,
        name: w,
        avatarUrls: v,
        active: q
      }))
    );
  }, [y]), !f && h ? /* @__PURE__ */ he.jsx(wn, { error: h }) : /* @__PURE__ */ he.jsx(
    Lr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (S) => u(S),
      onSelect: t,
      onClear: () => u(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: S, onSelect: j, checked: w }) => /* @__PURE__ */ he.jsx(
        xh,
        {
          item: S,
          checked: w,
          onSelectItem: j,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, Bb = ({
  field: e
}) => {
  const [n, t] = oe(!1), [i, a] = wC();
  return qe(() => {
    const o = n ? window.setTimeout(() => t(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ he.jsx(b, { children: /* @__PURE__ */ he.jsx(me, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ he.jsx(A.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ he.jsx(Qe, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ he.jsx(
      tr,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), t(!0);
        }
      }
    ) })
  ] });
}, Z5 = ({
  field: e,
  onChange: n,
  value: t,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ he.jsx(Bb, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ he.jsx(Pr, { onChange: n, value: t });
    case "string":
      return s === "description" ? /* @__PURE__ */ he.jsx(Uf, { onChange: n, value: t }) : /* @__PURE__ */ he.jsx(Pr, { onChange: n, value: t });
    case "textarea":
      return /* @__PURE__ */ he.jsx(Uf, { onChange: n, value: t });
    case "number":
      return /* @__PURE__ */ he.jsx(Pr, { type: "number", onChange: n, value: t });
    case "user":
      return /* @__PURE__ */ he.jsx(
        X5,
        {
          onSelect: n,
          selectedItems: t ? [t] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ he.jsx(
        Lr,
        {
          onSelect: n,
          selectedItems: t ? [t] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: u, value: m }) => ({
              id: l,
              name: u || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ he.jsx(W5, { field: e, value: t, onChange: n });
    default:
      return /* @__PURE__ */ he.jsx(Bb, { field: e });
  }
}, eq = ["description", "reporter", "summary"], nq = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: t,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ he.jsx(he.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || eq.includes(o)
).map((o) => /* @__PURE__ */ he.jsx(
  qt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ he.jsx(
      An,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: Z5({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: t
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), tq = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: t,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ he.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ he.jsxs(A.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ he.jsxs(
          A.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ he.jsx(me, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ he.jsx(An, { label: "Jira issue link", children: /* @__PURE__ */ he.jsx(
        Pr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: t ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), rq = "_modalBody_1hk1o_1", iq = "_modalBodyFormFields_1hk1o_4", qb = {
  modalBody: rq,
  modalBodyFormFields: iq
}, aq = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), oq = (e) => e?.custom?.split(":")?.[1] || null, sq = (e, n) => {
  if (e.startsWith("customfield_")) {
    const t = n.find((i) => i.key === e)?.schema;
    if (t)
      return t;
  }
  return null;
}, lq = (e, n) => {
  const t = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = sq(a, n), l = oq(s) ?? a;
        return t.includes(l) ? i[a] = aq(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, cq = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: t,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, u] = oe([]), [m, d] = oe(), [f, h] = oe(0), [y, x] = oe([]), [S, j] = oe([]), [w, v] = oe(!1), [q, T] = oe(!1), [I, O] = oe({}), { track: U } = gn(), { isCopied: Z, copyToClipboard: Q } = $5(), ee = Wn(() => i?.conversationId, [e]), { useMutation: J, useLazyQuery: G, showNotification: P } = mn(), {
    control: K,
    handleSubmit: ne,
    formState: { errors: pe },
    reset: ye,
    setValue: ue,
    getValues: ve
  } = xr({
    defaultValues: s
  }), H = S.length > 0, ke = `${a}/browse`, Ce = Object.keys(I).length > 0, [W, { loading: Be, error: Me }] = G(N5, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (de) => {
      u(de.Jira.getAllProjects);
    },
    onError: (de) => {
      P({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", de), u([]);
    }
  }), [
    Pe,
    { loading: Ue, error: Ie }
  ] = G(j5, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (de) => {
      h(0);
      const je = de?.Jira?.getCreateIssueMeta?.projects[0];
      if (je) {
        const Ae = je?.issuetypes.filter(
          ({ subtask: Re }) => !Re
        );
        x(Ae || []), ue(
          "issuetype",
          Ae.length > 0 ? Ae[0] : void 0
        );
      } else
        P({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), x([]), j([]);
    },
    onError: (de) => {
      P({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", de), x([]), j([]), h(0);
    }
  }), [Le, { error: Oe }] = J(
    w5,
    {
      onError: () => {
        v(!1), P({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), U("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (de) => {
        if (v(!1), de?.Jira && "key" in de.Jira.createIssue)
          d(de?.Jira?.createIssue), P({
            title: "Success",
            text: `Jira issue '${de.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), U("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: de.Jira.createIssue.key
          }), ee && t(
            de.Jira.createIssue.key,
            ee
          );
        else if ("errorMessages" in de.Jira.createIssue || "errors" in de.Jira.createIssue) {
          const je = de?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", je), P({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), an = (de) => {
    v(!0), O({}), Le({
      variables: {
        input: lq(de, S)
      }
    });
  };
  qe(() => {
    if (e)
      try {
        W();
      } catch (de) {
        console.warn("Error when fetching initial projects", de);
      }
  }, [e]), qe(() => {
    const de = q ? window.setTimeout(() => T(!1), 2e3) : void 0;
    return () => window.clearTimeout(de);
  }, [q]), qe(() => {
    if (y?.length > 0) {
      ue("issuetype", y[f]);
      const de = y[f]?.fields?.additionalProperties;
      if (de?.length > 0) {
        const je = de.map(
          ({ value: F }) => F
        ), Ae = (o ? je.sort(({ name: F }, { name: _ }) => F.localeCompare(_)) : je).sort(
          ({ required: F }, { required: _ }) => Number(_) - Number(F)
        ), { project: Re, issuetype: nn } = ve();
        ye({ project: Re, issuetype: nn }), j(Ae);
      }
    } else
      j([]), ue("issuetype", void 0);
  }, [y, ue, f]), qe(() => {
    if (Oe && tj(Oe)) {
      if (Oe?.graphQLErrors?.length > 0) {
        const { graphQLErrors: de } = Oe, je = de[0].extensions?.integration?.responseBody;
        try {
          const Ae = JSON.parse(je);
          if (Ae?.errors) {
            const Re = Object.keys(Ae.errors).reduce(
              (nn, F) => ({
                ...nn,
                [F]: {
                  type: "required",
                  message: Ae.errors[F],
                  ref: {
                    name: F
                  }
                }
              }),
              {}
            );
            O(Re);
          }
        } catch {
        }
      }
    } else
      O({});
  }, [Oe]);
  const Ne = () => {
    u([]), j([]), x([]), d(void 0), h(0), v(!1), O({});
  }, We = () => {
    Ne(), ye(s), n();
  }, Ke = (de) => {
    de && Pe({
      variables: {
        projectKey: de
      }
    });
  }, se = (de) => {
    const je = y.map((Ae) => Ae.id).indexOf(de);
    h(je ?? 0);
  };
  return /* @__PURE__ */ he.jsxs(
    Nt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: We,
      children: [
        /* @__PURE__ */ he.jsx(
          jt,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: We
          }
        ),
        /* @__PURE__ */ he.jsxs(wt, { className: qb.modalBody, children: [
          !Be && Me && /* @__PURE__ */ he.jsx(wn, { error: Me, retry: W }),
          !Ue && Ie && /* @__PURE__ */ he.jsx(
            wn,
            {
              error: Ie,
              retry: Pe
            }
          ),
          !w && Ce && /* @__PURE__ */ he.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ he.jsx(
            xc,
            {
              variant: "warning",
              description: /* @__PURE__ */ he.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ he.jsx(A.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ he.jsx(
                      Kn,
                      {
                        icon: Z ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Q(JSON.stringify(S, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ he.jsx(
            tq,
            {
              createdIssue: m,
              issueBaseLink: ke,
              issueLinkCopied: q,
              setIssueLinkCopied: T,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ he.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ne(an),
              children: /* @__PURE__ */ he.jsxs(Gt, { children: [
                /* @__PURE__ */ he.jsx(rn, { span: 3, children: /* @__PURE__ */ he.jsx(An, { label: "Project", required: !0, children: /* @__PURE__ */ he.jsx(
                  qt,
                  {
                    control: K,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: de, value: je } }) => /* @__PURE__ */ he.jsx(
                      Lr,
                      {
                        searchable: !0,
                        loading: Be,
                        onSelect: (Ae) => {
                          Ke(Ae.key), de(Ae);
                        },
                        selectedItems: [je],
                        placeholder: "Select Jira project",
                        emptyMessage: Me ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ae, onSelect: Re, checked: nn }) => /* @__PURE__ */ he.jsx(
                          xh,
                          {
                            item: Ae,
                            checked: nn,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ he.jsx(rn, { span: 3, children: /* @__PURE__ */ he.jsx(An, { label: "Issue type", required: !0, children: /* @__PURE__ */ he.jsx(
                  qt,
                  {
                    control: K,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: de, value: je } }) => /* @__PURE__ */ he.jsx(
                      Lr,
                      {
                        disabled: y.length === 0,
                        loading: Ue,
                        onSelect: (Ae) => {
                          se(Ae.id), de(Ae);
                        },
                        selectedItems: [je],
                        placeholder: y.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Ie ? "No issues found" : "No issues available",
                        items: y,
                        itemComponent: ({ item: Ae, onSelect: Re, checked: nn }) => /* @__PURE__ */ he.jsx(
                          xh,
                          {
                            item: Ae,
                            checked: nn,
                            onSelectItem: Re,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                H && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ he.jsx(rn, { className: qb.modalBodyFormFields, children: /* @__PURE__ */ he.jsx(
                  nq,
                  {
                    control: K,
                    errors: { ...pe, ...I },
                    getValues: ve,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: S
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ he.jsx(
          Ot,
          {
            confirmOnClick: m ? We : ne(an),
            confirmProps: {
              disabled: !H,
              isLoading: w,
              loadingIndicator: /* @__PURE__ */ he.jsx(dn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : We
          }
        )
      ]
    }
  );
}, uq = (e) => {
  if (!e) return "";
  const n = "https://", t = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${t}`;
}, dq = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const t = e.startsWith(n);
  if (t) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = t ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else {
    const i = "://";
    return e.includes(i) ? `The protocol \`${e.substring(
      0,
      e.indexOf(i) + i.length
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
  }
}, mq = "_wrapper_1bylq_1", pq = "_inputWrapper_1bylq_6", fq = "_inputSeparator_1bylq_18", hq = "_buttonLink_1bylq_23", vq = "_noIssuesFound_1bylq_27", co = {
  wrapper: mq,
  inputWrapper: pq,
  inputSeparator: fq,
  buttonLink: hq,
  noIssuesFound: vq
}, yq = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: t } = gn(), i = uq(n?.jiraSiteUrl), [a, o] = oe(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: u,
    unlinkIssue: m,
    unlinkAllIssues: d,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: y,
    isLoadingIssueLinks: x,
    isLoadingIssues: S,
    issues: j,
    error: w
  } = GC(
    s ? e.conversationId : null,
    i
  ), v = !!n?.enableCreateIssue, q = !!n?.enableSortIssueTypeByLabel, T = !!(j?.length || y?.length), I = !!n?.enableRemoveAllLinks && T, O = !x && !S && y?.length > 0 && !!n?.showDanglingLinks;
  return !S && w ? /* @__PURE__ */ he.jsx(wn, { error: w, retry: () => f() }) : /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
    /* @__PURE__ */ he.jsxs(b, { className: co.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ he.jsxs(b, { className: co.inputWrapper, flexDirection: "column", children: [
        v && /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
          /* @__PURE__ */ he.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ he.jsx("div", { className: co.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ he.jsx(
          H5,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      S ? /* @__PURE__ */ he.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ he.jsx(dn, { "data-testid": "jira-widget-issue-spinner" }) }) : j?.length ? /* @__PURE__ */ he.jsx(
        p5,
        {
          issues: j,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ he.jsx(A.Paragraph, { align: "center", className: co.noIssuesFound, children: "No linked issues found" }),
      I && j?.length > 0 && /* @__PURE__ */ he.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: !j?.length && !y?.length,
          onClick: d,
          children: "Unlink all issues"
        }
      ),
      O && /* @__PURE__ */ he.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ he.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ he.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: y.map((U) => /* @__PURE__ */ he.jsx(Rn, { onDelete: () => m(U), children: U }, U)) }),
            /* @__PURE__ */ he.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ he.jsx(
        Tt,
        {
          slotEnd: /* @__PURE__ */ he.jsx(me, { name: "external-link" }),
          variant: "tertiary",
          className: co.buttonLink,
          navigate: () => {
            t("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ he.jsx(
      cq,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: u,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: q
      }
    )
  ] });
}, Hb = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => dq(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: kc
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var yd = { exports: {} }, uo = {}, Wb;
function gq() {
  if (Wb) return uo;
  Wb = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return uo.Fragment = t, uo.jsx = s, uo.jsxs = s, uo;
}
var nl = {}, Kb;
function kq() {
  return Kb || (Kb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    nl.Fragment = i, nl.jsx = Bn, nl.jsxs = qn;
  }()), nl;
}
var Gb;
function bq() {
  return Gb || (Gb = 1, process.env.NODE_ENV === "production" ? yd.exports = gq() : yd.exports = kq()), yd.exports;
}
var Ee = bq();
function _q({
  query: e,
  options: n,
  delayMs: t
}) {
  const { useLazyQuery: i } = mn(), [a, o] = oe([]), [s] = i(e, n), [l, u] = oe(
    []
  );
  return qe(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const d = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((x) => {
        const S = setTimeout(x, t);
        u([...l, S]);
      });
      const y = await s({
        variables: h
      });
      d.push(y);
    }
    o(d);
  }, a];
}
const xq = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Sq = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Nq = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, jq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, wq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Cq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Fq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_EmailMessageContent" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Iq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, $q = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Eq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "EnumValue", value: "subscriptions" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Tq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_lists" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Oq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Rq = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": xq,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": Sq,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": jq,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": wq,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": Nq,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": Cq,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              content {\n                ... on Klaviyo_EmailMessageContent {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": Fq,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": Iq,
  "\n  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": $q,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": Eq,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_lists(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": Tq,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_segments(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": Oq
};
function fi(e) {
  return Rq[e] ?? {};
}
const Dq = fi(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Pq = fi(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {
          data {
            id
            type
            attributes {
              content {
                ... on Klaviyo_EmailMessageContent {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Aq = fi(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Lq = fi(
  /* GraphQL */
  `
  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Vq = fi(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), zq = fi(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_lists(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Mq = fi(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_segments(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Uq = fi(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Bq = fi(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function Sh(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function Yb(e) {
  return Sh(e) && e?.attributes?.event_properties?.$message;
}
function qq(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function Jb(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function Hq(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollection" && e.Klaviyo.get_metrics.data || [];
}
function Wq(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function Kq(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function Gq(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function Yq(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function Jq(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function Qb(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function Qq(e) {
  return e?.attributes?.content?.__typename === "Klaviyo_EmailMessageContent" && e.attributes.content.preview_text || void 0;
}
function Xq(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const Zq = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function e6(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function n6(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function t6({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: t, useQuery: i } = mn(), { track: a } = gn(), [o, s] = oe(null), [l, u] = oe(
    null
  ), [m, d] = oe(null), [f, h] = oe(null), [y, x] = oe(
    null
  ), [S, j] = oe([]), {
    data: w,
    error: v,
    loading: q,
    networkStatus: T
  } = i(Aq, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    I,
    {
      data: O,
      error: U,
      loading: Z,
      networkStatus: Q
    }
  ] = t(Dq, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return qe(() => {
    if (w && !q && T === yr.ready) {
      const ee = Hq(w);
      s(
        ee.find((J) => J?.attributes?.name === "Received Email")?.id || null
      ), u(
        ee.find((J) => J?.attributes?.name === "Opened Email")?.id || null
      ), d(
        ee.find((J) => J?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ee.find((J) => J?.attributes?.name === "Bounced Email")?.id || null
      ), x(
        ee.find((J) => J?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), u(null), d(null), h(null), x(null);
  }, [w]), qe(() => {
    o && l && m && f && y && !Z && Q === yr.ready ? I({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${y}")`,
        pageSize: n
      }
    }) : j([]);
  }, [
    o,
    l,
    m,
    f,
    y
  ]), qe(() => {
    if (!Z && O) {
      const ee = Wq(O), J = Gq(
        O
      ).map(
        (ye) => ye?.attributes?.event_properties.$message
      ), G = Yq(
        O
      ).map(
        (ye) => ye?.attributes?.event_properties.$message
      );
      ee.forEach((ye) => {
        const ue = ye.attributes?.event_properties.$message;
        ye.opened = J.includes(ue), ye.clicked = G.includes(ue);
      });
      const P = Kq(O), K = Jq(O), ne = [
        ...ee,
        ...K,
        ...P
      ].sort((ye, ue) => {
        const ve = Jb(ye), H = Jb(ue);
        return ve == null && H == null ? 0 : ve == null ? 1 : H == null ? -1 : H - ve;
      }).slice(0, n);
      j(ne);
      const pe = ne.map((ye) => ye.id);
      a("klaviyo:messages:received", {
        emailsReceived: ee.filter(
          (ye) => pe.includes(ye.id)
        ).length,
        emailsBounced: K.filter(
          (ye) => pe.includes(ye.id)
        ).length,
        smsReceived: P.filter(
          (ye) => pe.includes(ye.id)
        ).length,
        total: pe.length
      });
    } else
      j([]);
  }, [Z, O]), Wn(
    () => ({
      receivedMessages: S,
      isLoading: q || Z,
      error: v || U
    }),
    [
      S,
      q,
      Z,
      v,
      U
    ]
  );
}
function r6({ profileId: e }) {
  const { useQuery: n } = mn(), [t, i] = oe(), [a, o] = oe(), {
    data: s,
    error: l,
    loading: u,
    refetch: m
  } = n(Vq, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  qe(() => {
    l && o(l);
  }, [l]), qe(() => {
    !u && s && i(s.Klaviyo.get_profile);
  }, [u, s]);
  const d = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Wn(
    () => ({
      profile: t,
      refetchProfile: d,
      isLoading: u,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, u, a]
  );
}
function i6({
  email: e,
  phoneNumber: n
}) {
  const { track: t } = gn(), { useLazyQuery: i } = mn(), [a, o] = oe(), [s, l] = oe(), [
    u,
    { data: m, error: d, loading: f }
  ] = i(Lq, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    if (!f && m) {
      const y = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, x = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(y, x);
    }
  }, [f, m]);
  const h = (y, x) => {
    const S = y?.data?.length === 1 && y.data[0]?.id || void 0, j = x?.data?.length === 1 && x.data[0]?.id || void 0, w = S || j, v = !S || !j || S === j;
    if (w && v) {
      o(S || j), t("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), t("klaviyo:profile:received", { hasProfile: !1 }), v || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${S}) and phone number ${n} (profile ID ${j}).`
      )
    );
  };
  return Wn(
    () => ({
      profileId: a,
      getProfileId: u,
      isLoading: f,
      error: d || s
    }),
    [a, u, f, d, s]
  );
}
const Xb = 800, a6 = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, o6 = 3, s6 = 1.5, l6 = ({
  query: e,
  delay: n,
  delayRange: t,
  maxCount: i = o6,
  useDelayRange: a = !1
}) => {
  const o = (U) => Math.floor(Math.random() * (U.max - U.min) + U.min), [s, l] = oe(0), [u, m] = oe(n || Xb), [d, f] = oe(t || a6), [h, y] = oe(!1), [x, S] = oe(!1), j = a || !!t, w = j ? o(d) : n || Xb, [v, q] = oe(w);
  HU(
    async () => {
      const U = s + 1, Z = s6 ** U;
      l(U), q(
        (j ? o(d) : u) * Z
      ), await e().then(() => {
        S(!0), O();
      });
    },
    h ? v : null
  ), KU(() => O());
  const T = vt(() => {
    l(0), q(w);
  }, [w]), I = vt(
    (U = {}) => {
      const { delay: Z, delayRange: Q } = U;
      S(!1), T(), Q && (f(Q), q(o(Q))), Z && (m(Z), q(Z)), y(!0);
    },
    [T]
  ), O = vt(() => {
    y(!1), T();
  }, [T]);
  return qe(() => {
    s >= i && O();
  }, [s, i, O]), Wn(
    () => ({ isRunning: h, isSuccessful: x, start: I, stop: O }),
    [h, x, I, O]
  );
}, c6 = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, u6 = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function d6({
  profileId: e,
  query: n
}) {
  const { useQuery: t } = mn(), [i, a] = oe(), [o, s] = oe(), {
    data: l,
    error: u,
    loading: m,
    refetch: d,
    networkStatus: f
  } = t(
    n === "lists" ? zq : Mq,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: y,
    stop: x
  } = l6({
    query: d,
    useDelayRange: !0
  }), S = m || h;
  return qe(() => {
    if (u)
      if (tI({
        errors: u.graphQLErrors
      })) {
        if (!h) {
          const j = c6(u);
          y({
            ...j && {
              delayRange: u6(j)
            }
          });
        }
      } else
        s(u);
  }, [u]), qe(() => {
    if (!m && l?.Klaviyo) {
      let j = {}, w = {};
      n === "lists" && (j = l?.Klaviyo?.get_profile_lists), n === "segments" && (w = l?.Klaviyo?.get_profile_segments), (j?.data || w?.data) && (x(), a(
        (n === "lists" ? j?.data : w?.data)?.map((v) => ({
          ...v,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Wn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: y,
      isLoading: S,
      error: o,
      networkStatus: f
    }),
    [i, S, o, f, y]
  );
}
const m6 = "_notificationText_1polx_1", Wv = {
  notificationText: m6
}, Jc = ({ error: e }) => {
  const { track: n } = gn();
  let t = e;
  if (tj(e)) {
    const { graphQLErrors: i } = e, a = i.length === 1 && eI({ error: i[0] }), o = i.length === 1 && nI({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), t = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), t = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ Ee.jsx(wn, { error: e });
  }
  return /* @__PURE__ */ Ee.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ Ee.jsx(
    He.Item,
    {
      contentLeft: /* @__PURE__ */ Ee.jsx(me, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: t.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, p6 = "_message_1vrar_48", f6 = "_messageIsOpen_1vrar_56", h6 = "_messageHeader_1vrar_59", v6 = "_messageLabel_1vrar_65", y6 = "_messageText_1vrar_68", xa = {
  message: p6,
  messageIsOpen: f6,
  messageHeader: h6,
  messageLabel: v6,
  messageText: y6
}, g6 = ({ event: e, isLoadingPreview: n }) => {
  const t = e?.attributes?.event_properties, i = e.flowMessage && Qq(e.flowMessage);
  return /* @__PURE__ */ Ee.jsxs(Ee.Fragment, { children: [
    /* @__PURE__ */ Ee.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", className: xa.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ Ee.jsx(A.Paragraph, { children: t["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ Ee.jsx(dn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ Ee.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ Ee.jsx(b, { children: /* @__PURE__ */ Ee.jsx(
            A.Paragraph,
            {
              variant: "4",
              className: xa.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", className: xa.messageText, children: i })
        ]
      }
    )
  ] });
}, k6 = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ Ee.jsx(Ee.Fragment, { children: /* @__PURE__ */ Ee.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ Ee.jsx(b, { children: /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ Ee.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, b6 = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: t
}) => {
  const [i, a] = oe(t), { attributes: o, eventType: s } = e, l = o?.datetime, u = o?.timestamp, m = "DD MMM YYYY @ HH:mm", d = Wn(
    () => () => l ? Dn(l).format(m) : u ? Dn.unix(u).format(m) : null,
    [u, l]
  )(), f = s === "EMAIL", h = s === "SMS", y = f && e.opened, x = f && e.clicked, S = f && o?.event_properties.Subject, j = h && o?.event_properties["Message Name"], w = f ? "mail" : "sms";
  return /* @__PURE__ */ Ee.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: ut(xa.message, {
        [xa.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ Ee.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: xa.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ Ee.jsx(me, { size: 16, name: w }),
                  " ",
                  Zq(s),
                  d && /* @__PURE__ */ Ee.jsx(Mn, { size: "small", variant: "info", children: d })
                ] }),
                S && S,
                j && j
              ] }),
              /* @__PURE__ */ Ee.jsx(
                tr,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ Ee.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ Ee.jsx(Gh, {}),
          qq(e) && /* @__PURE__ */ Ee.jsx(b, { children: /* @__PURE__ */ Ee.jsx(Mn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ Ee.jsxs(Ee.Fragment, { children: [
            /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ Ee.jsx(Rn, { children: /* @__PURE__ */ Ee.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Ee.jsx(
                  me,
                  {
                    size: 16,
                    color: y ? "green.400" : "red.400",
                    name: y ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ Ee.jsx(Rn, { children: /* @__PURE__ */ Ee.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Ee.jsx(
                  me,
                  {
                    size: 16,
                    color: x ? "green.400" : "red.400",
                    name: x ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ Ee.jsx(g6, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ Ee.jsx(k6, { event: e })
        ] })
      ]
    }
  );
}, _6 = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, x6 = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [t, i] = oe(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = t6({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, u] = _q({
    query: Pq,
    options: _6,
    delayMs: 1e3
  }), [m, d] = oe([]);
  qe(() => {
    if (a.length > 0) {
      d(a);
      const h = a.filter((y) => Sh(y)).map((y) => Yb(y));
      h.length > 0 && (i(!0), l(
        h.map((y) => ({
          messageId: y
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), qe(() => {
    u.length > 0 && d(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && Sh(h) && !h.flowMessage) {
          const y = Yb(h), x = u.find((j) => (j.data && Qb(j.data))?.id === y), S = x?.data && Qb(x.data);
          if (S)
            return {
              ...Xq(h),
              flowMessage: S
            };
        }
        return h;
      })
    );
  }, [u]);
  const f = [];
  return s && f.push(s), u.length > 0 && f.push(
    ...u.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ Ee.jsx(Ee.Fragment, { children: f.map((h, y) => h.graphQLErrors ? /* @__PURE__ */ Ee.jsx(
    wn,
    {
      error: h
    },
    `lastMessagesError${y}`
  ) : /* @__PURE__ */ Ee.jsx(
    Jc,
    {
      error: h
    },
    `lastMessagesError${y}`
  )) }) : /* @__PURE__ */ Ee.jsxs(Ee.Fragment, { children: [
    /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ee.jsx(dn, {}) }) : /* @__PURE__ */ Ee.jsx(Ee.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, y) => /* @__PURE__ */ Ee.jsx(
      b6,
      {
        event: h,
        isLoadingPreview: t,
        openByDefault: y === 0
      },
      h.id
    )) }) : /* @__PURE__ */ Ee.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: Wv.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, S6 = "_list_ld0hf_1", N6 = "_listItem_ld0hf_4", Ao = {
  list: S6,
  listItem: N6
}, Zb = ({
  profileId: e,
  type: n
}) => {
  const [t, i] = oe(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: u
  } = d6({ profileId: e, query: n });
  qe(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || u();
  }, d = a || [];
  return o ? /* @__PURE__ */ Ee.jsx(Jc, { error: o }) : s ? /* @__PURE__ */ Ee.jsx(He.Text, { variant: "dense", className: Ao.listItem, children: /* @__PURE__ */ Ee.jsx(dn, { size: 14 }) }, "loading") : d.length > 0 ? /* @__PURE__ */ Ee.jsx(Ee.Fragment, { children: d.map(
    ({ attributes: f, type: h }, y) => /* @__PURE__ */ Ee.jsx(He.Text, { variant: "dense", className: Ao.listItem, children: /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ Ee.jsx(Rn, { children: bc(h) })
    ] }) }, y)
  ) }) : t && !a ? /* @__PURE__ */ Ee.jsx(He.Text, { variant: "dense", className: Ao.listItem, children: /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ee.jsx(me, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ Ee.jsxs(A.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ Ee.jsx(Qe, { content: "Refresh lists and segments", children: /* @__PURE__ */ Ee.jsx(Kn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ Ee.jsx(He.Text, { variant: "dense", className: Ao.listItem, children: /* @__PURE__ */ Ee.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ Ee.jsx(A.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ Ee.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, j6 = "_tagHover_kzbzk_1", w6 = "_channelUnsubscribed_kzbzk_6", e_ = {
  tagHover: j6,
  channelUnsubscribed: w6
}, n_ = ({
  isSubscribed: e,
  isLoading: n,
  channelName: t,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ Ee.jsx(
    Qe,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ Ee.jsx(
        Rn,
        {
          className: e_.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ Ee.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: ut({
                [e_.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ Ee.jsx(dn, { size: 16 }) : /* @__PURE__ */ Ee.jsx(me, { size: 16, name: i }),
                t
              ]
            }
          )
        }
      )
    }
  );
}, C6 = "_subscriptionError_1qhhx_1", F6 = {
  subscriptionError: C6
}, I6 = ({
  subscriptionListId: e,
  profile: n,
  email: t,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = oe(!1), [u, m] = oe(!1), [d, f] = oe(), { track: h } = gn(), [y, x] = WU({
    channel: null,
    request: null
  }), S = e6(n), j = n6(n), w = !!e, { useMutation: v } = mn(), [q] = v(
    Uq
  ), [T] = v(
    Bq
  ), I = (Z) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Z }), x.setAll({
      channel: Z,
      request: "subscribed"
    }), ((Q) => q({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: "profile",
                id: a,
                attributes: {
                  email: t,
                  // eslint-disable-next-line camelcase
                  phone_number: i,
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: e
            }
          }
        }
      }
    }))(Z).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !0
      })
    );
  }, O = (Z) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Z }), x.setAll({
      channel: Z,
      request: "unsubscribed"
    }), T({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: "profile",
                attributes: {
                  ...Z === "EMAIL" ? { email: t } : {},
                  // eslint-disable-next-line camelcase
                  ...Z === "SMS" ? { phone_number: i } : {}
                }
              }
            ]
          }
        }
      }
    }).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !1
      })
    );
  }, U = async ({
    channel: Z,
    mutationResponse: Q,
    mutationErrorResponse: ee,
    isSubscriptionRequest: J
  }) => {
    const G = ee?.networkError, P = G ? G?.statusCode : NaN, K = Q?.errors, ne = !!K && XN({
      errors: K
    });
    P === 202 ? (h(
      J ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Z }
    ), await o()) : ne ? (h(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${J ? "opt-in" : "opt-out"}.`
    )) : (h(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: G?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${J ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return qe(() => {
    if (y.request === "subscribed") {
      const Z = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${y.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      y.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Z), x.reset()), y.channel === "SMS" && !u && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Z), x.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    u
  ]), /* @__PURE__ */ Ee.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ Ee.jsx(
            n_,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: S,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: w,
              handleAction: () => {
                l(!0), f(void 0), S ? O("EMAIL") : I("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ Ee.jsx(
            n_,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: u,
              isSubscribed: j,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: w,
              handleAction: () => {
                m(!0), f(void 0), j ? O("SMS") : I("SMS");
              }
            }
          )
        ] }),
        d && /* @__PURE__ */ Ee.jsx(b, { className: F6.subscriptionError, children: d })
      ] })
    }
  );
}, $6 = ({
  profileId: e,
  email: n,
  phoneNumber: t,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  noOfMessagesToShow: s,
  subscriptionListId: l
}) => {
  const {
    profile: u,
    error: m,
    isLoading: d,
    refetchProfile: f
  } = r6({ profileId: e });
  return m ? /* @__PURE__ */ Ee.jsx(Jc, { error: m }) : d ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ee.jsx(dn, {}) }) : !u && !d ? /* @__PURE__ */ Ee.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: Wv.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ Ee.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ Ee.jsx(A.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ Ee.jsxs(He, { className: Ao.list, children: [
        i && /* @__PURE__ */ Ee.jsx(Zb, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ Ee.jsx(
          Zb,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ Ee.jsx(
      I6,
      {
        profile: u,
        profileId: e,
        subscriptionListId: l,
        refetchProfile: f,
        email: n,
        phoneNumber: t
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      x6,
      {
        profileId: e,
        noOfMessagesToShow: s
      }
    )
  ] });
}, E6 = ({
  conversationContext: e,
  settings: n
}) => {
  const t = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: m,
    getProfileId: d,
    isLoading: f,
    error: h
  } = i6({ email: t, phoneNumber: i });
  return aI(() => {
    (t || i) && d({
      variables: {
        emailFilter: `equals(email,"${t}")`,
        phoneNumberFilter: `equals(phone_number,"${i}")`
      }
    });
  }, [t, i]), !t && !i ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : f ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ee.jsx(dn, {}) }) : h ? /* @__PURE__ */ Ee.jsx(Jc, { error: h }) : m ? /* @__PURE__ */ Ee.jsx(
    $6,
    {
      profileId: m,
      email: t,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      noOfMessagesToShow: l,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ Ee.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Wv.notificationText,
      children: "No profile ID found"
    }
  );
}, T6 = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: ZF
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
];
function O6(e, n) {
  const t = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (t.padRight ? " " : "") + "," + (t.padLeft === !1 ? "" : " ")
  ).trim();
}
const R6 = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, D6 = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, P6 = {};
function t_(e, n) {
  return (P6.jsx ? D6 : R6).test(e);
}
const A6 = /[ \t\n\f\r]/g;
function L6(e) {
  return typeof e == "object" ? e.type === "text" ? r_(e.value) : !1 : r_(e);
}
function r_(e) {
  return e.replace(A6, "") === "";
}
class Cs {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, t, i) {
    this.property = n, this.normal = t, i && (this.space = i);
  }
}
Cs.prototype.property = {};
Cs.prototype.normal = {};
Cs.prototype.space = null;
function YC(e, n) {
  const t = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(t, e[a].property), Object.assign(i, e[a].normal);
  return new Cs(t, i, n);
}
function Nh(e) {
  return e.toLowerCase();
}
class Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, t) {
    this.property = n, this.attribute = t;
  }
}
Sr.prototype.space = null;
Sr.prototype.boolean = !1;
Sr.prototype.booleanish = !1;
Sr.prototype.overloadedBoolean = !1;
Sr.prototype.number = !1;
Sr.prototype.commaSeparated = !1;
Sr.prototype.spaceSeparated = !1;
Sr.prototype.commaOrSpaceSeparated = !1;
Sr.prototype.mustUseProperty = !1;
Sr.prototype.defined = !1;
let V6 = 0;
const Cn = Xi(), ft = Xi(), JC = Xi(), Ve = Xi(), Zn = Xi(), Sa = Xi(), ar = Xi();
function Xi() {
  return 2 ** ++V6;
}
const jh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Cn,
  booleanish: ft,
  commaOrSpaceSeparated: ar,
  commaSeparated: Sa,
  number: Ve,
  overloadedBoolean: JC,
  spaceSeparated: Zn
}, Symbol.toStringTag, { value: "Module" })), gd = Object.keys(jh);
class Kv extends Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, t, i, a) {
    let o = -1;
    if (super(n, t), i_(this, "space", a), typeof i == "number")
      for (; ++o < gd.length; ) {
        const s = gd[o];
        i_(this, gd[o], (i & jh[s]) === jh[s]);
      }
  }
}
Kv.prototype.defined = !0;
function i_(e, n, t) {
  t && (e[n] = t);
}
const z6 = {}.hasOwnProperty;
function Ha(e) {
  const n = {}, t = {};
  let i;
  for (i in e.properties)
    if (z6.call(e.properties, i)) {
      const a = e.properties[i], o = new Kv(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, t[Nh(i)] = i, t[Nh(o.attribute)] = i;
    }
  return new Cs(n, t, e.space);
}
const QC = Ha({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), XC = Ha({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function ZC(e, n) {
  return n in e ? e[n] : n;
}
function e1(e, n) {
  return ZC(e, n.toLowerCase());
}
const n1 = Ha({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: e1,
  properties: { xmlns: null, xmlnsXLink: null }
}), t1 = Ha({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: ft,
    ariaAutoComplete: null,
    ariaBusy: ft,
    ariaChecked: ft,
    ariaColCount: Ve,
    ariaColIndex: Ve,
    ariaColSpan: Ve,
    ariaControls: Zn,
    ariaCurrent: null,
    ariaDescribedBy: Zn,
    ariaDetails: null,
    ariaDisabled: ft,
    ariaDropEffect: Zn,
    ariaErrorMessage: null,
    ariaExpanded: ft,
    ariaFlowTo: Zn,
    ariaGrabbed: ft,
    ariaHasPopup: null,
    ariaHidden: ft,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Zn,
    ariaLevel: Ve,
    ariaLive: null,
    ariaModal: ft,
    ariaMultiLine: ft,
    ariaMultiSelectable: ft,
    ariaOrientation: null,
    ariaOwns: Zn,
    ariaPlaceholder: null,
    ariaPosInSet: Ve,
    ariaPressed: ft,
    ariaReadOnly: ft,
    ariaRelevant: null,
    ariaRequired: ft,
    ariaRoleDescription: Zn,
    ariaRowCount: Ve,
    ariaRowIndex: Ve,
    ariaRowSpan: Ve,
    ariaSelected: ft,
    ariaSetSize: Ve,
    ariaSort: null,
    ariaValueMax: Ve,
    ariaValueMin: Ve,
    ariaValueNow: Ve,
    ariaValueText: null,
    role: null
  }
}), M6 = Ha({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: e1,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Sa,
    acceptCharset: Zn,
    accessKey: Zn,
    action: null,
    allow: null,
    allowFullScreen: Cn,
    allowPaymentRequest: Cn,
    allowUserMedia: Cn,
    alt: null,
    as: null,
    async: Cn,
    autoCapitalize: null,
    autoComplete: Zn,
    autoFocus: Cn,
    autoPlay: Cn,
    blocking: Zn,
    capture: null,
    charSet: null,
    checked: Cn,
    cite: null,
    className: Zn,
    cols: Ve,
    colSpan: null,
    content: null,
    contentEditable: ft,
    controls: Cn,
    controlsList: Zn,
    coords: Ve | Sa,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Cn,
    defer: Cn,
    dir: null,
    dirName: null,
    disabled: Cn,
    download: JC,
    draggable: ft,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Cn,
    formTarget: null,
    headers: Zn,
    height: Ve,
    hidden: Cn,
    high: Ve,
    href: null,
    hrefLang: null,
    htmlFor: Zn,
    httpEquiv: Zn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Cn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Cn,
    itemId: null,
    itemProp: Zn,
    itemRef: Zn,
    itemScope: Cn,
    itemType: Zn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Cn,
    low: Ve,
    manifest: null,
    max: null,
    maxLength: Ve,
    media: null,
    method: null,
    min: null,
    minLength: Ve,
    multiple: Cn,
    muted: Cn,
    name: null,
    nonce: null,
    noModule: Cn,
    noValidate: Cn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Cn,
    optimum: Ve,
    pattern: null,
    ping: Zn,
    placeholder: null,
    playsInline: Cn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Cn,
    referrerPolicy: null,
    rel: Zn,
    required: Cn,
    reversed: Cn,
    rows: Ve,
    rowSpan: Ve,
    sandbox: Zn,
    scope: null,
    scoped: Cn,
    seamless: Cn,
    selected: Cn,
    shadowRootClonable: Cn,
    shadowRootDelegatesFocus: Cn,
    shadowRootMode: null,
    shape: null,
    size: Ve,
    sizes: null,
    slot: null,
    span: Ve,
    spellCheck: ft,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ve,
    step: null,
    style: null,
    tabIndex: Ve,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Cn,
    useMap: null,
    value: ft,
    width: Ve,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Zn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ve,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ve,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Cn,
    // Lists. Use CSS to reduce space between items instead
    declare: Cn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ve,
    // `<img>` and `<object>`
    leftMargin: Ve,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ve,
    // `<body>`
    marginWidth: Ve,
    // `<body>`
    noResize: Cn,
    // `<frame>`
    noHref: Cn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Cn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Cn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ve,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: ft,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ve,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ve,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Cn,
    disableRemotePlayback: Cn,
    prefix: null,
    property: null,
    results: Ve,
    security: null,
    unselectable: null
  }
}), U6 = Ha({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: ZC,
  properties: {
    about: ar,
    accentHeight: Ve,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ve,
    amplitude: Ve,
    arabicForm: null,
    ascent: Ve,
    attributeName: null,
    attributeType: null,
    azimuth: Ve,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ve,
    by: null,
    calcMode: null,
    capHeight: Ve,
    className: Zn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ve,
    diffuseConstant: Ve,
    direction: null,
    display: null,
    dur: null,
    divisor: Ve,
    dominantBaseline: null,
    download: Cn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ve,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ve,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ve,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Sa,
    g2: Sa,
    glyphName: Sa,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ve,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ve,
    horizOriginX: Ve,
    horizOriginY: Ve,
    id: null,
    ideographic: Ve,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ve,
    k: Ve,
    k1: Ve,
    k2: Ve,
    k3: Ve,
    k4: Ve,
    kernelMatrix: ar,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ve,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ve,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ve,
    overlineThickness: Ve,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ve,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Zn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ve,
    pointsAtY: Ve,
    pointsAtZ: Ve,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: ar,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: ar,
    rev: ar,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: ar,
    requiredFeatures: ar,
    requiredFonts: ar,
    requiredFormats: ar,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ve,
    specularExponent: Ve,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ve,
    strikethroughThickness: Ve,
    string: null,
    stroke: null,
    strokeDashArray: ar,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ve,
    strokeOpacity: Ve,
    strokeWidth: null,
    style: null,
    surfaceScale: Ve,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: ar,
    tabIndex: Ve,
    tableValues: null,
    target: null,
    targetX: Ve,
    targetY: Ve,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: ar,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ve,
    underlineThickness: Ve,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ve,
    values: null,
    vAlphabetic: Ve,
    vMathematical: Ve,
    vectorEffect: null,
    vHanging: Ve,
    vIdeographic: Ve,
    version: null,
    vertAdvY: Ve,
    vertOriginX: Ve,
    vertOriginY: Ve,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ve,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), B6 = /^data[-\w.:]+$/i, a_ = /-[a-z]/g, q6 = /[A-Z]/g;
function H6(e, n) {
  const t = Nh(n);
  let i = n, a = Sr;
  if (t in e.normal)
    return e.property[e.normal[t]];
  if (t.length > 4 && t.slice(0, 4) === "data" && B6.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(a_, K6);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!a_.test(o)) {
        let s = o.replace(q6, W6);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Kv;
  }
  return new a(i, n);
}
function W6(e) {
  return "-" + e.toLowerCase();
}
function K6(e) {
  return e.charAt(1).toUpperCase();
}
const G6 = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, Y6 = YC([XC, QC, n1, t1, M6], "html"), Gv = YC([XC, QC, n1, t1, U6], "svg");
function J6(e) {
  return e.join(" ").trim();
}
var la = {}, kd, o_;
function Q6() {
  if (o_) return kd;
  o_ = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, t = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, u = `
`, m = "/", d = "*", f = "", h = "comment", y = "declaration";
  kd = function(S, j) {
    if (typeof S != "string")
      throw new TypeError("First argument must be a string");
    if (!S) return [];
    j = j || {};
    var w = 1, v = 1;
    function q(P) {
      var K = P.match(n);
      K && (w += K.length);
      var ne = P.lastIndexOf(u);
      v = ~ne ? P.length - ne : v + P.length;
    }
    function T() {
      var P = { line: w, column: v };
      return function(K) {
        return K.position = new I(P), Z(), K;
      };
    }
    function I(P) {
      this.start = P, this.end = { line: w, column: v }, this.source = j.source;
    }
    I.prototype.content = S;
    function O(P) {
      var K = new Error(
        j.source + ":" + w + ":" + v + ": " + P
      );
      if (K.reason = P, K.filename = j.source, K.line = w, K.column = v, K.source = S, !j.silent) throw K;
    }
    function U(P) {
      var K = P.exec(S);
      if (K) {
        var ne = K[0];
        return q(ne), S = S.slice(ne.length), K;
      }
    }
    function Z() {
      U(t);
    }
    function Q(P) {
      var K;
      for (P = P || []; K = ee(); )
        K !== !1 && P.push(K);
      return P;
    }
    function ee() {
      var P = T();
      if (!(m != S.charAt(0) || d != S.charAt(1))) {
        for (var K = 2; f != S.charAt(K) && (d != S.charAt(K) || m != S.charAt(K + 1)); )
          ++K;
        if (K += 2, f === S.charAt(K - 1))
          return O("End of comment missing");
        var ne = S.slice(2, K - 2);
        return v += 2, q(ne), S = S.slice(K), v += 2, P({
          type: h,
          comment: ne
        });
      }
    }
    function J() {
      var P = T(), K = U(i);
      if (K) {
        if (ee(), !U(a)) return O("property missing ':'");
        var ne = U(o), pe = P({
          type: y,
          property: x(K[0].replace(e, f)),
          value: ne ? x(ne[0].replace(e, f)) : f
        });
        return U(s), pe;
      }
    }
    function G() {
      var P = [];
      Q(P);
      for (var K; K = J(); )
        K !== !1 && (P.push(K), Q(P));
      return P;
    }
    return Z(), G();
  };
  function x(S) {
    return S ? S.replace(l, f) : f;
  }
  return kd;
}
var s_;
function X6() {
  if (s_) return la;
  s_ = 1;
  var e = la && la.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(la, "__esModule", { value: !0 }), la.default = t;
  var n = e(Q6());
  function t(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(u) {
      if (u.type === "declaration") {
        var m = u.property, d = u.value;
        l ? a(m, d, u) : d && (o = o || {}, o[m] = d);
      }
    }), o;
  }
  return la;
}
var Z6 = X6();
const l_ = /* @__PURE__ */ Xh(Z6), eH = l_.default || l_, r1 = i1("end"), Yv = i1("start");
function i1(e) {
  return n;
  function n(t) {
    const i = t && t.position && t.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function nH(e) {
  const n = Yv(e), t = r1(e);
  if (n && t)
    return { start: n, end: t };
}
function Bo(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? c_(e.position) : "start" in e || "end" in e ? c_(e) : "line" in e || "column" in e ? wh(e) : "";
}
function wh(e) {
  return u_(e && e.line) + ":" + u_(e && e.column);
}
function c_(e) {
  return wh(e && e.start) + "-" + wh(e && e.end);
}
function u_(e) {
  return e && typeof e == "number" ? e : 1;
}
class Pt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, t, i) {
    super(), typeof t == "string" && (i = t, t = void 0);
    let a = "", o = {}, s = !1;
    if (t && ("line" in t && "column" in t ? o = { place: t } : "start" in t && "end" in t ? o = { place: t } : "type" in t ? o = {
      ancestors: [t],
      place: t.position
    } : o = { ...t }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const u = i.indexOf(":");
      u === -1 ? o.ruleId = i : (o.source = i.slice(0, u), o.ruleId = i.slice(u + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const u = o.ancestors[o.ancestors.length - 1];
      u && (o.place = u.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = Bo(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Pt.prototype.file = "";
Pt.prototype.name = "";
Pt.prototype.reason = "";
Pt.prototype.message = "";
Pt.prototype.stack = "";
Pt.prototype.column = void 0;
Pt.prototype.line = void 0;
Pt.prototype.ancestors = void 0;
Pt.prototype.cause = void 0;
Pt.prototype.fatal = void 0;
Pt.prototype.place = void 0;
Pt.prototype.ruleId = void 0;
Pt.prototype.source = void 0;
const Jv = {}.hasOwnProperty, tH = /* @__PURE__ */ new Map(), rH = /[A-Z]/g, iH = /-([a-z])/g, aH = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), oH = /* @__PURE__ */ new Set(["td", "th"]), a1 = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function sH(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const t = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = hH(t, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = fH(t, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: t,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Gv : Y6,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = o1(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function o1(e, n, t) {
  if (n.type === "element")
    return lH(e, n, t);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return cH(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return dH(e, n, t);
  if (n.type === "mdxjsEsm")
    return uH(e, n);
  if (n.type === "root")
    return mH(e, n, t);
  if (n.type === "text")
    return pH(e, n);
}
function lH(e, n, t) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Gv, e.schema = a), e.ancestors.push(n);
  const o = l1(e, n.tagName, !1), s = vH(e, n);
  let l = Xv(e, n);
  return aH.has(n.tagName) && (l = l.filter(function(u) {
    return typeof u == "string" ? !L6(u) : !0;
  })), s1(e, s, o, n), Qv(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, t);
}
function cH(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  rs(e, n.position);
}
function uH(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  rs(e, n.position);
}
function dH(e, n, t) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Gv, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : l1(e, n.name, !0), s = yH(e, n), l = Xv(e, n);
  return s1(e, s, o, n), Qv(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, t);
}
function mH(e, n, t) {
  const i = {};
  return Qv(i, Xv(e, n)), e.create(n, e.Fragment, i, t);
}
function pH(e, n) {
  return n.value;
}
function s1(e, n, t, i) {
  typeof t != "string" && t !== e.Fragment && e.passNode && (n.node = i);
}
function Qv(e, n) {
  if (n.length > 0) {
    const t = n.length > 1 ? n : n[0];
    t && (e.children = t);
  }
}
function fH(e, n, t) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? t : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function hH(e, n) {
  return t;
  function t(i, a, o, s) {
    const l = Array.isArray(o.children), u = Yv(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function vH(e, n) {
  const t = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && Jv.call(n.properties, a)) {
      const o = gH(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && oH.has(n.tagName) ? i = l : t[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      t.style || (t.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return t;
}
function yH(e, n) {
  const t = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          t,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        rs(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          rs(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      t[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return t;
}
function Xv(e, n) {
  const t = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : tH;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const u = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (u) {
        const m = a.get(u) || 0;
        s = u + "-" + m, a.set(u, m + 1);
      }
    }
    const l = o1(e, o, s);
    l !== void 0 && t.push(l);
  }
  return t;
}
function gH(e, n, t) {
  const i = H6(e.schema, n);
  if (!(t == null || typeof t == "number" && Number.isNaN(t))) {
    if (Array.isArray(t) && (t = i.commaSeparated ? O6(t) : J6(t)), i.property === "style") {
      let a = typeof t == "object" ? t : kH(e, String(t));
      return e.stylePropertyNameCase === "css" && (a = bH(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? G6[i.property] || i.property : i.attribute,
      t
    ];
  }
}
function kH(e, n) {
  const t = {};
  try {
    eH(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Pt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = a1 + "#cannot-parse-style-attribute", s;
    }
  }
  return t;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(iH, xH)), t[s] = o;
  }
}
function l1(e, n, t) {
  let i;
  if (!t)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = t_(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = t_(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return Jv.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  rs(e);
}
function rs(e, n) {
  const t = new Pt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw t.file = e.filePath || void 0, t.url = a1 + "#cannot-handle-mdx-estrees-without-createevaluater", t;
}
function bH(e) {
  const n = {};
  let t;
  for (t in e)
    Jv.call(e, t) && (n[_H(t)] = e[t]);
  return n;
}
function _H(e) {
  let n = e.replace(rH, SH);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function xH(e, n) {
  return n.toUpperCase();
}
function SH(e) {
  return "-" + e.toLowerCase();
}
const bd = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, NH = {};
function jH(e, n) {
  const t = NH, i = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, a = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return c1(e, i, a);
}
function c1(e, n, t) {
  if (wH(e)) {
    if ("value" in e)
      return e.type === "html" && !t ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return d_(e.children, n, t);
  }
  return Array.isArray(e) ? d_(e, n, t) : "";
}
function d_(e, n, t) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = c1(e[a], n, t);
  return i.join("");
}
function wH(e) {
  return !!(e && typeof e == "object");
}
const m_ = document.createElement("i");
function Zv(e) {
  const n = "&" + e + ";";
  m_.innerHTML = n;
  const t = m_.textContent;
  return t.charCodeAt(t.length - 1) === 59 && e !== "semi" || t === n ? !1 : t;
}
function ei(e, n, t, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, t = t > 0 ? t : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, t), e.splice(...s);
  else
    for (t && e.splice(n, t); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function fr(e, n) {
  return e.length > 0 ? (ei(e, e.length, 0, n), e) : n;
}
const p_ = {}.hasOwnProperty;
function CH(e) {
  const n = {};
  let t = -1;
  for (; ++t < e.length; )
    FH(n, e[t]);
  return n;
}
function FH(e, n) {
  let t;
  for (t in n) {
    const a = (p_.call(e, t) ? e[t] : void 0) || (e[t] = {}), o = n[t];
    let s;
    if (o)
      for (s in o) {
        p_.call(a, s) || (a[s] = []);
        const l = o[s];
        IH(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function IH(e, n) {
  let t = -1;
  const i = [];
  for (; ++t < n.length; )
    (n[t].add === "after" ? e : i).push(n[t]);
  ei(e, 0, 0, i);
}
function u1(e, n) {
  const t = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
function Na(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Gr = Fi(/[A-Za-z]/), ur = Fi(/[\dA-Za-z]/), $H = Fi(/[#-'*+\--9=?A-Z^-~]/);
function Ch(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Fh = Fi(/\d/), EH = Fi(/[\dA-Fa-f]/), TH = Fi(/[!-/:-@[-`{-~]/);
function hn(e) {
  return e !== null && e < -2;
}
function nr(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const OH = Fi(new RegExp("\\p{P}|\\p{S}", "u")), RH = Fi(/\s/);
function Fi(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function Wa(e) {
  const n = [];
  let t = -1, i = 0, a = 0;
  for (; ++t < e.length; ) {
    const o = e.charCodeAt(t);
    let s = "";
    if (o === 37 && ur(e.charCodeAt(t + 1)) && ur(e.charCodeAt(t + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(t + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, t), encodeURIComponent(s)), i = t + a + 1, s = ""), a && (t += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function et(e, n, t, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(u) {
    return zn(u) ? (e.enter(t), l(u)) : n(u);
  }
  function l(u) {
    return zn(u) && o++ < a ? (e.consume(u), l) : (e.exit(t), n(u));
  }
}
const DH = {
  tokenize: PH
};
function PH(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let t;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = u), t = u, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return hn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const AH = {
  tokenize: LH
}, f_ = {
  tokenize: VH
};
function LH(e) {
  const n = this, t = [];
  let i = 0, a, o, s;
  return l;
  function l(q) {
    if (i < t.length) {
      const T = t[i];
      return n.containerState = T[1], e.attempt(T[0].continuation, u, m)(q);
    }
    return m(q);
  }
  function u(q) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && v();
      const T = n.events.length;
      let I = T, O;
      for (; I--; )
        if (n.events[I][0] === "exit" && n.events[I][1].type === "chunkFlow") {
          O = n.events[I][1].end;
          break;
        }
      w(i);
      let U = T;
      for (; U < n.events.length; )
        n.events[U][1].end = {
          ...O
        }, U++;
      return ei(n.events, I + 1, 0, n.events.slice(T)), n.events.length = U, m(q);
    }
    return l(q);
  }
  function m(q) {
    if (i === t.length) {
      if (!a)
        return h(q);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return x(q);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(f_, d, f)(q);
  }
  function d(q) {
    return a && v(), w(i), h(q);
  }
  function f(q) {
    return n.parser.lazy[n.now().line] = i !== t.length, s = n.now().offset, x(q);
  }
  function h(q) {
    return n.containerState = {}, e.attempt(f_, y, x)(q);
  }
  function y(q) {
    return i++, t.push([n.currentConstruct, n.containerState]), h(q);
  }
  function x(q) {
    if (q === null) {
      a && v(), w(0), e.consume(q);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), S(q);
  }
  function S(q) {
    if (q === null) {
      j(e.exit("chunkFlow"), !0), w(0), e.consume(q);
      return;
    }
    return hn(q) ? (e.consume(q), j(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(q), S);
  }
  function j(q, T) {
    const I = n.sliceStream(q);
    if (T && I.push(null), q.previous = o, o && (o.next = q), o = q, a.defineSkip(q.start), a.write(I), n.parser.lazy[q.start.line]) {
      let O = a.events.length;
      for (; O--; )
        if (
          // The token starts before the line ending…
          a.events[O][1].start.offset < s && // …and either is not ended yet…
          (!a.events[O][1].end || // …or ends after it.
          a.events[O][1].end.offset > s)
        )
          return;
      const U = n.events.length;
      let Z = U, Q, ee;
      for (; Z--; )
        if (n.events[Z][0] === "exit" && n.events[Z][1].type === "chunkFlow") {
          if (Q) {
            ee = n.events[Z][1].end;
            break;
          }
          Q = !0;
        }
      for (w(i), O = U; O < n.events.length; )
        n.events[O][1].end = {
          ...ee
        }, O++;
      ei(n.events, Z + 1, 0, n.events.slice(U)), n.events.length = O;
    }
  }
  function w(q) {
    let T = t.length;
    for (; T-- > q; ) {
      const I = t[T];
      n.containerState = I[1], I[0].exit.call(n, e);
    }
    t.length = q;
  }
  function v() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function VH(e, n, t) {
  return et(e, e.attempt(this.parser.constructs.document, n, t), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function h_(e) {
  if (e === null || nr(e) || RH(e))
    return 1;
  if (OH(e))
    return 2;
}
function ey(e, n, t) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, t), i.push(o));
  }
  return n;
}
const Ih = {
  name: "attention",
  resolveAll: zH,
  tokenize: MH
};
function zH(e, n) {
  let t = -1, i, a, o, s, l, u, m, d;
  for (; ++t < e.length; )
    if (e[t][0] === "enter" && e[t][1].type === "attentionSequence" && e[t][1]._close) {
      for (i = t; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[t][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[t][1]._open) && (e[t][1].end.offset - e[t][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[t][1].end.offset - e[t][1].start.offset) % 3))
            continue;
          u = e[i][1].end.offset - e[i][1].start.offset > 1 && e[t][1].end.offset - e[t][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[t][1].start
          };
          v_(f, -u), v_(h, u), s = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[t][1].start
            },
            end: h
          }, o = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[t][1].start
            }
          }, a = {
            type: u > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[t][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = fr(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = fr(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = fr(m, ey(n.parser.constructs.insideSpan.null, e.slice(i + 1, t), n)), m = fr(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[t][1].end.offset - e[t][1].start.offset ? (d = 2, m = fr(m, [["enter", e[t][1], n], ["exit", e[t][1], n]])) : d = 0, ei(e, i - 1, t - i + 3, m), t = i + m.length - d - 2;
          break;
        }
    }
  for (t = -1; ++t < e.length; )
    e[t][1].type === "attentionSequence" && (e[t][1].type = "data");
  return e;
}
function MH(e, n) {
  const t = this.parser.constructs.attentionMarkers.null, i = this.previous, a = h_(i);
  let o;
  return s;
  function s(u) {
    return o = u, e.enter("attentionSequence"), l(u);
  }
  function l(u) {
    if (u === o)
      return e.consume(u), l;
    const m = e.exit("attentionSequence"), d = h_(u), f = !d || d === 2 && a || t.includes(u), h = !a || a === 2 && d || t.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (d || !f)), n(u);
  }
}
function v_(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const UH = {
  name: "autolink",
  tokenize: BH
};
function BH(e, n, t) {
  let i = 0;
  return a;
  function a(y) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(y), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(y) {
    return Gr(y) ? (e.consume(y), s) : y === 64 ? t(y) : m(y);
  }
  function s(y) {
    return y === 43 || y === 45 || y === 46 || ur(y) ? (i = 1, l(y)) : m(y);
  }
  function l(y) {
    return y === 58 ? (e.consume(y), i = 0, u) : (y === 43 || y === 45 || y === 46 || ur(y)) && i++ < 32 ? (e.consume(y), l) : (i = 0, m(y));
  }
  function u(y) {
    return y === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(y), e.exit("autolinkMarker"), e.exit("autolink"), n) : y === null || y === 32 || y === 60 || Ch(y) ? t(y) : (e.consume(y), u);
  }
  function m(y) {
    return y === 64 ? (e.consume(y), d) : $H(y) ? (e.consume(y), m) : t(y);
  }
  function d(y) {
    return ur(y) ? f(y) : t(y);
  }
  function f(y) {
    return y === 46 ? (e.consume(y), i = 0, d) : y === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(y), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(y);
  }
  function h(y) {
    if ((y === 45 || ur(y)) && i++ < 63) {
      const x = y === 45 ? h : f;
      return e.consume(y), x;
    }
    return t(y);
  }
}
const Qc = {
  partial: !0,
  tokenize: qH
};
function qH(e, n, t) {
  return i;
  function i(o) {
    return zn(o) ? et(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || hn(o) ? n(o) : t(o);
  }
}
const d1 = {
  continuation: {
    tokenize: WH
  },
  exit: KH,
  name: "blockQuote",
  tokenize: HH
};
function HH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return t(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function WH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? et(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(d1, n, t)(s);
  }
}
function KH(e) {
  e.exit("blockQuote");
}
const m1 = {
  name: "characterEscape",
  tokenize: GH
};
function GH(e, n, t) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return TH(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : t(o);
  }
}
const p1 = {
  name: "characterReference",
  tokenize: YH
};
function YH(e, n, t) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), u;
  }
  function u(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = ur, d(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = EH, d) : (e.enter("characterReferenceValue"), o = 7, s = Fh, d(f));
  }
  function d(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === ur && !Zv(i.sliceSerialize(h)) ? t(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), d) : t(f);
  }
}
const y_ = {
  partial: !0,
  tokenize: QH
}, g_ = {
  concrete: !0,
  name: "codeFenced",
  tokenize: JH
};
function JH(e, n, t) {
  const i = this, a = {
    partial: !0,
    tokenize: I
  };
  let o = 0, s = 0, l;
  return u;
  function u(O) {
    return m(O);
  }
  function m(O) {
    const U = i.events[i.events.length - 1];
    return o = U && U[1].type === "linePrefix" ? U[2].sliceSerialize(U[1], !0).length : 0, l = O, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), d(O);
  }
  function d(O) {
    return O === l ? (s++, e.consume(O), d) : s < 3 ? t(O) : (e.exit("codeFencedFenceSequence"), zn(O) ? et(e, f, "whitespace")(O) : f(O));
  }
  function f(O) {
    return O === null || hn(O) ? (e.exit("codeFencedFence"), i.interrupt ? n(O) : e.check(y_, S, T)(O)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(O));
  }
  function h(O) {
    return O === null || hn(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(O)) : zn(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), et(e, y, "whitespace")(O)) : O === 96 && O === l ? t(O) : (e.consume(O), h);
  }
  function y(O) {
    return O === null || hn(O) ? f(O) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), x(O));
  }
  function x(O) {
    return O === null || hn(O) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(O)) : O === 96 && O === l ? t(O) : (e.consume(O), x);
  }
  function S(O) {
    return e.attempt(a, T, j)(O);
  }
  function j(O) {
    return e.enter("lineEnding"), e.consume(O), e.exit("lineEnding"), w;
  }
  function w(O) {
    return o > 0 && zn(O) ? et(e, v, "linePrefix", o + 1)(O) : v(O);
  }
  function v(O) {
    return O === null || hn(O) ? e.check(y_, S, T)(O) : (e.enter("codeFlowValue"), q(O));
  }
  function q(O) {
    return O === null || hn(O) ? (e.exit("codeFlowValue"), v(O)) : (e.consume(O), q);
  }
  function T(O) {
    return e.exit("codeFenced"), n(O);
  }
  function I(O, U, Z) {
    let Q = 0;
    return ee;
    function ee(ne) {
      return O.enter("lineEnding"), O.consume(ne), O.exit("lineEnding"), J;
    }
    function J(ne) {
      return O.enter("codeFencedFence"), zn(ne) ? et(O, G, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ne) : G(ne);
    }
    function G(ne) {
      return ne === l ? (O.enter("codeFencedFenceSequence"), P(ne)) : Z(ne);
    }
    function P(ne) {
      return ne === l ? (Q++, O.consume(ne), P) : Q >= s ? (O.exit("codeFencedFenceSequence"), zn(ne) ? et(O, K, "whitespace")(ne) : K(ne)) : Z(ne);
    }
    function K(ne) {
      return ne === null || hn(ne) ? (O.exit("codeFencedFence"), U(ne)) : Z(ne);
    }
  }
}
function QH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? t(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? t(s) : n(s);
  }
}
const _d = {
  name: "codeIndented",
  tokenize: ZH
}, XH = {
  partial: !0,
  tokenize: eW
};
function ZH(e, n, t) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), et(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const d = i.events[i.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? s(m) : t(m);
  }
  function s(m) {
    return m === null ? u(m) : hn(m) ? e.attempt(XH, s, u)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || hn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function u(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function eW(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? t(s) : hn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : et(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : hn(s) ? a(s) : t(s);
  }
}
const nW = {
  name: "codeText",
  previous: rW,
  resolve: tW,
  tokenize: iW
};
function tW(e) {
  let n = e.length - 4, t = 3, i, a;
  if ((e[t][1].type === "lineEnding" || e[t][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = t; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[t][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", t += 2, n -= 2;
        break;
      }
  }
  for (i = t - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function rW(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function iW(e, n, t) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), u(f));
  }
  function u(f) {
    return f === null ? t(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), u) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, d(f)) : hn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), u) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || hn(f) ? (e.exit("codeTextData"), u(f)) : (e.consume(f), m);
  }
  function d(f) {
    return f === 96 ? (e.consume(f), a++, d) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class aW {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, t) {
    const i = t ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, t, i) {
    const a = t || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && mo(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), mo(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), mo(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const t = this.left.splice(n, Number.POSITIVE_INFINITY);
        mo(this.right, t.reverse());
      } else {
        const t = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        mo(this.left, t.reverse());
      }
  }
}
function mo(e, n) {
  let t = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; t < n.length; )
      e.push(...n.slice(t, t + 1e4)), t += 1e4;
}
function f1(e) {
  const n = {};
  let t = -1, i, a, o, s, l, u, m;
  const d = new aW(e);
  for (; ++t < d.length; ) {
    for (; t in n; )
      t = n[t];
    if (i = d.get(t), t && i[1].type === "chunkFlow" && d.get(t - 1)[1].type === "listItemPrefix" && (u = i[1]._tokenizer.events, o = 0, o < u.length && u[o][1].type === "lineEndingBlank" && (o += 2), o < u.length && u[o][1].type === "content"))
      for (; ++o < u.length && u[o][1].type !== "content"; )
        u[o][1].type === "chunkText" && (u[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, oW(d, t)), t = n[t], m = !0);
    else if (i[1]._container) {
      for (o = t, a = void 0; o-- && (s = d.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (d.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...d.get(a)[1].start
      }, l = d.slice(a, t), l.unshift(i), d.splice(a, t - a + 1, l));
    }
  }
  return ei(e, 0, Number.POSITIVE_INFINITY, d.slice(0)), !m;
}
function oW(e, n) {
  const t = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = t._tokenizer || i.parser[t.contentType](t.start), l = s.events, u = [], m = {};
  let d, f, h = -1, y = t, x = 0, S = 0;
  const j = [S];
  for (; y; ) {
    for (; e.get(++a)[1] !== y; )
      ;
    o.push(a), y._tokenizer || (d = i.sliceStream(y), y.next || d.push(null), f && s.defineSkip(y.start), y._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(d), y._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = y, y = y.next;
  }
  for (y = t; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (S = h + 1, j.push(S), y._tokenizer = void 0, y.previous = void 0, y = y.next);
  for (s.events = [], y ? (y._tokenizer = void 0, y.previous = void 0) : j.pop(), h = j.length; h--; ) {
    const w = l.slice(j[h], j[h + 1]), v = o.pop();
    u.push([v, v + w.length - 1]), e.splice(v, 2, w);
  }
  for (u.reverse(), h = -1; ++h < u.length; )
    m[x + u[h][0]] = x + u[h][1], x += u[h][1] - u[h][0] - 1;
  return m;
}
const sW = {
  resolve: cW,
  tokenize: uW
}, lW = {
  partial: !0,
  tokenize: dW
};
function cW(e) {
  return f1(e), e;
}
function uW(e, n) {
  let t;
  return i;
  function i(l) {
    return e.enter("content"), t = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : hn(l) ? e.check(lW, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), t.next = e.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, a;
  }
}
function dW(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), et(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || hn(s))
      return t(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, t, n)(s);
  }
}
function h1(e, n, t, i, a, o, s, l, u) {
  const m = u || Number.POSITIVE_INFINITY;
  let d = 0;
  return f;
  function f(w) {
    return w === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(w), e.exit(o), h) : w === null || w === 32 || w === 41 || Ch(w) ? t(w) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), S(w));
  }
  function h(w) {
    return w === 62 ? (e.enter(o), e.consume(w), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), y(w));
  }
  function y(w) {
    return w === 62 ? (e.exit("chunkString"), e.exit(l), h(w)) : w === null || w === 60 || hn(w) ? t(w) : (e.consume(w), w === 92 ? x : y);
  }
  function x(w) {
    return w === 60 || w === 62 || w === 92 ? (e.consume(w), y) : y(w);
  }
  function S(w) {
    return !d && (w === null || w === 41 || nr(w)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(w)) : d < m && w === 40 ? (e.consume(w), d++, S) : w === 41 ? (e.consume(w), d--, S) : w === null || w === 32 || w === 40 || Ch(w) ? t(w) : (e.consume(w), w === 92 ? j : S);
  }
  function j(w) {
    return w === 40 || w === 41 || w === 92 ? (e.consume(w), S) : S(w);
  }
}
function v1(e, n, t, i, a, o) {
  const s = this;
  let l = 0, u;
  return m;
  function m(y) {
    return e.enter(i), e.enter(a), e.consume(y), e.exit(a), e.enter(o), d;
  }
  function d(y) {
    return l > 999 || y === null || y === 91 || y === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    y === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? t(y) : y === 93 ? (e.exit(o), e.enter(a), e.consume(y), e.exit(a), e.exit(i), n) : hn(y) ? (e.enter("lineEnding"), e.consume(y), e.exit("lineEnding"), d) : (e.enter("chunkString", {
      contentType: "string"
    }), f(y));
  }
  function f(y) {
    return y === null || y === 91 || y === 93 || hn(y) || l++ > 999 ? (e.exit("chunkString"), d(y)) : (e.consume(y), u || (u = !zn(y)), y === 92 ? h : f);
  }
  function h(y) {
    return y === 91 || y === 92 || y === 93 ? (e.consume(y), l++, f) : f(y);
  }
}
function y1(e, n, t, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, u) : t(h);
  }
  function u(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), u(s)) : h === null ? t(h) : hn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), et(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === s || h === null || hn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : d);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), d) : d(h);
  }
}
function qo(e, n) {
  let t;
  return i;
  function i(a) {
    return hn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t = !0, i) : zn(a) ? et(e, i, t ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const mW = {
  name: "definition",
  tokenize: fW
}, pW = {
  partial: !0,
  tokenize: hW
};
function fW(e, n, t) {
  const i = this;
  let a;
  return o;
  function o(y) {
    return e.enter("definition"), s(y);
  }
  function s(y) {
    return v1.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(y);
  }
  function l(y) {
    return a = Na(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), y === 58 ? (e.enter("definitionMarker"), e.consume(y), e.exit("definitionMarker"), u) : t(y);
  }
  function u(y) {
    return nr(y) ? qo(e, m)(y) : m(y);
  }
  function m(y) {
    return h1(
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(y);
  }
  function d(y) {
    return e.attempt(pW, f, f)(y);
  }
  function f(y) {
    return zn(y) ? et(e, h, "whitespace")(y) : h(y);
  }
  function h(y) {
    return y === null || hn(y) ? (e.exit("definition"), i.parser.defined.push(a), n(y)) : t(y);
  }
}
function hW(e, n, t) {
  return i;
  function i(l) {
    return nr(l) ? qo(e, a)(l) : t(l);
  }
  function a(l) {
    return y1(e, o, t, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? et(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || hn(l) ? n(l) : t(l);
  }
}
const vW = {
  name: "hardBreakEscape",
  tokenize: yW
};
function yW(e, n, t) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return hn(o) ? (e.exit("hardBreakEscape"), n(o)) : t(o);
  }
}
const gW = {
  name: "headingAtx",
  resolve: kW,
  tokenize: bW
};
function kW(e, n) {
  let t = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), t - 2 > i && e[t][1].type === "whitespace" && (t -= 2), e[t][1].type === "atxHeadingSequence" && (i === t - 1 || t - 4 > i && e[t - 2][1].type === "whitespace") && (t -= i + 1 === t ? 2 : 4), t > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[t][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[t][1].end,
    contentType: "text"
  }, ei(e, i, t - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function bW(e, n, t) {
  let i = 0;
  return a;
  function a(d) {
    return e.enter("atxHeading"), o(d);
  }
  function o(d) {
    return e.enter("atxHeadingSequence"), s(d);
  }
  function s(d) {
    return d === 35 && i++ < 6 ? (e.consume(d), s) : d === null || nr(d) ? (e.exit("atxHeadingSequence"), l(d)) : t(d);
  }
  function l(d) {
    return d === 35 ? (e.enter("atxHeadingSequence"), u(d)) : d === null || hn(d) ? (e.exit("atxHeading"), n(d)) : zn(d) ? et(e, l, "whitespace")(d) : (e.enter("atxHeadingText"), m(d));
  }
  function u(d) {
    return d === 35 ? (e.consume(d), u) : (e.exit("atxHeadingSequence"), l(d));
  }
  function m(d) {
    return d === null || d === 35 || nr(d) ? (e.exit("atxHeadingText"), l(d)) : (e.consume(d), m);
  }
}
const _W = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], k_ = ["pre", "script", "style", "textarea"], xW = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: jW,
  tokenize: wW
}, SW = {
  partial: !0,
  tokenize: FW
}, NW = {
  partial: !0,
  tokenize: CW
};
function jW(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function wW(e, n, t) {
  const i = this;
  let a, o, s, l, u;
  return m;
  function m(W) {
    return d(W);
  }
  function d(W) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(W), f;
  }
  function f(W) {
    return W === 33 ? (e.consume(W), h) : W === 47 ? (e.consume(W), o = !0, S) : W === 63 ? (e.consume(W), a = 3, i.interrupt ? n : H) : Gr(W) ? (e.consume(W), s = String.fromCharCode(W), j) : t(W);
  }
  function h(W) {
    return W === 45 ? (e.consume(W), a = 2, y) : W === 91 ? (e.consume(W), a = 5, l = 0, x) : Gr(W) ? (e.consume(W), a = 4, i.interrupt ? n : H) : t(W);
  }
  function y(W) {
    return W === 45 ? (e.consume(W), i.interrupt ? n : H) : t(W);
  }
  function x(W) {
    const Be = "CDATA[";
    return W === Be.charCodeAt(l++) ? (e.consume(W), l === Be.length ? i.interrupt ? n : G : x) : t(W);
  }
  function S(W) {
    return Gr(W) ? (e.consume(W), s = String.fromCharCode(W), j) : t(W);
  }
  function j(W) {
    if (W === null || W === 47 || W === 62 || nr(W)) {
      const Be = W === 47, Me = s.toLowerCase();
      return !Be && !o && k_.includes(Me) ? (a = 1, i.interrupt ? n(W) : G(W)) : _W.includes(s.toLowerCase()) ? (a = 6, Be ? (e.consume(W), w) : i.interrupt ? n(W) : G(W)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? t(W) : o ? v(W) : q(W));
    }
    return W === 45 || ur(W) ? (e.consume(W), s += String.fromCharCode(W), j) : t(W);
  }
  function w(W) {
    return W === 62 ? (e.consume(W), i.interrupt ? n : G) : t(W);
  }
  function v(W) {
    return zn(W) ? (e.consume(W), v) : ee(W);
  }
  function q(W) {
    return W === 47 ? (e.consume(W), ee) : W === 58 || W === 95 || Gr(W) ? (e.consume(W), T) : zn(W) ? (e.consume(W), q) : ee(W);
  }
  function T(W) {
    return W === 45 || W === 46 || W === 58 || W === 95 || ur(W) ? (e.consume(W), T) : I(W);
  }
  function I(W) {
    return W === 61 ? (e.consume(W), O) : zn(W) ? (e.consume(W), I) : q(W);
  }
  function O(W) {
    return W === null || W === 60 || W === 61 || W === 62 || W === 96 ? t(W) : W === 34 || W === 39 ? (e.consume(W), u = W, U) : zn(W) ? (e.consume(W), O) : Z(W);
  }
  function U(W) {
    return W === u ? (e.consume(W), u = null, Q) : W === null || hn(W) ? t(W) : (e.consume(W), U);
  }
  function Z(W) {
    return W === null || W === 34 || W === 39 || W === 47 || W === 60 || W === 61 || W === 62 || W === 96 || nr(W) ? I(W) : (e.consume(W), Z);
  }
  function Q(W) {
    return W === 47 || W === 62 || zn(W) ? q(W) : t(W);
  }
  function ee(W) {
    return W === 62 ? (e.consume(W), J) : t(W);
  }
  function J(W) {
    return W === null || hn(W) ? G(W) : zn(W) ? (e.consume(W), J) : t(W);
  }
  function G(W) {
    return W === 45 && a === 2 ? (e.consume(W), pe) : W === 60 && a === 1 ? (e.consume(W), ye) : W === 62 && a === 4 ? (e.consume(W), ke) : W === 63 && a === 3 ? (e.consume(W), H) : W === 93 && a === 5 ? (e.consume(W), ve) : hn(W) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(SW, Ce, P)(W)) : W === null || hn(W) ? (e.exit("htmlFlowData"), P(W)) : (e.consume(W), G);
  }
  function P(W) {
    return e.check(NW, K, Ce)(W);
  }
  function K(W) {
    return e.enter("lineEnding"), e.consume(W), e.exit("lineEnding"), ne;
  }
  function ne(W) {
    return W === null || hn(W) ? P(W) : (e.enter("htmlFlowData"), G(W));
  }
  function pe(W) {
    return W === 45 ? (e.consume(W), H) : G(W);
  }
  function ye(W) {
    return W === 47 ? (e.consume(W), s = "", ue) : G(W);
  }
  function ue(W) {
    if (W === 62) {
      const Be = s.toLowerCase();
      return k_.includes(Be) ? (e.consume(W), ke) : G(W);
    }
    return Gr(W) && s.length < 8 ? (e.consume(W), s += String.fromCharCode(W), ue) : G(W);
  }
  function ve(W) {
    return W === 93 ? (e.consume(W), H) : G(W);
  }
  function H(W) {
    return W === 62 ? (e.consume(W), ke) : W === 45 && a === 2 ? (e.consume(W), H) : G(W);
  }
  function ke(W) {
    return W === null || hn(W) ? (e.exit("htmlFlowData"), Ce(W)) : (e.consume(W), ke);
  }
  function Ce(W) {
    return e.exit("htmlFlow"), n(W);
  }
}
function CW(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return hn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : t(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? t(s) : n(s);
  }
}
function FW(e, n, t) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(Qc, n, t);
  }
}
const IW = {
  name: "htmlText",
  tokenize: $W
};
function $W(e, n, t) {
  const i = this;
  let a, o, s;
  return l;
  function l(H) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(H), u;
  }
  function u(H) {
    return H === 33 ? (e.consume(H), m) : H === 47 ? (e.consume(H), I) : H === 63 ? (e.consume(H), q) : Gr(H) ? (e.consume(H), Z) : t(H);
  }
  function m(H) {
    return H === 45 ? (e.consume(H), d) : H === 91 ? (e.consume(H), o = 0, x) : Gr(H) ? (e.consume(H), v) : t(H);
  }
  function d(H) {
    return H === 45 ? (e.consume(H), y) : t(H);
  }
  function f(H) {
    return H === null ? t(H) : H === 45 ? (e.consume(H), h) : hn(H) ? (s = f, ye(H)) : (e.consume(H), f);
  }
  function h(H) {
    return H === 45 ? (e.consume(H), y) : f(H);
  }
  function y(H) {
    return H === 62 ? pe(H) : H === 45 ? h(H) : f(H);
  }
  function x(H) {
    const ke = "CDATA[";
    return H === ke.charCodeAt(o++) ? (e.consume(H), o === ke.length ? S : x) : t(H);
  }
  function S(H) {
    return H === null ? t(H) : H === 93 ? (e.consume(H), j) : hn(H) ? (s = S, ye(H)) : (e.consume(H), S);
  }
  function j(H) {
    return H === 93 ? (e.consume(H), w) : S(H);
  }
  function w(H) {
    return H === 62 ? pe(H) : H === 93 ? (e.consume(H), w) : S(H);
  }
  function v(H) {
    return H === null || H === 62 ? pe(H) : hn(H) ? (s = v, ye(H)) : (e.consume(H), v);
  }
  function q(H) {
    return H === null ? t(H) : H === 63 ? (e.consume(H), T) : hn(H) ? (s = q, ye(H)) : (e.consume(H), q);
  }
  function T(H) {
    return H === 62 ? pe(H) : q(H);
  }
  function I(H) {
    return Gr(H) ? (e.consume(H), O) : t(H);
  }
  function O(H) {
    return H === 45 || ur(H) ? (e.consume(H), O) : U(H);
  }
  function U(H) {
    return hn(H) ? (s = U, ye(H)) : zn(H) ? (e.consume(H), U) : pe(H);
  }
  function Z(H) {
    return H === 45 || ur(H) ? (e.consume(H), Z) : H === 47 || H === 62 || nr(H) ? Q(H) : t(H);
  }
  function Q(H) {
    return H === 47 ? (e.consume(H), pe) : H === 58 || H === 95 || Gr(H) ? (e.consume(H), ee) : hn(H) ? (s = Q, ye(H)) : zn(H) ? (e.consume(H), Q) : pe(H);
  }
  function ee(H) {
    return H === 45 || H === 46 || H === 58 || H === 95 || ur(H) ? (e.consume(H), ee) : J(H);
  }
  function J(H) {
    return H === 61 ? (e.consume(H), G) : hn(H) ? (s = J, ye(H)) : zn(H) ? (e.consume(H), J) : Q(H);
  }
  function G(H) {
    return H === null || H === 60 || H === 61 || H === 62 || H === 96 ? t(H) : H === 34 || H === 39 ? (e.consume(H), a = H, P) : hn(H) ? (s = G, ye(H)) : zn(H) ? (e.consume(H), G) : (e.consume(H), K);
  }
  function P(H) {
    return H === a ? (e.consume(H), a = void 0, ne) : H === null ? t(H) : hn(H) ? (s = P, ye(H)) : (e.consume(H), P);
  }
  function K(H) {
    return H === null || H === 34 || H === 39 || H === 60 || H === 61 || H === 96 ? t(H) : H === 47 || H === 62 || nr(H) ? Q(H) : (e.consume(H), K);
  }
  function ne(H) {
    return H === 47 || H === 62 || nr(H) ? Q(H) : t(H);
  }
  function pe(H) {
    return H === 62 ? (e.consume(H), e.exit("htmlTextData"), e.exit("htmlText"), n) : t(H);
  }
  function ye(H) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(H), e.exit("lineEnding"), ue;
  }
  function ue(H) {
    return zn(H) ? et(e, ve, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(H) : ve(H);
  }
  function ve(H) {
    return e.enter("htmlTextData"), s(H);
  }
}
const ny = {
  name: "labelEnd",
  resolveAll: RW,
  resolveTo: DW,
  tokenize: PW
}, EW = {
  tokenize: AW
}, TW = {
  tokenize: LW
}, OW = {
  tokenize: VW
};
function RW(e) {
  let n = -1;
  const t = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (t.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== t.length && ei(e, 0, e.length, t), e;
}
function DW(e, n) {
  let t = e.length, i = 0, a, o, s, l;
  for (; t--; )
    if (a = e[t][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[t][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[t][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = t, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = t);
  const u = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, d = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", u, n], ["enter", m, n]], l = fr(l, e.slice(o + 1, o + i + 3)), l = fr(l, [["enter", d, n]]), l = fr(l, ey(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = fr(l, [["exit", d, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = fr(l, e.slice(s + 1)), l = fr(l, [["exit", u, n]]), ei(e, o, e.length, l), e;
}
function PW(e, n, t) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(Na(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), u) : t(h);
  }
  function u(h) {
    return h === 40 ? e.attempt(EW, d, s ? d : f)(h) : h === 91 ? e.attempt(TW, d, s ? m : f)(h) : s ? d(h) : f(h);
  }
  function m(h) {
    return e.attempt(OW, d, f)(h);
  }
  function d(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, t(h);
  }
}
function AW(e, n, t) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return nr(f) ? qo(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? d(f) : h1(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return nr(f) ? qo(e, u)(f) : d(f);
  }
  function l(f) {
    return t(f);
  }
  function u(f) {
    return f === 34 || f === 39 || f === 40 ? y1(e, m, t, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : d(f);
  }
  function m(f) {
    return nr(f) ? qo(e, d)(f) : d(f);
  }
  function d(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : t(f);
  }
}
function LW(e, n, t) {
  const i = this;
  return a;
  function a(l) {
    return v1.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(Na(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : t(l);
  }
  function s(l) {
    return t(l);
  }
}
function VW(e, n, t) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : t(o);
  }
}
const zW = {
  name: "labelStartImage",
  resolveAll: ny.resolveAll,
  tokenize: MW
};
function MW(e, n, t) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : t(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? t(l) : n(l);
  }
}
const UW = {
  name: "labelStartLink",
  resolveAll: ny.resolveAll,
  tokenize: BW
};
function BW(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? t(s) : n(s);
  }
}
const xd = {
  name: "lineEnding",
  tokenize: qW
};
function qW(e, n) {
  return t;
  function t(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
}
const Pl = {
  name: "thematicBreak",
  tokenize: HW
};
function HW(e, n, t) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), u(m)) : i >= 3 && (m === null || hn(m)) ? (e.exit("thematicBreak"), n(m)) : t(m);
  }
  function u(m) {
    return m === a ? (e.consume(m), i++, u) : (e.exit("thematicBreakSequence"), zn(m) ? et(e, l, "whitespace")(m) : l(m));
  }
}
const Jt = {
  continuation: {
    tokenize: YW
  },
  exit: QW,
  name: "list",
  tokenize: GW
}, WW = {
  partial: !0,
  tokenize: XW
}, KW = {
  partial: !0,
  tokenize: JW
};
function GW(e, n, t) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(y) {
    const x = i.containerState.type || (y === 42 || y === 43 || y === 45 ? "listUnordered" : "listOrdered");
    if (x === "listUnordered" ? !i.containerState.marker || y === i.containerState.marker : Fh(y)) {
      if (i.containerState.type || (i.containerState.type = x, e.enter(x, {
        _container: !0
      })), x === "listUnordered")
        return e.enter("listItemPrefix"), y === 42 || y === 45 ? e.check(Pl, t, m)(y) : m(y);
      if (!i.interrupt || y === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(y);
    }
    return t(y);
  }
  function u(y) {
    return Fh(y) && ++s < 10 ? (e.consume(y), u) : (!i.interrupt || s < 2) && (i.containerState.marker ? y === i.containerState.marker : y === 41 || y === 46) ? (e.exit("listItemValue"), m(y)) : t(y);
  }
  function m(y) {
    return e.enter("listItemMarker"), e.consume(y), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || y, e.check(
      Qc,
      // Can’t be empty when interrupting.
      i.interrupt ? t : d,
      e.attempt(WW, h, f)
    );
  }
  function d(y) {
    return i.containerState.initialBlankLine = !0, o++, h(y);
  }
  function f(y) {
    return zn(y) ? (e.enter("listItemPrefixWhitespace"), e.consume(y), e.exit("listItemPrefixWhitespace"), h) : t(y);
  }
  function h(y) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(y);
  }
}
function YW(e, n, t) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Qc, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, et(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(KW, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, et(e, e.attempt(Jt, n, t), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function JW(e, n, t) {
  const i = this;
  return et(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : t(o);
  }
}
function QW(e) {
  e.exit(this.containerState.type);
}
function XW(e, n, t) {
  const i = this;
  return et(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : t(o);
  }
}
const b_ = {
  name: "setextUnderline",
  resolveTo: ZW,
  tokenize: eK
};
function ZW(e, n) {
  let t = e.length, i, a, o;
  for (; t--; )
    if (e[t][0] === "enter") {
      if (e[t][1].type === "content") {
        i = t;
        break;
      }
      e[t][1].type === "paragraph" && (a = t);
    } else
      e[t][1].type === "content" && e.splice(t, 1), !o && e[t][1].type === "definition" && (o = t);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function eK(e, n, t) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let d = i.events.length, f;
    for (; d--; )
      if (i.events[d][1].type !== "lineEnding" && i.events[d][1].type !== "linePrefix" && i.events[d][1].type !== "content") {
        f = i.events[d][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : t(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? et(e, u, "lineSuffix")(m) : u(m));
  }
  function u(m) {
    return m === null || hn(m) ? (e.exit("setextHeadingLine"), n(m)) : t(m);
  }
}
const nK = {
  tokenize: tK
};
function tK(e) {
  const n = this, t = e.attempt(
    // Try to parse a blank line.
    Qc,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, et(e, e.attempt(this.parser.constructs.flow, a, e.attempt(sW, a)), "linePrefix"))
  );
  return t;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, t;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, t;
  }
}
const rK = {
  resolveAll: k1()
}, iK = g1("string"), aK = g1("text");
function g1(e) {
  return {
    resolveAll: k1(e === "text" ? oK : void 0),
    tokenize: n
  };
  function n(t) {
    const i = this, a = this.parser.constructs[e], o = t.attempt(a, s, l);
    return s;
    function s(d) {
      return m(d) ? o(d) : l(d);
    }
    function l(d) {
      if (d === null) {
        t.consume(d);
        return;
      }
      return t.enter("data"), t.consume(d), u;
    }
    function u(d) {
      return m(d) ? (t.exit("data"), o(d)) : (t.consume(d), u);
    }
    function m(d) {
      if (d === null)
        return !0;
      const f = a[d];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const y = f[h];
          if (!y.previous || y.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function k1(e) {
  return n;
  function n(t, i) {
    let a = -1, o;
    for (; ++a <= t.length; )
      o === void 0 ? t[a] && t[a][1].type === "data" && (o = a, a++) : (!t[a] || t[a][1].type !== "data") && (a !== o + 2 && (t[o][1].end = t[a - 1][1].end, t.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(t, i) : t;
  }
}
function oK(e, n) {
  let t = 0;
  for (; ++t <= e.length; )
    if ((t === e.length || e[t][1].type === "lineEnding") && e[t - 1][1].type === "data") {
      const i = e[t - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, u;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          u = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: t === e.length || u || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(t, 0, ["enter", m, n], ["exit", m, n]), t += 2);
      }
      t++;
    }
  return e;
}
const sK = {
  42: Jt,
  43: Jt,
  45: Jt,
  48: Jt,
  49: Jt,
  50: Jt,
  51: Jt,
  52: Jt,
  53: Jt,
  54: Jt,
  55: Jt,
  56: Jt,
  57: Jt,
  62: d1
}, lK = {
  91: mW
}, cK = {
  [-2]: _d,
  [-1]: _d,
  32: _d
}, uK = {
  35: gW,
  42: Pl,
  45: [b_, Pl],
  60: xW,
  61: b_,
  95: Pl,
  96: g_,
  126: g_
}, dK = {
  38: p1,
  92: m1
}, mK = {
  [-5]: xd,
  [-4]: xd,
  [-3]: xd,
  33: zW,
  38: p1,
  42: Ih,
  60: [UH, IW],
  91: UW,
  92: [vW, m1],
  93: ny,
  95: Ih,
  96: nW
}, pK = {
  null: [Ih, rK]
}, fK = {
  null: [42, 95]
}, hK = {
  null: []
}, vK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: fK,
  contentInitial: lK,
  disable: hK,
  document: sK,
  flow: uK,
  flowInitial: cK,
  insideSpan: pK,
  string: dK,
  text: mK
}, Symbol.toStringTag, { value: "Module" }));
function yK(e, n, t) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: t && t.line || 1,
    column: t && t.column || 1,
    offset: t && t.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const u = {
    attempt: U(I),
    check: U(O),
    consume: v,
    enter: q,
    exit: T,
    interrupt: U(O, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: S,
    events: [],
    now: x,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: y,
    write: f
  };
  let d = n.tokenize.call(m, u);
  return n.resolveAll && o.push(n), m;
  function f(J) {
    return s = fr(s, J), j(), s[s.length - 1] !== null ? [] : (Z(n, 0), m.events = ey(o, m.events, m), m.events);
  }
  function h(J, G) {
    return kK(y(J), G);
  }
  function y(J) {
    return gK(s, J);
  }
  function x() {
    const {
      _bufferIndex: J,
      _index: G,
      line: P,
      column: K,
      offset: ne
    } = i;
    return {
      _bufferIndex: J,
      _index: G,
      line: P,
      column: K,
      offset: ne
    };
  }
  function S(J) {
    a[J.line] = J.column, ee();
  }
  function j() {
    let J;
    for (; i._index < s.length; ) {
      const G = s[i._index];
      if (typeof G == "string")
        for (J = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === J && i._bufferIndex < G.length; )
          w(G.charCodeAt(i._bufferIndex));
      else
        w(G);
    }
  }
  function w(J) {
    d = d(J);
  }
  function v(J) {
    hn(J) ? (i.line++, i.column = 1, i.offset += J === -3 ? 2 : 1, ee()) : J !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = J;
  }
  function q(J, G) {
    const P = G || {};
    return P.type = J, P.start = x(), m.events.push(["enter", P, m]), l.push(P), P;
  }
  function T(J) {
    const G = l.pop();
    return G.end = x(), m.events.push(["exit", G, m]), G;
  }
  function I(J, G) {
    Z(J, G.from);
  }
  function O(J, G) {
    G.restore();
  }
  function U(J, G) {
    return P;
    function P(K, ne, pe) {
      let ye, ue, ve, H;
      return Array.isArray(K) ? (
        /* c8 ignore next 1 */
        Ce(K)
      ) : "tokenize" in K ? (
        // Looks like a construct.
        Ce([
          /** @type {Construct} */
          K
        ])
      ) : ke(K);
      function ke(Pe) {
        return Ue;
        function Ue(Ie) {
          const Le = Ie !== null && Pe[Ie], Oe = Ie !== null && Pe.null, an = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Le) ? Le : Le ? [Le] : [],
            ...Array.isArray(Oe) ? Oe : Oe ? [Oe] : []
          ];
          return Ce(an)(Ie);
        }
      }
      function Ce(Pe) {
        return ye = Pe, ue = 0, Pe.length === 0 ? pe : W(Pe[ue]);
      }
      function W(Pe) {
        return Ue;
        function Ue(Ie) {
          return H = Q(), ve = Pe, Pe.partial || (m.currentConstruct = Pe), Pe.name && m.parser.constructs.disable.null.includes(Pe.name) ? Me() : Pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            G ? Object.assign(Object.create(m), G) : m,
            u,
            Be,
            Me
          )(Ie);
        }
      }
      function Be(Pe) {
        return J(ve, H), ne;
      }
      function Me(Pe) {
        return H.restore(), ++ue < ye.length ? W(ye[ue]) : pe;
      }
    }
  }
  function Z(J, G) {
    J.resolveAll && !o.includes(J) && o.push(J), J.resolve && ei(m.events, G, m.events.length - G, J.resolve(m.events.slice(G), m)), J.resolveTo && (m.events = J.resolveTo(m.events, m));
  }
  function Q() {
    const J = x(), G = m.previous, P = m.currentConstruct, K = m.events.length, ne = Array.from(l);
    return {
      from: K,
      restore: pe
    };
    function pe() {
      i = J, m.previous = G, m.currentConstruct = P, m.events.length = K, l = ne, ee();
    }
  }
  function ee() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function gK(e, n) {
  const t = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (t === a)
    s = [e[t].slice(i, o)];
  else {
    if (s = e.slice(t, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function kK(e, n) {
  let t = -1;
  const i = [];
  let a;
  for (; ++t < e.length; ) {
    const o = e[t];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function bK(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      CH([vK, ...(e || {}).extensions || []])
    ),
    content: a(DH),
    defined: [],
    document: a(AH),
    flow: a(nK),
    lazy: {},
    string: a(iK),
    text: a(aK)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return yK(i, o, l);
    }
  }
}
function _K(e) {
  for (; !f1(e); )
    ;
  return e;
}
const __ = /[\0\t\n\r]/g;
function xK() {
  let e = 1, n = "", t = !0, i;
  return a;
  function a(o, s, l) {
    const u = [];
    let m, d, f, h, y;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", t && (o.charCodeAt(0) === 65279 && f++, t = void 0); f < o.length; ) {
      if (__.lastIndex = f, m = __.exec(o), h = m && m.index !== void 0 ? m.index : o.length, y = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (y === 10 && f === h && i)
        u.push(-3), i = void 0;
      else
        switch (i && (u.push(-5), i = void 0), f < h && (u.push(o.slice(f, h)), e += h - f), y) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (d = Math.ceil(e / 4) * 4, u.push(-2); e++ < d; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && u.push(-5), n && u.push(n), u.push(null)), u;
  }
}
const SK = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function NK(e) {
  return e.replace(SK, jK);
}
function jK(e, n, t) {
  if (n)
    return n;
  if (t.charCodeAt(0) === 35) {
    const a = t.charCodeAt(1), o = a === 120 || a === 88;
    return u1(t.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Zv(t) || e;
}
const b1 = {}.hasOwnProperty;
function wK(e, n, t) {
  return typeof n != "string" && (t = n, n = void 0), CK(t)(_K(bK(t).document().write(xK()(e, n, !0))));
}
function CK(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Re),
      autolinkProtocol: Q,
      autolinkEmail: Q,
      atxHeading: o(se),
      blockQuote: o(Oe),
      characterEscape: Q,
      characterReference: Q,
      codeFenced: o(an),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(an, s),
      codeText: o(Ne, s),
      codeTextData: Q,
      data: Q,
      codeFlowValue: Q,
      definition: o(We),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Ke),
      hardBreakEscape: o(de),
      hardBreakTrailing: o(de),
      htmlFlow: o(je, s),
      htmlFlowData: Q,
      htmlText: o(je, s),
      htmlTextData: Q,
      image: o(Ae),
      label: s,
      link: o(Re),
      listItem: o(F),
      listItemValue: h,
      listOrdered: o(nn, f),
      listUnordered: o(nn),
      paragraph: o(_),
      reference: W,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(se),
      strong: o(E),
      thematicBreak: o(X)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: I,
      autolink: u(),
      autolinkEmail: Le,
      autolinkProtocol: Ie,
      blockQuote: u(),
      characterEscapeValue: ee,
      characterReferenceMarkerHexadecimal: Me,
      characterReferenceMarkerNumeric: Me,
      characterReferenceValue: Pe,
      characterReference: Ue,
      codeFenced: u(j),
      codeFencedFence: S,
      codeFencedFenceInfo: y,
      codeFencedFenceMeta: x,
      codeFlowValue: ee,
      codeIndented: u(w),
      codeText: u(ne),
      codeTextData: ee,
      data: ee,
      definition: u(),
      definitionDestinationString: T,
      definitionLabelString: v,
      definitionTitleString: q,
      emphasis: u(),
      hardBreakEscape: u(G),
      hardBreakTrailing: u(G),
      htmlFlow: u(P),
      htmlFlowData: ee,
      htmlText: u(K),
      htmlTextData: ee,
      image: u(ye),
      label: ve,
      labelText: ue,
      lineEnding: J,
      link: u(pe),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: Be,
      resourceDestinationString: H,
      resourceTitleString: ke,
      resource: Ce,
      setextHeading: u(Z),
      setextHeadingLineSequence: U,
      setextHeadingText: O,
      strong: u(),
      thematicBreak: u()
    }
  };
  _1(n, (e || {}).mdastExtensions || []);
  const t = {};
  return i;
  function i(D) {
    let B = {
      type: "root",
      children: []
    };
    const ie = {
      stack: [B],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: d,
      data: t
    }, fe = [];
    let _e = -1;
    for (; ++_e < D.length; )
      if (D[_e][1].type === "listOrdered" || D[_e][1].type === "listUnordered")
        if (D[_e][0] === "enter")
          fe.push(_e);
        else {
          const en = fe.pop();
          _e = a(D, en, _e);
        }
    for (_e = -1; ++_e < D.length; ) {
      const en = n[D[_e][0]];
      b1.call(en, D[_e][1].type) && en[D[_e][1].type].call(Object.assign({
        sliceSerialize: D[_e][2].sliceSerialize
      }, ie), D[_e][1]);
    }
    if (ie.tokenStack.length > 0) {
      const en = ie.tokenStack[ie.tokenStack.length - 1];
      (en[1] || x_).call(ie, void 0, en[0]);
    }
    for (B.position = {
      start: vi(D.length > 0 ? D[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: vi(D.length > 0 ? D[D.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, _e = -1; ++_e < n.transforms.length; )
      B = n.transforms[_e](B) || B;
    return B;
  }
  function a(D, B, ie) {
    let fe = B - 1, _e = -1, en = !1, un, tn, ln, fn;
    for (; ++fe <= ie; ) {
      const pn = D[fe];
      switch (pn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          pn[0] === "enter" ? _e++ : _e--, fn = void 0;
          break;
        }
        case "lineEndingBlank": {
          pn[0] === "enter" && (un && !fn && !_e && !ln && (ln = fe), fn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          fn = void 0;
      }
      if (!_e && pn[0] === "enter" && pn[1].type === "listItemPrefix" || _e === -1 && pn[0] === "exit" && (pn[1].type === "listUnordered" || pn[1].type === "listOrdered")) {
        if (un) {
          let vn = fe;
          for (tn = void 0; vn--; ) {
            const Xe = D[vn];
            if (Xe[1].type === "lineEnding" || Xe[1].type === "lineEndingBlank") {
              if (Xe[0] === "exit") continue;
              tn && (D[tn][1].type = "lineEndingBlank", en = !0), Xe[1].type = "lineEnding", tn = vn;
            } else if (!(Xe[1].type === "linePrefix" || Xe[1].type === "blockQuotePrefix" || Xe[1].type === "blockQuotePrefixWhitespace" || Xe[1].type === "blockQuoteMarker" || Xe[1].type === "listItemIndent")) break;
          }
          ln && (!tn || ln < tn) && (un._spread = !0), un.end = Object.assign({}, tn ? D[tn][1].start : pn[1].end), D.splice(tn || fe, 0, ["exit", un, pn[2]]), fe++, ie++;
        }
        if (pn[1].type === "listItemPrefix") {
          const vn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, pn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          un = vn, D.splice(fe, 0, ["enter", vn, pn[2]]), fe++, ie++, ln = void 0, fn = !0;
        }
      }
    }
    return D[B][1]._spread = en, ie;
  }
  function o(D, B) {
    return ie;
    function ie(fe) {
      l.call(this, D(fe), fe), B && B.call(this, fe);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(D, B, ie) {
    this.stack[this.stack.length - 1].children.push(D), this.stack.push(D), this.tokenStack.push([B, ie || void 0]), D.position = {
      start: vi(B.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(D) {
    return B;
    function B(ie) {
      D && D.call(this, ie), m.call(this, ie);
    }
  }
  function m(D, B) {
    const ie = this.stack.pop(), fe = this.tokenStack.pop();
    if (fe)
      fe[0].type !== D.type && (B ? B.call(this, D, fe[0]) : (fe[1] || x_).call(this, D, fe[0]));
    else throw new Error("Cannot close `" + D.type + "` (" + Bo({
      start: D.start,
      end: D.end
    }) + "): it’s not open");
    ie.position.end = vi(D.end);
  }
  function d() {
    return jH(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(D) {
    if (this.data.expectingFirstListItemValue) {
      const B = this.stack[this.stack.length - 2];
      B.start = Number.parseInt(this.sliceSerialize(D), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function y() {
    const D = this.resume(), B = this.stack[this.stack.length - 1];
    B.lang = D;
  }
  function x() {
    const D = this.resume(), B = this.stack[this.stack.length - 1];
    B.meta = D;
  }
  function S() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function j() {
    const D = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = D.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function w() {
    const D = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = D.replace(/(\r?\n|\r)$/g, "");
  }
  function v(D) {
    const B = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = B, ie.identifier = Na(this.sliceSerialize(D)).toLowerCase();
  }
  function q() {
    const D = this.resume(), B = this.stack[this.stack.length - 1];
    B.title = D;
  }
  function T() {
    const D = this.resume(), B = this.stack[this.stack.length - 1];
    B.url = D;
  }
  function I(D) {
    const B = this.stack[this.stack.length - 1];
    if (!B.depth) {
      const ie = this.sliceSerialize(D).length;
      B.depth = ie;
    }
  }
  function O() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function U(D) {
    const B = this.stack[this.stack.length - 1];
    B.depth = this.sliceSerialize(D).codePointAt(0) === 61 ? 1 : 2;
  }
  function Z() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Q(D) {
    const ie = this.stack[this.stack.length - 1].children;
    let fe = ie[ie.length - 1];
    (!fe || fe.type !== "text") && (fe = Y(), fe.position = {
      start: vi(D.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ie.push(fe)), this.stack.push(fe);
  }
  function ee(D) {
    const B = this.stack.pop();
    B.value += this.sliceSerialize(D), B.position.end = vi(D.end);
  }
  function J(D) {
    const B = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ie = B.children[B.children.length - 1];
      ie.position.end = vi(D.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(B.type) && (Q.call(this, D), ee.call(this, D));
  }
  function G() {
    this.data.atHardBreak = !0;
  }
  function P() {
    const D = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = D;
  }
  function K() {
    const D = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = D;
  }
  function ne() {
    const D = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = D;
  }
  function pe() {
    const D = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const B = this.data.referenceType || "shortcut";
      D.type += "Reference", D.referenceType = B, delete D.url, delete D.title;
    } else
      delete D.identifier, delete D.label;
    this.data.referenceType = void 0;
  }
  function ye() {
    const D = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const B = this.data.referenceType || "shortcut";
      D.type += "Reference", D.referenceType = B, delete D.url, delete D.title;
    } else
      delete D.identifier, delete D.label;
    this.data.referenceType = void 0;
  }
  function ue(D) {
    const B = this.sliceSerialize(D), ie = this.stack[this.stack.length - 2];
    ie.label = NK(B), ie.identifier = Na(B).toLowerCase();
  }
  function ve() {
    const D = this.stack[this.stack.length - 1], B = this.resume(), ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ie.type === "link") {
      const fe = D.children;
      ie.children = fe;
    } else
      ie.alt = B;
  }
  function H() {
    const D = this.resume(), B = this.stack[this.stack.length - 1];
    B.url = D;
  }
  function ke() {
    const D = this.resume(), B = this.stack[this.stack.length - 1];
    B.title = D;
  }
  function Ce() {
    this.data.inReference = void 0;
  }
  function W() {
    this.data.referenceType = "collapsed";
  }
  function Be(D) {
    const B = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = B, ie.identifier = Na(this.sliceSerialize(D)).toLowerCase(), this.data.referenceType = "full";
  }
  function Me(D) {
    this.data.characterReferenceType = D.type;
  }
  function Pe(D) {
    const B = this.sliceSerialize(D), ie = this.data.characterReferenceType;
    let fe;
    ie ? (fe = u1(B, ie === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : fe = Zv(B);
    const _e = this.stack[this.stack.length - 1];
    _e.value += fe;
  }
  function Ue(D) {
    const B = this.stack.pop();
    B.position.end = vi(D.end);
  }
  function Ie(D) {
    ee.call(this, D);
    const B = this.stack[this.stack.length - 1];
    B.url = this.sliceSerialize(D);
  }
  function Le(D) {
    ee.call(this, D);
    const B = this.stack[this.stack.length - 1];
    B.url = "mailto:" + this.sliceSerialize(D);
  }
  function Oe() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function an() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ne() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function We() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ke() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function se() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function de() {
    return {
      type: "break"
    };
  }
  function je() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ae() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Re() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function nn(D) {
    return {
      type: "list",
      ordered: D.type === "listOrdered",
      start: null,
      spread: D._spread,
      children: []
    };
  }
  function F(D) {
    return {
      type: "listItem",
      spread: D._spread,
      checked: null,
      children: []
    };
  }
  function _() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function E() {
    return {
      type: "strong",
      children: []
    };
  }
  function Y() {
    return {
      type: "text",
      value: ""
    };
  }
  function X() {
    return {
      type: "thematicBreak"
    };
  }
}
function vi(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function _1(e, n) {
  let t = -1;
  for (; ++t < n.length; ) {
    const i = n[t];
    Array.isArray(i) ? _1(e, i) : FK(e, i);
  }
}
function FK(e, n) {
  let t;
  for (t in n)
    if (b1.call(n, t))
      switch (t) {
        case "canContainEols": {
          const i = n[t];
          i && e[t].push(...i);
          break;
        }
        case "transforms": {
          const i = n[t];
          i && e[t].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[t];
          i && Object.assign(e[t], i);
          break;
        }
      }
}
function x_(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Bo({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Bo({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Bo({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function IK(e) {
  const n = this;
  n.parser = t;
  function t(i) {
    return wK(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function $K(e, n) {
  const t = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function EK(e, n) {
  const t = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, t), [e.applyData(n, t), { type: "text", value: `
` }];
}
function TK(e, n) {
  const t = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: t }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function OK(e, n) {
  const t = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function RK(e, n) {
  const t = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function DK(e, n) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Wa(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t + "fn-" + a,
      id: t + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, u);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function PK(e, n) {
  const t = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function AK(e, n) {
  if (e.options.allowDangerousHtml) {
    const t = { type: "raw", value: n.value };
    return e.patch(n, t), e.applyData(n, t);
  }
}
function x1(e, n) {
  const t = n.referenceType;
  let i = "]";
  if (t === "collapsed" ? i += "[]" : t === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function LK(e, n) {
  const t = String(n.identifier).toUpperCase(), i = e.definitionById.get(t);
  if (!i)
    return x1(e, n);
  const a = { src: Wa(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function VK(e, n) {
  const t = { src: Wa(n.url) };
  n.alt !== null && n.alt !== void 0 && (t.alt = n.alt), n.title !== null && n.title !== void 0 && (t.title = n.title);
  const i = { type: "element", tagName: "img", properties: t, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function zK(e, n) {
  const t = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, t);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [t]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function MK(e, n) {
  const t = String(n.identifier).toUpperCase(), i = e.definitionById.get(t);
  if (!i)
    return x1(e, n);
  const a = { href: Wa(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function UK(e, n) {
  const t = { href: Wa(n.url) };
  n.title !== null && n.title !== void 0 && (t.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: t,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function BK(e, n, t) {
  const i = e.all(n), a = t ? qK(t) : S1(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const d = i[0];
    let f;
    d && d.type === "element" && d.tagName === "p" ? f = d : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const d = i[l];
    (a || l !== 0 || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` }), d.type === "element" && d.tagName === "p" && !a ? s.push(...d.children) : s.push(d);
  }
  const u = i[i.length - 1];
  u && (a || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function qK(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const t = e.children;
    let i = -1;
    for (; !n && ++i < t.length; )
      n = S1(t[i]);
  }
  return n;
}
function S1(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function HK(e, n) {
  const t = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (t.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      t.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: t,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function WK(e, n) {
  const t = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function KK(e, n) {
  const t = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, t), e.applyData(n, t);
}
function GK(e, n) {
  const t = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function YK(e, n) {
  const t = e.all(n), i = t.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (t.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(t, !0)
    }, l = Yv(n.children[1]), u = r1(n.children[n.children.length - 1]);
    l && u && (s.position = { start: l, end: u }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function JK(e, n, t) {
  const i = t ? t.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = t && t.type === "table" ? t.align : void 0, l = s ? s.length : n.children.length;
  let u = -1;
  const m = [];
  for (; ++u < l; ) {
    const f = n.children[u], h = {}, y = s ? s[u] : void 0;
    y && (h.align = y);
    let x = { type: "element", tagName: o, properties: h, children: [] };
    f && (x.children = e.all(f), e.patch(f, x), x = e.applyData(f, x)), m.push(x);
  }
  const d = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, d), e.applyData(n, d);
}
function QK(e, n) {
  const t = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
const S_ = 9, N_ = 32;
function XK(e) {
  const n = String(e), t = /\r?\n|\r/g;
  let i = t.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      j_(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = t.exec(n);
  return o.push(j_(n.slice(a), a > 0, !1)), o.join("");
}
function j_(e, n, t) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === S_ || o === N_; )
      i++, o = e.codePointAt(i);
  }
  if (t) {
    let o = e.codePointAt(a - 1);
    for (; o === S_ || o === N_; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function ZK(e, n) {
  const t = { type: "text", value: XK(String(n.value)) };
  return e.patch(n, t), e.applyData(n, t);
}
function e9(e, n) {
  const t = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, t), e.applyData(n, t);
}
const n9 = {
  blockquote: $K,
  break: EK,
  code: TK,
  delete: OK,
  emphasis: RK,
  footnoteReference: DK,
  heading: PK,
  html: AK,
  imageReference: LK,
  image: VK,
  inlineCode: zK,
  linkReference: MK,
  link: UK,
  listItem: BK,
  list: HK,
  paragraph: WK,
  // @ts-expect-error: root is different, but hard to type.
  root: KK,
  strong: GK,
  table: YK,
  tableCell: QK,
  tableRow: JK,
  text: ZK,
  thematicBreak: e9,
  toml: tl,
  yaml: tl,
  definition: tl,
  footnoteDefinition: tl
};
function tl() {
}
const N1 = -1, Xc = 0, oc = 1, sc = 2, ty = 3, ry = 4, iy = 5, ay = 6, j1 = 7, w1 = 8, w_ = typeof self == "object" ? self : globalThis, t9 = (e, n) => {
  const t = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Xc:
      case N1:
        return t(s, a);
      case oc: {
        const l = t([], a);
        for (const u of s)
          l.push(i(u));
        return l;
      }
      case sc: {
        const l = t({}, a);
        for (const [u, m] of s)
          l[i(u)] = i(m);
        return l;
      }
      case ty:
        return t(new Date(s), a);
      case ry: {
        const { source: l, flags: u } = s;
        return t(new RegExp(l, u), a);
      }
      case iy: {
        const l = t(/* @__PURE__ */ new Map(), a);
        for (const [u, m] of s)
          l.set(i(u), i(m));
        return l;
      }
      case ay: {
        const l = t(/* @__PURE__ */ new Set(), a);
        for (const u of s)
          l.add(i(u));
        return l;
      }
      case j1: {
        const { name: l, message: u } = s;
        return t(new w_[l](u), a);
      }
      case w1:
        return t(BigInt(s), a);
      case "BigInt":
        return t(Object(BigInt(s)), a);
    }
    return t(new w_[o](s), a);
  };
  return i;
}, C_ = (e) => t9(/* @__PURE__ */ new Map(), e)(0), ca = "", { toString: r9 } = {}, { keys: i9 } = Object, po = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Xc, n];
  const t = r9.call(e).slice(8, -1);
  switch (t) {
    case "Array":
      return [oc, ca];
    case "Object":
      return [sc, ca];
    case "Date":
      return [ty, ca];
    case "RegExp":
      return [ry, ca];
    case "Map":
      return [iy, ca];
    case "Set":
      return [ay, ca];
  }
  return t.includes("Array") ? [oc, t] : t.includes("Error") ? [j1, t] : [sc, t];
}, rl = ([e, n]) => e === Xc && (n === "function" || n === "symbol"), a9 = (e, n, t, i) => {
  const a = (s, l) => {
    const u = i.push(s) - 1;
    return t.set(l, u), u;
  }, o = (s) => {
    if (t.has(s))
      return t.get(s);
    let [l, u] = po(s);
    switch (l) {
      case Xc: {
        let d = s;
        switch (u) {
          case "bigint":
            l = w1, d = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            d = null;
            break;
          case "undefined":
            return a([N1], s);
        }
        return a([l, d], s);
      }
      case oc: {
        if (u)
          return a([u, [...s]], s);
        const d = [], f = a([l, d], s);
        for (const h of s)
          d.push(o(h));
        return f;
      }
      case sc: {
        if (u)
          switch (u) {
            case "BigInt":
              return a([u, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([u, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const d = [], f = a([l, d], s);
        for (const h of i9(s))
          (e || !rl(po(s[h]))) && d.push([o(h), o(s[h])]);
        return f;
      }
      case ty:
        return a([l, s.toISOString()], s);
      case ry: {
        const { source: d, flags: f } = s;
        return a([l, { source: d, flags: f }], s);
      }
      case iy: {
        const d = [], f = a([l, d], s);
        for (const [h, y] of s)
          (e || !(rl(po(h)) || rl(po(y)))) && d.push([o(h), o(y)]);
        return f;
      }
      case ay: {
        const d = [], f = a([l, d], s);
        for (const h of s)
          (e || !rl(po(h))) && d.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: u, message: m }], s);
  };
  return o;
}, F_ = (e, { json: n, lossy: t } = {}) => {
  const i = [];
  return a9(!(n || t), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, lc = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? C_(F_(e, n)) : structuredClone(e)
) : (e, n) => C_(F_(e, n));
function o9(e, n) {
  const t = [{ type: "text", value: "↩" }];
  return n > 1 && t.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), t;
}
function s9(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function l9(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", t = e.options.footnoteBackContent || o9, i = e.options.footnoteBackLabel || s9, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!m)
      continue;
    const d = e.all(m), f = String(m.identifier).toUpperCase(), h = Wa(f.toLowerCase());
    let y = 0;
    const x = [], S = e.footnoteCounts.get(f);
    for (; S !== void 0 && ++y <= S; ) {
      x.length > 0 && x.push({ type: "text", value: " " });
      let v = typeof t == "string" ? t : t(u, y);
      typeof v == "string" && (v = { type: "text", value: v }), x.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (y > 1 ? "-" + y : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(u, y),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(v) ? v : [v]
      });
    }
    const j = d[d.length - 1];
    if (j && j.type === "element" && j.tagName === "p") {
      const v = j.children[j.children.length - 1];
      v && v.type === "text" ? v.value += " " : j.children.push({ type: "text", value: " " }), j.children.push(...x);
    } else
      d.push(...x);
    const w = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(d, !0)
    };
    e.patch(m, w), l.push(w);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...lc(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const C1 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return m9;
    if (typeof e == "function")
      return Zc(e);
    if (typeof e == "object")
      return Array.isArray(e) ? c9(e) : u9(e);
    if (typeof e == "string")
      return d9(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function c9(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; )
    n[t] = C1(e[t]);
  return Zc(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function u9(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Zc(t);
  function t(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function d9(e) {
  return Zc(n);
  function n(t) {
    return t && t.type === e;
  }
}
function Zc(e) {
  return n;
  function n(t, i, a) {
    return !!(p9(t) && e.call(
      this,
      t,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function m9() {
  return !0;
}
function p9(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const F1 = [], f9 = !0, I_ = !1, h9 = "skip";
function v9(e, n, t, i) {
  let a;
  typeof n == "function" && typeof t != "function" ? (i = t, t = n) : a = n;
  const o = C1(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(u, m, d) {
    const f = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof f.type == "string") {
      const y = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (u.type + (y ? "<" + y + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let y = F1, x, S, j;
      if ((!n || o(u, m, d[d.length - 1] || void 0)) && (y = y9(t(u, d)), y[0] === I_))
        return y;
      if ("children" in u && u.children) {
        const w = (
          /** @type {UnistParent} */
          u
        );
        if (w.children && y[0] !== h9)
          for (S = (i ? w.children.length : -1) + s, j = d.concat(w); S > -1 && S < w.children.length; ) {
            const v = w.children[S];
            if (x = l(v, S, j)(), x[0] === I_)
              return x;
            S = typeof x[1] == "number" ? x[1] : S + s;
          }
      }
      return y;
    }
  }
}
function y9(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [f9, e] : e == null ? F1 : [e];
}
function I1(e, n, t, i) {
  let a, o, s;
  typeof n == "function" && typeof t != "function" ? (o = void 0, s = n, a = t) : (o = n, s = t, a = i), v9(e, o, l, a);
  function l(u, m) {
    const d = m[m.length - 1], f = d ? d.children.indexOf(u) : void 0;
    return s(u, f, d);
  }
}
const $h = {}.hasOwnProperty, g9 = {};
function k9(e, n) {
  const t = n || g9, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...n9, ...t.handlers }, l = {
    all: m,
    applyData: _9,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: u,
    options: t,
    patch: b9,
    wrap: S9
  };
  return I1(e, function(d) {
    if (d.type === "definition" || d.type === "footnoteDefinition") {
      const f = d.type === "definition" ? i : a, h = String(d.identifier).toUpperCase();
      f.has(h) || f.set(h, d);
    }
  }), l;
  function u(d, f) {
    const h = d.type, y = l.handlers[h];
    if ($h.call(l.handlers, h) && y)
      return y(l, d, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in d) {
        const { children: S, ...j } = d, w = lc(j);
        return w.children = l.all(d), w;
      }
      return lc(d);
    }
    return (l.options.unknownHandler || x9)(l, d, f);
  }
  function m(d) {
    const f = [];
    if ("children" in d) {
      const h = d.children;
      let y = -1;
      for (; ++y < h.length; ) {
        const x = l.one(h[y], d);
        if (x) {
          if (y && h[y - 1].type === "break" && (!Array.isArray(x) && x.type === "text" && (x.value = $_(x.value)), !Array.isArray(x) && x.type === "element")) {
            const S = x.children[0];
            S && S.type === "text" && (S.value = $_(S.value));
          }
          Array.isArray(x) ? f.push(...x) : f.push(x);
        }
      }
    }
    return f;
  }
}
function b9(e, n) {
  e.position && (n.position = nH(e));
}
function _9(e, n) {
  let t = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (t.type === "element")
        t.tagName = i;
      else {
        const s = "children" in t ? t.children : [t];
        t = { type: "element", tagName: i, properties: {}, children: s };
      }
    t.type === "element" && o && Object.assign(t.properties, lc(o)), "children" in t && t.children && a !== null && a !== void 0 && (t.children = a);
  }
  return t;
}
function x9(e, n) {
  const t = n.data || {}, i = "value" in n && !($h.call(t, "hProperties") || $h.call(t, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function S9(e, n) {
  const t = [];
  let i = -1;
  for (n && t.push({ type: "text", value: `
` }); ++i < e.length; )
    i && t.push({ type: "text", value: `
` }), t.push(e[i]);
  return n && e.length > 0 && t.push({ type: "text", value: `
` }), t;
}
function $_(e) {
  let n = 0, t = e.charCodeAt(n);
  for (; t === 9 || t === 32; )
    n++, t = e.charCodeAt(n);
  return e.slice(n);
}
function E_(e, n) {
  const t = k9(e, n), i = t.one(e, void 0), a = l9(t), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function N9(e, n) {
  return e && "run" in e ? async function(t, i) {
    const a = (
      /** @type {HastRoot} */
      E_(t, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(t, i) {
    return (
      /** @type {HastRoot} */
      E_(t, { file: i, ...e || n })
    );
  };
}
function T_(e) {
  if (e)
    throw e;
}
var Sd, O_;
function j9() {
  if (O_) return Sd;
  O_ = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, t = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var d = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !d && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, d) {
    t && d.name === "__proto__" ? t(m, d.name, {
      enumerable: !0,
      configurable: !0,
      value: d.newValue,
      writable: !0
    }) : m[d.name] = d.newValue;
  }, l = function(m, d) {
    if (d === "__proto__")
      if (e.call(m, d)) {
        if (i)
          return i(m, d).value;
      } else return;
    return m[d];
  };
  return Sd = function u() {
    var m, d, f, h, y, x, S = arguments[0], j = 1, w = arguments.length, v = !1;
    for (typeof S == "boolean" && (v = S, S = arguments[1] || {}, j = 2), (S == null || typeof S != "object" && typeof S != "function") && (S = {}); j < w; ++j)
      if (m = arguments[j], m != null)
        for (d in m)
          f = l(S, d), h = l(m, d), S !== h && (v && h && (o(h) || (y = a(h))) ? (y ? (y = !1, x = f && a(f) ? f : []) : x = f && o(f) ? f : {}, s(S, { name: d, newValue: u(v, x, h) })) : typeof h < "u" && s(S, { name: d, newValue: h }));
    return S;
  }, Sd;
}
var w9 = j9();
const Nd = /* @__PURE__ */ Xh(w9);
function Eh(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function C9() {
  const e = [], n = { run: t, use: i };
  return n;
  function t(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(u, ...m) {
      const d = e[++o];
      let f = -1;
      if (u) {
        s(u);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, d ? F9(d, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function F9(e, n) {
  let t;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let u;
    l && s.push(a);
    try {
      u = e.apply(this, s);
    } catch (m) {
      const d = (
        /** @type {Error} */
        m
      );
      if (l && t)
        throw d;
      return a(d);
    }
    l || (u instanceof Promise ? u.then(o, a) : u instanceof Error ? a(u) : o(u));
  }
  function a(s, ...l) {
    t || (t = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Hr = { basename: I9, dirname: $9, extname: E9, join: T9, sep: "/" };
function I9(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  Fs(e);
  let t = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          t = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(t, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        t = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return t === i ? i = s : i < 0 && (i = e.length), e.slice(t, i);
}
function $9(e) {
  if (Fs(e), e.length === 0)
    return ".";
  let n = -1, t = e.length, i;
  for (; --t; )
    if (e.codePointAt(t) === 47) {
      if (i) {
        n = t;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function E9(e) {
  Fs(e);
  let n = e.length, t = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    t < 0 && (s = !0, t = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || t < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === t - 1 && a === i + 1 ? "" : e.slice(a, t);
}
function T9(...e) {
  let n = -1, t;
  for (; ++n < e.length; )
    Fs(e[n]), e[n] && (t = t === void 0 ? e[n] : t + "/" + e[n]);
  return t === void 0 ? "." : O9(t);
}
function O9(e) {
  Fs(e);
  const n = e.codePointAt(0) === 47;
  let t = R9(e, !n);
  return t.length === 0 && !n && (t = "."), t.length > 0 && e.codePointAt(e.length - 1) === 47 && (t += "/"), n ? "/" + t : t;
}
function R9(e, n) {
  let t = "", i = 0, a = -1, o = 0, s = -1, l, u;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (t.length < 2 || i !== 2 || t.codePointAt(t.length - 1) !== 46 || t.codePointAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            if (u = t.lastIndexOf("/"), u !== t.length - 1) {
              u < 0 ? (t = "", i = 0) : (t = t.slice(0, u), i = t.length - 1 - t.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (t.length > 0) {
            t = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (t = t.length > 0 ? t + "/.." : "..", i = 2);
      } else
        t.length > 0 ? t += "/" + e.slice(a + 1, s) : t = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return t;
}
function Fs(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const D9 = { cwd: P9 };
function P9() {
  return "/";
}
function Th(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function A9(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Th(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return L9(e);
}
function L9(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let t = -1;
  for (; ++t < n.length; )
    if (n.codePointAt(t) === 37 && n.codePointAt(t + 1) === 50) {
      const i = n.codePointAt(t + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const jd = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class $1 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let t;
    n ? Th(n) ? t = { path: n } : typeof n == "string" || V9(n) ? t = { value: n } : t = n : t = {}, this.cwd = "cwd" in t ? "" : D9.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < jd.length; ) {
      const o = jd[i];
      o in t && t[o] !== void 0 && t[o] !== null && (this[o] = o === "history" ? [...t[o]] : t[o]);
    }
    let a;
    for (a in t)
      jd.includes(a) || (this[a] = t[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Hr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Cd(n, "basename"), wd(n, "basename"), this.path = Hr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Hr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    R_(this.basename, "dirname"), this.path = Hr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Hr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (wd(n, "extname"), R_(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Hr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    Th(n) && (n = A9(n)), Cd(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Hr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Cd(n, "stem"), wd(n, "stem"), this.path = Hr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, t, i) {
    const a = this.message(n, t, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, t, i) {
    const a = this.message(n, t, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, t, i) {
    const a = new Pt(
      // @ts-expect-error: the overloads are fine.
      n,
      t,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function wd(e, n) {
  if (e && e.includes(Hr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Hr.sep + "`"
    );
}
function Cd(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function R_(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function V9(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const z9 = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  }
), M9 = {}.hasOwnProperty;
class oy extends z9 {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = C9();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new oy()
    );
    let t = -1;
    for (; ++t < this.attachers.length; ) {
      const i = this.attachers[t];
      n.use(...i);
    }
    return n.data(Nd(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, t) {
    return typeof n == "string" ? arguments.length === 2 ? ($d("data", this.frozen), this.namespace[n] = t, this) : M9.call(this.namespace, n) && this.namespace[n] || void 0 : n ? ($d("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [t, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = t.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const t = il(n), i = this.parser || this.Parser;
    return Fd("parse", i), i(String(t), t);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, t) {
    const i = this;
    return this.freeze(), Fd("process", this.parser || this.Parser), Id("process", this.compiler || this.Compiler), t ? a(void 0, t) : new Promise(a);
    function a(o, s) {
      const l = il(n), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(u, l, function(d, f, h) {
        if (d || !f || !h)
          return m(d);
        const y = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), x = i.stringify(y, h);
        q9(x) ? h.value = x : h.result = x, m(
          d,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(d, f) {
        d || !f ? s(d) : o ? o(f) : t(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let t = !1, i;
    return this.freeze(), Fd("processSync", this.parser || this.Parser), Id("processSync", this.compiler || this.Compiler), this.process(n, a), P_("processSync", "process", t), i;
    function a(o, s) {
      t = !0, T_(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, t, i) {
    D_(n), this.freeze();
    const a = this.transformers;
    return !i && typeof t == "function" && (i = t, t = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const u = il(t);
      a.run(n, u, m);
      function m(d, f, h) {
        const y = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        d ? l(d) : s ? s(y) : i(void 0, y, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, t) {
    let i = !1, a;
    return this.run(n, t, o), P_("runSync", "run", i), a;
    function o(s, l) {
      T_(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, t) {
    this.freeze();
    const i = il(t), a = this.compiler || this.Compiler;
    return Id("stringify", a), D_(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...t) {
    const i = this.attachers, a = this.namespace;
    if ($d("use", this.frozen), n != null) if (typeof n == "function")
      u(n, t);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        u(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [d, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          u(d, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = Nd(!0, a.settings, m.settings));
    }
    function l(m) {
      let d = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++d < m.length; ) {
          const f = m[d];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function u(m, d) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...d]);
      else if (d.length > 0) {
        let [y, ...x] = d;
        const S = i[h][1];
        Eh(S) && Eh(y) && (y = Nd(!0, S, y)), i[h] = [m, y, ...x];
      }
    }
  }
}
const U9 = new oy().freeze();
function Fd(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Id(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function $d(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function D_(e) {
  if (!Eh(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function P_(e, n, t) {
  if (!t)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function il(e) {
  return B9(e) ? e : new $1(e);
}
function B9(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function q9(e) {
  return typeof e == "string" || H9(e);
}
function H9(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const W9 = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", A_ = [], L_ = { allowDangerousHtml: !0 }, K9 = /^(https?|ircs?|mailto|xmpp)$/i, G9 = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Y9(e) {
  const n = e.allowedElements, t = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || A_, u = e.remarkPlugins || A_, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...L_ } : L_, d = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || J9, y = U9().use(IK).use(u).use(N9, m).use(l), x = new $1();
  typeof i == "string" && (x.value = i);
  for (const v of G9)
    Object.hasOwn(e, v.from) && ("" + v.from + (v.to ? "use `" + v.to + "` instead" : "remove it") + W9 + v.id, void 0);
  const S = y.parse(x);
  let j = y.runSync(S, x);
  return a && (j = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      j.type === "root" ? j.children : [j]
    )
  }), I1(j, w), sH(j, {
    Fragment: ze.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: ze.jsx,
    jsxs: ze.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function w(v, q, T) {
    if (v.type === "raw" && T && typeof q == "number")
      return d ? T.children.splice(q, 1) : T.children[q] = { type: "text", value: v.value }, q;
    if (v.type === "element") {
      let I;
      for (I in bd)
        if (Object.hasOwn(bd, I) && Object.hasOwn(v.properties, I)) {
          const O = v.properties[I], U = bd[I];
          (U === null || U.includes(v.tagName)) && (v.properties[I] = h(String(O || ""), I, v));
        }
    }
    if (v.type === "element") {
      let I = n ? !n.includes(v.tagName) : s ? s.includes(v.tagName) : !1;
      if (!I && t && typeof q == "number" && (I = !t(v, q, T)), I && T && typeof q == "number")
        return f && v.children ? T.children.splice(q, 1, ...v.children) : T.children.splice(q, 1), q;
    }
  }
}
function J9(e) {
  const n = e.indexOf(":"), t = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || t > -1 && n > t || i > -1 && n > i || // It is a protocol, it should be allowed.
    K9.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ed = { exports: {} }, fo = {}, V_;
function Q9() {
  if (V_) return fo;
  V_ = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return fo.Fragment = t, fo.jsx = s, fo.jsxs = s, fo;
}
var al = {}, z_;
function X9() {
  return z_ || (z_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    al.Fragment = i, al.jsx = Bn, al.jsxs = qn;
  }()), al;
}
var M_;
function Z9() {
  return M_ || (M_ = 1, process.env.NODE_ENV === "production" ? Ed.exports = Q9() : Ed.exports = X9()), Ed.exports;
}
var ae = Z9();
const e7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, n7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, t7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, r7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "or" }, value: { kind: "ListValue", values: [{ kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "containsIgnoreCase" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }] } }] }, { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "containsIgnoreCase" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }] } }] }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, i7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, a7 = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": e7,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": n7,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": t7,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      issues(\n        first:$first\n        after:$after\n        filter: {\n          or: [\n            { title: { containsIgnoreCase: $issueQuery } }\n            { description: { containsIgnoreCase: $issueQuery } }\n          ]\n        }\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": r7,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": i7
};
function Is(e) {
  return a7[e] ?? {};
}
const o7 = Is(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      issues(
        first:$first
        after:$after
        filter: {
          or: [
            { title: { containsIgnoreCase: $issueQuery } }
            { description: { containsIgnoreCase: $issueQuery } }
          ]
        }
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), s7 = Is(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), ol = ({
  title: e,
  children: n
}) => /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), l7 = "_issueAvatar_kc0sw_1", c7 = "_issueField_kc0sw_9", u7 = "_issueDescription_kc0sw_12", sl = {
  issueAvatar: l7,
  issueField: c7,
  issueDescription: u7
}, E1 = ({ issue: e }) => /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
  /* @__PURE__ */ ae.jsx(ol, { title: "Assignee", children: /* @__PURE__ */ ae.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: sl.issueAvatar,
      children: [
        /* @__PURE__ */ ae.jsx(
          Yh,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ ae.jsx(ol, { title: "Team", children: /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: sl.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ ae.jsx(ol, { title: "Project", children: /* @__PURE__ */ ae.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: sl.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ ae.jsx(ol, { title: "Description", children: /* @__PURE__ */ ae.jsx(Y9, { className: sl.issueDescription, children: e.description }) })
] }), d7 = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ ae.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ ae.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), m7 = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), p7 = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), f7 = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), h7 = /* @__PURE__ */ ae.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), T1 = {
  0: d7,
  1: h7,
  2: f7,
  3: p7,
  4: m7
}, v7 = (e) => e in T1, cc = ({ priority: e }) => v7(e) ? T1[e] : /* @__PURE__ */ ae.jsx(Rn, { "data-testid": "defaultPriorityTag", children: e }), y7 = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), g7 = (e, n) => /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ ae.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ ae.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), k7 = (e, n) => /* @__PURE__ */ ae.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ ae.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ ae.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), b7 = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), _7 = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), x7 = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), Oh = {
  backlog: (e, n) => y7(e, n),
  unstarted: (e, n) => g7(e, n),
  started: (e, n) => k7(e, n),
  done: (e, n) => b7(e, n),
  canceled: (e, n) => _7(e, n),
  completed: (e, n) => x7(e, n)
}, S7 = (e) => e in Oh, uc = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: t = "linear-backlog-icon"
}) => S7(e) ? Oh[e](n, t) : Oh.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), N7 = "_wrapper_e0qj3_1", j7 = "_resultTitle_e0qj3_21", w7 = "_resultTooltipTitle_e0qj3_28", C7 = "_resultLinkIcon_e0qj3_31", ho = {
  wrapper: N7,
  resultTitle: j7,
  resultTooltipTitle: w7,
  resultLinkIcon: C7
}, F7 = ({
  issue: e
}) => {
  const [n, t] = oe(!1);
  return /* @__PURE__ */ ae.jsx(
    Qe,
    {
      side: "left",
      content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "300", className: ho.wrapper, children: [
        /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ ae.jsx(
              uc,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ ae.jsx(cc, { priority: e.priority })
          ] }),
          /* @__PURE__ */ ae.jsx(Rn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ ae.jsx(
            A.Heading,
            {
              variant: "heading-3",
              className: ho.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ ae.jsx(E1, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ ae.jsx(
        ht.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: ho.result,
          onMouseEnter: () => t(!0),
          onMouseLeave: () => t(!1),
          "data-testid": "selectionListItemWrapper",
          children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ ae.jsx(
                    uc,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ ae.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ ae.jsx(cc, { priority: e.priority })
                ] }),
                /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "4", className: ho.resultTitle, children: e.title }),
                n && /* @__PURE__ */ ae.jsx(
                  me,
                  {
                    className: ho.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, I7 = "_loader_13xpk_1", $7 = "_dropdown_13xpk_8", E7 = "_loadMore_13xpk_13", Td = {
  loader: I7,
  dropdown: $7,
  loadMore: E7
}, T7 = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [t, i] = oe(), [a, o] = oe([]), [s, l] = oe(""), [u, m] = oe(!1), { useLazyQuery: d } = mn(), [f, { data: h, loading: y, networkStatus: x }] = d(
    o7,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Ba(
    () => {
      !y && s !== "" && x === yr.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), qe(() => {
    y || o([]);
  }, [s]), qe(() => {
    if (h && Object.keys(h).length > 0) {
      const j = h.Linear.issues.edges.map(
        ({ node: T }) => T
      ), w = a.filter(
        (T) => !n.find((I) => I.id === T.id)
      ), v = w.filter(
        (T) => !j.find(
          (I) => I.id === T.id
        )
      ), q = j.filter(
        (T) => !n.find((I) => I.id === T.id)
      );
      n.length > 0 ? o(
        u ? [...v, ...q] : q
      ) : h?.Linear?.issues?.edges && o(
        u ? [...w, ...j] : j
      ), h.Linear.issues.pageInfo.hasNextPage && m(!1), i(h.Linear.issues?.pageInfo);
    }
  }, [h, n]);
  const S = () => {
    !y && s !== "" && x === yr.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: t?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ ae.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ ae.jsxs(
    ki,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (j) => j?.title,
      onChange: (j) => e(j.selectedValues[0]),
      dropdownProps: { className: Td.dropdown },
      filter: {
        value: s,
        onChange: (j) => {
          const w = j.target.value;
          l(w);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((j) => /* @__PURE__ */ ae.jsx(F7, { issue: j }, j.id)),
        t?.hasNextPage && !y && s !== "" && a.length && /* @__PURE__ */ ae.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => S(),
            className: Td.loadMore,
            children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        y && s !== "" && /* @__PURE__ */ ae.jsx(b, { justifyContent: "center", className: Td.loader, children: /* @__PURE__ */ ae.jsx(dn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ ae.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !y && /* @__PURE__ */ ae.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ ae.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, O7 = "_collapse_su0f9_1", R7 = "_collapseHeader_su0f9_8", D7 = "_collapseContent_su0f9_31", P7 = "_url_su0f9_35", A7 = "_externalLink_su0f9_51", L7 = "_emptyState_su0f9_55", yi = {
  collapse: O7,
  collapseHeader: R7,
  collapseContent: D7,
  url: P7,
  externalLink: A7,
  emptyState: L7
}, V7 = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: t,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (d, f) => ({ ...d, [f.id]: !1 }),
    {}
  ), [l, u] = oe(s), { track: m } = gn();
  return n ? /* @__PURE__ */ ae.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ ae.jsx(dn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ ae.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ ae.jsx(
          A.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: yi.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Tt,
          {
            slotEnd: /* @__PURE__ */ ae.jsx(me, { name: "external-link" }),
            variant: "tertiary",
            className: yi.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ ae.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((d) => {
          const f = l[d.id];
          return /* @__PURE__ */ ae.jsxs(
            hr,
            {
              "data-testid": "collapseCard",
              onToggle: () => u({ ...l, [d.id]: !l[d.id] }),
              isOpen: f,
              className: yi.collapse,
              children: [
                /* @__PURE__ */ ae.jsx(hr.Header, { className: yi.collapseHeader, children: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ ae.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ ae.jsx(Qe, { content: /* @__PURE__ */ ae.jsx(b, { children: d.state.name }), children: /* @__PURE__ */ ae.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ ae.jsx(
                        uc,
                        {
                          type: d.state.type,
                          color: d.state.color,
                          name: d.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ ae.jsxs(
                        A.ExternalLink,
                        {
                          className: yi.url,
                          href: d.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            d.identifier,
                            /* @__PURE__ */ ae.jsx(me, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ ae.jsx(Qe, { content: /* @__PURE__ */ ae.jsx(b, { children: d.priorityLabel }), children: /* @__PURE__ */ ae.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ ae.jsx(cc, { priority: d.priority }) }) })
                    ] }),
                    /* @__PURE__ */ ae.jsx(Rn, { children: d.state.name })
                  ] }),
                  d.title
                ] }) }),
                /* @__PURE__ */ ae.jsx(hr.Content, { className: yi.collapseContent, children: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  d?.labels && d?.labels?.edges?.length > 0 && /* @__PURE__ */ ae.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: d.labels?.edges.map((h) => /* @__PURE__ */ ae.jsx(Rn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ ae.jsx(E1, { issue: d }),
                  /* @__PURE__ */ ae.jsx(
                    Kn,
                    {
                      slotStart: /* @__PURE__ */ ae.jsx(me, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => t(d.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ ae.jsxs(
                    Tt,
                    {
                      slotEnd: /* @__PURE__ */ ae.jsx(me, { name: "external-link" }),
                      variant: "tertiary",
                      className: yi.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: d.id
                        });
                      },
                      navigate: () => window.open(d.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        d.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            d.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ ae.jsx(
          Kn,
          {
            slotStart: /* @__PURE__ */ ae.jsx(me, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Tt,
          {
            slotEnd: /* @__PURE__ */ ae.jsx(me, { name: "external-link" }),
            variant: "tertiary",
            className: yi.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, z7 = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((t) => `- ${t}`).join(""),
    ordered_list: (e, n) => `
` + n().map((t) => `1. ${t}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, O1 = (e, n) => {
  const t = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => O1(l, s)) : [], a = n.nodes[e.type] || n.default;
  return t(
    a(e, i(e, n))
  );
}, M7 = "_modalBody_iv3ua_1", U7 = "_error_iv3ua_5", B7 = "_dropdown_iv3ua_16", ua = {
  modalBody: M7,
  error: U7,
  dropdown: B7
}, q7 = Is(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), H7 = Is(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), W7 = Is(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), K7 = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: t,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: u } = mn(), { control: m, handleSubmit: d, reset: f } = xr(), [h, y] = oe([]), [x, S] = oe(), [j, w] = oe([]), [v, q] = oe(), [T, I] = oe([]), [O, U] = oe(), [Z, Q] = oe([]), [ee, J] = oe(), [G, P] = oe([]), [K, ne] = oe(), [pe, ye] = oe(!1), { useMutation: ue } = mn(), { track: ve } = gn(), [H, { loading: ke }] = ue(
    q7,
    {
      onError: () => u({
        title: "Creation was not successful",
        text: "Please try again later or contact your admin.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }),
      onCompleted: (Ne) => {
        const We = {
          identifier: Ne.Linear?.issueCreate?.issue?.identifier,
          url: Ne.Linear?.issueCreate?.issue?.url
        };
        Ne.Linear && !ke && Ne.Linear?.issueCreate?.issue?.id && (a(Ne.Linear?.issueCreate?.issue?.id), Le(We), ye(!1), u({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ne.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), ve("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Ce,
    { data: W, loading: Be, error: Me }
  ] = l(H7, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ne) => {
      const We = Ne.Linear.teams.edges.map(
        ({ node: Ke }) => Ke
      );
      y(We), Q(Ne.Linear.issuePriorityValues), s(`${tG}${Ne.Linear.organization.urlKey}`);
    }
  }), [Pe, { data: Ue, loading: Ie }] = l(W7, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ne) => {
      const We = Ne?.Linear?.team?.projects?.edges?.map(
        ({ node: de }) => de
      );
      w(We);
      const Ke = Ne?.Linear?.team?.states?.edges?.map(
        ({ node: de }) => de
      );
      I(Ke);
      const se = Ne?.Linear?.team?.templates?.edges?.map(
        ({ node: de }) => de
      );
      P(
        se.filter(
          (de) => de.type === "issue"
        )
      );
    }
  }), Le = (Ne) => {
    t(!1), q(void 0), S(void 0), U(void 0), J(void 0), ne(void 0), Ne && (e(Ne), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Oe = (Ne) => {
    W && !Be && (H({
      variables: {
        issueTitle: Ne.title,
        issueDescription: Ne?.description,
        teamId: Ne.team.id,
        projectId: Ne?.project?.id,
        statusId: Ne?.status?.id,
        priority: Ne?.priority?.priority
      }
    }), ye(!0));
  };
  qe(() => {
    n && Ce();
  }, [n]);
  const an = () => {
    ve("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ ae.jsxs(
    Nt,
    {
      isOpen: n,
      onClose: () => {
        an(), Le();
      },
      children: [
        /* @__PURE__ */ ae.jsx(
          jt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              an(), Le();
            }
          }
        ),
        /* @__PURE__ */ ae.jsx(
          wt,
          {
            className: ua.modalBody,
            "data-testid": "createIssueModalBody",
            children: Me ? /* @__PURE__ */ ae.jsx(wn, { error: Me }) : /* @__PURE__ */ ae.jsx("form", { onSubmit: d(Oe), id: "issueCreationForm", children: /* @__PURE__ */ ae.jsxs(Gt, { children: [
              /* @__PURE__ */ ae.jsx(rn, { span: 3, children: /* @__PURE__ */ ae.jsx(
                qt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ne, onChange: We },
                    fieldState: { error: Ke }
                  }) => /* @__PURE__ */ ae.jsx(
                    An,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Ke?.message ?? null
                      },
                      children: /* @__PURE__ */ ae.jsx(
                        ki,
                        {
                          dropdownProps: { className: ua.dropdown },
                          placeholder: "Select Linear team",
                          className: ut({ [ua.error]: Ke }),
                          getItemTitleByValue: (se) => se?.name,
                          onChange: (se) => {
                            q(void 0), U(void 0), J(void 0), ne(void 0), S(se.selectedValues[0]), Pe({
                              variables: { teamId: se.selectedValues[0].id }
                            }), We(se.selectedValues[0]);
                          },
                          value: x ? [Ne] : void 0,
                          children: h?.map((se) => /* @__PURE__ */ ae.jsx(
                            ht.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ ae.jsx(rn, { span: 3, children: /* @__PURE__ */ ae.jsx(
                qt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ne, onChange: We } }) => {
                    const Ke = Ie ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ ae.jsx(An, { label: "Project", children: /* @__PURE__ */ ae.jsx(
                      ki,
                      {
                        dropdownProps: { className: ua.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: x === void 0,
                        placeholder: x ? "Select Linear project" : "Select a Team first",
                        onChange: (se) => {
                          q(se.selectedValues[0]), We(se.selectedValues[0]);
                        },
                        value: v ? [Ne] : Ke,
                        children: /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
                          Ie && /* @__PURE__ */ ae.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ae.jsx(dn, { size: 24 })
                            }
                          ),
                          Ue && !Ie && j.map((se) => /* @__PURE__ */ ae.jsx(
                            ht.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsx(A.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ae.jsx(rn, { span: 6, children: /* @__PURE__ */ ae.jsx(An, { label: "Template", children: /* @__PURE__ */ ae.jsx(
                ki,
                {
                  clearable: !0,
                  dropdownProps: { className: ua.dropdown },
                  disabled: !x || Ie,
                  placeholder: x ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ne) => Ne?.name,
                  onChange: (Ne) => {
                    if (Ne.selectedValues.length > 0) {
                      ne(Ne.selectedValues[0]);
                      const We = JSON.parse(
                        Ne.selectedValues[0].templateData
                      ), Ke = Z.filter(
                        (Ae) => Ae.priority === We.priority
                      );
                      J(
                        Ke ? Ke[0] : void 0
                      );
                      const se = T.filter(
                        (Ae) => Ae.id === We.stateId
                      );
                      U(
                        se ? se[0] : void 0
                      );
                      const de = j.filter(
                        (Ae) => Ae.id === We.projectId
                      );
                      q(
                        de ? de[0] : void 0
                      );
                      const je = We.description;
                      f({
                        title: We?.title,
                        priority: Ke[0],
                        status: se[0],
                        project: de[0],
                        description: je ? O1(je, z7) : "",
                        team: x
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: x
                      }), q(void 0), J(void 0), U(void 0), ne(void 0);
                  },
                  value: K ? [K] : void 0,
                  children: G?.map((Ne) => /* @__PURE__ */ ae.jsx(
                    ht.Item,
                    {
                      value: Ne,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ ae.jsx(A.Paragraph, { children: Ne.name })
                    },
                    Ne.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ ae.jsx(rn, { span: 6, children: /* @__PURE__ */ ae.jsx(
                qt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ne, value: We },
                    fieldState: { error: Ke }
                  }) => /* @__PURE__ */ ae.jsx(
                    vr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: We || "",
                        onChange: Ne
                      },
                      meta: {
                        error: Ke?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ ae.jsx(rn, { span: 3, children: /* @__PURE__ */ ae.jsx(
                qt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ne, onChange: We } }) => {
                    const Ke = Ie ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ ae.jsx(An, { label: "Status", children: /* @__PURE__ */ ae.jsx(
                      ki,
                      {
                        dropdownProps: { className: ua.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: x === void 0,
                        placeholder: x ? "Select Issue status" : "Select a Team first",
                        onChange: (se) => {
                          U(se.selectedValues[0]), We(se.selectedValues[0]);
                        },
                        value: O ? [Ne] : Ke,
                        children: /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
                          Ie && /* @__PURE__ */ ae.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ae.jsx(dn, { size: 24 })
                            }
                          ),
                          Ue && !Ie && T.map((se) => /* @__PURE__ */ ae.jsx(
                            ht.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ ae.jsx(
                                      uc,
                                      {
                                        type: se.type,
                                        color: se.color,
                                        name: se.name
                                      }
                                    ),
                                    /* @__PURE__ */ ae.jsx(A.Paragraph, { children: se.name })
                                  ]
                                }
                              )
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ae.jsx(rn, { span: 3, children: /* @__PURE__ */ ae.jsx(
                qt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ne, onChange: We } }) => {
                    const Ke = Be ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ ae.jsx(An, { label: "Priority", children: /* @__PURE__ */ ae.jsx(
                      ki,
                      {
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.label,
                        disabled: x === void 0,
                        placeholder: x ? "Select Issue priority" : "Select a Team first",
                        onChange: (se) => {
                          J(se.selectedValues[0]), We(se.selectedValues[0]);
                        },
                        value: ee ? [Ne] : Ke,
                        children: /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
                          Ie && /* @__PURE__ */ ae.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ae.jsx(dn, { size: 24 })
                            }
                          ),
                          W && !Be && Z.map((se) => /* @__PURE__ */ ae.jsx(
                            ht.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ ae.jsx(
                                      cc,
                                      {
                                        priority: se.priority
                                      }
                                    ),
                                    /* @__PURE__ */ ae.jsx(A.Paragraph, { children: se.label })
                                  ]
                                }
                              )
                            },
                            se.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ae.jsx(rn, { children: /* @__PURE__ */ ae.jsx(
                qt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ne, value: We },
                    fieldState: { error: Ke }
                  }) => /* @__PURE__ */ ae.jsx(
                    cI,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: We || "",
                        onChange: Ne
                      },
                      meta: {
                        error: Ke?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Ot,
          {
            confirmOnClick: d(Oe),
            confirmProps: {
              disabled: ke || !W,
              isLoading: pe || Be || Ie,
              loadingIndicator: /* @__PURE__ */ ae.jsx(dn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              an(), Le();
            }
          }
        )
      ]
    }
  );
}, G7 = "_modalWrapper_4kh9u_1", Y7 = "_copyButton_4kh9u_6", J7 = "_copyWrapper_4kh9u_15", Q7 = "_copyField_4kh9u_24", X7 = "_externalLink_4kh9u_47", Z7 = "_externalLinkIcon_4kh9u_52", eG = "_textWrapper_4kh9u_56", Ei = {
  modalWrapper: G7,
  copyButton: Y7,
  copyWrapper: J7,
  copyField: Q7,
  externalLink: X7,
  externalLinkIcon: Z7,
  textWrapper: eG
}, nG = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: t
}) => /* @__PURE__ */ ae.jsxs(
  Nt,
  {
    isOpen: !!n && e,
    className: Ei.modalWrapper,
    onClose: () => t(!1),
    children: [
      /* @__PURE__ */ ae.jsx(
        jt,
        {
          title: "Issue creation successful",
          onClose: () => t(!1)
        }
      ),
      /* @__PURE__ */ ae.jsx(wt, { children: /* @__PURE__ */ ae.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ ae.jsxs(A.Paragraph, { className: Ei.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ ae.jsxs(
                A.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: Ei.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ ae.jsx(me, { name: "external-link", className: Ei.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ ae.jsx(An, { label: "Linear issue link", children: /* @__PURE__ */ ae.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: Ei.copyWrapper,
                children: [
                  /* @__PURE__ */ ae.jsx(
                    Pr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: Ei.copyField
                    }
                  ),
                  /* @__PURE__ */ ae.jsx(
                    uI,
                    {
                      className: Ei.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ ae.jsx(
        Ot,
        {
          cancelOnClick: () => t(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), tG = "https://linear.app/", rG = ({
  conversationContext: e,
  settings: n
}) => {
  const [t, i] = oe([]), [a, o] = oe([]), [s, l] = oe(!1), [u, m] = oe(!1), [d, f] = oe(!1), [h, y] = oe(), { useLazyQuery: x } = mn(), [S, j] = oe(""), w = n?.enableCreateIssue, v = !!n?.enableUnlinkAll, { track: q } = gn(), {
    loading: T,
    data: I,
    error: O,
    store: U
  } = Kh(e?.conversationId ?? null), [
    Z,
    {
      data: Q,
      loading: ee,
      networkStatus: J,
      error: G
    }
  ] = x(s7, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    !T && !O && I && I?.linear?.issues?.length > 0 && (o(I.linear.issues), Z({
      variables: {
        linkedIssues: I.linear.issues
      }
    }));
  }, [I, T, O]), qe(() => {
    Q && Q?.Linear && !ee && J === yr.ready && Object.keys(Q).length > 0 && i(Q.Linear.issues?.edges?.map(({ node: pe }) => pe));
  }, [Q, ee, J]);
  const P = (pe) => {
    pe && pe?.team?.organization?.urlKey && q("linear:link:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: pe.id
    });
    const ye = (ue) => ue.id === pe?.id;
    t.some((ue) => ue && ye(ue)) || (I && a.length === 0 && o([]), U({
      linear: {
        issues: [...a, pe.id]
      }
    }));
  }, K = (pe) => {
    const ye = I?.linear.issues.filter((ue) => ue !== pe) || [];
    q("linear:unlink:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: pe
    }), i(t.filter(({ id: ue }) => ue !== pe)), o(ye), U({
      linear: {
        issues: ye
      }
    });
  }, ne = () => {
    l(!1), i([]), o([]), U({
      linear: {
        issues: []
      }
    });
  };
  return !T && !ee && (G || O) ? /* @__PURE__ */ ae.jsx(wn, { error: G || O }) : /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ ae.jsxs(
      Nt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ ae.jsx(
            jt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ ae.jsx(wt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ ae.jsx(
            Ot,
            {
              confirmOnClick: () => ne(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ ae.jsx(
      K7,
      {
        isCreateIssueModalOpen: u,
        setIsCreateIssueModalOpen: (pe) => m(pe),
        setIsCreationSuccessfulModalOpen: (pe) => f(pe),
        addToLinkedIssueIds: (pe) => {
          U({
            linear: {
              issues: [...a, pe]
            }
          });
        },
        setCreatedIssue: (pe) => y(pe),
        organizationUrl: S,
        setOrganizationUrl: (pe) => j(pe)
      }
    ),
    /* @__PURE__ */ ae.jsx(
      nG,
      {
        isCreationSuccessfulModalOpen: d,
        setIsCreationSuccessfulModalOpen: (pe) => f(pe),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ ae.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          w && /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
            /* @__PURE__ */ ae.jsx(
              Kn,
              {
                variant: "primary",
                onClick: () => {
                  q("linear:create:new:issue:clicked", {
                    linearInstanceUrl: S
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ ae.jsx(A.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ ae.jsx(T7, { handleSelect: P, linkedIssues: t })
        ]
      }
    ),
    /* @__PURE__ */ ae.jsx(
      V7,
      {
        linkedIssues: t,
        isLoading: ee,
        handleUnlinkIssue: K,
        showUnlinkAllModal: (pe) => l(pe),
        showUnlinkAllButton: v,
        organizationUrl: S
      }
    )
  ] });
}, iG = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: kc
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Od = { exports: {} }, vo = {}, U_;
function aG() {
  if (U_) return vo;
  U_ = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return vo.Fragment = t, vo.jsx = s, vo.jsxs = s, vo;
}
var ll = {}, B_;
function oG() {
  return B_ || (B_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    ll.Fragment = i, ll.jsx = Bn, ll.jsxs = qn;
  }()), ll;
}
var q_;
function sG() {
  return q_ || (q_ = 1, process.env.NODE_ENV === "production" ? Od.exports = aG() : Od.exports = oG()), Od.exports;
}
var Te = sG();
const lG = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, cG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, uG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, dG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, mG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, pG = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": lG,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": cG,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": uG,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": dG,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": mG
};
function eu(e) {
  return pG[e] ?? {};
}
const fG = eu(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), hG = eu(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), vG = eu(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), yG = eu(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function Rd(e = !1, n) {
  const [t, i] = oe(e);
  return qe(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const gG = "_wrapper_27vny_1", kG = "_copyIcon_27vny_12", yo = {
  wrapper: gG,
  copyIcon: kG
}, bG = ({
  customer: e
}) => {
  const { isCopied: n, copy: t } = Rd(), { isCopied: i, copy: a } = Rd(), { isCopied: o, copy: s } = Rd();
  if (!e)
    return null;
  const l = 14, {
    email: u,
    properties: m,
    metadata: d,
    birthday: f,
    created_at: h,
    enrolled: y,
    enrolled_at: x,
    referral_url: S
  } = e, j = f ? Dn(f).isSame(Date.now(), "day") : !1, { name: w, first_name: v, last_name: q } = m ?? {}, T = w ?? (`${v} ${q}`.trim() || "A customer has no name"), I = d?.shopify_source_url ? d.shopify_source_url.startsWith("https://") ? d.shopify_source_url : `https://${d.shopify_source_url}` : "";
  return /* @__PURE__ */ Te.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Te.jsxs(b, { className: yo.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: yo.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-2", children: T }),
          j && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Dn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    y && /* @__PURE__ */ Te.jsx(b, { gap: "200", children: /* @__PURE__ */ Te.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Dn(x).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Te.jsx(me, { size: l, name: "mail" }),
        /* @__PURE__ */ Te.jsx(A.ExternalLink, { href: `mailto:${u}`, children: u })
      ] }),
      /* @__PURE__ */ Te.jsx(Qe, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Te.jsx(
        me,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => t(u),
          className: yo.copyIcon
        }
      ) })
    ] }),
    I && /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Te.jsx(me, { size: l, name: "link" }),
        /* @__PURE__ */ Te.jsx(Qe, { content: "Shopify shop", children: /* @__PURE__ */ Te.jsx(
          A.ExternalLink,
          {
            href: I,
            target: "_blank",
            rel: "noreferrer",
            children: I.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Te.jsx(Qe, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Te.jsx(
        me,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(I),
          className: yo.copyIcon
        }
      ) })
    ] }),
    S && /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Te.jsx(me, { size: l, name: "external-link" }),
        /* @__PURE__ */ Te.jsx(Qe, { content: "Referral link", children: /* @__PURE__ */ Te.jsx(
          A.ExternalLink,
          {
            href: S,
            target: "_blank",
            rel: "noreferrer",
            children: S.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Te.jsx(Qe, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Te.jsx(
        me,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(S),
          className: yo.copyIcon
        }
      ) })
    ] })
  ] }) });
}, _G = "_list_1q5b5_5", xG = "_listItem_1q5b5_8", SG = "_listItemEdit_1q5b5_15", NG = "_notificationText_1q5b5_19", Ea = {
  list: _G,
  listItem: xG,
  listItemEdit: SG,
  notificationText: NG
}, jG = "_modalBody_1clhs_1", wG = {
  modalBody: jG
}, CG = ({
  isOpen: e,
  points: n,
  merchantId: t,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = gn(), [u, m] = oe(n), [d, f] = oe(""), [h, y] = oe(), [x, { loading: S }] = o(
    vG,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), J();
      }
    }
  ), [j, { loading: w }] = o(yG), v = S || w, q = !!h, T = n === u ? "Change the value to update the points" : "", I = isNaN(u), O = I ? "Points can not be empty" : "", U = u > n && u - n > 1e6, Z = U ? "Points can not exceed 1,000,000" : "", Q = () => {
    u > n && x({
      variables: {
        input: {
          points: u - n,
          reason: d
        },
        merchantId: t
      }
    }).catch((G) => {
      const P = G?.networkError;
      (P ? P?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : (l("loyaltylion:add:points:failed"), y(["Failed to add points, try again later."]));
    }), u < n && j({
      variables: {
        input: {
          points: n - u,
          reason: d
        },
        merchantId: t
      }
    }).then((G) => {
      G.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : "errors" in G && (l("loyaltylion:remove:points:failed"), y(
        G.errors?.map((P) => P.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), y(["Failed to remove points, try again later."]);
    });
  }, ee = () => {
    I && m(n), f(""), i();
  }, J = () => {
    a(), ee();
  };
  return /* @__PURE__ */ Te.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: ee,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Te.jsx(jt, { title: "Change points", onClose: ee }),
        /* @__PURE__ */ Te.jsxs(wt, { className: wG.modalBody, children: [
          /* @__PURE__ */ Te.jsxs(Gt, { children: [
            /* @__PURE__ */ Te.jsx(rn, { span: 6, children: /* @__PURE__ */ Te.jsx(
              vr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Z || O,
                  warning: T
                },
                input: {
                  name: "points",
                  value: u.toString(),
                  onChange: (G) => m(G?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Te.jsx(rn, { span: 6, children: /* @__PURE__ */ Te.jsx(
              vr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: d,
                  onChange: (G) => f(G?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !v && q && /* @__PURE__ */ Te.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Te.jsx(He, { children: h?.map((G, P) => /* @__PURE__ */ Te.jsx(
            He.Item,
            {
              variant: "dense",
              title: G,
              contentLeft: /* @__PURE__ */ Te.jsx(
                me,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            P
          )) }) })
        ] }),
        /* @__PURE__ */ Te.jsx(
          Ot,
          {
            confirmName: "Save",
            confirmOnClick: () => Q(),
            confirmProps: {
              isLoading: v,
              disabled: I || U || n === u,
              loadingIndicator: /* @__PURE__ */ Te.jsx(dn, { size: 16 })
            },
            cancelOnClick: ee
          }
        )
      ]
    }
  );
}, FG = ({
  label: e,
  points: n,
  setIsModalOpen: t
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Te.jsx(He.Text, { variant: "dense", className: Ea.listItem, children: /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(me, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
      t && /* @__PURE__ */ Te.jsx(Qe, { content: "Edit points", children: /* @__PURE__ */ Te.jsx(
        me,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Ea.listItemEdit,
          onClick: () => t(!0)
        }
      ) }),
      /* @__PURE__ */ Te.jsx(Mn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, IG = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [t, i] = oe(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: u
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: u ?? 0
    }
  ];
  return /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Te.jsx(He, { className: Ea.list, children: m.map(({ id: d, points: f, label: h, setIsModalOpen: y }) => /* @__PURE__ */ Te.jsx(
      FG,
      {
        points: f,
        label: h,
        setIsModalOpen: y
      },
      d
    )) }),
    /* @__PURE__ */ Te.jsx(
      CG,
      {
        isOpen: t,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, $G = "_reward_1wxia_1", EG = {
  reward: $G
}, TG = ({ reward: e }) => {
  const {
    title: n,
    point_cost: t,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Te.jsx(b, { gap: "100", flexDirection: "column", className: EG.reward, children: /* @__PURE__ */ Te.jsx(Qe, { content: a ?? "No description", children: /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Te.jsx(me, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Te.jsxs(Mn, { size: "small", variant: "info", children: [
        t ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Te.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(me, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Te.jsx(
        A.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, OG = ({ customer: e }) => {
  const { useQuery: n } = mn(), [t, i] = oe(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(hG, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  return qe(() => {
    if (l?.LoyaltyLion) {
      const u = l.LoyaltyLion?.getAvailableRewards?.rewards;
      u && i(u);
    }
  }, [l]), s ? as({ errors: s.graphQLErrors }) ? /* @__PURE__ */ Te.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Ea.notificationText,
      children: "No rewards found"
    }
  ) : XN({ errors: s.graphQLErrors }) ? /* @__PURE__ */ Te.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Ea.notificationText,
      children: "You don't have permissions to view rewards"
    }
  ) : /* @__PURE__ */ Te.jsx(wn, { error: s }) : /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Te.jsx(dn, {}) }) : /* @__PURE__ */ Te.jsx(b, { gap: "200", flexDirection: "column", children: t?.map((u) => /* @__PURE__ */ Te.jsx(TG, { reward: u }, u.id)) })
  ] });
}, RG = ({ customer: e }) => {
  const { blocked: n, guest: t, insights_segment: i } = e ?? {}, a = n || t || i, o = 14;
  return a ? /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Te.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Te.jsx(Rn, { children: /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(
        me,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    t && /* @__PURE__ */ Te.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Te.jsx(Rn, { children: /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(me, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Te.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Te.jsx(Qe, { content: "Insights segment", children: /* @__PURE__ */ Te.jsx(Rn, { children: /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(me, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, DG = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: t } = mn(), { track: i } = gn(), [a, o] = oe(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: u,
    showPointsBalance: m,
    showAvailableRewards: d
  } = n, f = !l && !u && !m && !d, {
    loading: h,
    error: y,
    data: x,
    refetch: S
  } = t(fG, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return qe(() => {
    if (x && !h) {
      const j = (x?.LoyaltyLion?.getCustomers).customers;
      j && j.length > 0 && (o(j[0]), i("loyaltylion:customer:received"));
    }
  }, [x, h]), s?.email ? y ? as({
    errors: y.graphQLErrors
  }) ? /* @__PURE__ */ Te.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Ea.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Te.jsx(wn, { error: y }) : h ? /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Te.jsx(dn, {}) }) : f ? /* @__PURE__ */ Te.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Te.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
        l && /* @__PURE__ */ Te.jsx(bG, { customer: a }),
        u && /* @__PURE__ */ Te.jsx(RG, { customer: a }),
        m && /* @__PURE__ */ Te.jsx(
          IG,
          {
            customer: a,
            refetchCustomerData: S
          }
        ),
        d && /* @__PURE__ */ Te.jsx(OG, { customer: a })
      ] }) : /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Te.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, PG = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Dd = { exports: {} }, go = {}, H_;
function AG() {
  if (H_) return go;
  H_ = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return go.Fragment = t, go.jsx = s, go.jsxs = s, go;
}
var cl = {}, W_;
function LG() {
  return W_ || (W_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    cl.Fragment = i, cl.jsx = Bn, cl.jsxs = qn;
  }()), cl;
}
var K_;
function VG() {
  return K_ || (K_ = 1, process.env.NODE_ENV === "production" ? Dd.exports = AG() : Dd.exports = LG()), Dd.exports;
}
var jn = VG();
const zG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, MG = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": zG
};
function UG(e) {
  return MG[e] ?? {};
}
const {
  entries: R1,
  setPrototypeOf: G_,
  isFrozen: BG,
  getPrototypeOf: qG,
  getOwnPropertyDescriptor: HG
} = Object;
let {
  freeze: Wt,
  seal: gr,
  create: D1
} = Object, {
  apply: Rh,
  construct: Dh
} = typeof Reflect < "u" && Reflect;
Wt || (Wt = function(e) {
  return e;
});
gr || (gr = function(e) {
  return e;
});
Rh || (Rh = function(e, n, t) {
  return e.apply(n, t);
});
Dh || (Dh = function(e, n) {
  return new e(...n);
});
const ul = Kt(Array.prototype.forEach), WG = Kt(Array.prototype.lastIndexOf), Y_ = Kt(Array.prototype.pop), ko = Kt(Array.prototype.push), KG = Kt(Array.prototype.splice), Al = Kt(String.prototype.toLowerCase), Pd = Kt(String.prototype.toString), J_ = Kt(String.prototype.match), bo = Kt(String.prototype.replace), GG = Kt(String.prototype.indexOf), YG = Kt(String.prototype.trim), wr = Kt(Object.prototype.hasOwnProperty), At = Kt(RegExp.prototype.test), _o = JG(TypeError);
function Kt(e) {
  return function(n) {
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
      i[a - 1] = arguments[a];
    return Rh(e, n, i);
  };
}
function JG(e) {
  return function() {
    for (var n = arguments.length, t = new Array(n), i = 0; i < n; i++)
      t[i] = arguments[i];
    return Dh(e, t);
  };
}
function En(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Al;
  G_ && G_(e, null);
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = t(a);
      o !== a && (BG(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function QG(e) {
  for (let n = 0; n < e.length; n++)
    wr(e, n) || (e[n] = null);
  return e;
}
function Di(e) {
  const n = D1(null);
  for (const [t, i] of R1(e))
    wr(e, t) && (Array.isArray(i) ? n[t] = QG(i) : i && typeof i == "object" && i.constructor === Object ? n[t] = Di(i) : n[t] = i);
  return n;
}
function xo(e, n) {
  for (; e !== null; ) {
    const i = HG(e, n);
    if (i) {
      if (i.get)
        return Kt(i.get);
      if (typeof i.value == "function")
        return Kt(i.value);
    }
    e = qG(e);
  }
  function t() {
    return null;
  }
  return t;
}
const Q_ = Wt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Ad = Wt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Ld = Wt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), XG = Wt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Vd = Wt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), ZG = Wt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), X_ = Wt(["#text"]), Z_ = Wt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), zd = Wt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), ex = Wt(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), dl = Wt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), e8 = gr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), n8 = gr(/<%[\w\W]*|[\w\W]*%>/gm), t8 = gr(/\$\{[\w\W]*/gm), r8 = gr(/^data-[\-\w.\u00B7-\uFFFF]+$/), i8 = gr(/^aria-[\-\w]+$/), P1 = gr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), a8 = gr(/^(?:\w+script|data):/i), o8 = gr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), A1 = gr(/^html$/i), s8 = gr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var nx = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: i8,
  ATTR_WHITESPACE: o8,
  CUSTOM_ELEMENT: s8,
  DATA_ATTR: r8,
  DOCTYPE_NAME: A1,
  ERB_EXPR: n8,
  IS_ALLOWED_URI: P1,
  IS_SCRIPT_OR_DATA: a8,
  MUSTACHE_EXPR: e8,
  TMPLIT_EXPR: t8
});
const So = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, l8 = function() {
  return typeof window > "u" ? null : window;
}, c8 = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let t = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (t = n.getAttribute(i));
  const a = "dompurify" + (t ? "#" + t : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, tx = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function L1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : l8();
  const n = ($) => L1($);
  if (n.version = "3.2.4", n.removed = [], !e || !e.document || e.document.nodeType !== So.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: t
  } = e;
  const i = t, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: u,
    NodeFilter: m,
    NamedNodeMap: d = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: y
  } = e, x = u.prototype, S = xo(x, "cloneNode"), j = xo(x, "remove"), w = xo(x, "nextSibling"), v = xo(x, "childNodes"), q = xo(x, "parentNode");
  if (typeof s == "function") {
    const $ = t.createElement("template");
    $.content && $.content.ownerDocument && (t = $.content.ownerDocument);
  }
  let T, I = "";
  const {
    implementation: O,
    createNodeIterator: U,
    createDocumentFragment: Z,
    getElementsByTagName: Q
  } = t, {
    importNode: ee
  } = i;
  let J = tx();
  n.isSupported = typeof R1 == "function" && typeof q == "function" && O && O.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: G,
    ERB_EXPR: P,
    TMPLIT_EXPR: K,
    DATA_ATTR: ne,
    ARIA_ATTR: pe,
    IS_SCRIPT_OR_DATA: ye,
    ATTR_WHITESPACE: ue,
    CUSTOM_ELEMENT: ve
  } = nx;
  let {
    IS_ALLOWED_URI: H
  } = nx, ke = null;
  const Ce = En({}, [...Q_, ...Ad, ...Ld, ...Vd, ...X_]);
  let W = null;
  const Be = En({}, [...Z_, ...zd, ...ex, ...dl]);
  let Me = Object.seal(D1(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Pe = null, Ue = null, Ie = !0, Le = !0, Oe = !1, an = !0, Ne = !1, We = !0, Ke = !1, se = !1, de = !1, je = !1, Ae = !1, Re = !1, nn = !0, F = !1;
  const _ = "user-content-";
  let E = !0, Y = !1, X = {}, D = null;
  const B = En({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let ie = null;
  const fe = En({}, ["audio", "video", "img", "source", "image", "track"]);
  let _e = null;
  const en = En({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), un = "http://www.w3.org/1998/Math/MathML", tn = "http://www.w3.org/2000/svg", ln = "http://www.w3.org/1999/xhtml";
  let fn = ln, pn = !1, vn = null;
  const Xe = En({}, [un, tn, ln], Pd);
  let yn = En({}, ["mi", "mo", "mn", "ms", "mtext"]), De = En({}, ["annotation-xml"]);
  const cn = En({}, ["title", "style", "font", "a", "script"]);
  let on = null;
  const _n = ["application/xhtml+xml", "text/html"], Hn = "text/html";
  let sn = null, On = null;
  const xn = t.createElement("form"), kn = function($) {
    return $ instanceof RegExp || $ instanceof Function;
  }, Vn = function() {
    let $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(On && On === $)) {
      if ((!$ || typeof $ != "object") && ($ = {}), $ = Di($), on = // eslint-disable-next-line unicorn/prefer-includes
      _n.indexOf($.PARSER_MEDIA_TYPE) === -1 ? Hn : $.PARSER_MEDIA_TYPE, sn = on === "application/xhtml+xml" ? Pd : Al, ke = wr($, "ALLOWED_TAGS") ? En({}, $.ALLOWED_TAGS, sn) : Ce, W = wr($, "ALLOWED_ATTR") ? En({}, $.ALLOWED_ATTR, sn) : Be, vn = wr($, "ALLOWED_NAMESPACES") ? En({}, $.ALLOWED_NAMESPACES, Pd) : Xe, _e = wr($, "ADD_URI_SAFE_ATTR") ? En(Di(en), $.ADD_URI_SAFE_ATTR, sn) : en, ie = wr($, "ADD_DATA_URI_TAGS") ? En(Di(fe), $.ADD_DATA_URI_TAGS, sn) : fe, D = wr($, "FORBID_CONTENTS") ? En({}, $.FORBID_CONTENTS, sn) : B, Pe = wr($, "FORBID_TAGS") ? En({}, $.FORBID_TAGS, sn) : {}, Ue = wr($, "FORBID_ATTR") ? En({}, $.FORBID_ATTR, sn) : {}, X = wr($, "USE_PROFILES") ? $.USE_PROFILES : !1, Ie = $.ALLOW_ARIA_ATTR !== !1, Le = $.ALLOW_DATA_ATTR !== !1, Oe = $.ALLOW_UNKNOWN_PROTOCOLS || !1, an = $.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ne = $.SAFE_FOR_TEMPLATES || !1, We = $.SAFE_FOR_XML !== !1, Ke = $.WHOLE_DOCUMENT || !1, je = $.RETURN_DOM || !1, Ae = $.RETURN_DOM_FRAGMENT || !1, Re = $.RETURN_TRUSTED_TYPE || !1, de = $.FORCE_BODY || !1, nn = $.SANITIZE_DOM !== !1, F = $.SANITIZE_NAMED_PROPS || !1, E = $.KEEP_CONTENT !== !1, Y = $.IN_PLACE || !1, H = $.ALLOWED_URI_REGEXP || P1, fn = $.NAMESPACE || ln, yn = $.MATHML_TEXT_INTEGRATION_POINTS || yn, De = $.HTML_INTEGRATION_POINTS || De, Me = $.CUSTOM_ELEMENT_HANDLING || {}, $.CUSTOM_ELEMENT_HANDLING && kn($.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Me.tagNameCheck = $.CUSTOM_ELEMENT_HANDLING.tagNameCheck), $.CUSTOM_ELEMENT_HANDLING && kn($.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Me.attributeNameCheck = $.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), $.CUSTOM_ELEMENT_HANDLING && typeof $.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Me.allowCustomizedBuiltInElements = $.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ne && (Le = !1), Ae && (je = !0), X && (ke = En({}, X_), W = [], X.html === !0 && (En(ke, Q_), En(W, Z_)), X.svg === !0 && (En(ke, Ad), En(W, zd), En(W, dl)), X.svgFilters === !0 && (En(ke, Ld), En(W, zd), En(W, dl)), X.mathMl === !0 && (En(ke, Vd), En(W, ex), En(W, dl))), $.ADD_TAGS && (ke === Ce && (ke = Di(ke)), En(ke, $.ADD_TAGS, sn)), $.ADD_ATTR && (W === Be && (W = Di(W)), En(W, $.ADD_ATTR, sn)), $.ADD_URI_SAFE_ATTR && En(_e, $.ADD_URI_SAFE_ATTR, sn), $.FORBID_CONTENTS && (D === B && (D = Di(D)), En(D, $.FORBID_CONTENTS, sn)), E && (ke["#text"] = !0), Ke && En(ke, ["html", "head", "body"]), ke.table && (En(ke, ["tbody"]), delete Pe.tbody), $.TRUSTED_TYPES_POLICY) {
        if (typeof $.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw _o('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof $.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw _o('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        T = $.TRUSTED_TYPES_POLICY, I = T.createHTML("");
      } else
        T === void 0 && (T = c8(y, a)), T !== null && typeof I == "string" && (I = T.createHTML(""));
      Wt && Wt($), On = $;
    }
  }, Un = En({}, [...Ad, ...Ld, ...XG]), bn = En({}, [...Vd, ...ZG]), Sn = function($) {
    let V = q($);
    (!V || !V.tagName) && (V = {
      namespaceURI: fn,
      tagName: "template"
    });
    const z = Al($.tagName), re = Al(V.tagName);
    return vn[$.namespaceURI] ? $.namespaceURI === tn ? V.namespaceURI === ln ? z === "svg" : V.namespaceURI === un ? z === "svg" && (re === "annotation-xml" || yn[re]) : !!Un[z] : $.namespaceURI === un ? V.namespaceURI === ln ? z === "math" : V.namespaceURI === tn ? z === "math" && De[re] : !!bn[z] : $.namespaceURI === ln ? V.namespaceURI === tn && !De[re] || V.namespaceURI === un && !yn[re] ? !1 : !bn[z] && (cn[z] || !Un[z]) : !!(on === "application/xhtml+xml" && vn[$.namespaceURI]) : !1;
  }, Tn = function($) {
    ko(n.removed, {
      element: $
    });
    try {
      q($).removeChild($);
    } catch {
      j($);
    }
  }, Ln = function($, V) {
    try {
      ko(n.removed, {
        attribute: V.getAttributeNode($),
        from: V
      });
    } catch {
      ko(n.removed, {
        attribute: null,
        from: V
      });
    }
    if (V.removeAttribute($), $ === "is")
      if (je || Ae)
        try {
          Tn(V);
        } catch {
        }
      else
        try {
          V.setAttribute($, "");
        } catch {
        }
  }, Bn = function($) {
    let V = null, z = null;
    if (de)
      $ = "<remove></remove>" + $;
    else {
      const be = J_($, /^[\r\n\t ]+/);
      z = be && be[0];
    }
    on === "application/xhtml+xml" && fn === ln && ($ = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + $ + "</body></html>");
    const re = T ? T.createHTML($) : $;
    if (fn === ln)
      try {
        V = new h().parseFromString(re, on);
      } catch {
      }
    if (!V || !V.documentElement) {
      V = O.createDocument(fn, "template", null);
      try {
        V.documentElement.innerHTML = pn ? I : re;
      } catch {
      }
    }
    const we = V.body || V.documentElement;
    return $ && z && we.insertBefore(t.createTextNode(z), we.childNodes[0] || null), fn === ln ? Q.call(V, Ke ? "html" : "body")[0] : Ke ? V.documentElement : we;
  }, qn = function($) {
    return U.call(
      $.ownerDocument || $,
      $,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, r = function($) {
    return $ instanceof f && (typeof $.nodeName != "string" || typeof $.textContent != "string" || typeof $.removeChild != "function" || !($.attributes instanceof d) || typeof $.removeAttribute != "function" || typeof $.setAttribute != "function" || typeof $.namespaceURI != "string" || typeof $.insertBefore != "function" || typeof $.hasChildNodes != "function");
  }, c = function($) {
    return typeof l == "function" && $ instanceof l;
  };
  function p($, V, z) {
    ul($, (re) => {
      re.call(n, V, z, On);
    });
  }
  const g = function($) {
    let V = null;
    if (p(J.beforeSanitizeElements, $, null), r($))
      return Tn($), !0;
    const z = sn($.nodeName);
    if (p(J.uponSanitizeElement, $, {
      tagName: z,
      allowedTags: ke
    }), $.hasChildNodes() && !c($.firstElementChild) && At(/<[/\w]/g, $.innerHTML) && At(/<[/\w]/g, $.textContent) || $.nodeType === So.progressingInstruction || We && $.nodeType === So.comment && At(/<[/\w]/g, $.data))
      return Tn($), !0;
    if (!ke[z] || Pe[z]) {
      if (!Pe[z] && L(z) && (Me.tagNameCheck instanceof RegExp && At(Me.tagNameCheck, z) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(z)))
        return !1;
      if (E && !D[z]) {
        const re = q($) || $.parentNode, we = v($) || $.childNodes;
        if (we && re) {
          const be = we.length;
          for (let te = be - 1; te >= 0; --te) {
            const Ze = S(we[te], !0);
            Ze.__removalCount = ($.__removalCount || 0) + 1, re.insertBefore(Ze, w($));
          }
        }
      }
      return Tn($), !0;
    }
    return $ instanceof u && !Sn($) || (z === "noscript" || z === "noembed" || z === "noframes") && At(/<\/no(script|embed|frames)/i, $.innerHTML) ? (Tn($), !0) : (Ne && $.nodeType === So.text && (V = $.textContent, ul([G, P, K], (re) => {
      V = bo(V, re, " ");
    }), $.textContent !== V && (ko(n.removed, {
      element: $.cloneNode()
    }), $.textContent = V)), p(J.afterSanitizeElements, $, null), !1);
  }, R = function($, V, z) {
    if (nn && (V === "id" || V === "name") && (z in t || z in xn))
      return !1;
    if (!(Le && !Ue[V] && At(ne, V)) && !(Ie && At(pe, V))) {
      if (!W[V] || Ue[V]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(L($) && (Me.tagNameCheck instanceof RegExp && At(Me.tagNameCheck, $) || Me.tagNameCheck instanceof Function && Me.tagNameCheck($)) && (Me.attributeNameCheck instanceof RegExp && At(Me.attributeNameCheck, V) || Me.attributeNameCheck instanceof Function && Me.attributeNameCheck(V)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          V === "is" && Me.allowCustomizedBuiltInElements && (Me.tagNameCheck instanceof RegExp && At(Me.tagNameCheck, z) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(z)))
        ) return !1;
      } else if (!_e[V] && !At(H, bo(z, ue, "")) && !((V === "src" || V === "xlink:href" || V === "href") && $ !== "script" && GG(z, "data:") === 0 && ie[$]) && !(Oe && !At(ye, bo(z, ue, ""))) && z)
        return !1;
    }
    return !0;
  }, L = function($) {
    return $ !== "annotation-xml" && J_($, ve);
  }, C = function($) {
    p(J.beforeSanitizeAttributes, $, null);
    const {
      attributes: V
    } = $;
    if (!V || r($))
      return;
    const z = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: W,
      forceKeepAttr: void 0
    };
    let re = V.length;
    for (; re--; ) {
      const we = V[re], {
        name: be,
        namespaceURI: te,
        value: Ze
      } = we, In = sn(be);
      let Nn = be === "value" ? Ze : YG(Ze);
      if (z.attrName = In, z.attrValue = Nn, z.keepAttr = !0, z.forceKeepAttr = void 0, p(J.uponSanitizeAttribute, $, z), Nn = z.attrValue, F && (In === "id" || In === "name") && (Ln(be, $), Nn = _ + Nn), We && At(/((--!?|])>)|<\/(style|title)/i, Nn)) {
        Ln(be, $);
        continue;
      }
      if (z.forceKeepAttr || (Ln(be, $), !z.keepAttr))
        continue;
      if (!an && At(/\/>/i, Nn)) {
        Ln(be, $);
        continue;
      }
      Ne && ul([G, P, K], (qF) => {
        Nn = bo(Nn, qF, " ");
      });
      const zy = sn($.nodeName);
      if (R(zy, In, Nn)) {
        if (T && typeof y == "object" && typeof y.getAttributeType == "function" && !te)
          switch (y.getAttributeType(zy, In)) {
            case "TrustedHTML": {
              Nn = T.createHTML(Nn);
              break;
            }
            case "TrustedScriptURL": {
              Nn = T.createScriptURL(Nn);
              break;
            }
          }
        try {
          te ? $.setAttributeNS(te, be, Nn) : $.setAttribute(be, Nn), r($) ? Tn($) : Y_(n.removed);
        } catch {
        }
      }
    }
    p(J.afterSanitizeAttributes, $, null);
  }, N = function $(V) {
    let z = null;
    const re = qn(V);
    for (p(J.beforeSanitizeShadowDOM, V, null); z = re.nextNode(); )
      p(J.uponSanitizeShadowNode, z, null), g(z), C(z), z.content instanceof o && $(z.content);
    p(J.afterSanitizeShadowDOM, V, null);
  };
  return n.sanitize = function($) {
    let V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, z = null, re = null, we = null, be = null;
    if (pn = !$, pn && ($ = "<!-->"), typeof $ != "string" && !c($))
      if (typeof $.toString == "function") {
        if ($ = $.toString(), typeof $ != "string")
          throw _o("dirty is not a string, aborting");
      } else
        throw _o("toString is not a function");
    if (!n.isSupported)
      return $;
    if (se || Vn(V), n.removed = [], typeof $ == "string" && (Y = !1), Y) {
      if ($.nodeName) {
        const In = sn($.nodeName);
        if (!ke[In] || Pe[In])
          throw _o("root node is forbidden and cannot be sanitized in-place");
      }
    } else if ($ instanceof l)
      z = Bn("<!---->"), re = z.ownerDocument.importNode($, !0), re.nodeType === So.element && re.nodeName === "BODY" || re.nodeName === "HTML" ? z = re : z.appendChild(re);
    else {
      if (!je && !Ne && !Ke && // eslint-disable-next-line unicorn/prefer-includes
      $.indexOf("<") === -1)
        return T && Re ? T.createHTML($) : $;
      if (z = Bn($), !z)
        return je ? null : Re ? I : "";
    }
    z && de && Tn(z.firstChild);
    const te = qn(Y ? $ : z);
    for (; we = te.nextNode(); )
      g(we), C(we), we.content instanceof o && N(we.content);
    if (Y)
      return $;
    if (je) {
      if (Ae)
        for (be = Z.call(z.ownerDocument); z.firstChild; )
          be.appendChild(z.firstChild);
      else
        be = z;
      return (W.shadowroot || W.shadowrootmode) && (be = ee.call(i, be, !0)), be;
    }
    let Ze = Ke ? z.outerHTML : z.innerHTML;
    return Ke && ke["!doctype"] && z.ownerDocument && z.ownerDocument.doctype && z.ownerDocument.doctype.name && At(A1, z.ownerDocument.doctype.name) && (Ze = "<!DOCTYPE " + z.ownerDocument.doctype.name + `>
` + Ze), Ne && ul([G, P, K], (In) => {
      Ze = bo(Ze, In, " ");
    }), T && Re ? T.createHTML(Ze) : Ze;
  }, n.setConfig = function() {
    let $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn($), se = !0;
  }, n.clearConfig = function() {
    On = null, se = !1;
  }, n.isValidAttribute = function($, V, z) {
    On || Vn({});
    const re = sn($), we = sn(V);
    return R(re, we, z);
  }, n.addHook = function($, V) {
    typeof V == "function" && ko(J[$], V);
  }, n.removeHook = function($, V) {
    if (V !== void 0) {
      const z = WG(J[$], V);
      return z === -1 ? void 0 : KG(J[$], z, 1)[0];
    }
    return Y_(J[$]);
  }, n.removeHooks = function($) {
    J[$] = [];
  }, n.removeAllHooks = function() {
    J = tx();
  }, n;
}
var u8 = L1();
const d8 = "_messageContainer_1rxr4_1", m8 = "_chip_1rxr4_7", p8 = "_chipLabel_1rxr4_10", f8 = "_chipValue_1rxr4_13", ml = {
  messageContainer: d8,
  chip: m8,
  chipLabel: p8,
  chipValue: f8
}, rx = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, h8 = ({
  messages: e,
  customFields: n,
  attachments: t,
  conversationContext: i
}) => {
  qe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: u,
      email: m,
      phone_number: d
    } = i.customer;
    return s ?? l ?? u ?? m ?? d ?? o;
  };
  return /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ jn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ jn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ jn.jsx(Qe, { content: "Conversation Attributes", children: /* @__PURE__ */ jn.jsx(
        Yh,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ jn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ jn.jsx(Rn, { className: ml.chip, children: /* @__PURE__ */ jn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ jn.jsxs(Qn, { className: ml.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ jn.jsx(Qn, { className: ml.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ jn.jsx(
      b,
      {
        className: ml.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? rx[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? rx[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ jn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ jn.jsx(A.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ jn.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ jn.jsx(dI, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ jn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: u8.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    t && /* @__PURE__ */ jn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: t.map((o, s) => /* @__PURE__ */ jn.jsx(
      mI,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ jn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, v8 = "_conversation_1draa_1", y8 = "_conversationSubLine_1draa_9", g8 = "_modal_1draa_14", Md = {
  conversation: v8,
  conversationSubLine: y8,
  modal: g8
}, k8 = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), b8 = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, t]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: t?.value ? t.value.toString() : ""
})), _8 = ({
  conversation: e,
  conversationContext: n
}) => {
  const [t, i] = oe(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ jn.jsxs(b, { className: Md.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ jn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ jn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ jn.jsx(A.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ jn.jsx(Mn, { size: "small", variant: "info", children: Dn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ jn.jsx(
          A.Heading,
          {
            variant: "heading-4",
            className: Md.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ jn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ jn.jsx(Rn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ jn.jsx(Qe, { content: "Show conversation preview", children: /* @__PURE__ */ jn.jsx(
        tr,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ jn.jsxs(
      Nt,
      {
        isOpen: t,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Md.modal,
        children: [
          /* @__PURE__ */ jn.jsx(
            jt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ jn.jsx(wt, { children: /* @__PURE__ */ jn.jsx(
            h8,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: k8(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: b8(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, x8 = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: t
}) => {
  const [i, a] = oe(!1), o = t > 0 ? t : 1, s = e?.length > o, l = Wn(
    () => e?.sort((u, m) => m?.created_at.localeCompare(u?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ jn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((u, m) => /* @__PURE__ */ jn.jsx(
      _8,
      {
        conversation: u,
        conversationContext: n
      },
      `${m}-${u?.id}`
    )),
    s && /* @__PURE__ */ jn.jsxs(
      Kn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, S8 = UG(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), N8 = ({
  conversationContext: e,
  settings: n
}) => {
  const [t, i] = oe([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((d) => !!d).map((d) => `'${d}'`).join(","), { useQuery: s } = mn(), { data: l, loading: u, error: m } = s(S8, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return qe(() => {
    if (l?.Miuros) {
      const d = l?.Miuros?.findTickets?.data;
      d && i(d);
    }
  }, [l]), m ? /* @__PURE__ */ jn.jsx(wn, { error: m }) : u ? /* @__PURE__ */ jn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ jn.jsx(dn, {}) }) : t?.length === 0 ? /* @__PURE__ */ jn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ jn.jsx(
    x8,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: t,
      conversationContext: e
    }
  );
}, j8 = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: kc
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ud = { exports: {} }, No = {}, ix;
function w8() {
  if (ix) return No;
  ix = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return No.Fragment = t, No.jsx = s, No.jsxs = s, No;
}
var pl = {}, ax;
function C8() {
  return ax || (ax = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    pl.Fragment = i, pl.jsx = Bn, pl.jsxs = qn;
  }()), pl;
}
var ox;
function F8() {
  return ox || (ox = 1, process.env.NODE_ENV === "production" ? Ud.exports = w8() : Ud.exports = C8()), Ud.exports;
}
var Fe = F8();
const I8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, $8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, E8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, T8 = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": I8,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": $8,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": E8
};
function sy(e) {
  return T8[e] ?? {};
}
const O8 = sy(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), R8 = sy(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), D8 = sy(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function Ph(e = !1, n) {
  const [t, i] = oe(e);
  return qe(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const P8 = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, V1 = "DD MMM YYYY @ HH:mm", A8 = "_list_2c4dq_1", L8 = "_listItem_2c4dq_4", V8 = "_copyIcon_2c4dq_12", qi = {
  list: A8,
  listItem: L8,
  copyIcon: V8
}, Ah = ({
  address: e,
  icon: n,
  title: t,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = Ph(), l = 14, {
    first_name: u,
    last_name: m,
    address1: d,
    address2: f,
    city: h,
    zip: y,
    country_code: x
  } = e ?? {}, S = `${u} ${m}`.trim() || void 0, j = `${h} ${y}`.trim() || void 0, w = [S, d, f, j, x].filter(
    Boolean
  );
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(me, { size: l, name: n }),
      i ? /* @__PURE__ */ Fe.jsx(dn, { size: l }) : /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
        t && /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: t }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: w.map((v, q) => /* @__PURE__ */ Fe.jsx(Qn, { children: v }, q)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Fe.jsx(Qe, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Fe.jsx(
        me,
        {
          size: l,
          name: "exclamation",
          className: qi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Qe, { content: `Copy ${t ? t.toLowerCase() : "address"}`, children: /* @__PURE__ */ Fe.jsx(
        me,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(w.join(", ")),
          className: qi.copyIcon
        }
      ) })
    ] })
  ] });
}, z8 = "_wrapper_1nher_1", M8 = {
  wrapper: z8
}, U8 = ({
  customer: e,
  store: n
}) => {
  const { track: t } = gn(), { isCopied: i, copy: a } = Ph(), { isCopied: o, copy: s } = Ph(), { useQuery: l } = mn(), [u, m] = oe(!1), [d, f] = oe(), h = e?.id, { loading: y, error: x } = l(R8, {
    skip: !h,
    variables: {
      customerId: h?.toString()
    },
    onCompleted(Q) {
      const ee = Q?.Recharge?.getAddresses;
      ee?.addresses && ee?.addresses.length > 0 && !y ? (f(ee.addresses[0]), t("recharge:profile:received"), ee.addresses.length > 1 ? m(!0) : m(!1)) : f(void 0);
    }
  });
  if (x)
    return /* @__PURE__ */ Fe.jsx(wn, { error: x });
  if (!e)
    return null;
  const {
    id: S,
    phone: j,
    email: w,
    first_name: v,
    last_name: q,
    created_at: T,
    has_valid_payment_method: I
  } = e, O = 14, U = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${S}` : null, Z = `${v || ""} ${q || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: M8.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-2", children: Z }),
    T && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: Dn(T).format(V1) })
    ] }),
    w && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(me, { size: O, name: "mail" }),
        /* @__PURE__ */ Fe.jsx(A.ExternalLink, { href: `mailto:${w}`, children: w })
      ] }),
      /* @__PURE__ */ Fe.jsx(Qe, { content: "Copy email", children: /* @__PURE__ */ Fe.jsx(
        me,
        {
          size: O,
          name: i ? "done" : "copy",
          onClick: () => a(w),
          className: qi.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(me, { size: O, name: "phone" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: j })
      ] }),
      /* @__PURE__ */ Fe.jsx(Qe, { content: "Copy phone number", children: /* @__PURE__ */ Fe.jsx(
        me,
        {
          size: O,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: qi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Fe.jsx(
      Ah,
      {
        address: d,
        icon: "home",
        isLoading: y,
        hasMultipleAddresses: u
      }
    ),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(me, { size: O, name: "credit-card" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Fe.jsx(
        me,
        {
          size: O,
          name: I ? "check-circle" : "close-circle-filled",
          color: I ? "green.500" : "red.500"
        }
      )
    ] }),
    U && /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Fe.jsx(me, { size: O, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        A.ExternalLink,
        {
          href: U,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => t("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, B8 = "_order_1dlaa_1", q8 = "_orderIsOpen_1dlaa_9", H8 = "_orderHeader_1dlaa_12", W8 = "_note_1dlaa_16", fl = {
  order: B8,
  orderIsOpen: q8,
  orderHeader: H8,
  note: W8
}, K8 = ({
  order: e,
  isOpenByDefault: n,
  store: t
}) => {
  const { track: i } = gn(), [a, o] = oe(n), {
    id: s,
    status: l,
    charge: u,
    currency: m,
    note: d,
    created_at: f,
    billing_address: h,
    shipping_address: y,
    total_price: x,
    is_prepaid: S
  } = e, j = 14, w = t ? `https://${t.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, v = u?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Fe.jsxs(
    b,
    {
      className: ut(fl.order, {
        [fl.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Fe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: fl.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Fe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: Dn(f).format(V1) }) }),
                /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Fe.jsx(
                tr,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          d && /* @__PURE__ */ Fe.jsx(Qe, { content: "Note", children: /* @__PURE__ */ Fe.jsx(
            A.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: fl.note,
              children: d
            }
          ) }),
          l && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(me, { size: j, name: "activity" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: P8(l) })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(me, { size: j, name: "credit-card" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: S ? "Yes" : "No" })
            ] })
          ] }),
          v && /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(me, { size: j, name: "cog" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: v })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Fe.jsx(me, { size: j, name: "chart-bar" }),
            /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Fe.jsxs(A.Paragraph, { variant: "4", children: [
                x,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Fe.jsx(
            Ah,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Fe.jsx(
            Ah,
            {
              address: y,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          w && /* @__PURE__ */ Fe.jsx(
            Tt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(w, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Fe.jsx(me, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, G8 = ({
  customerId: e,
  store: n
}) => {
  const { track: t } = gn(), { useQuery: i } = mn(), [a, o] = oe([]), { loading: s, error: l } = i(D8, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    },
    onCompleted(m) {
      const d = m?.Recharge?.getOrders;
      d?.orders && d?.orders.length > 0 && !s ? o(d.orders) : o([]);
    }
  });
  if (!e)
    return null;
  if (l)
    return /* @__PURE__ */ Fe.jsx(wn, { error: l });
  const u = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !s && /* @__PURE__ */ Fe.jsx(Mn, { variant: "success", size: "small", children: a.length })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
      s && /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(dn, {}) }),
      !s && a.length === 0 && /* @__PURE__ */ Fe.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Fe.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !s && a.length > 0 && /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: a.map((m, d) => /* @__PURE__ */ Fe.jsx(
        K8,
        {
          order: m,
          isOpenByDefault: d === 0,
          store: n
        },
        `${d}-${m.id}`
      )) }),
      u && /* @__PURE__ */ Fe.jsx(
        Tt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(u, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Fe.jsx(me, { name: "external-link" }),
          onClick: () => t("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, Y8 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: t
  } = e, i = t ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Fe.jsxs(He, { className: qi.list, children: [
      /* @__PURE__ */ Fe.jsx(He.Text, { variant: "dense", className: qi.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Fe.jsx(He.Text, { variant: "dense", className: qi.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Fe.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, J8 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: t } = mn(), [i, a] = oe(), [o, s] = oe(), l = e?.customer?.email, u = n.displayCustomerDetails ?? !1, m = n.displaysubscriptionOverview ?? !1, d = n.displayOrders ?? !1, f = !u && !m && !d, { loading: h, error: y } = t(O8, {
    skip: !l,
    variables: {
      email: l
    },
    onCompleted(x) {
      const S = x?.Recharge?.getCustomers, j = x?.Recharge?.getStore;
      S?.customers && S?.customers?.length > 0 && !h ? a(S.customers[0]) : a(void 0), j?.store && !h ? s(j.store) : s(void 0);
    }
  });
  return y ? Hh({ errors: y.graphQLErrors }) ? /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      "data-testid": "widget-downstream-api-forbidden-error",
      children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
    }
  ) : Wh({ errors: y.graphQLErrors }) ? /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      "data-testid": "widget-downstream-api-authorization-error",
      children: "The integration could not authorize against Recharge. Please contact your administrator."
    }
  ) : /* @__PURE__ */ Fe.jsx(wn, { error: y }) : h ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Fe.jsx(dn, {}) }) : i ? f ? /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Fe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        u && /* @__PURE__ */ Fe.jsx(U8, { customer: i, store: o }),
        m && /* @__PURE__ */ Fe.jsx(Y8, { customer: i }),
        d && /* @__PURE__ */ Fe.jsx(G8, { customerId: i.id, store: o })
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, Q8 = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
var hl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function z1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bd = { exports: {} }, jo = {}, sx;
function X8() {
  if (sx) return jo;
  sx = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return jo.Fragment = t, jo.jsx = s, jo.jsxs = s, jo;
}
var vl = {}, lx;
function Z8() {
  return lx || (lx = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    vl.Fragment = i, vl.jsx = Bn, vl.jsxs = qn;
  }()), vl;
}
var cx;
function eY() {
  return cx || (cx = 1, process.env.NODE_ENV === "production" ? Bd.exports = X8() : Bd.exports = Z8()), Bd.exports;
}
var Hi = eY();
function nY(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var qd, ux;
function Ii() {
  if (ux) return qd;
  ux = 1;
  var e = Array.isArray;
  return qd = e, qd;
}
var Hd, dx;
function M1() {
  if (dx) return Hd;
  dx = 1;
  var e = typeof hl == "object" && hl && hl.Object === Object && hl;
  return Hd = e, Hd;
}
var Wd, mx;
function ri() {
  if (mx) return Wd;
  mx = 1;
  var e = M1(), n = typeof self == "object" && self && self.Object === Object && self, t = e || n || Function("return this")();
  return Wd = t, Wd;
}
var Kd, px;
function $s() {
  if (px) return Kd;
  px = 1;
  var e = ri(), n = e.Symbol;
  return Kd = n, Kd;
}
var Gd, fx;
function tY() {
  if (fx) return Gd;
  fx = 1;
  var e = $s(), n = Object.prototype, t = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = t.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var d = i.call(s);
    return m && (l ? s[a] = u : delete s[a]), d;
  }
  return Gd = o, Gd;
}
var Yd, hx;
function rY() {
  if (hx) return Yd;
  hx = 1;
  var e = Object.prototype, n = e.toString;
  function t(i) {
    return n.call(i);
  }
  return Yd = t, Yd;
}
var Jd, vx;
function Ka() {
  if (vx) return Jd;
  vx = 1;
  var e = $s(), n = tY(), t = rY(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : t(l);
  }
  return Jd = s, Jd;
}
var Qd, yx;
function Zi() {
  if (yx) return Qd;
  yx = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Qd = e, Qd;
}
var Xd, gx;
function ly() {
  if (gx) return Xd;
  gx = 1;
  var e = Ka(), n = Zi(), t = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == t;
  }
  return Xd = i, Xd;
}
var Zd, kx;
function iY() {
  if (kx) return Zd;
  kx = 1;
  var e = Ii(), n = ly(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !t.test(o) || s != null && o in Object(s);
  }
  return Zd = a, Zd;
}
var em, bx;
function Ga() {
  if (bx) return em;
  bx = 1;
  function e(n) {
    var t = typeof n;
    return n != null && (t == "object" || t == "function");
  }
  return em = e, em;
}
var nm, _x;
function U1() {
  if (_x) return nm;
  _x = 1;
  var e = Ka(), n = Ga(), t = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var u = e(l);
    return u == i || u == a || u == t || u == o;
  }
  return nm = s, nm;
}
var tm, xx;
function aY() {
  if (xx) return tm;
  xx = 1;
  var e = ri(), n = e["__core-js_shared__"];
  return tm = n, tm;
}
var rm, Sx;
function oY() {
  if (Sx) return rm;
  Sx = 1;
  var e = aY(), n = function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  }();
  function t(i) {
    return !!n && n in i;
  }
  return rm = t, rm;
}
var im, Nx;
function B1() {
  if (Nx) return im;
  Nx = 1;
  var e = Function.prototype, n = e.toString;
  function t(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return im = t, im;
}
var am, jx;
function sY() {
  if (jx) return am;
  jx = 1;
  var e = U1(), n = oY(), t = Ga(), i = B1(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, u = s.toString, m = l.hasOwnProperty, d = RegExp(
    "^" + u.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!t(h) || n(h))
      return !1;
    var y = e(h) ? d : o;
    return y.test(i(h));
  }
  return am = f, am;
}
var om, wx;
function lY() {
  if (wx) return om;
  wx = 1;
  function e(n, t) {
    return n?.[t];
  }
  return om = e, om;
}
var sm, Cx;
function ea() {
  if (Cx) return sm;
  Cx = 1;
  var e = sY(), n = lY();
  function t(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return sm = t, sm;
}
var lm, Fx;
function nu() {
  if (Fx) return lm;
  Fx = 1;
  var e = ea(), n = e(Object, "create");
  return lm = n, lm;
}
var cm, Ix;
function cY() {
  if (Ix) return cm;
  Ix = 1;
  var e = nu();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return cm = n, cm;
}
var um, $x;
function uY() {
  if ($x) return um;
  $x = 1;
  function e(n) {
    var t = this.has(n) && delete this.__data__[n];
    return this.size -= t ? 1 : 0, t;
  }
  return um = e, um;
}
var dm, Ex;
function dY() {
  if (Ex) return dm;
  Ex = 1;
  var e = nu(), n = "__lodash_hash_undefined__", t = Object.prototype, i = t.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return dm = a, dm;
}
var mm, Tx;
function mY() {
  if (Tx) return mm;
  Tx = 1;
  var e = nu(), n = Object.prototype, t = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : t.call(o, a);
  }
  return mm = i, mm;
}
var pm, Ox;
function pY() {
  if (Ox) return pm;
  Ox = 1;
  var e = nu(), n = "__lodash_hash_undefined__";
  function t(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return pm = t, pm;
}
var fm, Rx;
function fY() {
  if (Rx) return fm;
  Rx = 1;
  var e = cY(), n = uY(), t = dY(), i = mY(), a = pY();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = t, o.prototype.has = i, o.prototype.set = a, fm = o, fm;
}
var hm, Dx;
function hY() {
  if (Dx) return hm;
  Dx = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return hm = e, hm;
}
var vm, Px;
function q1() {
  if (Px) return vm;
  Px = 1;
  function e(n, t) {
    return n === t || n !== n && t !== t;
  }
  return vm = e, vm;
}
var ym, Ax;
function tu() {
  if (Ax) return ym;
  Ax = 1;
  var e = q1();
  function n(t, i) {
    for (var a = t.length; a--; )
      if (e(t[a][0], i))
        return a;
    return -1;
  }
  return ym = n, ym;
}
var gm, Lx;
function vY() {
  if (Lx) return gm;
  Lx = 1;
  var e = tu(), n = Array.prototype, t = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : t.call(o, s, 1), --this.size, !0;
  }
  return gm = i, gm;
}
var km, Vx;
function yY() {
  if (Vx) return km;
  Vx = 1;
  var e = tu();
  function n(t) {
    var i = this.__data__, a = e(i, t);
    return a < 0 ? void 0 : i[a][1];
  }
  return km = n, km;
}
var bm, zx;
function gY() {
  if (zx) return bm;
  zx = 1;
  var e = tu();
  function n(t) {
    return e(this.__data__, t) > -1;
  }
  return bm = n, bm;
}
var _m, Mx;
function kY() {
  if (Mx) return _m;
  Mx = 1;
  var e = tu();
  function n(t, i) {
    var a = this.__data__, o = e(a, t);
    return o < 0 ? (++this.size, a.push([t, i])) : a[o][1] = i, this;
  }
  return _m = n, _m;
}
var xm, Ux;
function ru() {
  if (Ux) return xm;
  Ux = 1;
  var e = hY(), n = vY(), t = yY(), i = gY(), a = kY();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = t, o.prototype.has = i, o.prototype.set = a, xm = o, xm;
}
var Sm, Bx;
function cy() {
  if (Bx) return Sm;
  Bx = 1;
  var e = ea(), n = ri(), t = e(n, "Map");
  return Sm = t, Sm;
}
var Nm, qx;
function bY() {
  if (qx) return Nm;
  qx = 1;
  var e = fY(), n = ru(), t = cy();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (t || n)(),
      string: new e()
    };
  }
  return Nm = i, Nm;
}
var jm, Hx;
function _Y() {
  if (Hx) return jm;
  Hx = 1;
  function e(n) {
    var t = typeof n;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
  }
  return jm = e, jm;
}
var wm, Wx;
function iu() {
  if (Wx) return wm;
  Wx = 1;
  var e = _Y();
  function n(t, i) {
    var a = t.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return wm = n, wm;
}
var Cm, Kx;
function xY() {
  if (Kx) return Cm;
  Kx = 1;
  var e = iu();
  function n(t) {
    var i = e(this, t).delete(t);
    return this.size -= i ? 1 : 0, i;
  }
  return Cm = n, Cm;
}
var Fm, Gx;
function SY() {
  if (Gx) return Fm;
  Gx = 1;
  var e = iu();
  function n(t) {
    return e(this, t).get(t);
  }
  return Fm = n, Fm;
}
var Im, Yx;
function NY() {
  if (Yx) return Im;
  Yx = 1;
  var e = iu();
  function n(t) {
    return e(this, t).has(t);
  }
  return Im = n, Im;
}
var $m, Jx;
function jY() {
  if (Jx) return $m;
  Jx = 1;
  var e = iu();
  function n(t, i) {
    var a = e(this, t), o = a.size;
    return a.set(t, i), this.size += a.size == o ? 0 : 1, this;
  }
  return $m = n, $m;
}
var Em, Qx;
function H1() {
  if (Qx) return Em;
  Qx = 1;
  var e = bY(), n = xY(), t = SY(), i = NY(), a = jY();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = t, o.prototype.has = i, o.prototype.set = a, Em = o, Em;
}
var Tm, Xx;
function wY() {
  if (Xx) return Tm;
  Xx = 1;
  var e = H1(), n = "Expected a function";
  function t(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], u = o.cache;
      if (u.has(l))
        return u.get(l);
      var m = i.apply(this, s);
      return o.cache = u.set(l, m) || u, m;
    };
    return o.cache = new (t.Cache || e)(), o;
  }
  return t.Cache = e, Tm = t, Tm;
}
var Om, Zx;
function CY() {
  if (Zx) return Om;
  Zx = 1;
  var e = wY(), n = 500;
  function t(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Om = t, Om;
}
var Rm, eS;
function FY() {
  if (eS) return Rm;
  eS = 1;
  var e = CY(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, u, m) {
      o.push(u ? m.replace(t, "$1") : l || s);
    }), o;
  });
  return Rm = i, Rm;
}
var Dm, nS;
function W1() {
  if (nS) return Dm;
  nS = 1;
  function e(n, t) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = t(n[i], i, n);
    return o;
  }
  return Dm = e, Dm;
}
var Pm, tS;
function IY() {
  if (tS) return Pm;
  tS = 1;
  var e = $s(), n = W1(), t = Ii(), i = ly(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (t(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var u = l + "";
    return u == "0" && 1 / l == -1 / 0 ? "-0" : u;
  }
  return Pm = s, Pm;
}
var Am, rS;
function $Y() {
  if (rS) return Am;
  rS = 1;
  var e = IY();
  function n(t) {
    return t == null ? "" : e(t);
  }
  return Am = n, Am;
}
var Lm, iS;
function Ya() {
  if (iS) return Lm;
  iS = 1;
  var e = Ii(), n = iY(), t = FY(), i = $Y();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : t(i(o));
  }
  return Lm = a, Lm;
}
var Vm, aS;
function au() {
  if (aS) return Vm;
  aS = 1;
  var e = ly();
  function n(t) {
    if (typeof t == "string" || e(t))
      return t;
    var i = t + "";
    return i == "0" && 1 / t == -1 / 0 ? "-0" : i;
  }
  return Vm = n, Vm;
}
var zm, oS;
function K1() {
  if (oS) return zm;
  oS = 1;
  var e = Ya(), n = au();
  function t(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return zm = t, zm;
}
var Mm, sS;
function G1() {
  if (sS) return Mm;
  sS = 1;
  var e = ea(), n = function() {
    try {
      var t = e(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch {
    }
  }();
  return Mm = n, Mm;
}
var Um, lS;
function Y1() {
  if (lS) return Um;
  lS = 1;
  var e = G1();
  function n(t, i, a) {
    i == "__proto__" && e ? e(t, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : t[i] = a;
  }
  return Um = n, Um;
}
var Bm, cS;
function uy() {
  if (cS) return Bm;
  cS = 1;
  var e = Y1(), n = q1(), t = Object.prototype, i = t.hasOwnProperty;
  function a(o, s, l) {
    var u = o[s];
    (!(i.call(o, s) && n(u, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Bm = a, Bm;
}
var qm, uS;
function dy() {
  if (uS) return qm;
  uS = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function t(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return qm = t, qm;
}
var Hm, dS;
function EY() {
  if (dS) return Hm;
  dS = 1;
  var e = uy(), n = Ya(), t = dy(), i = Ga(), a = au();
  function o(s, l, u, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var d = -1, f = l.length, h = f - 1, y = s; y != null && ++d < f; ) {
      var x = a(l[d]), S = u;
      if (x === "__proto__" || x === "constructor" || x === "prototype")
        return s;
      if (d != h) {
        var j = y[x];
        S = m ? m(j, x, y) : void 0, S === void 0 && (S = i(j) ? j : t(l[d + 1]) ? [] : {});
      }
      e(y, x, S), y = y[x];
    }
    return s;
  }
  return Hm = o, Hm;
}
var Wm, mS;
function TY() {
  if (mS) return Wm;
  mS = 1;
  var e = K1(), n = EY(), t = Ya();
  function i(a, o, s) {
    for (var l = -1, u = o.length, m = {}; ++l < u; ) {
      var d = o[l], f = e(a, d);
      s(f, d) && n(m, t(d, a), f);
    }
    return m;
  }
  return Wm = i, Wm;
}
var Km, pS;
function OY() {
  if (pS) return Km;
  pS = 1;
  function e(n, t) {
    return n != null && t in Object(n);
  }
  return Km = e, Km;
}
var Gm, fS;
function RY() {
  if (fS) return Gm;
  fS = 1;
  var e = Ka(), n = Zi(), t = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == t;
  }
  return Gm = i, Gm;
}
var Ym, hS;
function my() {
  if (hS) return Ym;
  hS = 1;
  var e = RY(), n = Zi(), t = Object.prototype, i = t.hasOwnProperty, a = t.propertyIsEnumerable, o = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Ym = o, Ym;
}
var Jm, vS;
function py() {
  if (vS) return Jm;
  vS = 1;
  var e = 9007199254740991;
  function n(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= e;
  }
  return Jm = n, Jm;
}
var Qm, yS;
function DY() {
  if (yS) return Qm;
  yS = 1;
  var e = Ya(), n = my(), t = Ii(), i = dy(), a = py(), o = au();
  function s(l, u, m) {
    u = e(u, l);
    for (var d = -1, f = u.length, h = !1; ++d < f; ) {
      var y = o(u[d]);
      if (!(h = l != null && m(l, y)))
        break;
      l = l[y];
    }
    return h || ++d != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(y, f) && (t(l) || n(l)));
  }
  return Qm = s, Qm;
}
var Xm, gS;
function PY() {
  if (gS) return Xm;
  gS = 1;
  var e = OY(), n = DY();
  function t(i, a) {
    return i != null && n(i, a, e);
  }
  return Xm = t, Xm;
}
var Zm, kS;
function AY() {
  if (kS) return Zm;
  kS = 1;
  var e = TY(), n = PY();
  function t(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Zm = t, Zm;
}
var ep, bS;
function fy() {
  if (bS) return ep;
  bS = 1;
  function e(n, t) {
    for (var i = -1, a = t.length, o = n.length; ++i < a; )
      n[o + i] = t[i];
    return n;
  }
  return ep = e, ep;
}
var np, _S;
function LY() {
  if (_S) return np;
  _S = 1;
  var e = $s(), n = my(), t = Ii(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return t(o) || n(o) || !!(i && o && o[i]);
  }
  return np = a, np;
}
var tp, xS;
function VY() {
  if (xS) return tp;
  xS = 1;
  var e = fy(), n = LY();
  function t(i, a, o, s, l) {
    var u = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++u < m; ) {
      var d = i[u];
      a > 0 && o(d) ? a > 1 ? t(d, a - 1, o, s, l) : e(l, d) : s || (l[l.length] = d);
    }
    return l;
  }
  return tp = t, tp;
}
var rp, SS;
function zY() {
  if (SS) return rp;
  SS = 1;
  var e = VY();
  function n(t) {
    var i = t == null ? 0 : t.length;
    return i ? e(t, 1) : [];
  }
  return rp = n, rp;
}
var ip, NS;
function MY() {
  if (NS) return ip;
  NS = 1;
  function e(n, t, i) {
    switch (i.length) {
      case 0:
        return n.call(t);
      case 1:
        return n.call(t, i[0]);
      case 2:
        return n.call(t, i[0], i[1]);
      case 3:
        return n.call(t, i[0], i[1], i[2]);
    }
    return n.apply(t, i);
  }
  return ip = e, ip;
}
var ap, jS;
function UY() {
  if (jS) return ap;
  jS = 1;
  var e = MY(), n = Math.max;
  function t(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, u = n(s.length - a, 0), m = Array(u); ++l < u; )
        m[l] = s[a + l];
      l = -1;
      for (var d = Array(a + 1); ++l < a; )
        d[l] = s[l];
      return d[a] = o(m), e(i, this, d);
    };
  }
  return ap = t, ap;
}
var op, wS;
function BY() {
  if (wS) return op;
  wS = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return op = e, op;
}
var sp, CS;
function J1() {
  if (CS) return sp;
  CS = 1;
  function e(n) {
    return n;
  }
  return sp = e, sp;
}
var lp, FS;
function qY() {
  if (FS) return lp;
  FS = 1;
  var e = BY(), n = G1(), t = J1(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : t;
  return lp = i, lp;
}
var cp, IS;
function HY() {
  if (IS) return cp;
  IS = 1;
  var e = 800, n = 16, t = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = t(), u = n - (l - s);
      if (s = l, u > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return cp = i, cp;
}
var up, $S;
function WY() {
  if ($S) return up;
  $S = 1;
  var e = qY(), n = HY(), t = n(e);
  return up = t, up;
}
var dp, ES;
function Q1() {
  if (ES) return dp;
  ES = 1;
  var e = zY(), n = UY(), t = WY();
  function i(a) {
    return t(n(a, void 0, e), a + "");
  }
  return dp = i, dp;
}
var mp, TS;
function KY() {
  if (TS) return mp;
  TS = 1;
  var e = AY(), n = Q1(), t = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return mp = t, mp;
}
var GY = KY();
const X1 = /* @__PURE__ */ z1(GY), YY = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function Z1(e) {
  const n = X1(e, YY);
  return {
    controller: Mv(n),
    controllerProps: n
  };
}
const JY = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function eF(e) {
  const { controller: n, controllerProps: t } = Z1(e), i = {
    ...X1(e, JY),
    required: nY(t.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: t.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: t,
    fieldWrapperProps: i
  };
}
var pp, OS;
function QY() {
  if (OS) return pp;
  OS = 1;
  var e = ru();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return pp = n, pp;
}
var fp, RS;
function XY() {
  if (RS) return fp;
  RS = 1;
  function e(n) {
    var t = this.__data__, i = t.delete(n);
    return this.size = t.size, i;
  }
  return fp = e, fp;
}
var hp, DS;
function ZY() {
  if (DS) return hp;
  DS = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return hp = e, hp;
}
var vp, PS;
function eJ() {
  if (PS) return vp;
  PS = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return vp = e, vp;
}
var yp, AS;
function nJ() {
  if (AS) return yp;
  AS = 1;
  var e = ru(), n = cy(), t = H1(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var u = l.__data__;
      if (!n || u.length < i - 1)
        return u.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new t(u);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return yp = a, yp;
}
var gp, LS;
function tJ() {
  if (LS) return gp;
  LS = 1;
  var e = ru(), n = QY(), t = XY(), i = ZY(), a = eJ(), o = nJ();
  function s(l) {
    var u = this.__data__ = new e(l);
    this.size = u.size;
  }
  return s.prototype.clear = n, s.prototype.delete = t, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, gp = s, gp;
}
var kp, VS;
function rJ() {
  if (VS) return kp;
  VS = 1;
  function e(n, t) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && t(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return kp = e, kp;
}
var bp, zS;
function Es() {
  if (zS) return bp;
  zS = 1;
  var e = uy(), n = Y1();
  function t(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var u = -1, m = a.length; ++u < m; ) {
      var d = a[u], f = s ? s(o[d], i[d], d, o, i) : void 0;
      f === void 0 && (f = i[d]), l ? n(o, d, f) : e(o, d, f);
    }
    return o;
  }
  return bp = t, bp;
}
var _p, MS;
function iJ() {
  if (MS) return _p;
  MS = 1;
  function e(n, t) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = t(i);
    return a;
  }
  return _p = e, _p;
}
var Ll = { exports: {} }, xp, US;
function aJ() {
  if (US) return xp;
  US = 1;
  function e() {
    return !1;
  }
  return xp = e, xp;
}
Ll.exports;
var BS;
function nF() {
  return BS || (BS = 1, function(e, n) {
    var t = ri(), i = aJ(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? t.Buffer : void 0, u = l ? l.isBuffer : void 0, m = u || i;
    e.exports = m;
  }(Ll, Ll.exports)), Ll.exports;
}
var Sp, qS;
function oJ() {
  if (qS) return Sp;
  qS = 1;
  var e = Ka(), n = py(), t = Zi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", u = "[object Function]", m = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", y = "[object Set]", x = "[object String]", S = "[object WeakMap]", j = "[object ArrayBuffer]", w = "[object DataView]", v = "[object Float32Array]", q = "[object Float64Array]", T = "[object Int8Array]", I = "[object Int16Array]", O = "[object Int32Array]", U = "[object Uint8Array]", Z = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", ee = "[object Uint32Array]", J = {};
  J[v] = J[q] = J[T] = J[I] = J[O] = J[U] = J[Z] = J[Q] = J[ee] = !0, J[i] = J[a] = J[j] = J[o] = J[w] = J[s] = J[l] = J[u] = J[m] = J[d] = J[f] = J[h] = J[y] = J[x] = J[S] = !1;
  function G(P) {
    return t(P) && n(P.length) && !!J[e(P)];
  }
  return Sp = G, Sp;
}
var Np, HS;
function hy() {
  if (HS) return Np;
  HS = 1;
  function e(n) {
    return function(t) {
      return n(t);
    };
  }
  return Np = e, Np;
}
var Vl = { exports: {} };
Vl.exports;
var WS;
function vy() {
  return WS || (WS = 1, function(e, n) {
    var t = M1(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && t.process, l = function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    }();
    e.exports = l;
  }(Vl, Vl.exports)), Vl.exports;
}
var jp, KS;
function sJ() {
  if (KS) return jp;
  KS = 1;
  var e = oJ(), n = hy(), t = vy(), i = t && t.isTypedArray, a = i ? n(i) : e;
  return jp = a, jp;
}
var wp, GS;
function tF() {
  if (GS) return wp;
  GS = 1;
  var e = iJ(), n = my(), t = Ii(), i = nF(), a = dy(), o = sJ(), s = Object.prototype, l = s.hasOwnProperty;
  function u(m, d) {
    var f = t(m), h = !f && n(m), y = !f && !h && i(m), x = !f && !h && !y && o(m), S = f || h || y || x, j = S ? e(m.length, String) : [], w = j.length;
    for (var v in m)
      (d || l.call(m, v)) && !(S && // Safari 9 has enumerable `arguments.length` in strict mode.
      (v == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      y && (v == "offset" || v == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      x && (v == "buffer" || v == "byteLength" || v == "byteOffset") || // Skip index properties.
      a(v, w))) && j.push(v);
    return j;
  }
  return wp = u, wp;
}
var Cp, YS;
function yy() {
  if (YS) return Cp;
  YS = 1;
  var e = Object.prototype;
  function n(t) {
    var i = t && t.constructor, a = typeof i == "function" && i.prototype || e;
    return t === a;
  }
  return Cp = n, Cp;
}
var Fp, JS;
function rF() {
  if (JS) return Fp;
  JS = 1;
  function e(n, t) {
    return function(i) {
      return n(t(i));
    };
  }
  return Fp = e, Fp;
}
var Ip, QS;
function lJ() {
  if (QS) return Ip;
  QS = 1;
  var e = rF(), n = e(Object.keys, Object);
  return Ip = n, Ip;
}
var $p, XS;
function cJ() {
  if (XS) return $p;
  XS = 1;
  var e = yy(), n = lJ(), t = Object.prototype, i = t.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return $p = a, $p;
}
var Ep, ZS;
function iF() {
  if (ZS) return Ep;
  ZS = 1;
  var e = U1(), n = py();
  function t(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Ep = t, Ep;
}
var Tp, e0;
function gy() {
  if (e0) return Tp;
  e0 = 1;
  var e = tF(), n = cJ(), t = iF();
  function i(a) {
    return t(a) ? e(a) : n(a);
  }
  return Tp = i, Tp;
}
var Op, n0;
function uJ() {
  if (n0) return Op;
  n0 = 1;
  var e = Es(), n = gy();
  function t(i, a) {
    return i && e(a, n(a), i);
  }
  return Op = t, Op;
}
var Rp, t0;
function dJ() {
  if (t0) return Rp;
  t0 = 1;
  function e(n) {
    var t = [];
    if (n != null)
      for (var i in Object(n))
        t.push(i);
    return t;
  }
  return Rp = e, Rp;
}
var Dp, r0;
function mJ() {
  if (r0) return Dp;
  r0 = 1;
  var e = Ga(), n = yy(), t = dJ(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return t(s);
    var l = n(s), u = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || u.push(m);
    return u;
  }
  return Dp = o, Dp;
}
var Pp, i0;
function ky() {
  if (i0) return Pp;
  i0 = 1;
  var e = tF(), n = mJ(), t = iF();
  function i(a) {
    return t(a) ? e(a, !0) : n(a);
  }
  return Pp = i, Pp;
}
var Ap, a0;
function pJ() {
  if (a0) return Ap;
  a0 = 1;
  var e = Es(), n = ky();
  function t(i, a) {
    return i && e(a, n(a), i);
  }
  return Ap = t, Ap;
}
var zl = { exports: {} };
zl.exports;
var o0;
function fJ() {
  return o0 || (o0 = 1, function(e, n) {
    var t = ri(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? t.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function u(m, d) {
      if (d)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = u;
  }(zl, zl.exports)), zl.exports;
}
var Lp, s0;
function hJ() {
  if (s0) return Lp;
  s0 = 1;
  function e(n, t) {
    var i = -1, a = n.length;
    for (t || (t = Array(a)); ++i < a; )
      t[i] = n[i];
    return t;
  }
  return Lp = e, Lp;
}
var Vp, l0;
function vJ() {
  if (l0) return Vp;
  l0 = 1;
  function e(n, t) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      t(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Vp = e, Vp;
}
var zp, c0;
function aF() {
  if (c0) return zp;
  c0 = 1;
  function e() {
    return [];
  }
  return zp = e, zp;
}
var Mp, u0;
function by() {
  if (u0) return Mp;
  u0 = 1;
  var e = vJ(), n = aF(), t = Object.prototype, i = t.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Mp = o, Mp;
}
var Up, d0;
function yJ() {
  if (d0) return Up;
  d0 = 1;
  var e = Es(), n = by();
  function t(i, a) {
    return e(i, n(i), a);
  }
  return Up = t, Up;
}
var Bp, m0;
function _y() {
  if (m0) return Bp;
  m0 = 1;
  var e = rF(), n = e(Object.getPrototypeOf, Object);
  return Bp = n, Bp;
}
var qp, p0;
function oF() {
  if (p0) return qp;
  p0 = 1;
  var e = fy(), n = _y(), t = by(), i = aF(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, t(s)), s = n(s);
    return l;
  } : i;
  return qp = o, qp;
}
var Hp, f0;
function gJ() {
  if (f0) return Hp;
  f0 = 1;
  var e = Es(), n = oF();
  function t(i, a) {
    return e(i, n(i), a);
  }
  return Hp = t, Hp;
}
var Wp, h0;
function sF() {
  if (h0) return Wp;
  h0 = 1;
  var e = fy(), n = Ii();
  function t(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Wp = t, Wp;
}
var Kp, v0;
function kJ() {
  if (v0) return Kp;
  v0 = 1;
  var e = sF(), n = by(), t = gy();
  function i(a) {
    return e(a, t, n);
  }
  return Kp = i, Kp;
}
var Gp, y0;
function lF() {
  if (y0) return Gp;
  y0 = 1;
  var e = sF(), n = oF(), t = ky();
  function i(a) {
    return e(a, t, n);
  }
  return Gp = i, Gp;
}
var Yp, g0;
function bJ() {
  if (g0) return Yp;
  g0 = 1;
  var e = ea(), n = ri(), t = e(n, "DataView");
  return Yp = t, Yp;
}
var Jp, k0;
function _J() {
  if (k0) return Jp;
  k0 = 1;
  var e = ea(), n = ri(), t = e(n, "Promise");
  return Jp = t, Jp;
}
var Qp, b0;
function xJ() {
  if (b0) return Qp;
  b0 = 1;
  var e = ea(), n = ri(), t = e(n, "Set");
  return Qp = t, Qp;
}
var Xp, _0;
function SJ() {
  if (_0) return Xp;
  _0 = 1;
  var e = ea(), n = ri(), t = e(n, "WeakMap");
  return Xp = t, Xp;
}
var Zp, x0;
function xy() {
  if (x0) return Zp;
  x0 = 1;
  var e = bJ(), n = cy(), t = _J(), i = xJ(), a = SJ(), o = Ka(), s = B1(), l = "[object Map]", u = "[object Object]", m = "[object Promise]", d = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", y = s(e), x = s(n), S = s(t), j = s(i), w = s(a), v = o;
  return (e && v(new e(new ArrayBuffer(1))) != h || n && v(new n()) != l || t && v(t.resolve()) != m || i && v(new i()) != d || a && v(new a()) != f) && (v = function(q) {
    var T = o(q), I = T == u ? q.constructor : void 0, O = I ? s(I) : "";
    if (O)
      switch (O) {
        case y:
          return h;
        case x:
          return l;
        case S:
          return m;
        case j:
          return d;
        case w:
          return f;
      }
    return T;
  }), Zp = v, Zp;
}
var ef, S0;
function NJ() {
  if (S0) return ef;
  S0 = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function t(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return ef = t, ef;
}
var nf, N0;
function jJ() {
  if (N0) return nf;
  N0 = 1;
  var e = ri(), n = e.Uint8Array;
  return nf = n, nf;
}
var tf, j0;
function Sy() {
  if (j0) return tf;
  j0 = 1;
  var e = jJ();
  function n(t) {
    var i = new t.constructor(t.byteLength);
    return new e(i).set(new e(t)), i;
  }
  return tf = n, tf;
}
var rf, w0;
function wJ() {
  if (w0) return rf;
  w0 = 1;
  var e = Sy();
  function n(t, i) {
    var a = i ? e(t.buffer) : t.buffer;
    return new t.constructor(a, t.byteOffset, t.byteLength);
  }
  return rf = n, rf;
}
var af, C0;
function CJ() {
  if (C0) return af;
  C0 = 1;
  var e = /\w*$/;
  function n(t) {
    var i = new t.constructor(t.source, e.exec(t));
    return i.lastIndex = t.lastIndex, i;
  }
  return af = n, af;
}
var of, F0;
function FJ() {
  if (F0) return of;
  F0 = 1;
  var e = $s(), n = e ? e.prototype : void 0, t = n ? n.valueOf : void 0;
  function i(a) {
    return t ? Object(t.call(a)) : {};
  }
  return of = i, of;
}
var sf, I0;
function IJ() {
  if (I0) return sf;
  I0 = 1;
  var e = Sy();
  function n(t, i) {
    var a = i ? e(t.buffer) : t.buffer;
    return new t.constructor(a, t.byteOffset, t.length);
  }
  return sf = n, sf;
}
var lf, $0;
function $J() {
  if ($0) return lf;
  $0 = 1;
  var e = Sy(), n = wJ(), t = CJ(), i = FJ(), a = IJ(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", u = "[object Number]", m = "[object RegExp]", d = "[object Set]", f = "[object String]", h = "[object Symbol]", y = "[object ArrayBuffer]", x = "[object DataView]", S = "[object Float32Array]", j = "[object Float64Array]", w = "[object Int8Array]", v = "[object Int16Array]", q = "[object Int32Array]", T = "[object Uint8Array]", I = "[object Uint8ClampedArray]", O = "[object Uint16Array]", U = "[object Uint32Array]";
  function Z(Q, ee, J) {
    var G = Q.constructor;
    switch (ee) {
      case y:
        return e(Q);
      case o:
      case s:
        return new G(+Q);
      case x:
        return n(Q, J);
      case S:
      case j:
      case w:
      case v:
      case q:
      case T:
      case I:
      case O:
      case U:
        return a(Q, J);
      case l:
        return new G();
      case u:
      case f:
        return new G(Q);
      case m:
        return t(Q);
      case d:
        return new G();
      case h:
        return i(Q);
    }
  }
  return lf = Z, lf;
}
var cf, E0;
function EJ() {
  if (E0) return cf;
  E0 = 1;
  var e = Ga(), n = Object.create, t = /* @__PURE__ */ function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  }();
  return cf = t, cf;
}
var uf, T0;
function TJ() {
  if (T0) return uf;
  T0 = 1;
  var e = EJ(), n = _y(), t = yy();
  function i(a) {
    return typeof a.constructor == "function" && !t(a) ? e(n(a)) : {};
  }
  return uf = i, uf;
}
var df, O0;
function OJ() {
  if (O0) return df;
  O0 = 1;
  var e = xy(), n = Zi(), t = "[object Map]";
  function i(a) {
    return n(a) && e(a) == t;
  }
  return df = i, df;
}
var mf, R0;
function RJ() {
  if (R0) return mf;
  R0 = 1;
  var e = OJ(), n = hy(), t = vy(), i = t && t.isMap, a = i ? n(i) : e;
  return mf = a, mf;
}
var pf, D0;
function DJ() {
  if (D0) return pf;
  D0 = 1;
  var e = xy(), n = Zi(), t = "[object Set]";
  function i(a) {
    return n(a) && e(a) == t;
  }
  return pf = i, pf;
}
var ff, P0;
function PJ() {
  if (P0) return ff;
  P0 = 1;
  var e = DJ(), n = hy(), t = vy(), i = t && t.isSet, a = i ? n(i) : e;
  return ff = a, ff;
}
var hf, A0;
function AJ() {
  if (A0) return hf;
  A0 = 1;
  var e = tJ(), n = rJ(), t = uy(), i = uJ(), a = pJ(), o = fJ(), s = hJ(), l = yJ(), u = gJ(), m = kJ(), d = lF(), f = xy(), h = NJ(), y = $J(), x = TJ(), S = Ii(), j = nF(), w = RJ(), v = Ga(), q = PJ(), T = gy(), I = ky(), O = 1, U = 2, Z = 4, Q = "[object Arguments]", ee = "[object Array]", J = "[object Boolean]", G = "[object Date]", P = "[object Error]", K = "[object Function]", ne = "[object GeneratorFunction]", pe = "[object Map]", ye = "[object Number]", ue = "[object Object]", ve = "[object RegExp]", H = "[object Set]", ke = "[object String]", Ce = "[object Symbol]", W = "[object WeakMap]", Be = "[object ArrayBuffer]", Me = "[object DataView]", Pe = "[object Float32Array]", Ue = "[object Float64Array]", Ie = "[object Int8Array]", Le = "[object Int16Array]", Oe = "[object Int32Array]", an = "[object Uint8Array]", Ne = "[object Uint8ClampedArray]", We = "[object Uint16Array]", Ke = "[object Uint32Array]", se = {};
  se[Q] = se[ee] = se[Be] = se[Me] = se[J] = se[G] = se[Pe] = se[Ue] = se[Ie] = se[Le] = se[Oe] = se[pe] = se[ye] = se[ue] = se[ve] = se[H] = se[ke] = se[Ce] = se[an] = se[Ne] = se[We] = se[Ke] = !0, se[P] = se[K] = se[W] = !1;
  function de(je, Ae, Re, nn, F, _) {
    var E, Y = Ae & O, X = Ae & U, D = Ae & Z;
    if (Re && (E = F ? Re(je, nn, F, _) : Re(je)), E !== void 0)
      return E;
    if (!v(je))
      return je;
    var B = S(je);
    if (B) {
      if (E = h(je), !Y)
        return s(je, E);
    } else {
      var ie = f(je), fe = ie == K || ie == ne;
      if (j(je))
        return o(je, Y);
      if (ie == ue || ie == Q || fe && !F) {
        if (E = X || fe ? {} : x(je), !Y)
          return X ? u(je, a(E, je)) : l(je, i(E, je));
      } else {
        if (!se[ie])
          return F ? je : {};
        E = y(je, ie, Y);
      }
    }
    _ || (_ = new e());
    var _e = _.get(je);
    if (_e)
      return _e;
    _.set(je, E), q(je) ? je.forEach(function(tn) {
      E.add(de(tn, Ae, Re, tn, je, _));
    }) : w(je) && je.forEach(function(tn, ln) {
      E.set(ln, de(tn, Ae, Re, ln, je, _));
    });
    var en = D ? X ? d : m : X ? I : T, un = B ? void 0 : en(je);
    return n(un || je, function(tn, ln) {
      un && (ln = tn, tn = je[ln]), t(E, ln, de(tn, Ae, Re, ln, je, _));
    }), E;
  }
  return hf = de, hf;
}
var vf, L0;
function LJ() {
  if (L0) return vf;
  L0 = 1;
  function e(n) {
    var t = n == null ? 0 : n.length;
    return t ? n[t - 1] : void 0;
  }
  return vf = e, vf;
}
var yf, V0;
function VJ() {
  if (V0) return yf;
  V0 = 1;
  function e(n, t, i) {
    var a = -1, o = n.length;
    t < 0 && (t = -t > o ? 0 : o + t), i = i > o ? o : i, i < 0 && (i += o), o = t > i ? 0 : i - t >>> 0, t >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + t];
    return s;
  }
  return yf = e, yf;
}
var gf, z0;
function zJ() {
  if (z0) return gf;
  z0 = 1;
  var e = K1(), n = VJ();
  function t(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return gf = t, gf;
}
var kf, M0;
function MJ() {
  if (M0) return kf;
  M0 = 1;
  var e = Ya(), n = LJ(), t = zJ(), i = au();
  function a(o, s) {
    return s = e(s, o), o = t(o, s), o == null || delete o[i(n(s))];
  }
  return kf = a, kf;
}
var bf, U0;
function UJ() {
  if (U0) return bf;
  U0 = 1;
  var e = Ka(), n = _y(), t = Zi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, u = s.call(Object);
  function m(d) {
    if (!t(d) || e(d) != i)
      return !1;
    var f = n(d);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == u;
  }
  return bf = m, bf;
}
var _f, B0;
function BJ() {
  if (B0) return _f;
  B0 = 1;
  var e = UJ();
  function n(t) {
    return e(t) ? void 0 : t;
  }
  return _f = n, _f;
}
var xf, q0;
function qJ() {
  if (q0) return xf;
  q0 = 1;
  var e = W1(), n = AJ(), t = MJ(), i = Ya(), a = Es(), o = BJ(), s = Q1(), l = lF(), u = 1, m = 2, d = 4, f = s(function(h, y) {
    var x = {};
    if (h == null)
      return x;
    var S = !1;
    y = e(y, function(w) {
      return w = i(w, h), S || (S = w.length > 1), w;
    }), a(h, l(h), x), S && (x = n(x, u | m | d, o));
    for (var j = y.length; j--; )
      t(x, y[j]);
    return x;
  });
  return xf = f, xf;
}
qJ();
const Ar = ({
  children: e,
  ...n
}) => {
  const { controller: t, controllerProps: i, fieldWrapperProps: a } = eF(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...u
  } = t.field;
  return /* @__PURE__ */ Hi.jsx(An, { ...a, children: /* @__PURE__ */ Hi.jsx(
    ki,
    {
      ...n.componentProps,
      ...u,
      multiple: !1,
      value: u.value ? [u.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: An.getStatus(a.meta),
      children: e
    }
  ) });
};
var HJ = J1();
const WJ = /* @__PURE__ */ z1(HJ), Sf = ({
  transformValue: e = WJ,
  label: n,
  helpIcon: t,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = Z1(a);
  return /* @__PURE__ */ Hi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Hi.jsx(
      Bf,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Hi.jsx(pI, { htmlFor: s, helpIcon: t, children: n })
  ] });
}, Xt = (e) => {
  const { controller: n, controllerProps: t, fieldWrapperProps: i } = eF(e);
  return /* @__PURE__ */ Hi.jsx(An, { ...i, children: /* @__PURE__ */ Hi.jsx(
    Pr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: t.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: An.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1dntr_1,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
const KJ = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], GJ = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], H0 = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => JN(e)
  },
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
var Nf = { exports: {} }, wo = {}, W0;
function YJ() {
  if (W0) return wo;
  W0 = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return wo.Fragment = t, wo.jsx = s, wo.jsxs = s, wo;
}
var yl = {}, K0;
function JJ() {
  return K0 || (K0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    yl.Fragment = i, yl.jsx = Bn, yl.jsxs = qn;
  }()), yl;
}
var G0;
function QJ() {
  return G0 || (G0 = 1, process.env.NODE_ENV === "production" ? Nf.exports = YJ() : Nf.exports = JJ()), Nf.exports;
}
var k = QJ(), fa = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(fa || {}), Wi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(Wi || {}), Yr = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Yr || {}), cF = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(cF || {}), Pi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(Pi || {}), Wr = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Wr || {}), Ml = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(Ml || {});
const XJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, ZJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, eQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, nQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, tQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, rQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, iQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, aQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, oQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, sQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, lQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, cQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, uQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, dQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, mQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, pQ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, fQ = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": XJ,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": ZJ,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": eQ,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": nQ,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": tQ,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": rQ,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": iQ,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": aQ,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": oQ,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": sQ,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": lQ,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": cQ,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": uQ,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": dQ,
  "\n  query getProducts($productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": mQ,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": pQ
};
function Nr(e) {
  return fQ[e] ?? {};
}
const hQ = Nr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), vQ = Nr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  image {
                    url
                  }
                  product {
                    id
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), yQ = Nr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), gQ = Nr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Ny = Nr(
  /* GraphQL */
  `
  query getProducts($productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), kQ = Nr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), bQ = Nr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), _Q = Nr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), xQ = Nr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), SQ = Nr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), NQ = Nr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), jQ = Nr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), uF = ji`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, wQ = ji`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, CQ = ({
  conversationContext: e
}) => {
  const { useQuery: n } = mn(), t = e.customer?.email, i = e.customer?.phone_number, a = t ? `email:"${t}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: u,
    data: m,
    refetch: d,
    networkStatus: f
  } = n(hQ, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: u,
    customerData: m,
    refetchCustomer: d,
    customerNetworkStatus: f
  };
}, FQ = () => {
  const { useLazyQuery: e } = mn(), [
    n,
    {
      loading: t,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(vQ);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: t,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function is(e = !1, n) {
  const [t, i] = oe(e);
  return qe(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const IQ = "_list_alvh6_1", $Q = "_listItem_alvh6_4", EQ = "_fullWidth_alvh6_15", TQ = "_boxWrapper_alvh6_19", Ht = {
  list: IQ,
  listItem: $Q,
  fullWidth: EQ,
  boxWrapper: TQ
}, OQ = "_modal_1vkwz_1", RQ = "_disabled_1vkwz_5", jf = {
  modal: OQ,
  disabled: RQ
}, Y0 = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: Wi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: Wi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: Wi.Unknown
  }
], J0 = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Yr.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Yr.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Yr.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Yr.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Yr.Unsubscribed
  }
], DQ = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: t,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = gn(), { useMutation: l, showNotification: u } = mn(), [m, d] = oe(), [f, h] = oe(), [y, x] = pb(!0), [S, j] = pb(!0), w = !!m, v = e.customer?.email, q = e.customer?.phone_number, T = e.customer?.given_name, I = e.customer?.family_name, O = {
    email: v ?? "",
    phone: q ?? "",
    firstName: T ?? "",
    lastName: I ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, U = xr({
    defaultValues: O
  });
  qe(() => {
    f?.forEach((P) => {
      const K = P?.field?.[0];
      K && (U.setError(K, {
        type: "server",
        message: P.message
      }), U.setFocus(K));
    });
  }, [f, U]);
  const [Z, { error: Q, reset: ee }] = l(NQ, {
    onError: (P) => {
      d(P.message), a(!1), u({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (P) => {
      const K = P?.Shopify?.customerCreate?.userErrors || [];
      K.length > 0 ? (h(K), a(!1), u({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), u({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), t(!1));
    }
  }), J = vt(
    (P) => {
      a(!0), d(void 0), Z({
        variables: {
          input: {
            firstName: P.firstName,
            lastName: P.lastName,
            defaultEmailAddress: {
              ...y && { emailAddress: P.email }
            },
            defaultPhoneNumber: {
              ...S && { phoneNumber: P.phone },
              marketingState: P.smsMarketingState,
              marketingOptInLevel: P.smsMarketingOptInLevel
            }
          }
        }
      });
    },
    [Z, a, S, y]
  ), G = () => {
    t(!1), ee(), d(void 0), U.reset(O);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: n, onClose: G, className: jf.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: "Create new customer", onClose: G }),
    /* @__PURE__ */ k.jsx(wt, { children: /* @__PURE__ */ k.jsxs(Gt, { children: [
      /* @__PURE__ */ k.jsx(rn, { span: 3, children: /* @__PURE__ */ k.jsx(
        Xt,
        {
          label: "First name",
          name: "firstName",
          control: U.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(rn, { span: 3, children: /* @__PURE__ */ k.jsx(
        Xt,
        {
          label: "Last name",
          name: "lastName",
          control: U.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
        Xt,
        {
          label: "Email",
          name: "email",
          control: U.control,
          rules: {
            required: y ? "Email is required" : void 0
          },
          componentProps: {
            className: ut({
              [jf.disabled]: !y
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Bf,
                {
                  disabled: !S,
                  name: "hasEmail",
                  value: "email",
                  checked: y,
                  onChange: () => x()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
        Xt,
        {
          label: "Phone",
          name: "phone",
          control: U.control,
          rules: {
            required: S ? "Phone is required" : void 0
          },
          componentProps: {
            className: ut({
              [jf.disabled]: !S
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                Bf,
                {
                  disabled: !y,
                  name: "hasPhone",
                  value: "phone",
                  checked: S,
                  onChange: () => j()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
        Ar,
        {
          control: U.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (P, K) => P === K,
            getItemTitleByValue: (P) => {
              const K = J0.find(
                (ne) => ne.value === P
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: K.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: K.description })
                  ]
                }
              );
            }
          },
          children: J0.map((P) => /* @__PURE__ */ k.jsx(ht.Item, { value: P.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
        Ar,
        {
          control: U.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (P, K) => P === K,
            getItemTitleByValue: (P) => {
              const K = Y0.find(
                (ne) => ne.value === P
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: K.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: K.description })
                  ]
                }
              );
            }
          },
          children: Y0.map((P) => /* @__PURE__ */ k.jsx(ht.Item, { value: P.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      w && /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(me, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Ot,
      {
        confirmProps: {
          disabled: !(U.formState.isValid && U.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
        },
        confirmOnClick: U.handleSubmit(J),
        cancelOnClick: G,
        confirmName: Q ? "Close" : "Save",
        cancelName: Q ? void 0 : "Cancel"
      }
    )
  ] });
}, PQ = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [t, i] = oe(!1), [a, o] = oe(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(me, { size: 14, name: "user-plus", color: "green.500" }),
        className: Ht.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      DQ,
      {
        isOpen: t,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, jy = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, Lh = "DD MMM YYYY @ HH:mm", AQ = "_wrapper_10fld_1", LQ = "_copyIcon_10fld_7", gl = {
  wrapper: AQ,
  copyIcon: LQ
}, VQ = ({
  customer: e,
  shopifyDomain: n,
  refresh: t,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = is(), { isCopied: l, copy: u } = is(), { track: m } = gn();
  if (!e)
    return null;
  const {
    id: d,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: y,
    tags: x = [],
    verifiedEmail: S
  } = e, j = h?.emailAddress, w = y?.phoneNumber, v = jy(d), q = `https://${n}/admin/customers/${v ?? ""}`, T = i && a === yr.refetch, I = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: gl.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: f }),
        T ? /* @__PURE__ */ k.jsx(dn, { size: I }) : /* @__PURE__ */ k.jsx(Qe, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: I,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: d }), t();
            },
            className: gl.copyIcon
          }
        ) })
      ] }),
      j && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(me, { size: I, name: "mail" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `mailto:${j}`, children: j }),
          /* @__PURE__ */ k.jsx(
            Qe,
            {
              content: S ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                me,
                {
                  size: I,
                  color: S ? "green.500" : "red.500",
                  name: S ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(Qe, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: I,
            name: o ? "done" : "copy",
            onClick: () => s(j),
            className: gl.copyIcon
          }
        ) })
      ] }),
      w && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(me, { size: I, name: "phone" }),
          /* @__PURE__ */ k.jsx(A.ExternalLink, { href: `tel:${w}`, children: w })
        ] }),
        /* @__PURE__ */ k.jsx(Qe, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: I,
            name: l ? "done" : "copy",
            onClick: () => u(w),
            className: gl.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(me, { size: I, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          A.ExternalLink,
          {
            href: q,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    x.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: x.map((O) => /* @__PURE__ */ k.jsx(Rn, { children: O }, `${d}-${O}`)) })
    ] })
  ] });
}, zQ = "_creationModal_pbe64_1", MQ = "_detailsModal_pbe64_5", UQ = "_percentageSuffix_pbe64_9", wf = {
  creationModal: zQ,
  detailsModal: MQ,
  percentageSuffix: UQ
}, BQ = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, qQ = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, t = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: cF.All
    },
    ...t && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [t]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, Q0 = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], X0 = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], Z0 = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], HQ = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: t, copy: i } = Dr(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(He, { children: [
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            me,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "2", color: "secondary", children: Dn(e?.startsAt).format(ct) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(An, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      Pr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: t ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, WQ = "shopify-discount-code-form", eN = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, KQ = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: t } = gn(), { useMutation: i, showNotification: a } = mn(), [o, s] = oe(
    []
  ), [l, u] = oe(), m = xr({
    mode: "all",
    defaultValues: eN
  });
  qe(() => {
    o?.forEach((I) => {
      const O = I?.field?.[1];
      O && m.setError(O, {
        type: "server",
        message: I.message
      });
    });
  }, [o, m]);
  const d = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), y = Wn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    x,
    {
      loading: S,
      error: j,
      reset: w
    }
  ] = i(jQ, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (I) => {
      const O = I?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (O && O.length > 0)
        s(O);
      else {
        const U = I?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        U && "codes" in U && u(U), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), t("shopify:discount:code:created"), s([]);
      }
    }
  }), v = () => {
    m.setValue("code", BQ(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, q = (I) => {
    x({
      variables: {
        input: qQ(I)
      }
    });
  }, T = () => {
    m.reset(eN), s([]), w(), u(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: T,
      className: ut({
        [wf.creationModal]: !d,
        [wf.detailsModal]: d
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          jt,
          {
            title: d ? "Discount code details" : "Create new discount code",
            onClose: T
          }
        ),
        /* @__PURE__ */ k.jsxs(wt, { children: [
          d && /* @__PURE__ */ k.jsx(HQ, { codeDiscount: l }),
          !d && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: WQ, onSubmit: m.handleSubmit(q), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              xc,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(Gt, { children: [
              /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
                Xt,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(rn, { span: 3, children: /* @__PURE__ */ k.jsx(
                Ar,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (I, O) => I === O,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (I) => {
                      const O = Q0.find(
                        (U) => U.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: O?.label }) });
                    }
                  },
                  children: Q0.map((I) => /* @__PURE__ */ k.jsx(ht.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(rn, { span: 3, children: /* @__PURE__ */ k.jsx(
                Xt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (I) => {
                      if (I) {
                        if (h === "percentage" && (I < 0 || I > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && I < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: wf.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
                Xt,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: v
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(rn, { span: 3, children: /* @__PURE__ */ k.jsx(
                Ar,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (I, O) => I === O,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (I) => {
                      const O = X0.find(
                        (U) => U.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: O?.label }) });
                    }
                  },
                  children: X0.map((I) => /* @__PURE__ */ k.jsx(ht.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(rn, { span: 3, children: /* @__PURE__ */ k.jsx(
                Xt,
                {
                  name: "minimumRequirementValue",
                  label: y,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (I) => {
                      if (I && f !== "none" && I < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
                Ar,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (I, O) => I === O,
                    getItemTitleByValue: (I) => {
                      const O = Z0.find(
                        (U) => U.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: O?.label }) });
                    }
                  },
                  children: Z0.map((I) => /* @__PURE__ */ k.jsx(ht.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) })
            ] })
          ] }),
          j && /* @__PURE__ */ k.jsx(wn, { error: j })
        ] }),
        /* @__PURE__ */ k.jsx(
          Ot,
          {
            confirmProps: {
              disabled: !d && !(m.formState.isValid && m.formState.isDirty),
              isLoading: S,
              loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
            },
            confirmName: d ? "Close" : "Save",
            confirmOnClick: d ? T : m.handleSubmit(q),
            cancelOnClick: d ? void 0 : T
          }
        )
      ]
    }
  );
}, GQ = ({ code: e }) => {
  const { isCopied: n, copy: t } = is();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(me, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          tr,
          {
            icon: n ? "done" : "copy",
            onClick: () => t(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, YQ = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const t = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: n.title }),
    t && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(He, { children: i.map((a) => /* @__PURE__ */ k.jsx(He.Item, { className: Ht.listItem, children: /* @__PURE__ */ k.jsx(GQ, { code: a.code }, a.id) }, a.id)) })
  ] });
}, JQ = "_modal_11d6e_1", QQ = "_modalBody_11d6e_4", XQ = "_codeContainer_11d6e_9", Cf = {
  modal: JQ,
  modalBody: QQ,
  codeContainer: XQ
}, ZQ = [50, 100, 250], dF = 50, eX = {
  maxNumberOfCodesToDisplay: dF
}, nX = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: t } = mn(), [i, a] = oe(
    dF
  ), [o, s] = oe([]), l = o.length === 0, u = o.length > i, m = xr({
    mode: "all",
    defaultValues: eX
  }), { loading: d, error: f } = t(kQ, {
    variables: {
      first: i
    },
    onCompleted: (y) => {
      const x = y?.Shopify?.codeDiscountNodes?.nodes ?? [];
      x && x.length > 0 && s(x);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: e, onClose: h, className: Cf.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(wt, { className: Cf.modalBody, children: [
      u && /* @__PURE__ */ k.jsx(Gt, { children: /* @__PURE__ */ k.jsx(rn, { span: 3, children: /* @__PURE__ */ k.jsx(
        Ar,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (y) => {
              a(y.selectedValues[0]);
            },
            getItemTitleByValue: (y) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: y }) })
          },
          children: ZQ.map((y) => /* @__PURE__ */ k.jsx(ht.Item, { value: y, children: /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: y }) }, y))
        }
      ) }) }),
      d && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(dn, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !d && l && /* @__PURE__ */ k.jsx(
        Jh,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !d && !f && !l && o.map((y) => /* @__PURE__ */ k.jsx("div", { className: Cf.codeContainer, children: /* @__PURE__ */ k.jsx(YQ, { discountCode: y }) }, y.id))
    ] }),
    /* @__PURE__ */ k.jsx(Ot, { confirmName: "Close", confirmOnClick: h })
  ] });
}, tX = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, t] = oe(!1), [i, a] = oe(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => t(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      nX,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      KQ,
      {
        isOpen: n,
        setIsOpen: t
      }
    )
  ] });
}, rX = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: t } = e, i = (h) => h ? bc(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case fa.Invalid:
      case fa.NotSubscribed:
      case Yr.NotSubscribed:
        return "red.500";
      case fa.Pending:
      case Yr.Pending:
      case fa.Unsubscribed:
      case Yr.Unsubscribed:
        return "orange.500";
      case fa.Subscribed:
      case Yr.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case Wi.SingleOptIn:
      case Wi.ConfirmedOptIn:
        return "green.500";
      case Wi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: u
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: d,
    marketingOptInLevel: f
  } = t ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(me, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(Qe, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Mn, { size: "small", variant: "info", children: Dn(l).format(Lh) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Qe, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Rn, { color: o(u), children: i(u) }) }),
        /* @__PURE__ */ k.jsx(Qe, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Rn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(me, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      d && /* @__PURE__ */ k.jsx(Qe, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(Mn, { size: "small", variant: "info", children: Dn(d).format(Lh) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(Qe, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Rn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(Qe, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Rn, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, iX = ({
  ordersData: e
}) => {
  const n = (t) => t?.fulfillments?.length > 0 ? t.fulfillments[0].trackingInfo : [];
  return e.map(({ node: t }) => ({
    id: t.id,
    name: t.name,
    createdAt: new Date(t.createdAt),
    cancelledAt: t.cancelledAt ? new Date(t.cancelledAt) : void 0,
    status: `${t.displayFulfillmentStatus?.toLowerCase()}, ${t.displayFinancialStatus?.toLowerCase()}${t.cancelledAt ? ", cancelled" : ""}`,
    currentTotalPriceSet: t.currentTotalPriceSet,
    value: t.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: t.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: t.shippingAddress,
    billingAddress: t.billingAddress,
    lineItems: t.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: t.id,
      amount: t.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: t.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: t.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: t.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a || void 0,
          kind: "REFUND",
          orderId: t.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(t),
    tags: t.tags,
    refunds: t.refunds
  }));
}, nN = [
  {
    value: Wr.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Wr.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Wr.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Wr.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Wr.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Wr.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Wr.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], tN = [
  {
    value: Ml.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: Ml.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: Ml.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], kl = (e) => Vh(aX(e)), Vh = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), aX = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: t, ...i } = n;
    return {
      ...i,
      ...t && { countryCode: t }
    };
  }
  return e;
}, Ti = ({
  control: e,
  name: n,
  label: t,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  qt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      vr,
      {
        required: a,
        label: t,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), oX = "_modal_1wlra_1", sX = {
  modal: oX
};
function rN(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const iN = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], aN = "shopify-shiping-address-form", lX = ({
  title: e,
  address: n,
  isOpen: t,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: u
}) => {
  const { useMutation: m, showNotification: d } = mn(), { track: f } = gn(), [h, y] = oe(!1), [x, S] = oe({}), j = !l, [
    w,
    { error: v, reset: q }
  ] = m(bQ, {
    onError: () => {
      y(!1), d({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (J) => {
      y(!1);
      const G = J?.Shopify?.orderUpdate?.userErrors;
      if (G?.length > 0) {
        const P = G.reduce((K, ne) => (K[ne.field[ne.field.length - 1]] = ne.message, K), {});
        S(P);
      } else
        d({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), u(), ee();
    }
  }), T = vt(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: iN.find(
        (J) => J === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: I, handleSubmit: O, formState: U, reset: Z } = xr({
    mode: "all",
    defaultValues: T()
  }), Q = O((J) => {
    if (j) {
      y(!0), o && a && f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: G, ...P } = J, K = { ...P, countryCode: G };
      w({
        variables: {
          input: {
            id: a,
            shippingAddress: K
          }
        }
      });
    } else
      l(J), ee();
  });
  qe(() => {
    t && Z(T());
  }, [t, n, Z, T]);
  const ee = () => {
    Z(T()), S({}), q(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: t,
      onClose: ee,
      className: sX.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx(jt, { title: e, onClose: () => ee() }),
        /* @__PURE__ */ k.jsx(wt, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: aN, onSubmit: Q, children: [
          v && /* @__PURE__ */ k.jsx(wn, { error: v }),
          /* @__PURE__ */ k.jsxs(Gt, { children: [
            /* @__PURE__ */ k.jsx(rn, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                required: !0,
                control: I,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: x
              }
            ) }),
            /* @__PURE__ */ k.jsx(rn, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                required: !0,
                control: I,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: x
              }
            ) }),
            /* @__PURE__ */ k.jsx(rn, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                control: I,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(rn, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                required: !0,
                control: I,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: x
              }
            ) }),
            /* @__PURE__ */ k.jsx(rn, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                control: I,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(rn, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                required: !0,
                control: I,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: x
              }
            ) }),
            /* @__PURE__ */ k.jsx(rn, { span: 3, children: /* @__PURE__ */ k.jsx(
              Ti,
              {
                required: !0,
                control: I,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: x
              }
            ) }),
            /* @__PURE__ */ k.jsx(rn, { span: 6, children: /* @__PURE__ */ k.jsx(
              Ar,
              {
                name: "countryCodeV2",
                control: I,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (J) => J ? rN(J) : ""
                },
                children: iN.filter((J) => s.includes(J)).map((J) => /* @__PURE__ */ k.jsx(ht.Item, { value: J, children: /* @__PURE__ */ k.jsx(A.Paragraph, { children: rN(J) }) }, J))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          Ot,
          {
            confirmProps: {
              disabled: !(U.isValid && U.isDirty),
              type: "submit",
              form: aN,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
            },
            confirmOnClick: () => {
              v && ee();
            },
            cancelOnClick: () => {
              o && a && !v && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ee();
            },
            confirmName: v ? "Close" : "Save",
            cancelName: v ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, cX = "_clickableIcon_33mqm_1", Ff = {
  clickableIcon: cX
}, oN = ({
  formFieldName: e,
  ...n
}) => {
  const t = ti(), { field: i } = Mv({
    control: t.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    zh,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, zh = ({
  labelText: e,
  address: n,
  orderId: t,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: u,
  openByDefault: m = !1
}) => {
  const [d, f] = oe(!1), [h, y] = oe(m), { isCopied: x, copy: S } = is(), { track: j } = gn(), w = 14, v = o && (!!t || !!l), q = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), T = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), I = n?.countryCodeV2 && rI(n.countryCodeV2), O = vt(() => [
    T,
    n?.company,
    n?.address1,
    n?.address2,
    q,
    n?.province,
    I
  ].filter(Boolean).join(`
`), [n, T, q, I]);
  if (!n)
    return null;
  const U = () => {
    i && t && j("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: t
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(me, { size: w, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => y(!h),
              className: Ff.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  me,
                  {
                    size: w,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            T && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: T }),
            n?.company && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.address2 }),
            q && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: q }),
            n?.province && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.province }),
            I && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: I })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        v && /* @__PURE__ */ k.jsx(Qe, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: w,
            name: "pen",
            onClick: () => U(),
            className: Ff.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(Qe, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          me,
          {
            size: w,
            name: x ? "done" : "copy",
            onClick: () => S(O()),
            className: Ff.clickableIcon
          }
        ) })
      ] })
    ] }),
    v && /* @__PURE__ */ k.jsx(
      lX,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: d,
        setIsOpen: f,
        orderId: t,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: u
      }
    )
  ] });
}, wy = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const t = ti(), i = Rl({ control: t.control, name: "lineItems" }), a = Rl({
    control: t.control,
    name: "billingAddress"
  }), o = Rl({
    control: t.control,
    name: "shippingAddress"
  }), s = Wn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = Wn(() => !s || s.length === 0 ? 0 : s.reduce((m, d) => {
    const f = d.priceRangeV2?.minVariantPrice?.amount || 0, h = d.quantity || 0;
    return m + f * h;
  }, 0), [s]), u = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        oN,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        oN,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${u}` })
    ] }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, uX = "_productTableHeader_6h6pl_1", dX = "_productImage_6h6pl_5", Ho = {
  productTableHeader: uX,
  productImage: dX
}, Cy = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, mX = ({
  product: e,
  index: n,
  onRemove: t
}) => {
  const i = ti(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), u = Cy(e);
  return /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      u && /* @__PURE__ */ k.jsx(
        Ta,
        {
          src: u,
          alt: e.title,
          className: Ho.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
      Xt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(tr, { icon: "trash", variant: "secondary", onClick: t }) }) })
  ] });
}, pX = ({
  products: e,
  isLoadingProducts: n
}) => {
  const [t, i] = oe(""), a = ti(), o = Wn(() => {
    if (!t.trim())
      return e;
    const l = t.toLowerCase();
    return e.filter(
      (u) => u.title.toLowerCase().includes(l)
    );
  }, [e, t]), s = !o.length && !n;
  return /* @__PURE__ */ k.jsx(
    Ar,
    {
      noAlert: !0,
      label: "Product selection",
      control: a.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: n ? "Loading products..." : "Select or search products",
        tabIndex: 0,
        getItemTitleByValue: (l) => {
          const u = e.find((m) => m.id === l);
          return u ? /* @__PURE__ */ k.jsx(A.Paragraph, { children: u.title }) : null;
        },
        filter: {
          value: t,
          onChange: (l) => {
            i(l.target.value);
          }
        },
        onToggleDropdown: (l) => {
          !l && t !== "" && i("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        n && /* @__PURE__ */ k.jsx(ht.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(dn, {}) }) }),
        !n && o.map((l) => {
          const u = l.totalInventory <= 0, m = Cy(l);
          return /* @__PURE__ */ k.jsx(
            ht.Item,
            {
              value: l.id,
              isDisabled: u,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  m && /* @__PURE__ */ k.jsx(
                    Ta,
                    {
                      src: m,
                      alt: l.title,
                      className: Ho.productImage
                    }
                  ),
                  t ? /* @__PURE__ */ k.jsx(
                    fI,
                    {
                      text: l.title,
                      highlight: t
                    }
                  ) : /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: l.title })
                ] }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", children: u ? "Out of stock" : `${l.totalInventory} in stock` })
              ] })
            },
            l.id
          );
        }),
        s && /* @__PURE__ */ k.jsx(ht.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          Jh,
          {
            title: "No products found",
            description: t ? "Try changing your search criteria." : "No products available."
          }
        ) })
      ] })
    }
  );
}, Fy = ({
  isAlreadyLoadedProducts: e = !1,
  contextProducts: n = [],
  selectionMode: t = !1,
  hideDeleteButton: i = !1,
  selectedProductIds: a = [],
  onToggleSelect: o,
  onToggleSelectAll: s
}) => {
  const { useQuery: l } = mn(), u = ti(), m = u.watch("lineItems"), d = u.watch("selectedProductId"), f = m && m?.length > 0, h = t && f ? m.every((q) => a.includes(q?.id)) : !1, y = t && f ? m.some(
    (q) => a.includes(q?.id)
  ) && !h : !1, {
    data: x,
    loading: S,
    error: j
  } = l(Ny, {
    skip: e || n.length > 0,
    variables: {
      productCount: 250,
      mediaCount: 1
    }
  }), w = Wn(() => {
    const q = x?.Shopify?.products?.nodes || n;
    return !q || q.length === 0 ? [] : q.filter((T) => !!T).sort((T, I) => T.title.localeCompare(I.title));
  }, [x, n]);
  if (qe(() => {
    if (!d) return;
    const q = w.find(
      (I) => I.id === d
    );
    if (!q) {
      u.setValue("selectedProductId", void 0);
      return;
    }
    const T = m.findIndex(
      (I) => I?.id === q.id
    );
    if (T > -1) {
      const I = u.getValues(`lineItems.${T}.quantity`) || 0, O = [...m];
      O[T] = {
        ...q,
        quantity: I + 1
      }, u.setValue("lineItems", O);
    } else
      u.setValue("lineItems", [
        ...m,
        { ...q, quantity: 1 }
      ]);
    u.setValue("selectedProductId", void 0);
  }, [d, w, u, m]), j)
    return /* @__PURE__ */ k.jsx(wn, { error: j });
  const v = e || S;
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(pX, { products: w, isLoadingProducts: v }),
    !f && !v && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Ht.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          Jh,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    (f || v) && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      Xn,
      {
        hoverable: !0,
        loading: v,
        framed: !1,
        headerWithBackground: !1,
        className: Ho.productTable,
        children: [
          /* @__PURE__ */ k.jsx(Xn.Thead, { className: Ho.productTableHeader, children: /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
            t && /* @__PURE__ */ k.jsx(Xn.Th, { children: /* @__PURE__ */ k.jsx(
              My,
              {
                checked: h,
                indeterminate: y,
                onChange: () => s?.(!h)
              }
            ) }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Total" }),
            !i && /* @__PURE__ */ k.jsx(Xn.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(Xn.Tbody, { children: m?.map((q, T) => {
            if (!t)
              return /* @__PURE__ */ k.jsx(
                mX,
                {
                  product: q,
                  index: T,
                  onRemove: () => {
                    const P = m.filter(
                      (K, ne) => ne !== T
                    );
                    u.setValue("lineItems", P);
                  }
                },
                `${q?.id}-${T}`
              );
            const I = q, O = I.priceRangeV2.minVariantPrice.amount, U = I.priceRangeV2.minVariantPrice.currencyCode, Z = `lineItems.${T}.quantity`, Q = u.watch(Z) || 0, ee = O * Q, J = Cy(I), G = a.includes(I.id);
            return /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
              /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
                My,
                {
                  checked: G,
                  onChange: () => o?.(I.id, !G)
                }
              ) }),
              /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                J && /* @__PURE__ */ k.jsx(
                  Ta,
                  {
                    src: J,
                    alt: I.title,
                    className: Ho.productImage
                  }
                ),
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: I.title })
              ] }) }),
              /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: I.totalInventory }) }),
              /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${O} ${U}` }) }),
              /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
                Xt,
                {
                  noLabel: !0,
                  noAlert: !0,
                  name: Z,
                  control: u.control,
                  componentProps: {
                    type: "number",
                    min: 1,
                    max: I.totalInventory,
                    tabIndex: 0
                  }
                },
                `${Z}-${u.watch(Z)}`
              ) }),
              /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: `${ee} ${U}` }) }),
              !i && /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                tr,
                {
                  icon: "trash",
                  variant: "secondary",
                  onClick: () => {
                    const P = m.filter(
                      (K, ne) => ne !== T
                    );
                    u.setValue("lineItems", P), G && o?.(I.id, !1);
                  }
                }
              ) }) })
            ] }, `${I.id}-${T}`);
          }) })
        ]
      }
    ) })
  ] });
}, mF = () => {
  const e = ti();
  return /* @__PURE__ */ k.jsx(
    Ar,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: e.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const t = nN.find(
            (i) => i.value === n
          );
          return t ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: t.label }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  t.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: nN.map((n) => /* @__PURE__ */ k.jsx(ht.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, pF = () => {
  const e = ti();
  return /* @__PURE__ */ k.jsx(
    Ar,
    {
      label: "Fulfillment Status",
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const t = tN.find(
            (i) => i.value === n
          );
          return t ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: t.label }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              t.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: tN.map((n) => /* @__PURE__ */ k.jsx(ht.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, fX = "_modal_1mprq_1", hX = {
  modal: fX
}, If = "create-shopify-order-form", vX = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: t,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = gn(), [u, m] = oe(!1), [
    d,
    f
  ] = oe(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, y = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Wr.Pending,
    fulfillmentStatus: void 0
  }, [x, S] = oe([]), j = xr({
    mode: "all",
    defaultValues: y
  }), w = j.watch("lineItems").length > 0, v = () => {
    j.reset(y), S([]), i(!1);
  };
  qe(() => {
    x.length > 0 && j.setValue("tags", x, { shouldDirty: !0 });
  }, [x, j]);
  const [q, { error: T }] = o(
    uF,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), v();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), v();
      }
    }
  ), [I, { error: O }] = o(
    wQ,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), v();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), v();
      }
    }
  ), U = (Q) => {
    const ee = Q.lineItems.map((P) => ({
      productId: P.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: P.priceRangeV2.maxVariantPrice.amount,
          currencyCode: P.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: P.quantity
    }));
    m(!0);
    const J = kl(Q?.billingAddress), G = kl(
      Q?.shippingAddress
    );
    q({
      variables: {
        order: {
          lineItems: ee,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: Q.customNote,
          tags: Q.tags,
          financialStatus: Q.financialStatus,
          fulfillmentStatus: Q.fulfillmentStatus,
          shippingAddress: G,
          billingAddress: J
        }
      }
    });
  }, Z = (Q) => {
    const ee = Q.lineItems.map((P) => ({
      title: P.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: P.priceRangeV2.maxVariantPrice.amount,
        currencyCode: P.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: P.quantity
    }));
    f(!0);
    const J = kl(Q?.billingAddress), G = kl(
      Q?.shippingAddress
    );
    I({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: Q.customNote,
          tags: Q.tags,
          lineItems: ee,
          shippingAddress: G,
          billingAddress: J
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: v,
      className: hX.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(jt, { title: "Create new order", onClose: v }),
        /* @__PURE__ */ k.jsxs(wt, { children: [
          /* @__PURE__ */ k.jsx(zv, { ...j, children: /* @__PURE__ */ k.jsx("form", { id: If, children: /* @__PURE__ */ k.jsxs(Gt, { children: [
            /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(Fy, {}) }),
            /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
              qt,
              {
                name: "tags",
                render: ({ fieldState: { error: Q } }) => /* @__PURE__ */ k.jsx(
                  An,
                  {
                    label: "Tags",
                    meta: {
                      error: Q?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ee) => {
                          ee.key === "Enter" && (ee.preventDefault(), ee.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          _c,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: x,
                            onChange: (ee) => {
                              S(ee);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(rn, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(mF, {}),
              /* @__PURE__ */ k.jsx(pF, {}),
              /* @__PURE__ */ k.jsx(
                Xt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(rn, { span: 2, children: /* @__PURE__ */ k.jsx(An, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ht.boxWrapper,
                children: /* @__PURE__ */ k.jsx(wy, {})
              }
            ) }) })
          ] }) }) }),
          (T || O) && /* @__PURE__ */ k.jsx(wn, { error: T || O })
        ] }),
        /* @__PURE__ */ k.jsx(
          Ot,
          {
            confirmProps: {
              type: "submit",
              form: If,
              disabled: !w || u,
              isLoading: u,
              loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: j.handleSubmit(U),
            ...t && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                j.handleSubmit(Z)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: If,
                disabled: !w || d,
                isLoading: d,
                loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, yX = "_modal_al73g_1", gX = {
  modal: yX
}, sN = [
  {
    label: "Customer",
    value: Pi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: Pi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: Pi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: Pi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: Pi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: Pi.Staff,
    description: "Staff made an error."
  }
], kX = ({
  orderId: e,
  isOpen: n,
  orderName: t,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = gn(), { useMutation: u, showNotification: m } = mn(), [d, f] = oe([]), h = d.length > 0, y = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, x = xr({
    defaultValues: y
  }), [S, { error: j, reset: w }] = u(xQ, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (T) => {
      const I = T.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (I.length > 0)
        o(!1), f(I), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const O = T.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, O ? 0 : 4e3), m({
          title: "Success",
          text: `${O ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), v = vt(
    (T) => {
      o(!0), S({
        variables: T
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), q = () => {
    i(!1), w(), f([]), x.reset(y);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: n, onClose: q, className: gX.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: `Cancel order ${t}`, onClose: q }),
    /* @__PURE__ */ k.jsx(wt, { children: /* @__PURE__ */ k.jsxs(Gt, { children: [
      /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
        Ar,
        {
          control: x.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (T, I) => T === I,
            getItemTitleByValue: (T) => {
              if (!T)
                return "";
              const I = sN.find(
                (O) => O.value === T
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: I.label }),
                /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: I.description })
              ] });
            }
          },
          children: sN.map((T) => /* @__PURE__ */ k.jsx(ht.Item, { value: T.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T.label }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: T.description })
          ] }) }, T.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(An, { required: !0, label: "Refund order", children: /* @__PURE__ */ k.jsx(
        Sf,
        {
          control: x.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(An, { required: !0, label: "Restock items", children: /* @__PURE__ */ k.jsx(Sf, { control: x.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(An, { required: !0, label: "Notify the customer", children: /* @__PURE__ */ k.jsx(Sf, { control: x.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
        Xt,
        {
          name: "staffNote",
          label: "Staff note",
          control: x.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: d.map((T) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(me, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: T.code }),
            /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
              "(",
              T.field?.join(","),
              ") ",
              T.message
            ] })
          ]
        },
        T.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      Ot,
      {
        confirmProps: {
          disabled: !(x.formState.isValid && x.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
        },
        confirmOnClick: x.handleSubmit(v),
        cancelOnClick: q,
        confirmName: j ? "Close" : "Cancel order",
        cancelName: j ? void 0 : "Cancel"
      }
    )
  ] });
}, bX = ({
  orderId: e,
  orderName: n,
  refetchOrders: t,
  disabled: i
}) => {
  const [a, o] = oe(!1), [s, l] = oe(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          me,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Ht.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      kX,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: t
      }
    )
  ] });
}, _X = "_modal_1mprq_1", xX = {
  modal: _X
}, SX = ({
  order: e,
  orderName: n,
  isOpen: t,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: u } = mn(), { track: m } = gn(), [d, f] = oe(!1), [h, y] = oe(e?.tags || []), x = "duplicate-shopify-order-form", S = (ee) => ({
    firstName: ee?.firstName,
    lastName: ee?.lastName,
    address1: ee?.address1,
    address2: ee?.address2,
    city: ee?.city,
    provinceCode: ee?.provinceCode,
    zip: ee?.zip,
    countryCode: ee?.countryCodeV2
  }), j = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: S(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: S(e?.shippingAddress),
    financialStatus: Wr.Pending,
    fulfillmentStatus: void 0
  }, w = xr({
    mode: "all",
    defaultValues: j
  }), v = w.watch("lineItems").length > 0, { data: q, loading: T } = u(
    Ny,
    {
      variables: { productCount: 250, mediaCount: 1 }
    }
  ), I = Wn(() => {
    const ee = q?.Shopify?.products?.nodes;
    return !ee || ee.length === 0 ? [] : ee.filter((J) => !!J).sort((J, G) => J.title.localeCompare(G.title));
  }, [q]);
  qe(() => {
    if (!t || !I?.length || w.getValues("lineItems")?.length)
      return;
    const ee = [];
    e?.lineItems?.forEach((J) => {
      const G = I.find(
        (P) => P.id === J.product?.id
      );
      G && ee.push({ ...G, quantity: J.quantity || 1 });
    }), ee.length > 0 && w.setValue("lineItems", ee, { shouldDirty: !0 });
  }, [t, I, e, w]), qe(() => {
    (h.length > 0 || (w.getValues("tags") || []).length > 0) && w.setValue("tags", h, { shouldDirty: !0 });
  }, [h, w]);
  const [O, { error: U }] = s(
    uF,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), Q();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), Q();
      }
    }
  ), Z = (ee) => {
    const J = ee.lineItems.map((G) => ({
      productId: G.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: G.priceRangeV2.maxVariantPrice.amount,
          currencyCode: G.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: G.quantity
    }));
    f(!0), O({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: J,
          note: ee.customNote,
          tags: ee.tags,
          financialStatus: ee.financialStatus,
          fulfillmentStatus: ee.fulfillmentStatus,
          shippingAddress: Vh(ee?.shippingAddress),
          billingAddress: Vh(ee?.billingAddress)
        }
      }
    });
  }, Q = () => {
    w.reset(j), y(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Nt,
    {
      isOpen: t,
      onClose: Q,
      className: xX.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx(jt, { title: `Duplicate order ${n}`, onClose: Q }),
        /* @__PURE__ */ k.jsxs(wt, { children: [
          /* @__PURE__ */ k.jsx(zv, { ...w, children: /* @__PURE__ */ k.jsx("form", { id: x, children: /* @__PURE__ */ k.jsxs(Gt, { children: [
            /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
              Fy,
              {
                isAlreadyLoadedProducts: T,
                contextProducts: I
              }
            ) }),
            /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
              qt,
              {
                name: "tags",
                render: ({ fieldState: { error: ee } }) => /* @__PURE__ */ k.jsx(
                  An,
                  {
                    label: "Tags",
                    meta: {
                      error: ee?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (J) => {
                          J.key === "Enter" && (J.preventDefault(), J.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          _c,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (J) => {
                              y(J);
                            }
                          },
                          `tags-input-${t}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(rn, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(mF, {}),
              /* @__PURE__ */ k.jsx(pF, {}),
              /* @__PURE__ */ k.jsx(
                Xt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(rn, { span: 2, children: /* @__PURE__ */ k.jsx(An, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ht.boxWrapper,
                children: /* @__PURE__ */ k.jsx(wy, {})
              }
            ) }) })
          ] }) }) }),
          U && /* @__PURE__ */ k.jsx(wn, { error: U })
        ] }),
        /* @__PURE__ */ k.jsx(
          Ot,
          {
            confirmProps: {
              type: "submit",
              form: x,
              disabled: !v || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: w.handleSubmit(Z)
          }
        )
      ]
    }
  );
}, NX = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: t = {}
}) => {
  if (!n || n?.length === 0)
    return null;
  const i = Object.values(t).some(
    (a) => a > 0
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ k.jsx(me, { size: 14, name: "shopify", color: "green.500" }),
      /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    i && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(Rn, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(He, { children: n.map(({ id: a, title: o, quantity: s, variantTitle: l, image: u }) => {
      const m = t[a], d = m > 0, f = m > 1 ? `Refunded (${m} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        He.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: s }),
            /* @__PURE__ */ k.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "4", children: [
            o,
            " ",
            l && `(${l})`,
            d && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", color: "red.500", children: f })
          ] }),
          contentRight: u?.url && /* @__PURE__ */ k.jsx(Ta, { src: `${u?.url}&height=48`, alt: o })
        },
        `list-${e}-${a}`
      );
    }) })
  ] });
}, jX = ji`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, wX = "_modal_21e62_1", CX = {
  modal: wX
}, lN = "partial-refund-shopify-order-form", FX = ({
  order: e,
  orderName: n,
  isOpen: t,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = gn(), { useQuery: u } = mn(), [m, d] = oe(!1), [f, h] = oe([]), { data: y, loading: x } = u(
    Ny,
    {
      variables: { productCount: 250, mediaCount: 1 }
    }
  ), S = Wn(() => {
    const U = y?.Shopify?.products?.nodes;
    return !U || U.length === 0 ? [] : U.filter((Z) => !!Z).sort((Z, Q) => Z.title.localeCompare(Q.title));
  }, [y]), j = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, w = xr({
    mode: "all",
    defaultValues: j
  }), v = f.length > 0, [q, { error: T }] = o(
    jX,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), O();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), O();
      }
    }
  );
  qe(() => {
    if (!t || !S?.length || w.getValues("lineItems")?.length)
      return;
    const U = [];
    e?.lineItems?.forEach((Z) => {
      const Q = S.find(
        (ee) => ee.id === Z.product?.id
      );
      Q && U.push({ ...Q, quantity: Z.quantity || 1 });
    }), U.length > 0 && (w.setValue("lineItems", U, { shouldDirty: !0 }), h([]));
  }, [t, S, e, w]);
  const I = (U) => {
    d(!0);
    const Z = (U.lineItems || []).filter(
      (Q) => f.includes(Q.id)
    ).map((Q) => {
      const ee = e?.lineItems?.find(
        (P) => P.product?.id === Q.id
      ), J = ee?.quantity || 0, G = Math.max(
        0,
        Math.min(J, Q.quantity || 0)
      );
      return ee && G > 0 ? { lineItemId: ee.id, quantity: G } : void 0;
    }).filter((Q) => !!Q);
    q({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: Z,
          note: U.customNote || void 0,
          notify: !0
        }
      }
    });
  }, O = () => {
    w.reset(j), d(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: t, onClose: O, className: CX.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: `Refund order ${n}`, onClose: O }),
    /* @__PURE__ */ k.jsxs(wt, { children: [
      /* @__PURE__ */ k.jsx(zv, { ...w, children: /* @__PURE__ */ k.jsx("form", { id: lN, children: /* @__PURE__ */ k.jsxs(Gt, { children: [
        /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
          Fy,
          {
            selectionMode: !0,
            hideDeleteButton: !0,
            isAlreadyLoadedProducts: x,
            contextProducts: S,
            selectedProductIds: f,
            onToggleSelect: (U, Z) => {
              h((Q) => Z ? Array.from(/* @__PURE__ */ new Set([...Q, U])) : Q.filter((ee) => ee !== U));
            },
            onToggleSelectAll: (U) => {
              const Z = (w.getValues("lineItems") || []).map((Q) => Q.id);
              h(U ? Z : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(rn, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          Xt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(rn, { span: 2, children: /* @__PURE__ */ k.jsx(An, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Ht.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              wy,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      T && /* @__PURE__ */ k.jsx(wn, { error: T })
    ] }),
    /* @__PURE__ */ k.jsx(
      Ot,
      {
        confirmProps: {
          type: "submit",
          form: lN,
          disabled: !v || m,
          isLoading: m,
          loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: w.handleSubmit(I)
      }
    )
  ] });
}, IX = ({
  order: e,
  shopifyId: n,
  orderLink: t,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = mn(), { track: l } = gn(), { suggestedRefund: u, currencyCode: m, id: d, name: f } = e, [h] = a(_Q, {
    onError: (S) => {
      setTimeout(() => x(S), 500);
    },
    onCompleted: (S) => {
      const j = S.Shopify?.refundCreate?.userErrors;
      j && j.length > 0 ? x(
        new _I({
          graphQLErrors: j.map((w) => ({
            message: w.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), y = vt(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: d });
    const { amount: S, ...j } = u;
    s({
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(A.Paragraph, { children: [
        "You are about to refund ",
        S,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: d }), h({
          variables: {
            input: j
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: d })
    });
  }, [n, d]), x = vt(
    (S) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(wn, { error: S }),
          /* @__PURE__ */ k.jsx(
            Tt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(t, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [t]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    Kn,
    {
      variant: "secondary",
      onClick: y,
      disabled: u?.refundLineItems?.length === 0,
      slotStart: /* @__PURE__ */ k.jsx(me, { size: 14, name: "undo" }),
      className: Ht.fullWidth,
      children: "Full refund"
    }
  ) });
}, $X = "_modal_al73g_1", EX = {
  modal: $X
}, TX = ({
  orderId: e,
  tags: n,
  isOpen: t,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = gn(), { useMutation: s, showNotification: l } = mn(), [u, m] = oe(n), [d, f] = oe(!1), h = xr({
    defaultValues: {
      tags: n
    }
  });
  qe(() => {
    u && h.setValue("tags", u, { shouldDirty: !0 });
  }, [u]);
  const [y, { error: x, reset: S }] = s(SQ, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), j = vt(
    (v) => {
      f(!0), y({
        variables: {
          input: {
            id: e,
            tags: v.tags
          }
        }
      }).then((q) => {
        h.reset({ tags: q.data.Shopify.orderUpdate.order.tags });
      });
    },
    [e]
  ), w = () => {
    i(!1), S();
  };
  return /* @__PURE__ */ k.jsxs(Nt, { isOpen: t, onClose: w, className: EX.modal, children: [
    /* @__PURE__ */ k.jsx(jt, { title: "Manage tags for order", onClose: w }),
    /* @__PURE__ */ k.jsxs(wt, { children: [
      /* @__PURE__ */ k.jsx(Gt, { children: /* @__PURE__ */ k.jsx(rn, { children: /* @__PURE__ */ k.jsx(
        qt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: v } }) => /* @__PURE__ */ k.jsx(
            An,
            {
              label: "Tags",
              meta: {
                error: v?.message
              },
              children: /* @__PURE__ */ k.jsx(
                _c,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (q) => m(q)
                }
              )
            }
          )
        }
      ) }) }),
      x && /* @__PURE__ */ k.jsx(wn, { error: x })
    ] }),
    /* @__PURE__ */ k.jsx(
      Ot,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: d,
          loadingIndicator: /* @__PURE__ */ k.jsx(dn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(j),
        cancelOnClick: w,
        confirmName: x ? "Close" : "Save",
        cancelName: x ? void 0 : "Cancel"
      }
    )
  ] });
}, OX = "_editIcon_1dntr_1", RX = {
  editIcon: OX
}, DX = ({
  orderId: e,
  tags: n,
  refetchOrders: t
}) => {
  const [i, a] = oe(!1), o = 14, s = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(me, { size: o, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !s && /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            s && n.map((l, u) => /* @__PURE__ */ k.jsx(Mn, { size: "small", variant: "primary", children: l }, u))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsx(b, { gap: "250", flexDirection: "row", children: /* @__PURE__ */ k.jsx(Qe, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
        me,
        {
          size: o,
          name: "pen",
          className: RX.editIcon,
          onClick: () => a(!0)
        }
      ) }) })
    ] }),
    /* @__PURE__ */ k.jsx(
      TX,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: t
      }
    )
  ] });
}, PX = "_icon_cddi1_1", AX = "_link_cddi1_6", cN = {
  icon: PX,
  link: AX
}, LX = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: t } = is(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    He.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        A.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: cN.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(Qe, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        me,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => t(a.toString()),
          className: cN.icon
        }
      ) })
    }
  );
}, VX = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(me, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(He, { children: e.map((n) => /* @__PURE__ */ k.jsx(LX, { trackingInfo: n }, n.number)) })
] }), zX = "_order_135ze_1", MX = "_orderIsOpen_135ze_9", UX = "_orderHeader_135ze_12", $f = {
  order: zX,
  orderIsOpen: MX,
  orderHeader: UX
}, BX = (e) => {
  const n = [];
  return e.refunds.forEach((t) => {
    const i = t.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...t,
      refundLineItems: {
        ...t.refundLineItems,
        edges: i
      }
    });
  }), n;
}, qX = (e) => {
  const n = {}, t = BX(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), t.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, HX = ({
  order: e,
  shopifyId: n,
  openByDefault: t,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: u,
  displayPartialRefundOrder: m,
  refetchOrders: d
}) => {
  const { track: f } = gn(), [h, y] = oe(!1), [x, S] = oe(!1), [j, w] = oe(t), {
    id: v,
    name: q,
    createdAt: T,
    status: I,
    currentTotalPriceSet: O,
    currencyCode: U,
    lineItems: Z,
    billingAddress: Q,
    shippingAddress: ee,
    trackingInfos: J,
    tags: G
  } = e, P = !!ee, K = jy(v), ne = `https://${l}/admin/orders/${K ?? ""}`, pe = O?.shopMoney?.amount ?? 0, ye = I.includes("cancelled"), ue = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: U
  }).format(pe), ve = e?.refunds ? qX(e) : {};
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: ut($f.order, {
        [$f.orderIsOpen]: j
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: $f.orderHeader,
            onClick: () => w(!j),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                T && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: Dn(T).format(Lh) }) }),
                /* @__PURE__ */ k.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order ",
                  q
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                tr,
                {
                  variant: "tertiary",
                  icon: j ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        j && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(me, { size: 14, name: "activity", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: I })
            ] })
          ] }),
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ k.jsx(me, { size: 14, name: "chart-bar", color: "green.500" }),
            /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: ue })
            ] })
          ] }),
          /* @__PURE__ */ k.jsx(
            DX,
            {
              orderId: v,
              tags: G,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            zh,
            {
              openByDefault: !P,
              labelText: "Billing address",
              address: Q,
              shippingCountryCodes: i,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            zh,
            {
              openByDefault: P,
              shopifyId: n,
              orderId: v,
              icon: "map-pin",
              labelText: "Shipping address",
              address: ee,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ k.jsx(
            NX,
            {
              orderId: v,
              lineItems: Z,
              refundedQuantities: ve
            }
          ),
          /* @__PURE__ */ k.jsx(VX, { trackingInfos: J }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              IX,
              {
                order: e,
                shopifyId: n,
                refetchOrders: d,
                orderLink: ne
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => S(!0),
                className: Ht.fullWidth,
                children: "Partial refund"
              }
            ) })
          ] }),
          (u || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            u && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => y(!0),
                className: Ht.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              bX,
              {
                orderId: v,
                orderName: q,
                disabled: ye,
                refetchOrders: d
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            Tt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(ne, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: v
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        h && /* @__PURE__ */ k.jsx(
          SX,
          {
            order: e,
            shopifyId: n,
            orderName: q,
            isOpen: h,
            setIsOpen: y,
            refetchOrders: d
          }
        ),
        x && /* @__PURE__ */ k.jsx(
          FX,
          {
            order: e,
            orderName: q,
            isOpen: x,
            setIsOpen: S,
            refetchOrders: () => {
              d();
            }
          }
        )
      ]
    }
  );
}, WX = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: t,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: u,
  shopifyCustomer: m
}) => {
  const { track: d } = gn(), [f, h] = oe([]), [y, x] = oe(!1), S = jy(m?.id), j = `https://${n}/admin/orders?customer_id=${S ?? ""}`, {
    getCustomerOrders: w,
    isCustomerOrdersLoading: v,
    customerOrdersError: q,
    customerOrders: T,
    refetchCustomerOrders: I
  } = FQ();
  return qe(() => {
    !v && S && w({
      variables: {
        query: `customer_id:${S}`
      }
    });
  }, [S]), qe(() => {
    const O = T?.Shopify?.orders?.edges;
    O && h(iX({ ordersData: O }));
  }, [T]), m ? q ? /* @__PURE__ */ k.jsx(wn, { error: q }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !v && /* @__PURE__ */ k.jsx(Mn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Kn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => x(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      v && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(dn, {}) }),
      !v && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !v && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((O, U) => /* @__PURE__ */ k.jsx(
        HX,
        {
          order: O,
          openByDefault: U === 0,
          shopifyId: m?.id,
          displayRefund: t,
          displayCancel: i,
          enableEditShippingAddress: u,
          customerCountryCodes: e,
          refetchOrders: I,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${U}-${O.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        Tt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(j, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
          onClick: () => d("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      vX,
      {
        isOpen: y,
        setIsOpen: x,
        shopifyCustomer: m,
        refetchCustomerOrders: I,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, KX = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const t = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(t).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(He, { className: Ht.list, children: [
      /* @__PURE__ */ k.jsx(He.Text, { variant: "dense", className: Ht.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(He.Text, { variant: "dense", className: Ht.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, GX = "_segmentName_1dkhk_1", YX = {
  segmentName: GX
}, JX = 100, bl = 10, QX = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: t } = mn(), [i, a] = oe([]), [o, s] = oe(bl), [l, u] = oe(!1), m = Wn(
    () => i.filter((S) => S.isMember).length,
    [i]
  ), { loading: d, error: f } = n(
    yQ,
    {
      skip: !e,
      variables: {
        first: JX
      },
      onCompleted: (S) => {
        const j = S?.Shopify?.segments?.edges;
        if (j && j.length > 0) {
          const w = j.map(({ node: v }) => ({
            ...v,
            isMember: !1
          })).sort((v, q) => v.name.localeCompare(q.name));
          a(w), h({
            variables: {
              customerId: e,
              segmentIds: w.map((v) => v.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: y, error: x }
  ] = t(gQ, {
    onCompleted: (S) => {
      const j = S?.Shopify?.customerSegmentMembership?.memberships;
      if (j && j.length > 0) {
        const w = i.map((v) => {
          const q = j.find(
            (T) => T.segmentId === v.id
          );
          return {
            ...v,
            ...q?.isMember && { isMember: q.isMember }
          };
        }).sort(
          (v, q) => v.isMember === q.isMember ? 0 : v.isMember ? -1 : 1
        );
        a(w);
      }
    }
  });
  return qe(() => {
    s(l ? i.length : bl);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(A.Heading, { variant: "heading-3", children: "Segment membership" }),
      !d && /* @__PURE__ */ k.jsx(Mn, { variant: "success", size: "small", children: m })
    ] }),
    d && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(dn, {}) }),
    !d && i.length === 0 && /* @__PURE__ */ k.jsx(A.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(wn, { error: f }),
    x && /* @__PURE__ */ k.jsx(wn, { error: x }),
    !d && i.length > 0 && /* @__PURE__ */ k.jsxs(He, { className: Ht.list, children: [
      i.slice(0, o).map(({ id: S, name: j, isMember: w }) => /* @__PURE__ */ k.jsx(He.Text, { className: Ht.listItem, children: /* @__PURE__ */ k.jsx(
        Qe,
        {
          content: `${w ? "Member of" : "Not a member of"} ${j}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(A.Paragraph, { variant: "4", className: YX.segmentName, children: j }),
            y && /* @__PURE__ */ k.jsx(dn, { size: 12 }),
            !y && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              me,
              {
                color: w ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, S)),
      i.length > bl && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Kn,
        {
          variant: "secondary",
          onClick: () => u(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - bl} more`
        }
      ) })
    ] })
  ] }) : null;
}, XX = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: t,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = CQ({ conversationContext: e }), [l, u] = oe(), [m, d] = oe(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, y = n.displayCancelOrder ?? !1, x = n.enableEditShippingAddress ?? !1, S = n.displayEmailMarketingConsent ?? !1, j = n.displayOrdersOverview ?? !1, w = n.displaySegmentMembership ?? !1, v = n.displayDiscountCodeCreation ?? !1, q = n.displayDiscountCodes ?? !1, T = n.displayCreateOrder ?? !1, I = n.displayDuplicateOrder ?? !1, O = n.displayCreateDraftOrder ?? !1, U = n.displayPartialRefundOrder ?? !1;
  if (qe(() => {
    const Z = a?.Shopify?.customers?.edges[0]?.node;
    Z && !t ? (d(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), u(Z)) : u(void 0);
  }, [a]), !t && i)
    return /* @__PURE__ */ k.jsx(wn, { error: i, retry: o });
  if (!t && !i && !l) {
    const Z = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(A.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              PQ,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              Tt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Z, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(me, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return t && s !== yr.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(dn, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          VQ,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: t,
            networkStatus: s
          }
        ),
        j && /* @__PURE__ */ k.jsx(
          KX,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        w && /* @__PURE__ */ k.jsx(QX, { shopifyId: l?.id }),
        S && /* @__PURE__ */ k.jsx(rX, { customer: l }),
        q && /* @__PURE__ */ k.jsx(
          tX,
          {
            displayDiscountCodeCreation: v
          }
        ),
        /* @__PURE__ */ k.jsx(
          WX,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: y,
            displayCreateOrder: T,
            displayCreateDraftOrder: O,
            enableEditShippingAddress: x,
            customerCountryCodes: m,
            displayDuplicateOrder: I,
            displayPartialRefundOrder: U
          }
        )
      ]
    }
  );
}, Ft = [];
for (let e = 0; e < 256; ++e)
  Ft.push((e + 256).toString(16).slice(1));
function ZX(e, n = 0) {
  return (Ft[e[n + 0]] + Ft[e[n + 1]] + Ft[e[n + 2]] + Ft[e[n + 3]] + "-" + Ft[e[n + 4]] + Ft[e[n + 5]] + "-" + Ft[e[n + 6]] + Ft[e[n + 7]] + "-" + Ft[e[n + 8]] + Ft[e[n + 9]] + "-" + Ft[e[n + 10]] + Ft[e[n + 11]] + Ft[e[n + 12]] + Ft[e[n + 13]] + Ft[e[n + 14]] + Ft[e[n + 15]]).toLowerCase();
}
let Ef;
const eZ = new Uint8Array(16);
function nZ() {
  if (!Ef) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Ef = crypto.getRandomValues.bind(crypto);
  }
  return Ef(eZ);
}
const tZ = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), uN = { randomUUID: tZ };
function rZ(e, n, t) {
  if (uN.randomUUID && !e)
    return uN.randomUUID();
  e = e || {};
  const i = e.random ?? e.rng?.() ?? nZ();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, ZX(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Tf = { exports: {} }, Co = {}, dN;
function iZ() {
  if (dN) return Co;
  dN = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return Co.Fragment = t, Co.jsx = s, Co.jsxs = s, Co;
}
var _l = {}, mN;
function aZ() {
  return mN || (mN = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    _l.Fragment = i, _l.jsx = Bn, _l.jsxs = qn;
  }()), _l;
}
var pN;
function oZ() {
  return pN || (pN = 1, process.env.NODE_ENV === "production" ? Tf.exports = iZ() : Tf.exports = aZ()), Tf.exports;
}
var M = oZ(), fF = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(fF || {}), Mh = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(Mh || {});
const sZ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, lZ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, cZ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, uZ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, dZ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, mZ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, pZ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, fZ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, hZ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, vZ = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": sZ,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": lZ,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": cZ,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": uZ,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": dZ,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": mZ,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": pZ,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": fZ,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": hZ
};
function hi(e) {
  return vZ[e] ?? {};
}
const yZ = hi(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), gZ = hi(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), kZ = hi(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), bZ = hi(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), _Z = hi(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), xZ = hi(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), SZ = hi(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), NZ = hi(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), jZ = hi(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), wZ = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: t } = gn(), [i, a] = oe(), [o, s] = oe(), [l, u] = oe(), {
    loading: m,
    error: d,
    data: f,
    refetch: h
  } = n(yZ, {
    skip: !e,
    variables: { contactId: e }
  });
  return qe(() => {
    const y = f?.Voyado?.ContactsV_GetContactById;
    !m && y && typeof y == "object" && ("id" in y && t("voyado:profile:received", { hasProfile: !0 }), "attributes" in y && a(y.attributes), "preferences" in y && s(y.preferences), "consents" in y && u(
      y?.consents?.filter(
        (x) => x !== null
      ) || void 0
    )), !m && (!y || typeof y != "object") && t("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Wn(
    () => ({
      isLoading: m,
      error: d,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [d, i, o, l]
  );
};
function Ul(e = !1, n) {
  const [t, i] = oe(e);
  return qe(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const CZ = {
  count: 0,
  items: []
}, FZ = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: t } = gn(), [i, a] = oe(CZ), {
    loading: o,
    error: s,
    data: l
  } = n(bZ, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const u = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, d = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (d?.count ?? 0) + (u?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...u.items ?? [],
          ...d.items ?? []
        ]
      };
      a(f), t("voyado:messages:received", {
        emailsReceived: u.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: d.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, IZ = {
  count: 0,
  totalCount: 0,
  items: []
}, $Z = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), { track: t } = gn(), [i, a] = oe(
    IZ
  ), {
    loading: o,
    error: s,
    data: l
  } = n(_Z, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    const u = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && u) {
      a(
        u
      );
      const { count: m } = u;
      m && t("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, EZ = ({
  conversationContext: e
}) => {
  const { useQuery: n } = mn(), [t, i] = oe(void 0), [a, o] = oe(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: u,
    error: m,
    data: d,
    refetch: f
  } = n(kZ, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return qe(() => {
    const h = d?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [d?.Voyado, u]), {
    isLoading: u,
    contactId: t,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, TZ = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: t } = mn(), [i, a] = oe(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: u
  } = t(gZ, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return qe(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const d = m?.memberlevel;
      a({
        levelName: d?.levelName,
        remainingToUpgrade: d?.remainingToUpgrade,
        basedOnRewardPoints: d?.basedOnRewardPoints,
        levelId: d?.levelId,
        latestChange: d?.latestChange,
        expires: d?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Wn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: u
    }),
    [o, s, i, u]
  );
}, OZ = "_pointer_ls8kj_48", RZ = "_list_ls8kj_53", DZ = "_listItem_ls8kj_63", tt = {
  pointer: OZ,
  list: RZ,
  listItem: DZ
};
var Ts = (e) => e.type === "checkbox", zi = (e) => e instanceof Date, Ut = (e) => e == null;
const hF = (e) => typeof e == "object";
var st = (e) => !Ut(e) && !Array.isArray(e) && hF(e) && !zi(e), vF = (e) => st(e) && e.target ? Ts(e.target) ? e.target.checked : e.target.value : e, PZ = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, yF = (e, n) => e.has(PZ(n)), AZ = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return st(n) && n.hasOwnProperty("isPrototypeOf");
}, Iy = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function $t(e) {
  let n;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Iy && (e instanceof Blob || i)) && (t || st(e)))
    if (n = t ? [] : {}, !t && !AZ(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = $t(e[a]));
  else
    return e;
  return n;
}
var ou = (e) => Array.isArray(e) ? e.filter(Boolean) : [], it = (e) => e === void 0, Ye = (e, n, t) => {
  if (!n || !st(e))
    return t;
  const i = ou(n.split(/[,[\].]+?/)).reduce((a, o) => Ut(a) ? a : a[o], e);
  return it(i) || i === e ? it(e[n]) ? t : e[n] : i;
}, sr = (e) => typeof e == "boolean", $y = (e) => /^\w*$/.test(e), gF = (e) => ou(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, t) => {
  let i = -1;
  const a = $y(n) ? [n] : gF(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = t;
    if (i !== s) {
      const m = e[l];
      u = st(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const dc = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, $r = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, li = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, LZ = Se.createContext(null), Ey = () => Se.useContext(LZ);
var kF = (e, n, t, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== $r.all && (n._proxyFormState[s] = !i || $r.all), t && (t[s] = !0), e[s];
      }
    });
  return a;
};
function VZ(e) {
  const n = Ey(), { control: t = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(t._formState), u = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => t._subscribe({
    name: m.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...t._formState,
        ...d
      });
    }
  }), [t, i, o]), Se.useEffect(() => {
    u.current.isValid && t._setValid(!0);
  }, [t]), Se.useMemo(() => kF(s, t, u.current, !1), [s, t]);
}
var Qr = (e) => typeof e == "string", bF = (e, n, t, i, a) => Qr(e) ? (i && n.watch.add(e), Ye(t, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ye(t, o))) : (i && (n.watchAll = !0), t);
function _F(e) {
  const n = Ey(), { control: t = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), u = Se.useRef(a);
  l.current = i, Se.useEffect(() => t._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(bF(l.current, t._names, f.values || t._formValues, !1, u.current))
  }), [t, o, s]);
  const [m, d] = Se.useState(t._getWatch(i, a));
  return Se.useEffect(() => t._removeUnmounted()), m;
}
function zZ(e) {
  const n = Ey(), { name: t, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = yF(a._names.array, t), l = _F({
    control: a,
    name: t,
    defaultValue: Ye(a._formValues, t, Ye(a._defaultValues, t, e.defaultValue)),
    exact: !0
  }), u = VZ({
    control: a,
    name: t,
    exact: !0
  }), m = Se.useRef(e), d = Se.useRef(a.register(t, {
    ...e.rules,
    value: l,
    ...sr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ye(u.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ye(u.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ye(u.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ye(u.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => Ye(u.errors, t)
    }
  }), [u, t]), h = Se.useCallback((j) => d.current.onChange({
    target: {
      value: vF(j),
      name: t
    },
    type: dc.CHANGE
  }), [t]), y = Se.useCallback(() => d.current.onBlur({
    target: {
      value: Ye(a._formValues, t),
      name: t
    },
    type: dc.BLUR
  }), [t, a._formValues]), x = Se.useCallback((j) => {
    const w = Ye(a._fields, t);
    w && j && (w._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (v) => j.setCustomValidity(v),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, t]), S = Se.useMemo(() => ({
    name: t,
    value: l,
    ...sr(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: y,
    ref: x
  }), [t, i, u.disabled, h, y, x, l]);
  return Se.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(t, {
      ...m.current.rules,
      ...sr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const w = (v, q) => {
      const T = Ye(a._fields, v);
      T && T._f && (T._f.mount = q);
    };
    if (w(t, !0), j) {
      const v = $t(Ye(a._options.defaultValues, t));
      Yn(a._defaultValues, t, v), it(Ye(a._formValues, t)) && Yn(a._formValues, t, v);
    }
    return !s && a.register(t), () => {
      (s ? j && !a._state.action : j) ? a.unregister(t) : w(t, !1);
    };
  }, [t, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, a]), Se.useMemo(() => ({
    field: S,
    formState: u,
    fieldState: f
  }), [S, u, f]);
}
const fN = (e) => e.render(zZ(e));
var MZ = (e, n, t, i, a) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: a || !0
  }
} : {}, Wo = (e) => Array.isArray(e) ? e : [e], hN = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const t of e)
        t.next && t.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((t) => t !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Uh = (e) => Ut(e) || !hF(e);
function _i(e, n) {
  if (Uh(e) || Uh(n))
    return e === n;
  if (zi(e) && zi(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const a of t) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (zi(o) && zi(s) || st(o) && st(s) || Array.isArray(o) && Array.isArray(s) ? !_i(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Vt = (e) => st(e) && !Object.keys(e).length, Ty = (e) => e.type === "file", Er = (e) => typeof e == "function", mc = (e) => {
  if (!Iy)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, xF = (e) => e.type === "select-multiple", Oy = (e) => e.type === "radio", UZ = (e) => Oy(e) || Ts(e), Of = (e) => mc(e) && e.isConnected;
function BZ(e, n) {
  const t = n.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = it(e) ? i++ : e[n[i++]];
  return e;
}
function qZ(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !it(e[n]))
      return !1;
  return !0;
}
function kt(e, n) {
  const t = Array.isArray(n) ? n : $y(n) ? [n] : gF(n), i = t.length === 1 ? e : BZ(e, t), a = t.length - 1, o = t[a];
  return i && delete i[o], a !== 0 && (st(i) && Vt(i) || Array.isArray(i) && qZ(i)) && kt(e, t.slice(0, -1)), e;
}
var SF = (e) => {
  for (const n in e)
    if (Er(e[n]))
      return !0;
  return !1;
};
function pc(e, n = {}) {
  const t = Array.isArray(e);
  if (st(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || st(e[i]) && !SF(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, pc(e[i], n[i])) : Ut(e[i]) || (n[i] = !0);
  return n;
}
function NF(e, n, t) {
  const i = Array.isArray(e);
  if (st(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || st(e[a]) && !SF(e[a]) ? it(n) || Uh(t[a]) ? t[a] = Array.isArray(e[a]) ? pc(e[a], []) : { ...pc(e[a]) } : NF(e[a], Ut(n) ? {} : n[a], t[a]) : t[a] = !_i(e[a], n[a]);
  return t;
}
var Fo = (e, n) => NF(e, n, pc(n));
const vN = {
  value: !1,
  isValid: !1
}, yN = { value: !0, isValid: !0 };
var jF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !it(e[0].attributes.value) ? it(e[0].value) || e[0].value === "" ? yN : { value: e[0].value, isValid: !0 } : yN
    ) : vN;
  }
  return vN;
}, wF = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: i }) => it(e) ? e : n ? e === "" ? NaN : e && +e : t && Qr(e) ? new Date(e) : i ? i(e) : e;
const gN = {
  isValid: !1,
  value: null
};
var CF = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, gN) : gN;
function kN(e) {
  const n = e.ref;
  return Ty(n) ? n.files : Oy(n) ? CF(e.refs).value : xF(n) ? [...n.selectedOptions].map(({ value: t }) => t) : Ts(n) ? jF(e.refs).value : wF(it(n.value) ? e.ref.value : n.value, e);
}
var HZ = (e, n, t, i) => {
  const a = {};
  for (const o of e) {
    const s = Ye(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, fc = (e) => e instanceof RegExp, Io = (e) => it(e) ? e : fc(e) ? e.source : st(e) ? fc(e.value) ? e.value.source : e.value : e, bN = (e) => ({
  isOnSubmit: !e || e === $r.onSubmit,
  isOnBlur: e === $r.onBlur,
  isOnChange: e === $r.onChange,
  isOnAll: e === $r.all,
  isOnTouch: e === $r.onTouched
});
const _N = "AsyncFunction";
var WZ = (e) => !!e && !!e.validate && !!(Er(e.validate) && e.validate.constructor.name === _N || st(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === _N)), KZ = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), xN = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ko = (e, n, t, i) => {
  for (const a of t || Object.keys(e)) {
    const o = Ye(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ko(l, n))
          break;
      } else if (st(l) && Ko(l, n))
        break;
    }
  }
};
function SN(e, n, t) {
  const i = Ye(e, t);
  if (i || $y(t))
    return {
      error: i,
      name: t
    };
  const a = t.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ye(n, o), l = Ye(e, o);
    if (s && !Array.isArray(s) && t !== o)
      return { name: t };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: t
  };
}
var GZ = (e, n, t, i) => {
  t(e);
  const { name: a, ...o } = e;
  return Vt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || $r.all));
}, YZ = (e, n, t) => !e || !n || e === n || Wo(e).some((i) => i && (t ? i === n : i.startsWith(n) || n.startsWith(i))), JZ = (e, n, t, i, a) => a.isOnAll ? !1 : !t && a.isOnTouch ? !(n || e) : (t ? i.isOnBlur : a.isOnBlur) ? !e : (t ? i.isOnChange : a.isOnChange) ? e : !0, QZ = (e, n) => !ou(Ye(e, n)).length && kt(e, n), XZ = (e, n, t) => {
  const i = Wo(Ye(e, t));
  return Yn(i, "root", n[t]), Yn(e, t, i), e;
}, Bl = (e) => Qr(e);
function NN(e, n, t = "validate") {
  if (Bl(e) || Array.isArray(e) && e.every(Bl) || sr(e) && !e)
    return {
      type: t,
      message: Bl(e) ? e : "",
      ref: n
    };
}
var da = (e) => st(e) && !fc(e) ? e : {
  value: e,
  message: ""
}, jN = async (e, n, t, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: m, minLength: d, min: f, max: h, pattern: y, validate: x, name: S, valueAsNumber: j, mount: w } = e._f, v = Ye(t, S);
  if (!w || n.has(S))
    return {};
  const q = l ? l[0] : s, T = (G) => {
    a && q.reportValidity && (q.setCustomValidity(sr(G) ? "" : G || ""), q.reportValidity());
  }, I = {}, O = Oy(s), U = Ts(s), Z = O || U, Q = (j || Ty(s)) && it(s.value) && it(v) || mc(s) && s.value === "" || v === "" || Array.isArray(v) && !v.length, ee = MZ.bind(null, S, i, I), J = (G, P, K, ne = li.maxLength, pe = li.minLength) => {
    const ye = G ? P : K;
    I[S] = {
      type: G ? ne : pe,
      message: ye,
      ref: s,
      ...ee(G ? ne : pe, ye)
    };
  };
  if (o ? !Array.isArray(v) || !v.length : u && (!Z && (Q || Ut(v)) || sr(v) && !v || U && !jF(l).isValid || O && !CF(l).isValid)) {
    const { value: G, message: P } = Bl(u) ? { value: !!u, message: u } : da(u);
    if (G && (I[S] = {
      type: li.required,
      message: P,
      ref: q,
      ...ee(li.required, P)
    }, !i))
      return T(P), I;
  }
  if (!Q && (!Ut(f) || !Ut(h))) {
    let G, P;
    const K = da(h), ne = da(f);
    if (!Ut(v) && !isNaN(v)) {
      const pe = s.valueAsNumber || v && +v;
      Ut(K.value) || (G = pe > K.value), Ut(ne.value) || (P = pe < ne.value);
    } else {
      const pe = s.valueAsDate || new Date(v), ye = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), ue = s.type == "time", ve = s.type == "week";
      Qr(K.value) && v && (G = ue ? ye(v) > ye(K.value) : ve ? v > K.value : pe > new Date(K.value)), Qr(ne.value) && v && (P = ue ? ye(v) < ye(ne.value) : ve ? v < ne.value : pe < new Date(ne.value));
    }
    if ((G || P) && (J(!!G, K.message, ne.message, li.max, li.min), !i))
      return T(I[S].message), I;
  }
  if ((m || d) && !Q && (Qr(v) || o && Array.isArray(v))) {
    const G = da(m), P = da(d), K = !Ut(G.value) && v.length > +G.value, ne = !Ut(P.value) && v.length < +P.value;
    if ((K || ne) && (J(K, G.message, P.message), !i))
      return T(I[S].message), I;
  }
  if (y && !Q && Qr(v)) {
    const { value: G, message: P } = da(y);
    if (fc(G) && !v.match(G) && (I[S] = {
      type: li.pattern,
      message: P,
      ref: s,
      ...ee(li.pattern, P)
    }, !i))
      return T(P), I;
  }
  if (x) {
    if (Er(x)) {
      const G = await x(v, t), P = NN(G, q);
      if (P && (I[S] = {
        ...P,
        ...ee(li.validate, P.message)
      }, !i))
        return T(P.message), I;
    } else if (st(x)) {
      let G = {};
      for (const P in x) {
        if (!Vt(G) && !i)
          break;
        const K = NN(await x[P](v, t), q, P);
        K && (G = {
          ...K,
          ...ee(P, K.message)
        }, T(K.message), i && (I[S] = G));
      }
      if (!Vt(G) && (I[S] = {
        ref: q,
        ...G
      }, !i))
        return I;
    }
  }
  return T(!0), I;
};
const ZZ = {
  mode: $r.onSubmit,
  reValidateMode: $r.onChange,
  shouldFocusError: !0
};
function eee(e = {}) {
  let n = {
    ...ZZ,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Er(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = st(n.defaultValues) || st(n.values) ? $t(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : $t(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, m = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: hN(),
    state: hN()
  }, y = bN(n.mode), x = bN(n.reValidateMode), S = n.criteriaMode === $r.all, j = (F) => (_) => {
    clearTimeout(m), m = setTimeout(F, _);
  }, w = async (F) => {
    if (!n.disabled && (d.isValid || f.isValid || F)) {
      const _ = n.resolver ? Vt((await Q()).errors) : await J(i, !0);
      _ !== t.isValid && h.state.next({
        isValid: _
      });
    }
  }, v = (F, _) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((F || Array.from(l.mount)).forEach((E) => {
      E && (_ ? Yn(t.validatingFields, E, _) : kt(t.validatingFields, E));
    }), h.state.next({
      validatingFields: t.validatingFields,
      isValidating: !Vt(t.validatingFields)
    }));
  }, q = (F, _ = [], E, Y, X = !0, D = !0) => {
    if (Y && E && !n.disabled) {
      if (s.action = !0, D && Array.isArray(Ye(i, F))) {
        const B = E(Ye(i, F), Y.argA, Y.argB);
        X && Yn(i, F, B);
      }
      if (D && Array.isArray(Ye(t.errors, F))) {
        const B = E(Ye(t.errors, F), Y.argA, Y.argB);
        X && Yn(t.errors, F, B), QZ(t.errors, F);
      }
      if ((d.touchedFields || f.touchedFields) && D && Array.isArray(Ye(t.touchedFields, F))) {
        const B = E(Ye(t.touchedFields, F), Y.argA, Y.argB);
        X && Yn(t.touchedFields, F, B);
      }
      (d.dirtyFields || f.dirtyFields) && (t.dirtyFields = Fo(a, o)), h.state.next({
        name: F,
        isDirty: P(F, _),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Yn(o, F, _);
  }, T = (F, _) => {
    Yn(t.errors, F, _), h.state.next({
      errors: t.errors
    });
  }, I = (F) => {
    t.errors = F, h.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, O = (F, _, E, Y) => {
    const X = Ye(i, F);
    if (X) {
      const D = Ye(o, F, it(E) ? Ye(a, F) : E);
      it(D) || Y && Y.defaultChecked || _ ? Yn(o, F, _ ? D : kN(X._f)) : pe(F, D), s.mount && w();
    }
  }, U = (F, _, E, Y, X) => {
    let D = !1, B = !1;
    const ie = {
      name: F
    };
    if (!n.disabled) {
      if (!E || Y) {
        (d.isDirty || f.isDirty) && (B = t.isDirty, t.isDirty = ie.isDirty = P(), D = B !== ie.isDirty);
        const fe = _i(Ye(a, F), _);
        B = !!Ye(t.dirtyFields, F), fe ? kt(t.dirtyFields, F) : Yn(t.dirtyFields, F, !0), ie.dirtyFields = t.dirtyFields, D = D || (d.dirtyFields || f.dirtyFields) && B !== !fe;
      }
      if (E) {
        const fe = Ye(t.touchedFields, F);
        fe || (Yn(t.touchedFields, F, E), ie.touchedFields = t.touchedFields, D = D || (d.touchedFields || f.touchedFields) && fe !== E);
      }
      D && X && h.state.next(ie);
    }
    return D ? ie : {};
  }, Z = (F, _, E, Y) => {
    const X = Ye(t.errors, F), D = (d.isValid || f.isValid) && sr(_) && t.isValid !== _;
    if (n.delayError && E ? (u = j(() => T(F, E)), u(n.delayError)) : (clearTimeout(m), u = null, E ? Yn(t.errors, F, E) : kt(t.errors, F)), (E ? !_i(X, E) : X) || !Vt(Y) || D) {
      const B = {
        ...Y,
        ...D && sr(_) ? { isValid: _ } : {},
        errors: t.errors,
        name: F
      };
      t = {
        ...t,
        ...B
      }, h.state.next(B);
    }
  }, Q = async (F) => {
    v(F, !0);
    const _ = await n.resolver(o, n.context, HZ(F || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return v(F), _;
  }, ee = async (F) => {
    const { errors: _ } = await Q(F);
    if (F)
      for (const E of F) {
        const Y = Ye(_, E);
        Y ? Yn(t.errors, E, Y) : kt(t.errors, E);
      }
    else
      t.errors = _;
    return _;
  }, J = async (F, _, E = {
    valid: !0
  }) => {
    for (const Y in F) {
      const X = F[Y];
      if (X) {
        const { _f: D, ...B } = X;
        if (D) {
          const ie = l.array.has(D.name), fe = X._f && WZ(X._f);
          fe && d.validatingFields && v([Y], !0);
          const _e = await jN(X, l.disabled, o, S, n.shouldUseNativeValidation && !_, ie);
          if (fe && d.validatingFields && v([Y]), _e[D.name] && (E.valid = !1, _))
            break;
          !_ && (Ye(_e, D.name) ? ie ? XZ(t.errors, _e, D.name) : Yn(t.errors, D.name, _e[D.name]) : kt(t.errors, D.name));
        }
        !Vt(B) && await J(B, _, E);
      }
    }
    return E.valid;
  }, G = () => {
    for (const F of l.unMount) {
      const _ = Ye(i, F);
      _ && (_._f.refs ? _._f.refs.every((E) => !Of(E)) : !Of(_._f.ref)) && Le(F);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (F, _) => !n.disabled && (F && _ && Yn(o, F, _), !_i(Ce(), a)), K = (F, _, E) => bF(F, l, {
    ...s.mount ? o : it(_) ? a : Qr(F) ? { [F]: _ } : _
  }, E, _), ne = (F) => ou(Ye(s.mount ? o : a, F, n.shouldUnregister ? Ye(a, F, []) : [])), pe = (F, _, E = {}) => {
    const Y = Ye(i, F);
    let X = _;
    if (Y) {
      const D = Y._f;
      D && (!D.disabled && Yn(o, F, wF(_, D)), X = mc(D.ref) && Ut(_) ? "" : _, xF(D.ref) ? [...D.ref.options].forEach((B) => B.selected = X.includes(B.value)) : D.refs ? Ts(D.ref) ? D.refs.length > 1 ? D.refs.forEach((B) => (!B.defaultChecked || !B.disabled) && (B.checked = Array.isArray(X) ? !!X.find((ie) => ie === B.value) : X === B.value)) : D.refs[0] && (D.refs[0].checked = !!X) : D.refs.forEach((B) => B.checked = B.value === X) : Ty(D.ref) ? D.ref.value = "" : (D.ref.value = X, D.ref.type || h.state.next({
        name: F,
        values: $t(o)
      })));
    }
    (E.shouldDirty || E.shouldTouch) && U(F, X, E.shouldTouch, E.shouldDirty, !0), E.shouldValidate && ke(F);
  }, ye = (F, _, E) => {
    for (const Y in _) {
      const X = _[Y], D = `${F}.${Y}`, B = Ye(i, D);
      (l.array.has(F) || st(X) || B && !B._f) && !zi(X) ? ye(D, X, E) : pe(D, X, E);
    }
  }, ue = (F, _, E = {}) => {
    const Y = Ye(i, F), X = l.array.has(F), D = $t(_);
    Yn(o, F, D), X ? (h.array.next({
      name: F,
      values: $t(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && E.shouldDirty && h.state.next({
      name: F,
      dirtyFields: Fo(a, o),
      isDirty: P(F, D)
    })) : Y && !Y._f && !Ut(D) ? ye(F, D, E) : pe(F, D, E), xN(F, l) && h.state.next({ ...t }), h.state.next({
      name: s.mount ? F : void 0,
      values: $t(o)
    });
  }, ve = async (F) => {
    s.mount = !0;
    const _ = F.target;
    let E = _.name, Y = !0;
    const X = Ye(i, E), D = (B) => {
      Y = Number.isNaN(B) || zi(B) && isNaN(B.getTime()) || _i(B, Ye(o, E, B));
    };
    if (X) {
      let B, ie;
      const fe = _.type ? kN(X._f) : vF(F), _e = F.type === dc.BLUR || F.type === dc.FOCUS_OUT, en = !KZ(X._f) && !n.resolver && !Ye(t.errors, E) && !X._f.deps || JZ(_e, Ye(t.touchedFields, E), t.isSubmitted, x, y), un = xN(E, l, _e);
      Yn(o, E, fe), _e ? (X._f.onBlur && X._f.onBlur(F), u && u(0)) : X._f.onChange && X._f.onChange(F);
      const tn = U(E, fe, _e), ln = !Vt(tn) || un;
      if (!_e && h.state.next({
        name: E,
        type: F.type,
        values: $t(o)
      }), en)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? _e && w() : _e || w()), ln && h.state.next({ name: E, ...un ? {} : tn });
      if (!_e && un && h.state.next({ ...t }), n.resolver) {
        const { errors: fn } = await Q([E]);
        if (D(fe), Y) {
          const pn = SN(t.errors, i, E), vn = SN(fn, i, pn.name || E);
          B = vn.error, E = vn.name, ie = Vt(fn);
        }
      } else
        v([E], !0), B = (await jN(X, l.disabled, o, S, n.shouldUseNativeValidation))[E], v([E]), D(fe), Y && (B ? ie = !1 : (d.isValid || f.isValid) && (ie = await J(i, !0)));
      Y && (X._f.deps && ke(X._f.deps), Z(E, ie, B, tn));
    }
  }, H = (F, _) => {
    if (Ye(t.errors, _) && F.focus)
      return F.focus(), 1;
  }, ke = async (F, _ = {}) => {
    let E, Y;
    const X = Wo(F);
    if (n.resolver) {
      const D = await ee(it(F) ? F : X);
      E = Vt(D), Y = F ? !X.some((B) => Ye(D, B)) : E;
    } else F ? (Y = (await Promise.all(X.map(async (D) => {
      const B = Ye(i, D);
      return await J(B && B._f ? { [D]: B } : B);
    }))).every(Boolean), !(!Y && !t.isValid) && w()) : Y = E = await J(i);
    return h.state.next({
      ...!Qr(F) || (d.isValid || f.isValid) && E !== t.isValid ? {} : { name: F },
      ...n.resolver || !F ? { isValid: E } : {},
      errors: t.errors
    }), _.shouldFocus && !Y && Ko(i, H, F ? X : l.mount), Y;
  }, Ce = (F) => {
    const _ = {
      ...s.mount ? o : a
    };
    return it(F) ? _ : Qr(F) ? Ye(_, F) : F.map((E) => Ye(_, E));
  }, W = (F, _) => ({
    invalid: !!Ye((_ || t).errors, F),
    isDirty: !!Ye((_ || t).dirtyFields, F),
    error: Ye((_ || t).errors, F),
    isValidating: !!Ye(t.validatingFields, F),
    isTouched: !!Ye((_ || t).touchedFields, F)
  }), Be = (F) => {
    F && Wo(F).forEach((_) => kt(t.errors, _)), h.state.next({
      errors: F ? t.errors : {}
    });
  }, Me = (F, _, E) => {
    const Y = (Ye(i, F, { _f: {} })._f || {}).ref, X = Ye(t.errors, F) || {}, { ref: D, message: B, type: ie, ...fe } = X;
    Yn(t.errors, F, {
      ...fe,
      ..._,
      ref: Y
    }), h.state.next({
      name: F,
      errors: t.errors,
      isValid: !1
    }), E && E.shouldFocus && Y && Y.focus && Y.focus();
  }, Pe = (F, _) => Er(F) ? h.state.subscribe({
    next: (E) => F(K(void 0, _), E)
  }) : K(F, _, !0), Ue = (F) => h.state.subscribe({
    next: (_) => {
      YZ(F.name, _.name, F.exact) && GZ(_, F.formState || d, Re, F.reRenderRoot) && F.callback({
        values: { ...o },
        ...t,
        ..._
      });
    }
  }).unsubscribe, Ie = (F) => (s.mount = !0, f = {
    ...f,
    ...F.formState
  }, Ue({
    ...F,
    formState: f
  })), Le = (F, _ = {}) => {
    for (const E of F ? Wo(F) : l.mount)
      l.mount.delete(E), l.array.delete(E), _.keepValue || (kt(i, E), kt(o, E)), !_.keepError && kt(t.errors, E), !_.keepDirty && kt(t.dirtyFields, E), !_.keepTouched && kt(t.touchedFields, E), !_.keepIsValidating && kt(t.validatingFields, E), !n.shouldUnregister && !_.keepDefaultValue && kt(a, E);
    h.state.next({
      values: $t(o)
    }), h.state.next({
      ...t,
      ..._.keepDirty ? { isDirty: P() } : {}
    }), !_.keepIsValid && w();
  }, Oe = ({ disabled: F, name: _ }) => {
    (sr(F) && s.mount || F || l.disabled.has(_)) && (F ? l.disabled.add(_) : l.disabled.delete(_));
  }, an = (F, _ = {}) => {
    let E = Ye(i, F);
    const Y = sr(_.disabled) || sr(n.disabled);
    return Yn(i, F, {
      ...E || {},
      _f: {
        ...E && E._f ? E._f : { ref: { name: F } },
        name: F,
        mount: !0,
        ..._
      }
    }), l.mount.add(F), E ? Oe({
      disabled: sr(_.disabled) ? _.disabled : n.disabled,
      name: F
    }) : O(F, !0, _.value), {
      ...Y ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Io(_.min),
        max: Io(_.max),
        minLength: Io(_.minLength),
        maxLength: Io(_.maxLength),
        pattern: Io(_.pattern)
      } : {},
      name: F,
      onChange: ve,
      onBlur: ve,
      ref: (X) => {
        if (X) {
          an(F, _), E = Ye(i, F);
          const D = it(X.value) && X.querySelectorAll && X.querySelectorAll("input,select,textarea")[0] || X, B = UZ(D), ie = E._f.refs || [];
          if (B ? ie.find((fe) => fe === D) : D === E._f.ref)
            return;
          Yn(i, F, {
            _f: {
              ...E._f,
              ...B ? {
                refs: [
                  ...ie.filter(Of),
                  D,
                  ...Array.isArray(Ye(a, F)) ? [{}] : []
                ],
                ref: { type: D.type, name: F }
              } : { ref: D }
            }
          }), O(F, !1, void 0, D);
        } else
          E = Ye(i, F, {}), E._f && (E._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !(yF(l.array, F) && s.action) && l.unMount.add(F);
      }
    };
  }, Ne = () => n.shouldFocusError && Ko(i, H, l.mount), We = (F) => {
    sr(F) && (h.state.next({ disabled: F }), Ko(i, (_, E) => {
      const Y = Ye(i, E);
      Y && (_.disabled = Y._f.disabled || F, Array.isArray(Y._f.refs) && Y._f.refs.forEach((X) => {
        X.disabled = Y._f.disabled || F;
      }));
    }, 0, !1));
  }, Ke = (F, _) => async (E) => {
    let Y;
    E && (E.preventDefault && E.preventDefault(), E.persist && E.persist());
    let X = $t(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: D, values: B } = await Q();
      t.errors = D, X = B;
    } else
      await J(i);
    if (l.disabled.size)
      for (const D of l.disabled)
        Yn(X, D, void 0);
    if (kt(t.errors, "root"), Vt(t.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await F(X, E);
      } catch (D) {
        Y = D;
      }
    } else
      _ && await _({ ...t.errors }, E), Ne(), setTimeout(Ne);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Vt(t.errors) && !Y,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), Y)
      throw Y;
  }, se = (F, _ = {}) => {
    Ye(i, F) && (it(_.defaultValue) ? ue(F, $t(Ye(a, F))) : (ue(F, _.defaultValue), Yn(a, F, $t(_.defaultValue))), _.keepTouched || kt(t.touchedFields, F), _.keepDirty || (kt(t.dirtyFields, F), t.isDirty = _.defaultValue ? P(F, $t(Ye(a, F))) : P()), _.keepError || (kt(t.errors, F), d.isValid && w()), h.state.next({ ...t }));
  }, de = (F, _ = {}) => {
    const E = F ? $t(F) : a, Y = $t(E), X = Vt(F), D = X ? a : Y;
    if (_.keepDefaultValues || (a = E), !_.keepValues) {
      if (_.keepDirtyValues) {
        const B = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Fo(a, o))
        ]);
        for (const ie of Array.from(B))
          Ye(t.dirtyFields, ie) ? Yn(D, ie, Ye(o, ie)) : ue(ie, Ye(D, ie));
      } else {
        if (Iy && it(F))
          for (const B of l.mount) {
            const ie = Ye(i, B);
            if (ie && ie._f) {
              const fe = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (mc(fe)) {
                const _e = fe.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const B of l.mount)
          ue(B, Ye(D, B));
      }
      o = $t(D), h.array.next({
        values: { ...D }
      }), h.state.next({
        values: { ...D }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? t.submitCount : 0,
      isDirty: X ? !1 : _.keepDirty ? t.isDirty : !!(_.keepDefaultValues && !_i(F, a)),
      isSubmitted: _.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: X ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? Fo(a, o) : t.dirtyFields : _.keepDefaultValues && F ? Fo(a, F) : _.keepDirty ? t.dirtyFields : {},
      touchedFields: _.keepTouched ? t.touchedFields : {},
      errors: _.keepErrors ? t.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, je = (F, _) => de(Er(F) ? F(o) : F, _), Ae = (F, _ = {}) => {
    const E = Ye(i, F), Y = E && E._f;
    if (Y) {
      const X = Y.refs ? Y.refs[0] : Y.ref;
      X.focus && (X.focus(), _.shouldSelect && Er(X.select) && X.select());
    }
  }, Re = (F) => {
    t = {
      ...t,
      ...F
    };
  }, nn = {
    control: {
      register: an,
      unregister: Le,
      getFieldState: W,
      handleSubmit: Ke,
      setError: Me,
      _subscribe: Ue,
      _runSchema: Q,
      _getWatch: K,
      _getDirty: P,
      _setValid: w,
      _setFieldArray: q,
      _setDisabledField: Oe,
      _setErrors: I,
      _getFieldArray: ne,
      _reset: de,
      _resetDefaultValues: () => Er(n.defaultValues) && n.defaultValues().then((F) => {
        je(F, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: G,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(F) {
        s = F;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(F) {
        l = F;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return n;
      },
      set _options(F) {
        n = {
          ...n,
          ...F
        };
      }
    },
    subscribe: Ie,
    trigger: ke,
    register: an,
    handleSubmit: Ke,
    watch: Pe,
    setValue: ue,
    getValues: Ce,
    reset: je,
    resetField: se,
    clearErrors: Be,
    unregister: Le,
    setError: Me,
    setFocus: Ae,
    getFieldState: W
  };
  return {
    ...nn,
    formControl: nn
  };
}
function nee(e = {}) {
  const n = Se.useRef(void 0), t = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Er(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Er(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : eee(e),
    formState: i
  }, e.formControl && e.defaultValues && !Er(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !_i(e.values, t.current) ? (o._reset(e.values, o._options.resetOptions), t.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !Vt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = kF(i, o), n.current;
}
const tee = "_modalBody_1clhs_1", ree = {
  modalBody: tee
}, iee = ({
  isOpen: e,
  onClose: n,
  pointsAccount: t,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = mn(), { track: l } = gn(), u = t?.id, m = t?.balance ?? 0, d = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: y } = nee({
    defaultValues: d,
    mode: "onChange"
  }), x = _F({ control: f }), S = parseInt(x?.balance ?? "0", 10), j = m === S, w = j ? "Change the value to update the points" : "", v = S < 0, q = v ? "Points can not be negative" : "", T = x.description === "", I = T ? "Description can not be empty" : "";
  qe(() => {
    S > m ? h(
      "transactionType",
      Mh.Addition
    ) : S < m && h(
      "transactionType",
      Mh.Deduction
    );
  }, [m, S, h]);
  const [O, { loading: U, error: Z, reset: Q }] = o(jZ, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ee = () => {
    if (u) {
      const G = rZ();
      O({
        variables: {
          input: {
            accountId: u,
            transactionId: G,
            amount: Math.abs(S - m),
            transactionType: x.transactionType,
            description: x.description,
            source: fF.UpdateBalance
          }
        }
      }).then(async (P) => {
        P?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), J());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, J = () => {
    y(d), Q(), n();
  };
  return /* @__PURE__ */ M.jsxs(
    Nt,
    {
      isOpen: e,
      onClose: J,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ M.jsx(jt, { title: "Update points balance", onClose: J }),
        /* @__PURE__ */ M.jsxs(wt, { className: ree.modalBody, children: [
          /* @__PURE__ */ M.jsxs(Gt, { children: [
            /* @__PURE__ */ M.jsx(rn, { span: 6, children: /* @__PURE__ */ M.jsx(
              fN,
              {
                name: "balance",
                control: f,
                render: ({ field: G }) => /* @__PURE__ */ M.jsx(
                  vr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: w || q
                    },
                    input: {
                      ...G,
                      value: G.value.toString(),
                      onChange: (P) => G.onChange(P)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ M.jsx(rn, { span: 6, children: /* @__PURE__ */ M.jsx(
              fN,
              {
                name: "description",
                control: f,
                render: ({ field: G }) => /* @__PURE__ */ M.jsx(
                  vr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: G,
                    meta: {
                      warning: I
                    }
                  }
                )
              }
            ) })
          ] }),
          Z && /* @__PURE__ */ M.jsx(wn, { error: Z })
        ] }),
        /* @__PURE__ */ M.jsx(
          Ot,
          {
            confirmName: "Save",
            confirmOnClick: () => ee(),
            confirmProps: {
              isLoading: U,
              disabled: j || v || T,
              loadingIndicator: /* @__PURE__ */ M.jsx(dn, { size: 16 })
            },
            cancelOnClick: J
          }
        )
      ]
    }
  );
}, aee = "_wrapper_1ge6c_1", oee = "_block_1ge6c_12", wN = {
  wrapper: aee,
  block: oee
}, see = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: t } = mn(), { isCopied: i, copy: a } = Ul(), { isCopied: o, copy: s } = Ul(), { isCopied: l, copy: u } = Ul(), [m, d] = oe(!1), [f, h] = oe(), [y, x] = oe(!1), {
    loading: S,
    data: j,
    refetch: w
  } = t(SZ, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  qe(() => {
    if (j) {
      const ne = j?.Voyado?.PointAccountV_GetPointAccounts;
      ne && ne?.length > 0 && h(ne[0]);
    }
  }, [j]);
  const v = !!f?.id, q = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: T,
    lastName: I,
    street: O,
    zipCode: U,
    city: Z,
    country: Q,
    isRegistrationCompleted: ee,
    email: J,
    mobilePhone: G
  } = e, P = 14, K = `${T || ""} ${I || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", className: wN.wrapper, children: [
    /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: wN.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: K }),
          S && /* @__PURE__ */ M.jsx(dn, { size: 12 }),
          v && !S && /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ M.jsxs(Mn, { size: "small", variant: "warning", children: [
              q,
              " points"
            ] }),
            /* @__PURE__ */ M.jsx(Qe, { content: "Update points balance", children: /* @__PURE__ */ M.jsx(
              me,
              {
                name: "pen",
                size: 12,
                onClick: () => d(!0),
                className: tt.pointer
              }
            ) }),
            y && /* @__PURE__ */ M.jsx(Qe, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ M.jsx(
              me,
              {
                name: "info",
                size: 12,
                className: tt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (O || Z || U || Q || G || J) && /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
      G && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(me, { size: P, name: "phone" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: G })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            size: P,
            name: o ? "done" : "copy",
            onClick: () => s(G),
            className: tt.pointer
          }
        )
      ] }),
      J && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(me, { size: P, name: "mail" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: J })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            size: P,
            name: i ? "done" : "copy",
            onClick: () => a(J),
            className: tt.pointer
          }
        )
      ] }),
      (O || Z || U || Q) && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(me, { size: P, name: "home" }),
          /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ M.jsx(Qn, { children: O }),
            /* @__PURE__ */ M.jsxs(Qn, { children: [
              U,
              " ",
              Z
            ] }),
            /* @__PURE__ */ M.jsx(Qn, { children: Q })
          ] })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            size: P,
            name: l ? "done" : "copy",
            onClick: () => u(`${O}, ${U} ${Z}, ${Q}`),
            className: tt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(me, { size: P, name: "sign-in" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ M.jsx(
          me,
          {
            name: ee ? "check-circle-filled" : "close-circle-filled",
            color: ee ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    v && /* @__PURE__ */ M.jsx(
      iee,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => d(!1),
        setHasPointsBeenUpdated: x,
        refetchPointsQuery: w
      }
    )
  ] });
}, lee = "_list_yud4a_7", cee = "_listItem_yud4a_11", uee = "_listItemTooltip_yud4a_15", dee = "_listItemTimestamp_yud4a_18", xl = {
  list: lee,
  listItem: cee,
  listItemTooltip: uee,
  listItemTimestamp: dee
}, mee = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ M.jsx(He, { className: xl.list, children: e.map((n, t) => /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: xl.listItem, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ M.jsx(Qe, { content: n?.comment, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: ut({
          [xl.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { className: xl.listItemTimestamp, children: Dn(n.date).format(ct) }),
          n?.comment && /* @__PURE__ */ M.jsx(me, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ M.jsx(
      me,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, t)) })
] }), pee = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, t = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Dn(e.latestChange).format(ct) : null, o = e?.expires ? `${Dn(e.expires).fromNow()} (${Dn(e.expires).format(ct)})` : null, s = !n && !a && !t && !i && !o;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ M.jsx(Qe, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ M.jsx(
        me,
        {
          name: "question",
          size: 14,
          className: tt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsxs(He, { className: tt.list, children: [
      s && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: tt.listItem, children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: tt.listItem, children: /* @__PURE__ */ M.jsx(Qe, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ M.jsx(Mn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: tt.listItem, children: /* @__PURE__ */ M.jsx(Qe, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ M.jsx(Mn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      t && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: tt.listItem, children: /* @__PURE__ */ M.jsx(Qe, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ M.jsx(Mn, { variant: "success", size: "small", children: t })
      ] }) }) }),
      a && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: tt.listItem, children: /* @__PURE__ */ M.jsx(Qe, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: tt.listItem, children: /* @__PURE__ */ M.jsx(Qe, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, fee = "_tagHover_kzbzk_1", hee = "_channelUnsubscribed_kzbzk_6", CN = {
  tagHover: fee,
  channelUnsubscribed: hee
}, Rf = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: t,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = gn(), { useMutation: l } = mn(), [u, m] = oe(!1), [d, { loading: f }] = l(NZ), h = async ({
    newPreference: x,
    isSubscribed: S,
    channelType: j
  }) => {
    m(!0), (await d({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...x
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? S ? s("voyado:channel:unsubscribe:succeeded", { channel: j }) : s("voyado:channel:subscribe:succeeded", { channel: j }) : S ? s("voyado:channel:unsubscribe:failed", { channel: j }) : s("voyado:channel:subscribe:failed", { channel: j }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, y = u || f;
  return /* @__PURE__ */ M.jsx(Qe, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ M.jsx(
    Rn,
    {
      className: CN.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ M.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: ut({
            [CN.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            y ? /* @__PURE__ */ M.jsx(dn, { size: 16 }) : /* @__PURE__ */ M.jsx(me, { size: 16, name: t }),
            n
          ]
        }
      )
    }
  ) });
}, vee = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: t
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        Rf,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: t
        }
      ),
      /* @__PURE__ */ M.jsx(
        Rf,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: t
        }
      ),
      /* @__PURE__ */ M.jsx(
        Rf,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: t
        }
      )
    ] })
  ] }) });
}, yee = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: t,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: u,
    refetch: m,
    attributes: d,
    preferences: f,
    consents: h
  } = wZ({ contactId: e }), {
    isLoading: y,
    error: x,
    memberLevel: S
  } = TZ({ contactId: e, skip: !s }), j = y || l, w = Wn(
    () => h?.filter(
      (v) => v !== null
    ),
    [h]
  );
  return u || x ? as({
    errors: u?.graphQLErrors || x?.graphQLErrors || []
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ M.jsx(wn, { error: u || x }) : !t && !i && !a && !o && !s ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : j ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(dn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    t && /* @__PURE__ */ M.jsx(
      see,
      {
        contactAttributes: d,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ M.jsx(pee, { memberLevel: S }),
    i && /* @__PURE__ */ M.jsx(
      vee,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ M.jsx(mee, { contactConsents: w })
  ] });
}, Bh = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, gee = "_list_zu4s7_1", kee = "_listItem_zu4s7_4", bee = "_listSum_zu4s7_7", Sl = {
  list: gee,
  listItem: kee,
  listSum: bee
}, _ee = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: t
}) => /* @__PURE__ */ M.jsxs(He, { className: Sl.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: Sl.listItem, children: /* @__PURE__ */ M.jsx(Qe, { content: s, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ M.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flex: "auto", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ M.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Bh(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ M.jsx(
    He.Text,
    {
      variant: "dense",
      className: ut(Sl.listItem, Sl.listSum),
      children: /* @__PURE__ */ M.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: Bh(t, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), xee = "_transaction_1kr8d_1", See = "_transactionIsOpen_1kr8d_9", Nee = "_transactionHeader_1kr8d_12", jee = "_transactionHeaderSubLine_1kr8d_15", wee = "_transactionHeaderAlignItemRight_1kr8d_19", ma = {
  transaction: xee,
  transactionIsOpen: See,
  transactionHeader: Nee,
  transactionHeaderSubLine: jee,
  transactionHeaderAlignItemRight: wee
}, Cee = ({
  transaction: e,
  openByDefault: n
}) => {
  const [t, i] = oe(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: u,
    lineItems: m,
    localCurrency: d,
    localNetPriceSum: f
  } = e, h = d ?? "", y = f ?? 0, x = m?.length ? m : [];
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: ut(ma.transaction, {
        [ma.transactionIsOpen]: t
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ma.transactionHeader,
            onClick: () => i(!t),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ M.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ M.jsx(Mn, { size: "small", variant: "info", children: Dn(o).format(ct) }),
                  /* @__PURE__ */ M.jsxs(
                    A.Heading,
                    {
                      variant: "heading-4",
                      className: ma.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ma.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-4", children: Bh(y, h) }),
                      /* @__PURE__ */ M.jsxs(
                        A.Heading,
                        {
                          variant: "heading-4",
                          className: ma.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsx(
                tr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        t && /* @__PURE__ */ M.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ M.jsx(Gh, {}),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: s }),
                u && /* @__PURE__ */ M.jsx(Rn, { children: /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: u }) }),
                /* @__PURE__ */ M.jsx(
                  _ee,
                  {
                    lineItems: x,
                    localCurrency: h,
                    localNetPriceSum: y
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, Fee = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: t,
    transactions: i
  } = $Z({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return t ? /* @__PURE__ */ M.jsx(wn, { error: t }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ M.jsx(Mn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(dn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
          s === 0 && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, u) => /* @__PURE__ */ M.jsx(
            Cee,
            {
              transaction: l,
              openByDefault: u === 0
            },
            u
          ))
        ] })
      ]
    }
  );
}, Iee = "_message_unsvt_48", $ee = "_messageIsOpen_unsvt_56", Eee = "_messageHeader_unsvt_60", Tee = "_messageText_unsvt_64", Oee = "_buttonLink_unsvt_86", $o = {
  message: Iee,
  messageIsOpen: $ee,
  messageHeader: Eee,
  messageText: Tee,
  buttonLink: Oee
}, Df = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Pf = (e, n) => n && e in Df && n in Df[e] ? Df[e][n] : null, Ree = ({
  message: e,
  openByDefault: n
}) => {
  const [t, i] = oe(n), { track: a } = gn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: u,
    isTransactional: m,
    status: d,
    messageLink: f,
    messageText: h
  } = e, y = l ? Pf("type", l) : null, x = u ? Pf("source", u) : null, S = d ? Pf("status", d) : null, j = l?.replace("Message", "");
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: ut($o.message, {
        [$o.messageIsOpen]: t
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: $o.messageHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
                  y && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
                    /* @__PURE__ */ M.jsx(me, { name: y, size: 16 }),
                    " ",
                    j
                  ] }),
                  s && /* @__PURE__ */ M.jsx(Mn, { size: "small", variant: "info", children: Dn(s).format(ct) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ M.jsx(
                tr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ M.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ M.jsx(Gh, {}),
          /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            S && /* @__PURE__ */ M.jsx(Rn, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(me, { name: S }),
              " ",
              d
            ] }) }),
            x && /* @__PURE__ */ M.jsx(Rn, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(me, { name: x }),
              " ",
              u
            ] }) }),
            m && /* @__PURE__ */ M.jsx(Rn, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(me, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", className: $o.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ M.jsx(
            Tt,
            {
              slotEnd: /* @__PURE__ */ M.jsx(me, { name: "external-link" }),
              variant: "tertiary",
              className: $o.buttonLink,
              navigate: () => {
                j && a("voyado:message:external-link:opened", {
                  channel: j.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, Dee = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: t,
    lastMessages: i
  } = FZ({ contactId: e });
  if (!e)
    return null;
  if (t)
    return /* @__PURE__ */ M.jsx(wn, { error: t });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ M.jsx(Mn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(dn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      l && o?.map((u, m) => /* @__PURE__ */ M.jsx(
        Ree,
        {
          message: u || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, su = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, FN = ({
  labelText: e,
  address: n,
  icon: t = "home"
}) => {
  const { isCopied: i, copy: a } = Ul(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = vt(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(me, { size: l, name: t, color: "green.500" }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ M.jsx(Qe, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ M.jsx(
      me,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: tt.pointer
      }
    ) })
  ] });
}, Pee = "_order_19t4p_1", Aee = "_orderIsOpen_19t4p_9", Lee = "_orderHeader_19t4p_12", Vee = "_orderIconColor_19t4p_15", Kr = {
  order: Pee,
  orderIsOpen: Aee,
  orderHeader: Lee,
  orderIconColor: Vee
}, zee = "_delivery_1m9nb_1", Mee = "_deliveryCode_1m9nb_4", Af = {
  delivery: zee,
  deliveryCode: Mee
}, Uee = ({
  delivery: e
}) => {
  const { isCopied: n, copy: t } = Dr();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ M.jsx(
      me,
      {
        size: l,
        name: "eye",
        className: Kr.orderIconColor
      }
    ),
    /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ M.jsx(
        Qe,
        {
          content: /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Dn(s).format(ct)
          ] }),
          children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ M.jsx(
              A.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Af.delivery,
                    children: [
                      /* @__PURE__ */ M.jsx(me, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ M.jsx(
              A.Paragraph,
              {
                variant: "4",
                className: ut(Af.delivery, Af.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ M.jsx(Qe, { content: "Copy tracking code", children: /* @__PURE__ */ M.jsx(
      me,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => t(a.toString()),
        className: tt.pointer
      }
    ) })
  ] });
}, Bee = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const t = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        me,
        {
          size: 14,
          name: "file-text",
          className: Kr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ M.jsx(He, { className: tt.list, children: t?.map((i, a) => /* @__PURE__ */ M.jsx(He.Item, { className: tt.listItem, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ M.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ M.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: tt.listItemAlignRight,
              children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: su({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, qee = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const t = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        me,
        {
          size: 14,
          name: "tag",
          className: Kr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ M.jsx(He, { className: tt.list, children: t?.map((i) => /* @__PURE__ */ M.jsx(
      He.Item,
      {
        className: tt.listItem,
        contentLeft: /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ M.jsx(
          Qe,
          {
            content: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ M.jsx(b, { children: /* @__PURE__ */ M.jsx(Mn, { size: "small", variant: "info", children: su({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ M.jsx(
          Ta,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, Hee = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const t = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        me,
        {
          size: 14,
          name: "credit-card",
          className: Kr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ M.jsx(He, { className: tt.list, children: t?.map((i, a) => /* @__PURE__ */ M.jsx(
      He.Item,
      {
        className: tt.listItem,
        children: /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ M.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: tt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: Dn(i?.paidAt).format(ct) }),
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: su({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, Wee = ({
  order: e,
  openByDefault: n
}) => {
  const [t, i] = oe(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: u,
    createdAt: m,
    lastChangedAt: d,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: y,
    totalPrice: x
  } = e, S = 14;
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: ut(Kr.order, {
        [Kr.orderIsOpen]: t
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Kr.orderHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Dn(m).format(ct) }) }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ M.jsx(
                tr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              me,
              {
                size: S,
                name: "activity",
                className: Kr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ M.jsx(Qe, { content: "Internal status", children: /* @__PURE__ */ M.jsx(Mn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ M.jsx(Qe, { content: "External status", children: /* @__PURE__ */ M.jsx(Mn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: s }) }) }),
                /* @__PURE__ */ M.jsx(Qe, { content: "Last updated at", children: /* @__PURE__ */ M.jsx(A.Paragraph, { as: "span", variant: "5", children: Dn(d).format(ct) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              me,
              {
                size: S,
                name: "chart-bar",
                className: Kr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: su({
                value: x,
                currencyCode: l
              }) })
            ] })
          ] }),
          u && /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              me,
              {
                size: S,
                name: "channels",
                className: Kr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ M.jsx(Mn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: u }) }) })
            ] })
          ] }),
          /* @__PURE__ */ M.jsx(FN, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ M.jsx(
            FN,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: y
            }
          ),
          /* @__PURE__ */ M.jsx(Uee, { delivery: e.delivery }),
          /* @__PURE__ */ M.jsx(qee, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ M.jsx(Bee, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ M.jsx(
            Hee,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, Kee = ({
  error: e,
  itemCount: n,
  children: t
}) => e ? n === 0 || as({ errors: e.graphQLErrors }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ M.jsx(wn, { error: e }) : /* @__PURE__ */ M.jsx(M.Fragment, { children: t }), Gee = ({
  contactId: e
}) => {
  const { useQuery: n } = mn(), [t, i] = oe([]), { track: a } = gn(), {
    loading: o,
    error: s,
    data: l
  } = n(xZ, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return qe(() => {
    if (l?.Voyado) {
      const u = l?.Voyado.Orders_GetAllByContact;
      if (!o && u?.items) {
        i(u.items);
        const { totalCount: m } = u;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      t.length > 0 && /* @__PURE__ */ M.jsx(Mn, { size: "small", variant: "success", children: t.length })
    ] }),
    o ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(dn, {}) }) : /* @__PURE__ */ M.jsx(Kee, { error: s, itemCount: t.length, children: t.map((u, m) => /* @__PURE__ */ M.jsx(
      Wee,
      {
        order: u,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, Yee = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: t, contactId: i, hasMultipleContacts: a, error: o } = EZ({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: u,
    showPreferences: m,
    showAudiences: d,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: y,
    showOrders: x
  } = n;
  return s ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? as({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ M.jsx(wn, { error: o }) : !u && !m && !d && !f && !h && !y ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : t ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(dn, {}) }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ M.jsx(yee, { contactId: i, settings: n }),
        h && /* @__PURE__ */ M.jsx(Dee, { contactId: i }),
        y && /* @__PURE__ */ M.jsx(Fee, { contactId: i }),
        x && /* @__PURE__ */ M.jsx(Gee, { contactId: i }),
        !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, Jee = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_nr4rl_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_nr4rl_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_nr4rl_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_nr4rl_63:last-child{border-bottom:none}._channelHeadline_yeqqp_1{padding:var(--dixa-size-spacer-200);border-bottom:var(--dixa-size-border-200) solid var(--dixa-color-neutral-200)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Lf = { exports: {} }, Eo = {}, IN;
function Qee() {
  if (IN) return Eo;
  IN = 1;
  var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, y = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: y, props: f, _owner: a.current };
  }
  return Eo.Fragment = t, Eo.jsx = s, Eo.jsxs = s, Eo;
}
var Nl = {}, $N;
function Xee() {
  return $N || ($N = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Se, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function j(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
          p[g - 1] = arguments[g];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var g = w.ReactDebugCurrentFrame, R = g.getStackAddendum();
        R !== "" && (c += "%s", p = p.concat([R]));
        var L = p.map(function(C) {
          return String(C);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var T = !1, I = !1, O = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === y || T || I || O || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var g = r.displayName;
      if (g)
        return g;
      var R = c.displayName || c.name || "";
      return R !== "" ? p + "(" + R + ")" : p;
    }
    function G(r) {
      return r.displayName || "Context";
    }
    function P(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return G(c) + ".Consumer";
          case s:
            var p = r;
            return G(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var g = r.displayName || null;
            return g !== null ? g : P(r.type) || "Memo";
          case h: {
            var R = r, L = R._payload, C = R._init;
            try {
              return P(C(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ne = 0, pe, ye, ue, ve, H, ke, Ce;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Be() {
      {
        if (ne === 0) {
          pe = console.log, ye = console.info, ue = console.warn, ve = console.error, H = console.group, ke = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, r, {
              value: pe
            }),
            info: K({}, r, {
              value: ye
            }),
            warn: K({}, r, {
              value: ue
            }),
            error: K({}, r, {
              value: ve
            }),
            group: K({}, r, {
              value: H
            }),
            groupCollapsed: K({}, r, {
              value: ke
            }),
            groupEnd: K({}, r, {
              value: Ce
            })
          });
        }
        ne < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Pe = w.ReactCurrentDispatcher, Ue;
    function Ie(r, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (R) {
            var g = R.stack.trim().match(/\n( *(at )?)/);
            Ue = g && g[1] || "";
          }
        return `
` + Ue + r;
      }
    }
    var Le = !1, Oe;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new an();
    }
    function Ne(r, c) {
      if (!r || Le)
        return "";
      {
        var p = Oe.get(r);
        if (p !== void 0)
          return p;
      }
      var g;
      Le = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Pe.current, Pe.current = null, Be();
      try {
        if (c) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (te) {
              g = te;
            }
            Reflect.construct(r, [], C);
          } else {
            try {
              C.call();
            } catch (te) {
              g = te;
            }
            r.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (te) {
            g = te;
          }
          r();
        }
      } catch (te) {
        if (te && g && typeof te.stack == "string") {
          for (var N = te.stack.split(`
`), $ = g.stack.split(`
`), V = N.length - 1, z = $.length - 1; V >= 1 && z >= 0 && N[V] !== $[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (N[V] !== $[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || N[V] !== $[z]) {
                    var re = `
` + N[V].replace(" at new ", " at ");
                    return r.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", r.displayName)), typeof r == "function" && Oe.set(r, re), re;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Le = !1, Pe.current = L, Me(), Error.prepareStackTrace = R;
      }
      var we = r ? r.displayName || r.name : "", be = we ? Ie(we) : "";
      return typeof r == "function" && Oe.set(r, be), be;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Ke(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Ke(r));
      if (typeof r == "string")
        return Ie(r);
      switch (r) {
        case m:
          return Ie("Suspense");
        case d:
          return Ie("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return se(r.type, c, p);
          case h: {
            var g = r, R = g._payload, L = g._init;
            try {
              return se(L(R), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, je = {}, Ae = w.ReactDebugCurrentFrame;
    function Re(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        Ae.setExtraStackFrame(p);
      } else
        Ae.setExtraStackFrame(null);
    }
    function nn(r, c, p, g, R) {
      {
        var L = Function.call.bind(de);
        for (var C in r)
          if (L(r, C)) {
            var N = void 0;
            try {
              if (typeof r[C] != "function") {
                var $ = Error((g || "React class") + ": " + p + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              N = r[C](c, C, g, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              N = V;
            }
            N && !(N instanceof Error) && (Re(R), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", p, C, typeof N), Re(null)), N instanceof Error && !(N.message in je) && (je[N.message] = !0, Re(R), v("Failed %s type: %s", p, N.message), Re(null));
          }
      }
    }
    var F = Array.isArray;
    function _(r) {
      return F(r);
    }
    function E(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function D(r) {
      if (Y(r))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", E(r)), X(r);
    }
    var B = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, _e;
    function en(r) {
      if (de.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function un(r) {
      if (de.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function tn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function ln(r, c) {
      {
        var p = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var pn = function(r, c, p, g, R, L, C) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: C,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function vn(r, c, p, g, R) {
      {
        var L, C = {}, N = null, $ = null;
        p !== void 0 && (D(p), N = "" + p), un(c) && (D(c.key), N = "" + c.key), en(c) && ($ = c.ref, tn(c));
        for (L in c)
          de.call(c, L) && !ie.hasOwnProperty(L) && (C[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            C[L] === void 0 && (C[L] = V[L]);
        }
        if (N || $) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          N && ln(C, z), $ && fn(C, z);
        }
        return pn(r, N, $, R, g, B.current, C);
      }
    }
    var Xe = w.ReactCurrentOwner, yn = w.ReactDebugCurrentFrame;
    function De(r) {
      if (r) {
        var c = r._owner, p = se(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function on(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function _n() {
      {
        if (Xe.current) {
          var r = P(Xe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var sn = {};
    function On(r) {
      {
        var c = _n();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function xn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = On(c);
        if (sn[p])
          return;
        sn[p] = !0;
        var g = "";
        r && r._owner && r._owner !== Xe.current && (g = " It was passed a child from " + P(r._owner.type) + "."), De(r), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, g), De(null);
      }
    }
    function kn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (_(r))
          for (var p = 0; p < r.length; p++) {
            var g = r[p];
            on(g) && xn(g, c);
          }
        else if (on(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var R = j(r);
          if (typeof R == "function" && R !== r.entries)
            for (var L = R.call(r), C; !(C = L.next()).done; )
              on(C.value) && xn(C.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var g = P(c);
          nn(p, r.props, "prop", g, r);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var R = P(c);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Un(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var g = c[p];
          if (g !== "children" && g !== "key") {
            De(r), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), De(null);
            break;
          }
        }
        r.ref !== null && (De(r), v("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    var bn = {};
    function Sn(r, c, p, g, R, L) {
      {
        var C = ee(r);
        if (!C) {
          var N = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var $ = Hn();
          $ ? N += $ : N += _n();
          var V;
          r === null ? V = "null" : _(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (P(r.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, N);
        }
        var z = vn(r, c, p, R, L);
        if (z == null)
          return z;
        if (C) {
          var re = c.children;
          if (re !== void 0)
            if (g)
              if (_(re)) {
                for (var we = 0; we < re.length; we++)
                  kn(re[we], r);
                Object.freeze && Object.freeze(re);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kn(re, r);
        }
        if (de.call(c, "key")) {
          var be = P(r), te = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Ze = te.length > 0 ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bn[be + Ze]) {
            var In = te.length > 0 ? "{" + te.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ze, be, In, be), bn[be + Ze] = !0;
          }
        }
        return r === i ? Un(z) : Vn(z), z;
      }
    }
    function Tn(r, c, p) {
      return Sn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Sn(r, c, p, !1);
    }
    var Bn = Ln, qn = Tn;
    Nl.Fragment = i, Nl.jsx = Bn, Nl.jsxs = qn;
  }()), Nl;
}
var EN;
function Zee() {
  return EN || (EN = 1, process.env.NODE_ENV === "production" ? Lf.exports = Qee() : Lf.exports = Xee()), Lf.exports;
}
var ce = Zee();
const ene = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "account_status" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "accepts_sms_marketing" } }, { kind: "Field", name: { kind: "Name", value: "accepts_email_marketing" } }, { kind: "Field", name: { kind: "Name", value: "channels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "suppressions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "province_code" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }] } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "response_messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "keyword" } }, { kind: "Field", name: { kind: "Name", value: "flowId" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }, { kind: "Field", name: { kind: "Name", value: "converted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_promotional_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_delivered" } }, { kind: "Field", name: { kind: "Name", value: "last_opened" } }, { kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_spam" } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, nne = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              account_status\n              default_language\n              dafault_currency\n              accepts_sms_marketing\n              accepts_email_marketing\n              channels {\n                sms {\n                  marketing {\n                    consent\n                    timestamp\n                  }\n                }\n                email {\n                  marketing {\n                    consent\n                    timestamp\n                    suppressions {\n                      timestamp\n                      timestamp\n                    }\n                  }\n                }\n              }\n              tags\n              address {\n                address1\n                address2\n                city\n                company\n                state\n                zip\n                province_code\n                country_code\n                phone_number\n              }\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n              }\n              yotpo_sms {\n                last_engaged\n                last_converted\n                last_sent\n                response_messages {\n                  id\n                  keyword\n                  flowId\n                  timestamp\n                }\n                campaigns {\n                  converted\n                  id\n                  clicked\n                }\n                flows {\n                  id\n                  opened\n                  clicked\n                  converted\n                }\n              }\n              yotpo_email {\n                last_sent\n                last_promotional_sent\n                last_delivered\n                last_opened\n                last_engaged\n                last_converted\n                last_spam\n                campaigns {\n                  opened\n                  id\n                  clicked\n                }\n                flows {\n                  converted\n                  id\n                }\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": ene
};
function tne(e) {
  return nne[e] ?? {};
}
const rne = tne(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              account_status
              default_language
              dafault_currency
              accepts_sms_marketing
              accepts_email_marketing
              channels {
                sms {
                  marketing {
                    consent
                    timestamp
                  }
                }
                email {
                  marketing {
                    consent
                    timestamp
                    suppressions {
                      timestamp
                      timestamp
                    }
                  }
                }
              }
              tags
              address {
                address1
                address2
                city
                company
                state
                zip
                province_code
                country_code
                phone_number
              }
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
              }
              yotpo_sms {
                last_engaged
                last_converted
                last_sent
                response_messages {
                  id
                  keyword
                  flowId
                  timestamp
                }
                campaigns {
                  converted
                  id
                  clicked
                }
                flows {
                  id
                  opened
                  clicked
                  converted
                }
              }
              yotpo_email {
                last_sent
                last_promotional_sent
                last_delivered
                last_opened
                last_engaged
                last_converted
                last_spam
                campaigns {
                  opened
                  id
                  clicked
                }
                flows {
                  converted
                  id
                }
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), ine = "_copyIcon_nr4rl_48", ane = "_list_nr4rl_53", one = "_listItem_nr4rl_63", Zr = {
  copyIcon: ine,
  list: ane,
  listItem: one
}, $n = ({
  description: e,
  content: n,
  tooltip: t
}) => {
  if (n == null)
    return null;
  const i = oI(n);
  return /* @__PURE__ */ ce.jsx(He.Text, { variant: "dense", className: Zr.listItem, children: /* @__PURE__ */ ce.jsx(Qe, { content: t, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: e }),
    i ? n : QN(n)
  ] }) }) });
}, TN = ({
  channel: e
}) => {
  const n = (a) => bc(a.replace("_", " "));
  if (!e?.marketing)
    return null;
  const { marketing: t } = e, i = "suppressions" in t && !!t.suppressions;
  return /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
    /* @__PURE__ */ ce.jsx(He.Text, { variant: "dense", className: Zr.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Consent" }),
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        t?.timestamp && /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Dn(t?.timestamp).format(ct) }),
        t?.consent && /* @__PURE__ */ ce.jsx(Mn, { variant: "primary", size: "small", children: n(t?.consent) })
      ] })
    ] }) }),
    i && /* @__PURE__ */ ce.jsx(He.Text, { variant: "dense", className: Zr.listItem, children: /* @__PURE__ */ ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Suppressions" }),
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", alignItems: "center", children: [
        t.suppressions?.timestamp && /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Dn(t.suppressions?.timestamp).format(
          ct
        ) }),
        t.suppressions?.suppression_reason && /* @__PURE__ */ ce.jsx(Mn, { variant: "warning", size: "small", children: t.suppressions?.suppression_reason })
      ] })
    ] }) })
  ] });
}, sne = "_channelHeadline_yeqqp_1", ON = {
  channelHeadline: sne
}, lne = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { channels: n } = e, { yotpo_email: t, yotpo_sms: i } = e;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Channels" }),
    /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", className: ON.channelHeadline, children: [
        /* @__PURE__ */ ce.jsx(me, { name: "mail" }),
        /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-4", children: "EMAIL" })
      ] }),
      /* @__PURE__ */ ce.jsxs(He, { className: Zr.list, children: [
        /* @__PURE__ */ ce.jsx(TN, { channel: n?.email }),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the customer's last email was sent.",
            content: t?.last_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last promotional sent",
            tooltip: "The timestamp for when the customer's last promotional email was sent.",
            content: t?.last_promotional_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last delivered",
            tooltip: "The timestamp for when the customer's last email was delivered.",
            content: t?.last_delivered
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last opened",
            tooltip: "The timestamp for when the customer's last email was opened.",
            content: t?.last_opened
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via email.",
            content: t?.last_engaged
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via email.",
            content: t?.last_converted
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last spam",
            tooltip: "The timestamp for when the customer's last email was marked as spam.",
            content: t?.last_spam
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "100", className: ON.channelHeadline, children: [
        /* @__PURE__ */ ce.jsx(me, { name: "sms" }),
        /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-4", children: "SMS" })
      ] }),
      /* @__PURE__ */ ce.jsxs(He, { className: Zr.list, children: [
        /* @__PURE__ */ ce.jsx(TN, { channel: n?.sms }),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via SMS.",
            content: i?.last_engaged
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the last SMS was sent to the customer.",
            content: i?.last_sent
          }
        ),
        /* @__PURE__ */ ce.jsx(
          $n,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via SMS.",
            content: i?.last_converted
          }
        )
      ] })
    ] })
  ] });
}, cne = "_wrapper_1xucg_1", une = "_externalLink_1xucg_7", Vf = {
  wrapper: cne,
  externalLink: une
}, dne = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: t } = Dr(), { isCopied: i, copy: a } = Dr(), { isCopied: o, copy: s } = Dr();
  if (!e)
    return null;
  const {
    first_name: l,
    last_name: u,
    address: m,
    email: d,
    phone_number: f,
    account_created_at: h,
    account_status: y,
    accepts_sms_marketing: x,
    accepts_email_marketing: S
  } = e, j = 14, w = `${l || ""} ${u || ""}`.trim() || "A customer has no name", {
    address1: v,
    address2: q,
    city: T,
    company: I,
    state: O,
    zip: U,
    province_code: Z,
    country_code: Q
  } = m || {}, ee = [
    v,
    q,
    [U, T].filter(Boolean).join(", "),
    [Q, O, Z].filter(Boolean).join(", "),
    I
  ].filter(Boolean);
  return /* @__PURE__ */ ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ce.jsxs(b, { className: Vf.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(
      b,
      {
        justifyContent: "space-between",
        className: Vf.block,
        alignItems: "center",
        children: /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-2", children: w })
      }
    ),
    h && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: Dn(h).format(ct) })
    ] }),
    d && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(me, { size: j, name: "mail" }),
        /* @__PURE__ */ ce.jsx("span", { className: Vf.externalLink, children: d })
      ] }),
      /* @__PURE__ */ ce.jsx(Qe, { content: "Copy email", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        me,
        {
          size: j,
          name: n ? "done" : "copy",
          onClick: () => t(d),
          className: Zr.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(me, { size: j, name: "phone" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: f })
      ] }),
      /* @__PURE__ */ ce.jsx(Qe, { content: "Copy phone number", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        me,
        {
          size: j,
          name: i ? "done" : "copy",
          onClick: () => a(f),
          className: Zr.copyIcon
        }
      ) }) })
    ] }),
    (v || T || I || O || U || Q) && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", children: [
        /* @__PURE__ */ ce.jsx(me, { size: j, name: "home" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: ee.map((J) => /* @__PURE__ */ ce.jsx(Qn, { children: J }, J)) })
      ] }),
      /* @__PURE__ */ ce.jsx(Qe, { content: "Copy address", children: /* @__PURE__ */ ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ce.jsx(
        me,
        {
          size: j,
          name: o ? "done" : "copy",
          onClick: () => s(ee.join(", ")),
          className: Zr.copyIcon
        }
      ) }) })
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(me, { size: j, name: "sms" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Accepts sms marketing" })
      ] }),
      /* @__PURE__ */ ce.jsx(
        me,
        {
          name: x ? "check-circle-filled" : "close-circle-filled",
          color: x ? "green.500" : "red.500"
        }
      )
    ] }),
    /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(me, { size: j, name: "paper-plane" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Accepts email marketing" })
      ] }),
      /* @__PURE__ */ ce.jsx(
        me,
        {
          name: S ? "check-circle-filled" : "close-circle-filled",
          color: S ? "green.500" : "red.500"
        }
      )
    ] }),
    y && /* @__PURE__ */ ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ce.jsx(me, { size: j, name: "yotpo", color: "rgb(0, 66, 228)" }),
        /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", children: "Account status" })
      ] }),
      /* @__PURE__ */ ce.jsx(Rn, { children: bc(y) })
    ] })
  ] }) });
}, mne = ({
  loyalty: e
}) => /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ ce.jsxs(He, { className: Zr.list, children: [
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Points expire date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.points_expire_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), pne = ({ tags: e }) => {
  const n = e?.split(","), t = n && n.length > 0;
  return /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
    !t && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No tags available" }) }),
    t && /* @__PURE__ */ ce.jsx(b, { gap: "200", flexWrap: "wrap", children: n.map((i, a) => /* @__PURE__ */ ce.jsx(Rn, { children: i }, a)) })
  ] });
}, fne = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ ce.jsxs(He, { className: Zr.list, children: [
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: e.sentiment_avg_site
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Dn(e.last_review_date).format(
          ct
        )
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: e.last_sentiment
      }
    ),
    /* @__PURE__ */ ce.jsx(
      $n,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ ce.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, t) => /* @__PURE__ */ ce.jsx(Mn, { variant: "info", size: "small", children: /* @__PURE__ */ ce.jsx(ce.Fragment, { children: n }) }, t))
          }
        )
      }
    )
  ] })
] }), hne = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: t } = mn(), { track: i } = gn(), [a, o] = oe(), [s, l] = oe(!1), u = e?.customer?.email, m = e?.customer?.phone_number, d = !u && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, y = n?.showTags ?? !1, x = n?.showChannels ?? !1, S = n?.showUserGeneratedContent ?? !1, j = n?.displayLoyalty ?? !1, w = n?.displayEmailData ?? !1, v = n?.displaySmsData ?? !1, q = n?.displaySubscriptions ?? !1, T = !h && !y && !x && !S && !j && !w && !v && !q, {
    loading: I,
    error: O,
    data: U
  } = t(rne, {
    skip: !u || !f,
    variables: {
      ...u && { email: u },
      ...!u && m && { phone_number: m },
      storeId: f
    }
  });
  return qe(() => {
    const Z = U?.Yotpo?.getCustomers;
    Z?.customers && (Z?.customers?.length > 0 ? (o(Z?.customers[0]), l(!1), i("yotpo:customer:received")) : l(!0));
  }, [U?.Yotpo, I]), d ? /* @__PURE__ */ ce.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : s ? /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) }) : T ? /* @__PURE__ */ ce.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-features",
      children: /* @__PURE__ */ ce.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
    }
  ) : O ? Hh({ errors: O.graphQLErrors }) ? /* @__PURE__ */ ce.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      variant: "4",
      "data-testid": "widget-downstream-api-forbidden-error",
      children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
    }
  ) : Wh({ errors: O.graphQLErrors }) ? /* @__PURE__ */ ce.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      variant: "4",
      "data-testid": "widget-downstream-api-authorization-error",
      children: "The integration could not authorize against Yotpo. Please contact your administrator."
    }
  ) : /* @__PURE__ */ ce.jsx(wn, { error: O }) : I ? /* @__PURE__ */ ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ce.jsx(dn, {}) }) : /* @__PURE__ */ ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ce.jsx(dne, { customerDetails: a }),
        y && /* @__PURE__ */ ce.jsx(pne, { tags: a?.tags }),
        x && /* @__PURE__ */ ce.jsx(lne, { customerDetails: a }),
        S && /* @__PURE__ */ ce.jsx(
          fne,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        j && /* @__PURE__ */ ce.jsx(mne, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var Os = (e) => e.type === "checkbox", Mi = (e) => e instanceof Date, Bt = (e) => e == null;
const FF = (e) => typeof e == "object";
var lt = (e) => !Bt(e) && !Array.isArray(e) && FF(e) && !Mi(e), IF = (e) => lt(e) && e.target ? Os(e.target) ? e.target.checked : e.target.value : e, vne = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, $F = (e, n) => e.has(vne(n)), yne = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return lt(n) && n.hasOwnProperty("isPrototypeOf");
}, Ry = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Et(e) {
  let n;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Ry && (e instanceof Blob || i)) && (t || lt(e)))
    if (n = t ? [] : {}, !t && !yne(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Et(e[a]));
  else
    return e;
  return n;
}
var lu = (e) => Array.isArray(e) ? e.filter(Boolean) : [], at = (e) => e === void 0, Je = (e, n, t) => {
  if (!n || !lt(e))
    return t;
  const i = lu(n.split(/[,[\].]+?/)).reduce((a, o) => Bt(a) ? a : a[o], e);
  return at(i) || i === e ? at(e[n]) ? t : e[n] : i;
}, lr = (e) => typeof e == "boolean", Dy = (e) => /^\w*$/.test(e), EF = (e) => lu(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Jn = (e, n, t) => {
  let i = -1;
  const a = Dy(n) ? [n] : EF(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = t;
    if (i !== s) {
      const m = e[l];
      u = lt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const hc = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Tr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ci = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, gne = Se.createContext(null), Py = () => Se.useContext(gne);
var TF = (e, n, t, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Tr.all && (n._proxyFormState[s] = !i || Tr.all), t && (t[s] = !0), e[s];
      }
    });
  return a;
};
function kne(e) {
  const n = Py(), { control: t = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Se.useState(t._formState), u = Se.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Se.useRef(a);
  return m.current = a, Se.useEffect(() => t._subscribe({
    name: m.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...t._formState,
        ...d
      });
    }
  }), [t, i, o]), Se.useEffect(() => {
    u.current.isValid && t._setValid(!0);
  }, [t]), Se.useMemo(() => TF(s, t, u.current, !1), [s, t]);
}
var Xr = (e) => typeof e == "string", OF = (e, n, t, i, a) => Xr(e) ? (i && n.watch.add(e), Je(t, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(t, o))) : (i && (n.watchAll = !0), t);
function RF(e) {
  const n = Py(), { control: t = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Se.useRef(i), u = Se.useRef(a);
  l.current = i, Se.useEffect(() => t._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(OF(l.current, t._names, f.values || t._formValues, !1, u.current))
  }), [t, o, s]);
  const [m, d] = Se.useState(t._getWatch(i, a));
  return Se.useEffect(() => t._removeUnmounted()), m;
}
function bne(e) {
  const n = Py(), { name: t, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = $F(a._names.array, t), l = RF({
    control: a,
    name: t,
    defaultValue: Je(a._formValues, t, Je(a._defaultValues, t, e.defaultValue)),
    exact: !0
  }), u = kne({
    control: a,
    name: t,
    exact: !0
  }), m = Se.useRef(e), d = Se.useRef(a.register(t, {
    ...e.rules,
    value: l,
    ...lr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Se.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(u.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(u.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(u.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(u.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => Je(u.errors, t)
    }
  }), [u, t]), h = Se.useCallback((j) => d.current.onChange({
    target: {
      value: IF(j),
      name: t
    },
    type: hc.CHANGE
  }), [t]), y = Se.useCallback(() => d.current.onBlur({
    target: {
      value: Je(a._formValues, t),
      name: t
    },
    type: hc.BLUR
  }), [t, a._formValues]), x = Se.useCallback((j) => {
    const w = Je(a._fields, t);
    w && j && (w._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (v) => j.setCustomValidity(v),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, t]), S = Se.useMemo(() => ({
    name: t,
    value: l,
    ...lr(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: y,
    ref: x
  }), [t, i, u.disabled, h, y, x, l]);
  return Se.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(t, {
      ...m.current.rules,
      ...lr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const w = (v, q) => {
      const T = Je(a._fields, v);
      T && T._f && (T._f.mount = q);
    };
    if (w(t, !0), j) {
      const v = Et(Je(a._options.defaultValues, t));
      Jn(a._defaultValues, t, v), at(Je(a._formValues, t)) && Jn(a._formValues, t, v);
    }
    return !s && a.register(t), () => {
      (s ? j && !a._state.action : j) ? a.unregister(t) : w(t, !1);
    };
  }, [t, a, s, o]), Se.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, a]), Se.useMemo(() => ({
    field: S,
    formState: u,
    fieldState: f
  }), [S, u, f]);
}
const RN = (e) => e.render(bne(e));
var _ne = (e, n, t, i, a) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: a || !0
  }
} : {}, Go = (e) => Array.isArray(e) ? e : [e], DN = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const t of e)
        t.next && t.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((t) => t !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, qh = (e) => Bt(e) || !FF(e);
function xi(e, n) {
  if (qh(e) || qh(n))
    return e === n;
  if (Mi(e) && Mi(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const a of t) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Mi(o) && Mi(s) || lt(o) && lt(s) || Array.isArray(o) && Array.isArray(s) ? !xi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var zt = (e) => lt(e) && !Object.keys(e).length, Ay = (e) => e.type === "file", Or = (e) => typeof e == "function", vc = (e) => {
  if (!Ry)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, DF = (e) => e.type === "select-multiple", Ly = (e) => e.type === "radio", xne = (e) => Ly(e) || Os(e), zf = (e) => vc(e) && e.isConnected;
function Sne(e, n) {
  const t = n.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = at(e) ? i++ : e[n[i++]];
  return e;
}
function Nne(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !at(e[n]))
      return !1;
  return !0;
}
function bt(e, n) {
  const t = Array.isArray(n) ? n : Dy(n) ? [n] : EF(n), i = t.length === 1 ? e : Sne(e, t), a = t.length - 1, o = t[a];
  return i && delete i[o], a !== 0 && (lt(i) && zt(i) || Array.isArray(i) && Nne(i)) && bt(e, t.slice(0, -1)), e;
}
var PF = (e) => {
  for (const n in e)
    if (Or(e[n]))
      return !0;
  return !1;
};
function yc(e, n = {}) {
  const t = Array.isArray(e);
  if (lt(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || lt(e[i]) && !PF(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, yc(e[i], n[i])) : Bt(e[i]) || (n[i] = !0);
  return n;
}
function AF(e, n, t) {
  const i = Array.isArray(e);
  if (lt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || lt(e[a]) && !PF(e[a]) ? at(n) || qh(t[a]) ? t[a] = Array.isArray(e[a]) ? yc(e[a], []) : { ...yc(e[a]) } : AF(e[a], Bt(n) ? {} : n[a], t[a]) : t[a] = !xi(e[a], n[a]);
  return t;
}
var To = (e, n) => AF(e, n, yc(n));
const PN = {
  value: !1,
  isValid: !1
}, AN = { value: !0, isValid: !0 };
var LF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !at(e[0].attributes.value) ? at(e[0].value) || e[0].value === "" ? AN : { value: e[0].value, isValid: !0 } : AN
    ) : PN;
  }
  return PN;
}, VF = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: i }) => at(e) ? e : n ? e === "" ? NaN : e && +e : t && Xr(e) ? new Date(e) : i ? i(e) : e;
const LN = {
  isValid: !1,
  value: null
};
var zF = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, LN) : LN;
function VN(e) {
  const n = e.ref;
  return Ay(n) ? n.files : Ly(n) ? zF(e.refs).value : DF(n) ? [...n.selectedOptions].map(({ value: t }) => t) : Os(n) ? LF(e.refs).value : VF(at(n.value) ? e.ref.value : n.value, e);
}
var jne = (e, n, t, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Jn(a, o, s._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, gc = (e) => e instanceof RegExp, Oo = (e) => at(e) ? e : gc(e) ? e.source : lt(e) ? gc(e.value) ? e.value.source : e.value : e, zN = (e) => ({
  isOnSubmit: !e || e === Tr.onSubmit,
  isOnBlur: e === Tr.onBlur,
  isOnChange: e === Tr.onChange,
  isOnAll: e === Tr.all,
  isOnTouch: e === Tr.onTouched
});
const MN = "AsyncFunction";
var wne = (e) => !!e && !!e.validate && !!(Or(e.validate) && e.validate.constructor.name === MN || lt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === MN)), Cne = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), UN = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Yo = (e, n, t, i) => {
  for (const a of t || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Yo(l, n))
          break;
      } else if (lt(l) && Yo(l, n))
        break;
    }
  }
};
function BN(e, n, t) {
  const i = Je(e, t);
  if (i || Dy(t))
    return {
      error: i,
      name: t
    };
  const a = t.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && t !== o)
      return { name: t };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: t
  };
}
var Fne = (e, n, t, i) => {
  t(e);
  const { name: a, ...o } = e;
  return zt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Tr.all));
}, Ine = (e, n, t) => !e || !n || e === n || Go(e).some((i) => i && (t ? i === n : i.startsWith(n) || n.startsWith(i))), $ne = (e, n, t, i, a) => a.isOnAll ? !1 : !t && a.isOnTouch ? !(n || e) : (t ? i.isOnBlur : a.isOnBlur) ? !e : (t ? i.isOnChange : a.isOnChange) ? e : !0, Ene = (e, n) => !lu(Je(e, n)).length && bt(e, n), Tne = (e, n, t) => {
  const i = Go(Je(e, t));
  return Jn(i, "root", n[t]), Jn(e, t, i), e;
}, ql = (e) => Xr(e);
function qN(e, n, t = "validate") {
  if (ql(e) || Array.isArray(e) && e.every(ql) || lr(e) && !e)
    return {
      type: t,
      message: ql(e) ? e : "",
      ref: n
    };
}
var pa = (e) => lt(e) && !gc(e) ? e : {
  value: e,
  message: ""
}, HN = async (e, n, t, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: m, minLength: d, min: f, max: h, pattern: y, validate: x, name: S, valueAsNumber: j, mount: w } = e._f, v = Je(t, S);
  if (!w || n.has(S))
    return {};
  const q = l ? l[0] : s, T = (G) => {
    a && q.reportValidity && (q.setCustomValidity(lr(G) ? "" : G || ""), q.reportValidity());
  }, I = {}, O = Ly(s), U = Os(s), Z = O || U, Q = (j || Ay(s)) && at(s.value) && at(v) || vc(s) && s.value === "" || v === "" || Array.isArray(v) && !v.length, ee = _ne.bind(null, S, i, I), J = (G, P, K, ne = ci.maxLength, pe = ci.minLength) => {
    const ye = G ? P : K;
    I[S] = {
      type: G ? ne : pe,
      message: ye,
      ref: s,
      ...ee(G ? ne : pe, ye)
    };
  };
  if (o ? !Array.isArray(v) || !v.length : u && (!Z && (Q || Bt(v)) || lr(v) && !v || U && !LF(l).isValid || O && !zF(l).isValid)) {
    const { value: G, message: P } = ql(u) ? { value: !!u, message: u } : pa(u);
    if (G && (I[S] = {
      type: ci.required,
      message: P,
      ref: q,
      ...ee(ci.required, P)
    }, !i))
      return T(P), I;
  }
  if (!Q && (!Bt(f) || !Bt(h))) {
    let G, P;
    const K = pa(h), ne = pa(f);
    if (!Bt(v) && !isNaN(v)) {
      const pe = s.valueAsNumber || v && +v;
      Bt(K.value) || (G = pe > K.value), Bt(ne.value) || (P = pe < ne.value);
    } else {
      const pe = s.valueAsDate || new Date(v), ye = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), ue = s.type == "time", ve = s.type == "week";
      Xr(K.value) && v && (G = ue ? ye(v) > ye(K.value) : ve ? v > K.value : pe > new Date(K.value)), Xr(ne.value) && v && (P = ue ? ye(v) < ye(ne.value) : ve ? v < ne.value : pe < new Date(ne.value));
    }
    if ((G || P) && (J(!!G, K.message, ne.message, ci.max, ci.min), !i))
      return T(I[S].message), I;
  }
  if ((m || d) && !Q && (Xr(v) || o && Array.isArray(v))) {
    const G = pa(m), P = pa(d), K = !Bt(G.value) && v.length > +G.value, ne = !Bt(P.value) && v.length < +P.value;
    if ((K || ne) && (J(K, G.message, P.message), !i))
      return T(I[S].message), I;
  }
  if (y && !Q && Xr(v)) {
    const { value: G, message: P } = pa(y);
    if (gc(G) && !v.match(G) && (I[S] = {
      type: ci.pattern,
      message: P,
      ref: s,
      ...ee(ci.pattern, P)
    }, !i))
      return T(P), I;
  }
  if (x) {
    if (Or(x)) {
      const G = await x(v, t), P = qN(G, q);
      if (P && (I[S] = {
        ...P,
        ...ee(ci.validate, P.message)
      }, !i))
        return T(P.message), I;
    } else if (lt(x)) {
      let G = {};
      for (const P in x) {
        if (!zt(G) && !i)
          break;
        const K = qN(await x[P](v, t), q, P);
        K && (G = {
          ...K,
          ...ee(P, K.message)
        }, T(K.message), i && (I[S] = G));
      }
      if (!zt(G) && (I[S] = {
        ref: q,
        ...G
      }, !i))
        return I;
    }
  }
  return T(!0), I;
};
const One = {
  mode: Tr.onSubmit,
  reValidateMode: Tr.onChange,
  shouldFocusError: !0
};
function Rne(e = {}) {
  let n = {
    ...One,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Or(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = lt(n.defaultValues) || lt(n.values) ? Et(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Et(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, m = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: DN(),
    state: DN()
  }, y = zN(n.mode), x = zN(n.reValidateMode), S = n.criteriaMode === Tr.all, j = (F) => (_) => {
    clearTimeout(m), m = setTimeout(F, _);
  }, w = async (F) => {
    if (!n.disabled && (d.isValid || f.isValid || F)) {
      const _ = n.resolver ? zt((await Q()).errors) : await J(i, !0);
      _ !== t.isValid && h.state.next({
        isValid: _
      });
    }
  }, v = (F, _) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((F || Array.from(l.mount)).forEach((E) => {
      E && (_ ? Jn(t.validatingFields, E, _) : bt(t.validatingFields, E));
    }), h.state.next({
      validatingFields: t.validatingFields,
      isValidating: !zt(t.validatingFields)
    }));
  }, q = (F, _ = [], E, Y, X = !0, D = !0) => {
    if (Y && E && !n.disabled) {
      if (s.action = !0, D && Array.isArray(Je(i, F))) {
        const B = E(Je(i, F), Y.argA, Y.argB);
        X && Jn(i, F, B);
      }
      if (D && Array.isArray(Je(t.errors, F))) {
        const B = E(Je(t.errors, F), Y.argA, Y.argB);
        X && Jn(t.errors, F, B), Ene(t.errors, F);
      }
      if ((d.touchedFields || f.touchedFields) && D && Array.isArray(Je(t.touchedFields, F))) {
        const B = E(Je(t.touchedFields, F), Y.argA, Y.argB);
        X && Jn(t.touchedFields, F, B);
      }
      (d.dirtyFields || f.dirtyFields) && (t.dirtyFields = To(a, o)), h.state.next({
        name: F,
        isDirty: P(F, _),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Jn(o, F, _);
  }, T = (F, _) => {
    Jn(t.errors, F, _), h.state.next({
      errors: t.errors
    });
  }, I = (F) => {
    t.errors = F, h.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, O = (F, _, E, Y) => {
    const X = Je(i, F);
    if (X) {
      const D = Je(o, F, at(E) ? Je(a, F) : E);
      at(D) || Y && Y.defaultChecked || _ ? Jn(o, F, _ ? D : VN(X._f)) : pe(F, D), s.mount && w();
    }
  }, U = (F, _, E, Y, X) => {
    let D = !1, B = !1;
    const ie = {
      name: F
    };
    if (!n.disabled) {
      if (!E || Y) {
        (d.isDirty || f.isDirty) && (B = t.isDirty, t.isDirty = ie.isDirty = P(), D = B !== ie.isDirty);
        const fe = xi(Je(a, F), _);
        B = !!Je(t.dirtyFields, F), fe ? bt(t.dirtyFields, F) : Jn(t.dirtyFields, F, !0), ie.dirtyFields = t.dirtyFields, D = D || (d.dirtyFields || f.dirtyFields) && B !== !fe;
      }
      if (E) {
        const fe = Je(t.touchedFields, F);
        fe || (Jn(t.touchedFields, F, E), ie.touchedFields = t.touchedFields, D = D || (d.touchedFields || f.touchedFields) && fe !== E);
      }
      D && X && h.state.next(ie);
    }
    return D ? ie : {};
  }, Z = (F, _, E, Y) => {
    const X = Je(t.errors, F), D = (d.isValid || f.isValid) && lr(_) && t.isValid !== _;
    if (n.delayError && E ? (u = j(() => T(F, E)), u(n.delayError)) : (clearTimeout(m), u = null, E ? Jn(t.errors, F, E) : bt(t.errors, F)), (E ? !xi(X, E) : X) || !zt(Y) || D) {
      const B = {
        ...Y,
        ...D && lr(_) ? { isValid: _ } : {},
        errors: t.errors,
        name: F
      };
      t = {
        ...t,
        ...B
      }, h.state.next(B);
    }
  }, Q = async (F) => {
    v(F, !0);
    const _ = await n.resolver(o, n.context, jne(F || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return v(F), _;
  }, ee = async (F) => {
    const { errors: _ } = await Q(F);
    if (F)
      for (const E of F) {
        const Y = Je(_, E);
        Y ? Jn(t.errors, E, Y) : bt(t.errors, E);
      }
    else
      t.errors = _;
    return _;
  }, J = async (F, _, E = {
    valid: !0
  }) => {
    for (const Y in F) {
      const X = F[Y];
      if (X) {
        const { _f: D, ...B } = X;
        if (D) {
          const ie = l.array.has(D.name), fe = X._f && wne(X._f);
          fe && d.validatingFields && v([Y], !0);
          const _e = await HN(X, l.disabled, o, S, n.shouldUseNativeValidation && !_, ie);
          if (fe && d.validatingFields && v([Y]), _e[D.name] && (E.valid = !1, _))
            break;
          !_ && (Je(_e, D.name) ? ie ? Tne(t.errors, _e, D.name) : Jn(t.errors, D.name, _e[D.name]) : bt(t.errors, D.name));
        }
        !zt(B) && await J(B, _, E);
      }
    }
    return E.valid;
  }, G = () => {
    for (const F of l.unMount) {
      const _ = Je(i, F);
      _ && (_._f.refs ? _._f.refs.every((E) => !zf(E)) : !zf(_._f.ref)) && Le(F);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (F, _) => !n.disabled && (F && _ && Jn(o, F, _), !xi(Ce(), a)), K = (F, _, E) => OF(F, l, {
    ...s.mount ? o : at(_) ? a : Xr(F) ? { [F]: _ } : _
  }, E, _), ne = (F) => lu(Je(s.mount ? o : a, F, n.shouldUnregister ? Je(a, F, []) : [])), pe = (F, _, E = {}) => {
    const Y = Je(i, F);
    let X = _;
    if (Y) {
      const D = Y._f;
      D && (!D.disabled && Jn(o, F, VF(_, D)), X = vc(D.ref) && Bt(_) ? "" : _, DF(D.ref) ? [...D.ref.options].forEach((B) => B.selected = X.includes(B.value)) : D.refs ? Os(D.ref) ? D.refs.length > 1 ? D.refs.forEach((B) => (!B.defaultChecked || !B.disabled) && (B.checked = Array.isArray(X) ? !!X.find((ie) => ie === B.value) : X === B.value)) : D.refs[0] && (D.refs[0].checked = !!X) : D.refs.forEach((B) => B.checked = B.value === X) : Ay(D.ref) ? D.ref.value = "" : (D.ref.value = X, D.ref.type || h.state.next({
        name: F,
        values: Et(o)
      })));
    }
    (E.shouldDirty || E.shouldTouch) && U(F, X, E.shouldTouch, E.shouldDirty, !0), E.shouldValidate && ke(F);
  }, ye = (F, _, E) => {
    for (const Y in _) {
      const X = _[Y], D = `${F}.${Y}`, B = Je(i, D);
      (l.array.has(F) || lt(X) || B && !B._f) && !Mi(X) ? ye(D, X, E) : pe(D, X, E);
    }
  }, ue = (F, _, E = {}) => {
    const Y = Je(i, F), X = l.array.has(F), D = Et(_);
    Jn(o, F, D), X ? (h.array.next({
      name: F,
      values: Et(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && E.shouldDirty && h.state.next({
      name: F,
      dirtyFields: To(a, o),
      isDirty: P(F, D)
    })) : Y && !Y._f && !Bt(D) ? ye(F, D, E) : pe(F, D, E), UN(F, l) && h.state.next({ ...t }), h.state.next({
      name: s.mount ? F : void 0,
      values: Et(o)
    });
  }, ve = async (F) => {
    s.mount = !0;
    const _ = F.target;
    let E = _.name, Y = !0;
    const X = Je(i, E), D = (B) => {
      Y = Number.isNaN(B) || Mi(B) && isNaN(B.getTime()) || xi(B, Je(o, E, B));
    };
    if (X) {
      let B, ie;
      const fe = _.type ? VN(X._f) : IF(F), _e = F.type === hc.BLUR || F.type === hc.FOCUS_OUT, en = !Cne(X._f) && !n.resolver && !Je(t.errors, E) && !X._f.deps || $ne(_e, Je(t.touchedFields, E), t.isSubmitted, x, y), un = UN(E, l, _e);
      Jn(o, E, fe), _e ? (X._f.onBlur && X._f.onBlur(F), u && u(0)) : X._f.onChange && X._f.onChange(F);
      const tn = U(E, fe, _e), ln = !zt(tn) || un;
      if (!_e && h.state.next({
        name: E,
        type: F.type,
        values: Et(o)
      }), en)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? _e && w() : _e || w()), ln && h.state.next({ name: E, ...un ? {} : tn });
      if (!_e && un && h.state.next({ ...t }), n.resolver) {
        const { errors: fn } = await Q([E]);
        if (D(fe), Y) {
          const pn = BN(t.errors, i, E), vn = BN(fn, i, pn.name || E);
          B = vn.error, E = vn.name, ie = zt(fn);
        }
      } else
        v([E], !0), B = (await HN(X, l.disabled, o, S, n.shouldUseNativeValidation))[E], v([E]), D(fe), Y && (B ? ie = !1 : (d.isValid || f.isValid) && (ie = await J(i, !0)));
      Y && (X._f.deps && ke(X._f.deps), Z(E, ie, B, tn));
    }
  }, H = (F, _) => {
    if (Je(t.errors, _) && F.focus)
      return F.focus(), 1;
  }, ke = async (F, _ = {}) => {
    let E, Y;
    const X = Go(F);
    if (n.resolver) {
      const D = await ee(at(F) ? F : X);
      E = zt(D), Y = F ? !X.some((B) => Je(D, B)) : E;
    } else F ? (Y = (await Promise.all(X.map(async (D) => {
      const B = Je(i, D);
      return await J(B && B._f ? { [D]: B } : B);
    }))).every(Boolean), !(!Y && !t.isValid) && w()) : Y = E = await J(i);
    return h.state.next({
      ...!Xr(F) || (d.isValid || f.isValid) && E !== t.isValid ? {} : { name: F },
      ...n.resolver || !F ? { isValid: E } : {},
      errors: t.errors
    }), _.shouldFocus && !Y && Yo(i, H, F ? X : l.mount), Y;
  }, Ce = (F) => {
    const _ = {
      ...s.mount ? o : a
    };
    return at(F) ? _ : Xr(F) ? Je(_, F) : F.map((E) => Je(_, E));
  }, W = (F, _) => ({
    invalid: !!Je((_ || t).errors, F),
    isDirty: !!Je((_ || t).dirtyFields, F),
    error: Je((_ || t).errors, F),
    isValidating: !!Je(t.validatingFields, F),
    isTouched: !!Je((_ || t).touchedFields, F)
  }), Be = (F) => {
    F && Go(F).forEach((_) => bt(t.errors, _)), h.state.next({
      errors: F ? t.errors : {}
    });
  }, Me = (F, _, E) => {
    const Y = (Je(i, F, { _f: {} })._f || {}).ref, X = Je(t.errors, F) || {}, { ref: D, message: B, type: ie, ...fe } = X;
    Jn(t.errors, F, {
      ...fe,
      ..._,
      ref: Y
    }), h.state.next({
      name: F,
      errors: t.errors,
      isValid: !1
    }), E && E.shouldFocus && Y && Y.focus && Y.focus();
  }, Pe = (F, _) => Or(F) ? h.state.subscribe({
    next: (E) => F(K(void 0, _), E)
  }) : K(F, _, !0), Ue = (F) => h.state.subscribe({
    next: (_) => {
      Ine(F.name, _.name, F.exact) && Fne(_, F.formState || d, Re, F.reRenderRoot) && F.callback({
        values: { ...o },
        ...t,
        ..._
      });
    }
  }).unsubscribe, Ie = (F) => (s.mount = !0, f = {
    ...f,
    ...F.formState
  }, Ue({
    ...F,
    formState: f
  })), Le = (F, _ = {}) => {
    for (const E of F ? Go(F) : l.mount)
      l.mount.delete(E), l.array.delete(E), _.keepValue || (bt(i, E), bt(o, E)), !_.keepError && bt(t.errors, E), !_.keepDirty && bt(t.dirtyFields, E), !_.keepTouched && bt(t.touchedFields, E), !_.keepIsValidating && bt(t.validatingFields, E), !n.shouldUnregister && !_.keepDefaultValue && bt(a, E);
    h.state.next({
      values: Et(o)
    }), h.state.next({
      ...t,
      ..._.keepDirty ? { isDirty: P() } : {}
    }), !_.keepIsValid && w();
  }, Oe = ({ disabled: F, name: _ }) => {
    (lr(F) && s.mount || F || l.disabled.has(_)) && (F ? l.disabled.add(_) : l.disabled.delete(_));
  }, an = (F, _ = {}) => {
    let E = Je(i, F);
    const Y = lr(_.disabled) || lr(n.disabled);
    return Jn(i, F, {
      ...E || {},
      _f: {
        ...E && E._f ? E._f : { ref: { name: F } },
        name: F,
        mount: !0,
        ..._
      }
    }), l.mount.add(F), E ? Oe({
      disabled: lr(_.disabled) ? _.disabled : n.disabled,
      name: F
    }) : O(F, !0, _.value), {
      ...Y ? { disabled: _.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!_.required,
        min: Oo(_.min),
        max: Oo(_.max),
        minLength: Oo(_.minLength),
        maxLength: Oo(_.maxLength),
        pattern: Oo(_.pattern)
      } : {},
      name: F,
      onChange: ve,
      onBlur: ve,
      ref: (X) => {
        if (X) {
          an(F, _), E = Je(i, F);
          const D = at(X.value) && X.querySelectorAll && X.querySelectorAll("input,select,textarea")[0] || X, B = xne(D), ie = E._f.refs || [];
          if (B ? ie.find((fe) => fe === D) : D === E._f.ref)
            return;
          Jn(i, F, {
            _f: {
              ...E._f,
              ...B ? {
                refs: [
                  ...ie.filter(zf),
                  D,
                  ...Array.isArray(Je(a, F)) ? [{}] : []
                ],
                ref: { type: D.type, name: F }
              } : { ref: D }
            }
          }), O(F, !1, void 0, D);
        } else
          E = Je(i, F, {}), E._f && (E._f.mount = !1), (n.shouldUnregister || _.shouldUnregister) && !($F(l.array, F) && s.action) && l.unMount.add(F);
      }
    };
  }, Ne = () => n.shouldFocusError && Yo(i, H, l.mount), We = (F) => {
    lr(F) && (h.state.next({ disabled: F }), Yo(i, (_, E) => {
      const Y = Je(i, E);
      Y && (_.disabled = Y._f.disabled || F, Array.isArray(Y._f.refs) && Y._f.refs.forEach((X) => {
        X.disabled = Y._f.disabled || F;
      }));
    }, 0, !1));
  }, Ke = (F, _) => async (E) => {
    let Y;
    E && (E.preventDefault && E.preventDefault(), E.persist && E.persist());
    let X = Et(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: D, values: B } = await Q();
      t.errors = D, X = B;
    } else
      await J(i);
    if (l.disabled.size)
      for (const D of l.disabled)
        Jn(X, D, void 0);
    if (bt(t.errors, "root"), zt(t.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await F(X, E);
      } catch (D) {
        Y = D;
      }
    } else
      _ && await _({ ...t.errors }, E), Ne(), setTimeout(Ne);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: zt(t.errors) && !Y,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), Y)
      throw Y;
  }, se = (F, _ = {}) => {
    Je(i, F) && (at(_.defaultValue) ? ue(F, Et(Je(a, F))) : (ue(F, _.defaultValue), Jn(a, F, Et(_.defaultValue))), _.keepTouched || bt(t.touchedFields, F), _.keepDirty || (bt(t.dirtyFields, F), t.isDirty = _.defaultValue ? P(F, Et(Je(a, F))) : P()), _.keepError || (bt(t.errors, F), d.isValid && w()), h.state.next({ ...t }));
  }, de = (F, _ = {}) => {
    const E = F ? Et(F) : a, Y = Et(E), X = zt(F), D = X ? a : Y;
    if (_.keepDefaultValues || (a = E), !_.keepValues) {
      if (_.keepDirtyValues) {
        const B = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(To(a, o))
        ]);
        for (const ie of Array.from(B))
          Je(t.dirtyFields, ie) ? Jn(D, ie, Je(o, ie)) : ue(ie, Je(D, ie));
      } else {
        if (Ry && at(F))
          for (const B of l.mount) {
            const ie = Je(i, B);
            if (ie && ie._f) {
              const fe = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (vc(fe)) {
                const _e = fe.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const B of l.mount)
          ue(B, Je(D, B));
      }
      o = Et(D), h.array.next({
        values: { ...D }
      }), h.state.next({
        values: { ...D }
      });
    }
    l = {
      mount: _.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!_.keepIsValid || !!_.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: _.keepSubmitCount ? t.submitCount : 0,
      isDirty: X ? !1 : _.keepDirty ? t.isDirty : !!(_.keepDefaultValues && !xi(F, a)),
      isSubmitted: _.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: X ? {} : _.keepDirtyValues ? _.keepDefaultValues && o ? To(a, o) : t.dirtyFields : _.keepDefaultValues && F ? To(a, F) : _.keepDirty ? t.dirtyFields : {},
      touchedFields: _.keepTouched ? t.touchedFields : {},
      errors: _.keepErrors ? t.errors : {},
      isSubmitSuccessful: _.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, je = (F, _) => de(Or(F) ? F(o) : F, _), Ae = (F, _ = {}) => {
    const E = Je(i, F), Y = E && E._f;
    if (Y) {
      const X = Y.refs ? Y.refs[0] : Y.ref;
      X.focus && (X.focus(), _.shouldSelect && Or(X.select) && X.select());
    }
  }, Re = (F) => {
    t = {
      ...t,
      ...F
    };
  }, nn = {
    control: {
      register: an,
      unregister: Le,
      getFieldState: W,
      handleSubmit: Ke,
      setError: Me,
      _subscribe: Ue,
      _runSchema: Q,
      _getWatch: K,
      _getDirty: P,
      _setValid: w,
      _setFieldArray: q,
      _setDisabledField: Oe,
      _setErrors: I,
      _getFieldArray: ne,
      _reset: de,
      _resetDefaultValues: () => Or(n.defaultValues) && n.defaultValues().then((F) => {
        je(F, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: G,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(F) {
        s = F;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(F) {
        l = F;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return n;
      },
      set _options(F) {
        n = {
          ...n,
          ...F
        };
      }
    },
    subscribe: Ie,
    trigger: ke,
    register: an,
    handleSubmit: Ke,
    watch: Pe,
    setValue: ue,
    getValues: Ce,
    reset: je,
    resetField: se,
    clearErrors: Be,
    unregister: Le,
    setError: Me,
    setFocus: Ae,
    getFieldState: W
  };
  return {
    ...nn,
    formControl: nn
  };
}
function Dne(e = {}) {
  const n = Se.useRef(void 0), t = Se.useRef(void 0), [i, a] = Se.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Or(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Or(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : Rne(e),
    formState: i
  }, e.formControl && e.defaultValues && !Or(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Se.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Se.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Se.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Se.useEffect(() => {
    e.values && !xi(e.values, t.current) ? (o._reset(e.values, o._options.resetOptions), t.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Se.useEffect(() => {
    e.errors && !zt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Se.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Se.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = TF(i, o), n.current;
}
const Pne = "_settingsWrapper_1ycvy_1", Ane = "_settingsWrapperHeader_1ycvy_6", Lne = "_settingsWrapperContent_1ycvy_10", Vne = "_settingsWrapperContentCode_1ycvy_18", zne = "_settingsWrapperContentCURL_1ycvy_26", Ro = {
  settingsWrapper: Pne,
  settingsWrapperHeader: Ane,
  settingsWrapperContent: Lne,
  settingsWrapperContentCode: Vne,
  settingsWrapperContentCURL: zne
}, Mne = ({
  handleChangeText: e
}) => {
  const [n, t] = oe(!1), { isCopied: i, copy: a } = Dr(), { control: o } = Dne({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = RF({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", u = vt(() => {
    const m = s.storeId, d = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${d ? ` \\
  --data '{"secret":"${d}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ ce.jsx(ce.Fragment, { children: /* @__PURE__ */ ce.jsx(rn, { span: 6, children: /* @__PURE__ */ ce.jsxs(b, { flexDirection: "column", className: Ro.settingsWrapper, children: [
    /* @__PURE__ */ ce.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: Ro.settingsWrapperHeader,
        onClick: () => t(!n),
        children: [
          /* @__PURE__ */ ce.jsx(A.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ ce.jsx(me, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ ce.jsxs(
      b,
      {
        flexDirection: "column",
        className: Ro.settingsWrapperContent,
        children: [
          /* @__PURE__ */ ce.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ce.jsx(
            xc,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ ce.jsxs("ol", { children: [
                /* @__PURE__ */ ce.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ ce.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ ce.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ ce.jsx("span", { className: Ro.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ ce.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ ce.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ ce.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ ce.jsx(
            RN,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ ce.jsx(
                vr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (d) => {
                      m.onChange(d), e({
                        target: {
                          name: "yotpoStoreId",
                          value: d?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ ce.jsx(
            RN,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ ce.jsx(
                vr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ ce.jsxs(ce.Fragment, { children: [
            /* @__PURE__ */ ce.jsx(An, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ ce.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Ro.settingsWrapperContentCURL,
                children: u()
              }
            ) }),
            /* @__PURE__ */ ce.jsx(b, { alignContent: "start", children: /* @__PURE__ */ ce.jsx(
              Qe,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ ce.jsx(
                  Kn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(u()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, Une = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: Mne
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showChannels",
    label: "Show email and sms channels",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], MF = ({
  hasShopifyOAuth: e = !1
} = {}) => ({
  SHOPIFY: {
    widget: XX,
    icon: "shopify",
    iconColors: {
      contentColor: "rgb(148, 190, 69)",
      backgroundColor: "rgba(148, 190, 69, 0.1)"
    },
    settingsConfiguration: [
      ...e ? KJ : GJ,
      ...H0 ? [...H0] : []
    ]
  },
  JIRA: {
    widget: yq,
    icon: "jira",
    iconColors: {
      contentColor: "rgb(38, 132, 255)",
      backgroundColor: "rgba(38, 132, 255, 0.075)"
    },
    settingsConfiguration: [
      ...Hb ? [...Hb] : []
    ]
  },
  GITHUB: {
    widget: SB,
    icon: "github",
    iconColors: {
      contentColor: "rgb(87, 96, 106)",
      backgroundColor: "rgba(221, 244, 255, 0.75)"
    },
    settingsConfiguration: [...NB]
  },
  MIUROS: {
    widget: N8,
    icon: "miuros",
    iconColors: {
      contentColor: "rgb(246, 135, 179)",
      backgroundColor: "rgba(246, 135, 179, 0.15)"
    },
    settingsConfiguration: [...j8]
  },
  KLAVIYO: {
    widget: E6,
    icon: "klaviyo",
    iconColors: {
      contentColor: "rgb(0, 0, 0)",
      backgroundColor: "rgba(0, 0, 0, 0.075)"
    },
    settingsConfiguration: [...T6]
  },
  LINEAR: {
    widget: rG,
    icon: "linear",
    iconColors: {
      contentColor: "rgb(94, 106, 210)",
      backgroundColor: "rgba(94, 106, 210, 0.15)"
    },
    settingsConfiguration: [...iG]
  },
  VOYADO: {
    widget: Yee,
    icon: "voyado",
    iconColors: {
      contentColor: "rgb(0, 0, 0)",
      backgroundColor: "rgba(0, 0, 0, 0.075)"
    },
    settingsConfiguration: [...Jee]
  },
  LOYALTYLION: {
    widget: DG,
    icon: "loyaltylion",
    iconColors: {
      contentColor: "rgb(36, 31, 79)",
      backgroundColor: "rgba(36, 31, 79, 0.075)"
    },
    settingsConfiguration: [...PG]
  },
  RECHARGE: {
    widget: J8,
    icon: "recharge",
    iconColors: {
      contentColor: "rgb(57, 1, 241)",
      backgroundColor: "rgba(57, 1, 241, 0.075)"
    },
    settingsConfiguration: [...Q8]
  },
  BRAZE: {
    widget: RU,
    icon: "braze",
    iconColors: {
      contentColor: "rgb(48, 2, 102)",
      backgroundColor: "rgba(48, 2, 102, 0.075)"
    },
    settingsConfiguration: [...DU]
  },
  YOTPO: {
    widget: hne,
    icon: "yotpo",
    iconColors: {
      contentColor: "rgb(0, 66, 228)",
      backgroundColor: "rgba(0, 66, 228, 0.075)"
    },
    settingsConfiguration: [...Une]
  },
  INGRID: {
    widget: YB,
    icon: "ingrid",
    iconColors: {
      contentColor: "rgb(0, 0, 0)",
      backgroundColor: "rgba(0, 0, 0, 0.075)"
    },
    settingsConfiguration: [...JB]
  }
}), Bne = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, qne = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, UF = ({
  key: e,
  configuration: n,
  settingType: t,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = qne(a?.value, t), s = i !== void 0 ? i : Bne(
    t
  );
  return o !== void 0 ? o : s;
}, Hne = (e) => {
  const n = MF();
  return e.map(
    ({ id: t, type: i, name: a, settings: o, misconfigured: s }) => {
      const u = n[i], { settingsConfiguration: m } = u, d = m?.filter(({ secret: f }) => !f)?.map(
        ({
          key: f,
          type: h,
          defaultValue: y
        }) => ({
          key: f,
          value: UF({
            key: f,
            configuration: o,
            settingType: h,
            settingDefault: y
          })
        })
      );
      return {
        id: t,
        type: i,
        name: a,
        settings: d,
        misconfigured: s,
        icon: u.icon,
        iconColors: u.iconColors,
        widget: u.widget
      };
    }
  );
}, Ute = ({
  configuration: e,
  conversationContext: n,
  showNotification: t,
  onToggleFn: i,
  isOpenFn: a,
  isMinimized: o
}) => {
  const { track: s } = gn(), { isLoading: l, widgets: u } = oU(
    e.baseUrl
  ), [m, d] = oe([]);
  qe(() => {
    if (u?.length && !l) {
      const v = u.filter((q) => e.featureFlags[q.type]).filter((q) => q.enabled);
      d(
        // Mapping the widget from the backend (`widgets`) to our
        // `widgetDefinitions` configuration
        Hne(v)
      );
    }
  }, [l]);
  const f = {
    headline: "",
    text: "",
    onConfirm: () => w(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [h, y] = oe(f), [x, S] = oe(!1), j = (v) => {
    S(!0), y(v);
  }, w = () => {
    S(!1), y(f);
  };
  return /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
    m.sort((v, q) => v.name.localeCompare(q.name)).map(
      ({
        id: v,
        name: q,
        type: T,
        widget: I,
        settings: O,
        misconfigured: U,
        icon: Z,
        iconColors: Q
      }) => {
        const ee = `partner-integration-${v}`, J = `partner-integration-${T}`, G = /* @__PURE__ */ ze.jsx(Yh, { icon: Z, color: Q }), P = O?.reduce(
          (K, ne) => (K[ne.key] = ne.value, K),
          {}
        );
        return o ? /* @__PURE__ */ ze.jsx("div", { className: "icon-holder", children: G }, `partner-icon-${v}`) : /* @__PURE__ */ ze.jsxs(
          hr,
          {
            onToggle: () => {
              s(
                a(ee) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: v,
                  widgetType: T.toLowerCase()
                }
              ), i(ee);
            },
            isOpen: a(ee),
            className: J,
            children: [
              /* @__PURE__ */ ze.jsx(hr.Header, { avatar: G, children: q }),
              /* @__PURE__ */ ze.jsx(hr.Content, { children: U ? /* @__PURE__ */ ze.jsx(wn, { isMisconfigured: !0 }) : /* @__PURE__ */ ze.jsx(
                ZN.Provider,
                {
                  value: {
                    onError: (K, ne) => console.warn(
                      `Something went wrong with a partner widget of type '${T}' and id '${v}'`,
                      K,
                      ne
                    )
                  },
                  children: /* @__PURE__ */ ze.jsx(
                    SC,
                    {
                      integrationId: v,
                      type: T,
                      configuration: e,
                      showNotification: t,
                      showModal: j,
                      children: sI(I, {
                        conversationContext: n,
                        settings: P
                      })
                    }
                  )
                }
              ) })
            ]
          },
          ee
        );
      }
    ),
    /* @__PURE__ */ ze.jsx(
      NC,
      {
        isOpen: x,
        setIsOpen: S,
        headline: h.headline,
        text: h.text,
        confirmLabel: h.confirmLabel,
        confirmVariant: h.confirmVariant,
        cancelLabel: h.cancelLabel,
        cancelVariant: h.cancelVariant,
        onConfirm: h.onConfirm ? () => {
          try {
            h.onConfirm && h.onConfirm();
          } finally {
            S(!1), y(f);
          }
        } : void 0,
        onCancel: h.onCancel ? () => {
          try {
            h.onCancel && h.onCancel();
          } finally {
            S(!1), y(f);
          }
        } : void 0,
        children: h.children
      }
    )
  ] });
}, Wne = ({
  widgetConfiguration: e,
  integrationType: n,
  additionalParameters: t
}) => {
  const i = n === "SHOPIFY", a = Wn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), o = i && Object.keys(t?.shopify ?? {}).length > 0, s = Wn(
    () => i && o ? t?.shopify?.["partner-integrations-widget-name-form-field"] : null,
    [i, o, t]
  ), l = Wn(
    () => [
      {
        key: "apiHostName",
        value: t?.shopify?.apiHostName
      }
    ],
    [t]
  ), u = Wn(
    () => [
      ...i && o ? l : []
    ],
    [i, o, l]
  );
  return {
    hasShopifyWidgetOAuth: a,
    prefilledNameForShopify: s,
    initialValuesForShopify: u
  };
}, Kne = "FULL_ACCESS", Gne = "2", Yne = ({
  type: e,
  baseUrl: n
}) => {
  const t = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((u) => u.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: t,
        scopes: [Kne],
        version: Gne
      })
    }).then((l) => l.json())
  };
}, Jne = "dixaApiToken", Vy = "dixaApiTokenId", BF = "dixaApiTokenName", WN = (e) => [Vy, BF].every(
  (t) => e.find((i) => i?.key === t)
);
function Qne({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const t = Xne(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(t, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const Xne = (e) => [
  {
    key: Jne,
    value: e.value,
    secret: !0
  },
  {
    key: Vy,
    value: e.id,
    secret: !1
  },
  {
    key: BF,
    value: e.name,
    secret: !1
  }
], Zne = ji`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, ete = ji`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, nte = ji`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, tte = ji`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, rte = "_wrapper_1lmim_1", ite = "_wrapperBox_1lmim_4", ate = "_wrapperBoxErrorBorder_1lmim_9", Mf = {
  wrapper: rte,
  wrapperBox: ite,
  wrapperBoxErrorBorder: ate
}, ote = ({
  required: e,
  readOnly: n,
  isSecret: t,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: u,
  handleChangeText: m
}) => {
  const f = o?.find(
    (q) => q.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: y } = f, x = `Insert your ${h.label.toLowerCase()}`, S = `Insert your ${y.label.toLowerCase()}`, [j, w] = oe({
    username: "",
    password: ""
  }), v = vt(
    (q) => {
      m({
        target: {
          name: s,
          value: q
        }
      });
    },
    [s, m]
  );
  return qe(() => {
    v(
      j.username !== "" && j.password !== "" ? window.btoa(`${j.username}:${j.password}`) : ""
    );
  }, [j]), /* @__PURE__ */ ze.jsx(
    An,
    {
      required: e,
      label: a,
      meta: l,
      className: Mf.wrapper,
      children: /* @__PURE__ */ ze.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: ut(Mf.wrapperBox, {
            [Mf.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ ze.jsx(
              vr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: x,
                input: {
                  name: s,
                  value: j.username,
                  onChange: (q) => w({
                    username: q?.target.value ?? "",
                    password: j.password
                  })
                },
                ...t && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ ze.jsx(
              vr,
              {
                noAlert: !0,
                required: e,
                label: y.label,
                readOnly: n,
                placeholder: S,
                input: {
                  name: s,
                  value: j.password,
                  onChange: (q) => w({
                    username: j.username,
                    password: q?.target.value ?? ""
                  })
                },
                ...t && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function ste({
  isSecret: e,
  widgetSettingsKey: n,
  label: t,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: u,
  handleEditSecret: m,
  getValueByKey: d,
  isEditingField: f,
  errors: h,
  type: y,
  isCreationMode: x,
  prefix: S,
  integrationId: j,
  integrationType: w,
  configuration: v,
  settings: q,
  otherProps: T
}) {
  const I = y === "custom" && T?.component, O = d(n)?.value;
  return I ? /* @__PURE__ */ ze.jsx(
    I,
    {
      configuration: v,
      integrationId: j,
      integrationType: w,
      label: t,
      settings: q,
      getValueByKey: d,
      widgetSettingsKey: n,
      handleChangeSelect: u,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
    /* @__PURE__ */ ze.jsx(rn, { span: 3, children: /* @__PURE__ */ ze.jsx(
      lte,
      {
        widgetSettingsKey: n,
        label: t,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: x,
        children: y === "input" ? /* @__PURE__ */ ze.jsx(
          vr,
          {
            required: i,
            readOnly: a,
            label: t,
            placeholder: o,
            input: {
              name: n,
              value: O,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: S,
            ...e && !x && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : y === "basicAuthInput" ? /* @__PURE__ */ ze.jsx(
          ote,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: x,
            label: t,
            widgetSettingsKey: n,
            settings: q,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : y === "switch" ? /* @__PURE__ */ ze.jsx(An, { label: t, children: /* @__PURE__ */ ze.jsx(
          ej,
          {
            input: {
              name: n,
              value: "",
              checked: O,
              onChange: l
            }
          }
        ) }) : y === "select" ? /* @__PURE__ */ ze.jsx(An, { label: t, children: /* @__PURE__ */ ze.jsx(
          ki,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (U) => u(n, U),
            getItemTitleByValue: (U) => U ? /* @__PURE__ */ ze.jsx(A.Paragraph, { children: U.label }) : /* @__PURE__ */ ze.jsx(ze.Fragment, {}),
            value: O ? [
              {
                label: (T?.selectItems || []).find(
                  (U) => U.value === O
                )?.label,
                value: O
              }
            ] : [],
            equalityFn: (U, Z) => U.value === Z.value,
            children: (T?.selectItems || []).map((U) => /* @__PURE__ */ ze.jsx(ht.Item, { value: U, children: U.label }, U.value))
          }
        ) }) : /* @__PURE__ */ ze.jsx(ze.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ ze.jsx(rn, { span: 3 })
  ] });
}
function lte({
  widgetSettingsKey: e,
  label: n,
  isEditingField: t,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return t || o ? a : /* @__PURE__ */ ze.jsx(An, { label: n, children: /* @__PURE__ */ ze.jsxs(
    Kn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Jo = "partner-integrations-widget-name-form-field", KN = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: t = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: u
  }) => ({
    key: i,
    value: UF({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: t ? !0 : !o,
    type: s,
    ...u && { customValidation: u }
  })
), cte = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [t, i] = oe(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = oe({}), s = (T) => i(T), l = (T) => !T || T === "", u = (T) => {
    const { [T]: I, ...O } = a;
    o(O);
  }, m = (T) => ({
    ...T,
    settings: T.settings.filter(({ isEditing: I }) => I).map(({ key: I, value: O, secret: U }) => ({
      key: I,
      value: O,
      secret: U
    }))
  }), d = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (T) => {
    if (!T)
      return;
    const {
      target: { name: I, value: O }
    } = T;
    a[I] && !l(O) && u(I), i({
      ...t,
      settings: t.settings.map(
        (U) => U.key === I ? { ...U, value: O } : U
      )
    });
  }, h = (T) => {
    if (!T)
      return;
    const {
      target: { name: I, checked: O }
    } = T;
    i({
      ...t,
      settings: t.settings.map(
        (U) => U.key === I ? { ...U, value: O } : U
      )
    });
  }, y = (T, I) => {
    if (!I)
      return;
    const { selectedValues: O } = I, U = O?.[0];
    if (U) {
      const Z = t.settings.map(
        (Q) => Q.key === T ? { ...Q, value: U?.value } : Q
      );
      i({
        ...t,
        settings: Z
      });
    } else {
      const Z = t.settings.filter(
        (Q) => Q.key !== T
      );
      i({
        ...t,
        settings: Z
      });
    }
  }, x = (T) => {
    i({
      ...t,
      enabled: T
    });
  }, S = (T) => {
    if (!T)
      return;
    const {
      target: { value: I }
    } = T;
    a[Jo] && !l(I) && u(Jo), i({
      ...t,
      name: I
    });
  }, j = (T, I) => {
    const { settings: O } = t, U = O.map((Z) => Z.key === I ? {
      ...Z,
      isEditing: T,
      ...!T && { value: "" }
    } : Z);
    a[I] && !T && u(I), i({
      ...t,
      settings: U
    });
  }, w = (T) => t.settings.find(
    (I) => I.key === T
  ), v = async (T) => {
    T.preventDefault(), q() && n(m(t));
  }, q = () => {
    const T = {}, { name: I, settings: O } = t;
    return l(I) && (T[Jo] = d.input), O.forEach(
      ({ key: U, value: Z, required: Q, isEditing: ee, type: J, customValidation: G }) => {
        if (Q && ee)
          if (G) {
            const P = G(Z);
            typeof P == "string" && (T[U] = P);
          } else
            typeof Z == "string" && l(Z) && (T[U] = d[J]);
      }
    ), o(T), !Object.keys(T)?.length;
  };
  return {
    formData: t,
    errors: a,
    handleIsEnabled: x,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: y,
    handleEditSecret: j,
    handleChangeName: S,
    handleSubmit: v,
    getSettingValueByKey: w,
    initializeFormData: s,
    validate: q
  };
}, ute = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], GN = "The configuration of the integration is not correct. Please check the settings.", dte = ({
  integrationId: e,
  type: n,
  handleRedirect: t,
  showNotification: i,
  configuration: a,
  additionalParameters: o,
  automationCouplingState: s
}) => {
  const { track: l } = gn(), { deleteDixaApiToken: u, createDixaApiToken: m } = Yne({
    type: n,
    baseUrl: a.baseUrl
  }), f = jI().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), h = !e && !!n && !!f, y = ute.includes(n), [x, S] = oe(), [j, w] = oe(!1), [v, q] = oe(!1), [T, I] = oe(!1), [O, U] = oe(null), [Z, Q] = oe(), {
    hasShopifyWidgetOAuth: ee,
    prefilledNameForShopify: J,
    initialValuesForShopify: G
  } = Wne({
    featureFlags: a.featureFlags,
    widgetConfiguration: Z,
    integrationType: n,
    additionalParameters: o
  }), ne = MF({
    hasShopifyOAuth: h || ee
  })[n].settingsConfiguration, pe = ne.filter(({ type: se }) => se !== "hidden").filter(({ hideOnCreate: se }) => h ? !se : !0), {
    error: ye,
    loading: ue,
    refetch: ve
  } = xI(Zne, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (se) => {
      if (Object.keys(se).length === 0)
        I(!0);
      else {
        I(!1);
        const de = se?.Management?.widgetConfigurations[0];
        de && Q(de);
      }
    }
  }), [H, { error: ke }] = Uy(
    h ? nte : ete,
    {
      onError: (se) => {
        S(se), w(!1), i({
          title: "Something went wrong",
          text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (se) => {
        if (w(!1), Object.keys(se).length !== 0) {
          if (h && t(se?.Management?.createWidgetConfiguration?.id), !h) {
            const de = se?.Management?.updateWidgetConfiguration;
            de.misconfigured ? U(
              de?.misconfigurationCause ?? GN
            ) : U(null);
          }
          i({
            title: `${h ? "Creating" : "Updating"} was successful`,
            text: `${h ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [Ce] = Uy(tte, {
    onError: (se) => {
      S(se), w(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      w(!1), t(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: W,
    handleIsEnabled: Be,
    errors: Me,
    handleChangeText: Pe,
    handleChangeBoolean: Ue,
    handleChangeSelect: Ie,
    handleEditSecret: Le,
    handleChangeName: Oe,
    handleSubmit: an,
    getSettingValueByKey: Ne,
    initializeFormData: We
  } = cte({
    onSubmit: async (se) => {
      h ? l("settings:create:submitted", { widgetType: n }) : e && l("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), w(!0);
      const de = se.settings.map(
        (nn) => typeof nn.value == "boolean" ? { ...nn, value: nn.value.toString() } : nn
      ), je = WN(de) && h;
      let Ae = [];
      if (je) {
        const nn = await m().catch(
          (F) => {
            w(!1), console.warn("API-Token (creation) error resonse", F), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        nn?.data && (Ae = Qne({
          token: nn.data,
          settings: de
        }));
      }
      const Re = {
        ...se,
        settings: [
          ...Ae.length > 0 ? Ae : de
        ]
      };
      (je && Ae.length > 1 || !je && Ae.length === 0) && (H({
        variables: {
          ...!h && { id: e },
          ...h && { type: n },
          ...Re
        }
      }), de.forEach(
        (nn) => nn.secret && Le(!1, nn.key)
      ));
    },
    ...h && {
      initialValues: {
        enabled: !1,
        name: J ?? "",
        settings: KN({
          settingsFromBackend: G,
          settingsConfiguration: ne,
          creating: !0
        })
      }
    }
  });
  qe(() => {
    if (Z) {
      const se = KN({
        settingsFromBackend: Z.settings,
        settingsConfiguration: ne
      });
      We({
        enabled: !!Z.enabled,
        name: Z.name,
        settings: se
      }), Z.misconfigured ? U(
        Z?.misconfigurationCause ?? GN
      ) : U(null);
    }
  }, [Z]);
  const Ke = Wn(() => s ? !s.isCoupled : !0, [s]);
  return ye || ke || x ? /* @__PURE__ */ ze.jsx(
    wn,
    {
      error: ye || x,
      retry: ye ? ve : void 0
    }
  ) : j || ue ? /* @__PURE__ */ ze.jsx(dn, { "data-testid": "widget-settings-loading" }) : T ? /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ ze.jsx(Rn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ ze.jsxs("form", { children: [
    O && /* @__PURE__ */ ze.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ ze.jsx(
      xc,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ ze.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ ze.jsx(A.Paragraph, { children: O }),
          /* @__PURE__ */ ze.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ ze.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ ze.jsx(A.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ ze.jsxs(
      Gt,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          /* @__PURE__ */ ze.jsx(rn, { children: /* @__PURE__ */ ze.jsx(An, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ze.jsx(
            ej,
            {
              input: {
                name: "enabled",
                checked: W.enabled,
                value: "dummy",
                onChange: (se) => Be(se.target.checked)
              }
            }
          ) }) }),
          /* @__PURE__ */ ze.jsx(rn, { span: 3, children: /* @__PURE__ */ ze.jsx(
            vr,
            {
              required: !0,
              label: "Widget name",
              placeholder: "Insert the name of the widget",
              input: {
                name: Jo,
                value: W.name,
                onChange: Oe
              },
              meta: {
                error: Me[Jo]
              }
            }
          ) }),
          /* @__PURE__ */ ze.jsx(rn, { span: 3 }),
          pe?.map(
            ({
              key: se,
              secret: de,
              label: je,
              placeholder: Ae = "",
              required: Re = !1,
              type: nn,
              prefix: F,
              readOnly: _,
              ...E
            }) => {
              const { settings: Y } = W, X = Y.find(
                (D) => D.key === se
              );
              return /* @__PURE__ */ ze.jsx(lI, { children: /* @__PURE__ */ ze.jsx(
                ste,
                {
                  widgetSettingsKey: se,
                  isEditingField: !!X?.isEditing,
                  handleEditSecret: Le,
                  handleChangeText: Pe,
                  handleChangeBoolean: Ue,
                  handleChangeSelect: Ie,
                  getValueByKey: Ne,
                  isSecret: de,
                  label: je,
                  placeholder: Ae,
                  required: Re,
                  errors: Me,
                  type: nn,
                  isCreationMode: h,
                  prefix: F,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: _,
                  settings: ne,
                  otherProps: E
                }
              ) }, se);
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ ze.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ ze.jsx(Kn, { onClick: an, children: "Submit" }),
      !h && /* @__PURE__ */ ze.jsx(
        Qe,
        {
          content: "The widget is used in automations",
          disabled: Ke,
          children: /* @__PURE__ */ ze.jsx(
            Kn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && l("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), q(!0);
              },
              disabled: !Ke,
              isLoading: s?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ ze.jsx(
      NC,
      {
        isOpen: v,
        setIsOpen: q,
        confirmVariant: y ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && l("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && l("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), WN(W.settings)) {
            const se = W.settings.find(
              ({ key: de }) => de === Vy
            )?.value;
            se && u(se).catch((de) => {
              console.warn("API-Token (deletion) error response", de), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          Ce({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ ze.jsx(b, { children: y ? /* @__PURE__ */ ze.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ ze.jsx(
            me,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ ze.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ ze.jsxs(A.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              W.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          W.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, Bte = ({
  configuration: e,
  additionalParameters: n,
  integrationId: t,
  type: i,
  handleRedirect: a,
  showNotification: o,
  automationCouplingState: s
}) => /* @__PURE__ */ ze.jsx(
  ZN.Provider,
  {
    value: {
      onError: (l, u) => console.warn(
        `Something went wrong with the partner widget settings of type ${i} and id ${t}`,
        l,
        u
      )
    },
    children: /* @__PURE__ */ ze.jsx(
      SC,
      {
        integrationId: t,
        type: i,
        configuration: e,
        showNotification: o,
        children: /* @__PURE__ */ ze.jsx(
          dte,
          {
            configuration: e,
            additionalParameters: n,
            integrationId: t,
            type: i,
            handleRedirect: a,
            showNotification: o,
            automationCouplingState: s
          }
        )
      }
    )
  }
);
var jl = { exports: {} }, YN;
function mte() {
  if (YN) return jl.exports;
  YN = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(I, O, U) {
    return Function.prototype.apply.call(I, O, U);
  }, t;
  e && typeof e.ownKeys == "function" ? t = e.ownKeys : Object.getOwnPropertySymbols ? t = function(I) {
    return Object.getOwnPropertyNames(I).concat(Object.getOwnPropertySymbols(I));
  } : t = function(I) {
    return Object.getOwnPropertyNames(I);
  };
  function i(T) {
    console && console.warn && console.warn(T);
  }
  var a = Number.isNaN || function(I) {
    return I !== I;
  };
  function o() {
    o.init.call(this);
  }
  jl.exports = o, jl.exports.once = w, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(T) {
    if (typeof T != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof T);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(T) {
      if (typeof T != "number" || T < 0 || a(T))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + T + ".");
      s = T;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(I) {
    if (typeof I != "number" || I < 0 || a(I))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + I + ".");
    return this._maxListeners = I, this;
  };
  function u(T) {
    return T._maxListeners === void 0 ? o.defaultMaxListeners : T._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return u(this);
  }, o.prototype.emit = function(I) {
    for (var O = [], U = 1; U < arguments.length; U++) O.push(arguments[U]);
    var Z = I === "error", Q = this._events;
    if (Q !== void 0)
      Z = Z && Q.error === void 0;
    else if (!Z)
      return !1;
    if (Z) {
      var ee;
      if (O.length > 0 && (ee = O[0]), ee instanceof Error)
        throw ee;
      var J = new Error("Unhandled error." + (ee ? " (" + ee.message + ")" : ""));
      throw J.context = ee, J;
    }
    var G = Q[I];
    if (G === void 0)
      return !1;
    if (typeof G == "function")
      n(G, this, O);
    else
      for (var P = G.length, K = x(G, P), U = 0; U < P; ++U)
        n(K[U], this, O);
    return !0;
  };
  function m(T, I, O, U) {
    var Z, Q, ee;
    if (l(O), Q = T._events, Q === void 0 ? (Q = T._events = /* @__PURE__ */ Object.create(null), T._eventsCount = 0) : (Q.newListener !== void 0 && (T.emit(
      "newListener",
      I,
      O.listener ? O.listener : O
    ), Q = T._events), ee = Q[I]), ee === void 0)
      ee = Q[I] = O, ++T._eventsCount;
    else if (typeof ee == "function" ? ee = Q[I] = U ? [O, ee] : [ee, O] : U ? ee.unshift(O) : ee.push(O), Z = u(T), Z > 0 && ee.length > Z && !ee.warned) {
      ee.warned = !0;
      var J = new Error("Possible EventEmitter memory leak detected. " + ee.length + " " + String(I) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      J.name = "MaxListenersExceededWarning", J.emitter = T, J.type = I, J.count = ee.length, i(J);
    }
    return T;
  }
  o.prototype.addListener = function(I, O) {
    return m(this, I, O, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(I, O) {
    return m(this, I, O, !0);
  };
  function d() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(T, I, O) {
    var U = { fired: !1, wrapFn: void 0, target: T, type: I, listener: O }, Z = d.bind(U);
    return Z.listener = O, U.wrapFn = Z, Z;
  }
  o.prototype.once = function(I, O) {
    return l(O), this.on(I, f(this, I, O)), this;
  }, o.prototype.prependOnceListener = function(I, O) {
    return l(O), this.prependListener(I, f(this, I, O)), this;
  }, o.prototype.removeListener = function(I, O) {
    var U, Z, Q, ee, J;
    if (l(O), Z = this._events, Z === void 0)
      return this;
    if (U = Z[I], U === void 0)
      return this;
    if (U === O || U.listener === O)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Z[I], Z.removeListener && this.emit("removeListener", I, U.listener || O));
    else if (typeof U != "function") {
      for (Q = -1, ee = U.length - 1; ee >= 0; ee--)
        if (U[ee] === O || U[ee].listener === O) {
          J = U[ee].listener, Q = ee;
          break;
        }
      if (Q < 0)
        return this;
      Q === 0 ? U.shift() : S(U, Q), U.length === 1 && (Z[I] = U[0]), Z.removeListener !== void 0 && this.emit("removeListener", I, J || O);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(I) {
    var O, U, Z;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[I] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[I]), this;
    if (arguments.length === 0) {
      var Q = Object.keys(U), ee;
      for (Z = 0; Z < Q.length; ++Z)
        ee = Q[Z], ee !== "removeListener" && this.removeAllListeners(ee);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (O = U[I], typeof O == "function")
      this.removeListener(I, O);
    else if (O !== void 0)
      for (Z = O.length - 1; Z >= 0; Z--)
        this.removeListener(I, O[Z]);
    return this;
  };
  function h(T, I, O) {
    var U = T._events;
    if (U === void 0)
      return [];
    var Z = U[I];
    return Z === void 0 ? [] : typeof Z == "function" ? O ? [Z.listener || Z] : [Z] : O ? j(Z) : x(Z, Z.length);
  }
  o.prototype.listeners = function(I) {
    return h(this, I, !0);
  }, o.prototype.rawListeners = function(I) {
    return h(this, I, !1);
  }, o.listenerCount = function(T, I) {
    return typeof T.listenerCount == "function" ? T.listenerCount(I) : y.call(T, I);
  }, o.prototype.listenerCount = y;
  function y(T) {
    var I = this._events;
    if (I !== void 0) {
      var O = I[T];
      if (typeof O == "function")
        return 1;
      if (O !== void 0)
        return O.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? t(this._events) : [];
  };
  function x(T, I) {
    for (var O = new Array(I), U = 0; U < I; ++U)
      O[U] = T[U];
    return O;
  }
  function S(T, I) {
    for (; I + 1 < T.length; I++)
      T[I] = T[I + 1];
    T.pop();
  }
  function j(T) {
    for (var I = new Array(T.length), O = 0; O < I.length; ++O)
      I[O] = T[O].listener || T[O];
    return I;
  }
  function w(T, I) {
    return new Promise(function(O, U) {
      function Z(ee) {
        T.removeListener(I, Q), U(ee);
      }
      function Q() {
        typeof T.removeListener == "function" && T.removeListener("error", Z), O([].slice.call(arguments));
      }
      q(T, I, Q, { once: !0 }), I !== "error" && v(T, Z, { once: !0 });
    });
  }
  function v(T, I, O) {
    typeof T.on == "function" && q(T, "error", I, O);
  }
  function q(T, I, O, U) {
    if (typeof T.on == "function")
      U.once ? T.once(I, O) : T.on(I, O);
    else if (typeof T.addEventListener == "function")
      T.addEventListener(I, function Z(Q) {
        U.once && T.removeEventListener(I, Z), O(Q);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof T);
  }
  return jl.exports;
}
var pte = mte();
function qte() {
  const e = new pte.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  nU as GraphQLClientProvider,
  NC as IntegrationModal,
  Ute as PartnerIntegrations,
  Bte as PartnerIntegrationsSettings,
  nte as createWidgetConfigurationMutation,
  tte as deleteWidgetConfigurationMutation,
  Zne as getWidgetConfigurationByIdQuery,
  MF as getWidgetDefinitions,
  qte as initializePartnerEventEmitter,
  ete as updateWidgetConfigurationMutation,
  oU as usePartnerIntegrationWidgetConfigurations,
  Wne as useShopifyConfiguration
};
